import * as React from "react";
import wrapIcon from "../utils/wrapIcon";

const Box20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10 7.96l3.03-1.21-7.5-3-2.59 1.03a1.5 1.5 0 00-.36.21L10 7.96zm-7.96-2.1c-.03.1-.04.2-.04.32v7.64c0 .62.37 1.17.94 1.4l5.76 2.3c.26.1.53.17.8.21v-8.9L2.04 5.86zm8.46 11.87c.27-.04.54-.1.8-.21l5.76-2.3c.57-.23.94-.78.94-1.4V6.18c0-.11-.01-.22-.04-.33L10.5 8.84v8.9zM17.42 5l-3.04 1.22-7.5-3 1.82-.73a3.5 3.5 0 012.6 0l5.76 2.3c.13.06.25.13.36.21z",
    fill: primaryFill
  }));
};

export const Box20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Box20FilledIcon, 'Box20Filled');

const Box20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M11.3 2.48a3.5 3.5 0 00-2.6 0l-5.76 2.3A1.5 1.5 0 002 6.18v7.64c0 .62.37 1.17.94 1.4l5.76 2.3a3.5 3.5 0 002.6 0l5.76-2.3c.57-.23.94-.78.94-1.4V6.18a1.5 1.5 0 00-.94-1.4l-5.76-2.3zm-2.23.93a2.5 2.5 0 011.86 0l5.22 2.09-2.27.91-6.16-2.46 1.35-.54zm-2.7 1.08l6.16 2.46L10 7.96 3.85 5.5l2.53-1.01zm4.13 4.35l6.5-2.6v7.58a.5.5 0 01-.31.47l-5.76 2.3c-.14.06-.28.1-.43.13V8.84zm-1 0v7.88a2.5 2.5 0 01-.43-.13l-5.76-2.3a.5.5 0 01-.31-.47V6.24l6.5 2.6z",
    fill: primaryFill
  }));
};

export const Box20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Box20RegularIcon, 'Box20Regular');

const Box24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M13.4 2.51a3.75 3.75 0 00-2.8 0l-2.2.9L18 7.12l3.37-1.3c-.14-.12-.3-.2-.46-.28l-7.5-3.04zM22 7.2l-9.25 3.58v10.92c.22-.05.44-.11.66-.2l7.5-3.04c.66-.27 1.09-.91 1.09-1.62V7.19zM11.25 21.7V10.77L2 7.19v9.64c0 .71.43 1.35 1.1 1.62l7.5 3.04c.2.09.43.15.65.2zM2.63 5.83L12 9.45l3.92-1.52-9.55-3.7L3.1 5.54c-.17.07-.32.16-.46.28z",
    fill: primaryFill
  }));
};

export const Box24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Box24FilledIcon, 'Box24Filled');

const Box24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10.6 2.51c.9-.36 1.9-.36 2.8 0l7.5 3.04c.67.27 1.1.91 1.1 1.62v9.66c0 .71-.43 1.35-1.1 1.62l-7.5 3.04c-.9.37-1.9.37-2.8 0l-7.5-3.04c-.67-.27-1.1-.91-1.1-1.62V7.17c0-.7.43-1.35 1.1-1.62l7.5-3.04zm2.25 1.4a2.25 2.25 0 00-1.7 0l-1.9.77 7.52 2.93 2.67-1.03-6.6-2.68zm1.84 4.5L7.21 5.5 4.6 6.56 12 9.45l2.7-1.04zM3.5 16.83c0 .1.06.2.16.23l7.5 3.04.09.04v-9.38L3.5 7.75v9.08zm9.35 3.27l7.5-3.04c.09-.04.15-.13.15-.23V7.77l-7.75 3v9.37l.1-.04z",
    fill: primaryFill
  }));
};

export const Box24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Box24RegularIcon, 'Box24Regular');

const BoxArrowLeft20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M17.42 5L14.38 6.2l-7.5-3 1.82-.73a3.5 3.5 0 012.6 0l5.76 2.3c.13.06.25.13.36.21zM10 7.95l3.03-1.21-7.5-3-2.59 1.03a1.5 1.5 0 00-.36.21L10 7.96zM2 6.18c0-.11.01-.22.04-.33L9.5 8.84v3.36a5.48 5.48 0 000 4.6v.93a3.5 3.5 0 01-.8-.21l-5.76-2.3a1.5 1.5 0 01-.94-1.4V6.18zm16 0v4.08a5.48 5.48 0 00-7.5.46V8.84l7.46-2.99c.03.1.04.22.04.33zm1 8.32a4.5 4.5 0 10-9 0 4.5 4.5 0 009 0zm-6.86-.35l2-2a.5.5 0 11.71.7L13.71 14h2.79a.5.5 0 010 1h-2.8l1.15 1.15a.5.5 0 11-.7.7l-2-2a.5.5 0 01-.15-.35.5.5 0 01.14-.35z",
    fill: primaryFill
  }));
};

export const BoxArrowLeft20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/BoxArrowLeft20FilledIcon, 'BoxArrowLeft20Filled');

const BoxArrowLeft20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M11.3 2.48a3.5 3.5 0 00-2.6 0l-5.76 2.3A1.5 1.5 0 002 6.18v7.64c0 .62.37 1.17.94 1.4l5.76 2.3c.44.17.9.26 1.38.25a5.5 5.5 0 01-.62-1.06 2.5 2.5 0 01-.39-.12l-5.76-2.3a.5.5 0 01-.31-.47V6.24l6.5 2.6v3.36c.25-.54.6-1.04 1-1.48V8.84l6.5-2.6V9.6c.36.18.7.4 1 .66V6.18a1.5 1.5 0 00-.94-1.4l-5.76-2.3zm-2.23.93a2.5 2.5 0 011.86 0l5.22 2.09-2.27.91-6.16-2.46 1.35-.54zm-2.7 1.08l6.16 2.46L10 7.96 3.85 5.5l2.53-1.01zm12.63 10a4.5 4.5 0 10-9 0 4.5 4.5 0 009 0zm-6.86-.34l2-2a.5.5 0 11.71.7L13.71 14h2.79a.5.5 0 010 1h-2.8l1.15 1.15a.5.5 0 11-.7.7l-2-2a.5.5 0 01-.15-.35.5.5 0 01.14-.35z",
    fill: primaryFill
  }));
};

export const BoxArrowLeft20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/BoxArrowLeft20RegularIcon, 'BoxArrowLeft20Regular');

const BoxArrowLeft24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M13.4 2.51a3.75 3.75 0 00-2.8 0l-2.2.9L18 7.12l3.37-1.3c-.14-.12-.3-.2-.46-.28l-7.5-3.04zM22 7.2l-9.25 3.58v2.3A6.48 6.48 0 0122 12.8V7.19zm-10.75 8.52v-4.94L2 7.19v9.64c0 .71.43 1.35 1.1 1.62l7.5 3.04c.2.09.43.15.65.2v-2.4a6.5 6.5 0 010-3.58zM2.63 5.83L12 9.45l3.92-1.52-9.55-3.7L3.1 5.54c-.17.07-.32.16-.46.28zM17.5 12a5.5 5.5 0 100 11 5.5 5.5 0 000-11zM14 17.46l.02-.09.02-.06.03-.07.03-.04 2.55-2.55.07-.06a.5.5 0 01.7.7l-.07.06L15.71 17h5.38c.2.05.36.2.4.41l.01.1v.08a.5.5 0 01-.41.4L21 18h-5.3l1.65 1.65.06.07a.5.5 0 010 .57l-.06.06-.07.06a.5.5 0 01-.56 0l-.07-.06-2.52-2.5-.04-.06-.04-.08-.03-.08-.01-.06-.01-.06v-.05z",
    fill: primaryFill
  }));
};

export const BoxArrowLeft24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/BoxArrowLeft24FilledIcon, 'BoxArrowLeft24Filled');

const BoxArrowLeft24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10.6 2.51c.9-.36 1.9-.36 2.8 0l7.5 3.04c.67.27 1.1.91 1.1 1.62v5.64a6.52 6.52 0 00-1.5-1.08V7.77l-7.75 3v2.3a6.5 6.5 0 00-1.5 2.64v-4.95L3.5 7.75v9.08c0 .1.06.2.16.23l7.5 3.04.09.04.19.07.18.06c.25.53.56 1.01.94 1.45-.66.1-1.34.02-1.97-.23l-7.5-3.04C2.43 18.18 2 17.54 2 16.83V7.17c0-.7.43-1.35 1.1-1.62l7.5-3.04zm2.25 1.4a2.25 2.25 0 00-1.7 0l-1.9.77 7.52 2.93 2.67-1.03-6.6-2.68zM4.59 6.55L12 9.45l2.7-1.04L7.21 5.5 4.59 6.56zM17.5 12a5.5 5.5 0 100 11 5.5 5.5 0 000-11zM14 17.46l.02-.09.02-.06.03-.07.03-.04 2.55-2.55.07-.06a.5.5 0 01.7.7l-.07.06L15.71 17h5.38c.2.05.36.2.4.41l.01.1v.08a.5.5 0 01-.41.4L21 18h-5.3l1.65 1.65.06.07a.5.5 0 010 .57l-.06.06-.07.06a.5.5 0 01-.56 0l-.07-.06-2.52-2.5-.04-.06-.04-.08-.03-.08-.01-.06-.01-.06v-.05z",
    fill: primaryFill
  }));
};

export const BoxArrowLeft24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/BoxArrowLeft24RegularIcon, 'BoxArrowLeft24Regular');

const BoxArrowUp20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M17.42 5L14.38 6.2l-7.5-3 1.82-.73a3.5 3.5 0 012.6 0l5.76 2.3c.13.06.25.13.36.21zM10 7.95l3.03-1.21-7.5-3-2.59 1.03a1.5 1.5 0 00-.36.21L10 7.96zM2 6.18c0-.11.01-.22.04-.33L9.5 8.84v3.36a5.48 5.48 0 000 4.6v.93a3.5 3.5 0 01-.8-.21l-5.76-2.3a1.5 1.5 0 01-.94-1.4V6.18zm16 0v4.08a5.48 5.48 0 00-7.5.46V8.84l7.46-2.99c.03.1.04.22.04.33zM14.5 19a4.5 4.5 0 100-9 4.5 4.5 0 000 9zm.35-6.86l2 2a.5.5 0 11-.7.71L15 13.71v2.79a.5.5 0 01-1 0v-2.8l-1.15 1.15a.5.5 0 11-.7-.7l2-2a.5.5 0 01.35-.15.5.5 0 01.35.14z",
    fill: primaryFill
  }));
};

export const BoxArrowUp20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/BoxArrowUp20FilledIcon, 'BoxArrowUp20Filled');

const BoxArrowUp20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M11.3 2.48a3.5 3.5 0 00-2.6 0l-5.76 2.3A1.5 1.5 0 002 6.18v7.64c0 .62.37 1.17.94 1.4l5.76 2.3c.44.17.9.26 1.38.25a5.5 5.5 0 01-.62-1.06 2.5 2.5 0 01-.39-.12l-5.76-2.3a.5.5 0 01-.31-.47V6.24l6.5 2.6v3.36c.25-.54.6-1.04 1-1.48V8.84l6.5-2.6V9.6c.36.18.7.4 1 .66V6.18a1.5 1.5 0 00-.94-1.4l-5.76-2.3zm-2.23.93a2.5 2.5 0 011.86 0l5.22 2.09-2.27.91-6.16-2.46 1.35-.54zm-2.7 1.08l6.16 2.46L10 7.96 3.85 5.5l2.53-1.01zm8.13 14.5a4.5 4.5 0 100-8.99 4.5 4.5 0 000 9zm.35-6.85l2 2a.5.5 0 11-.7.71L15 13.71v2.79a.5.5 0 01-1 0v-2.8l-1.15 1.15a.5.5 0 11-.7-.7l2-2a.5.5 0 01.35-.15.5.5 0 01.35.14z",
    fill: primaryFill
  }));
};

export const BoxArrowUp20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/BoxArrowUp20RegularIcon, 'BoxArrowUp20Regular');

const BoxArrowUp24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M13.4 2.51a3.75 3.75 0 00-2.8 0l-2.2.9L18 7.12l3.37-1.3c-.14-.12-.3-.2-.46-.28l-7.5-3.04zM22 7.2l-9.25 3.58v2.3A6.48 6.48 0 0122 12.8V7.19zm-10.75 3.58v4.94a6.5 6.5 0 000 3.58v2.4a3.75 3.75 0 01-.66-.2l-7.5-3.04C2.43 18.18 2 17.54 2 16.83V7.19l9.25 3.58zM2.63 5.83L12 9.45l3.92-1.52-9.55-3.7L3.1 5.54c-.17.07-.32.16-.46.28zM23 17.5a5.5 5.5 0 10-11 0 5.5 5.5 0 0011 0zM17.54 14l.09.02.06.02.07.03.05.04 2.54 2.54.06.07a.5.5 0 01-.7.7l-.06-.07L18 15.71v5.38a.5.5 0 01-.41.4l-.09.01h-.09a.5.5 0 01-.4-.4L17 21v-5.3l-1.65 1.65-.07.06a.5.5 0 01-.56 0l-.07-.06-.06-.06a.5.5 0 010-.57l.06-.07 2.5-2.51.07-.05.07-.04.08-.03.06-.01h.11z",
    fill: primaryFill
  }));
};

export const BoxArrowUp24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/BoxArrowUp24FilledIcon, 'BoxArrowUp24Filled');

const BoxArrowUp24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10.6 2.51c.9-.36 1.9-.36 2.8 0l7.5 3.04c.67.27 1.1.91 1.1 1.62v5.64a6.52 6.52 0 00-1.5-1.08V7.77l-7.75 3v2.3a6.5 6.5 0 00-1.5 2.64v-4.95L3.5 7.75v9.08c0 .1.06.2.16.23l7.5 3.04.09.04.19.07.18.06c.25.53.56 1.01.94 1.45-.66.1-1.34.02-1.97-.23l-7.5-3.04C2.43 18.18 2 17.54 2 16.83V7.17c0-.7.43-1.35 1.1-1.62l7.5-3.04zm2.25 1.4a2.25 2.25 0 00-1.7 0l-1.9.77 7.52 2.93 2.67-1.03-6.6-2.68zM4.59 6.55L12 9.45l2.7-1.04L7.21 5.5 4.59 6.56zM23 17.5a5.5 5.5 0 10-11 0 5.5 5.5 0 0011 0zM17.54 14l.09.02.06.02.07.03.05.04 2.54 2.54.06.07a.5.5 0 01-.7.7l-.06-.07L18 15.71v5.38a.5.5 0 01-.41.4l-.09.01h-.09a.5.5 0 01-.4-.4L17 21v-5.3l-1.65 1.65-.07.06a.5.5 0 01-.56 0l-.07-.06-.06-.06a.5.5 0 010-.57l.06-.07 2.5-2.51.07-.05.07-.04.08-.03.06-.01h.11z",
    fill: primaryFill
  }));
};

export const BoxArrowUp24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/BoxArrowUp24RegularIcon, 'BoxArrowUp24Regular');

const BoxCheckmark20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M17.42 5L14.38 6.2l-7.5-3 1.82-.73a3.5 3.5 0 012.6 0l5.76 2.3c.13.06.25.13.36.21zM10 7.95l3.03-1.21-7.5-3-2.59 1.03a1.5 1.5 0 00-.36.21L10 7.96zM2 6.18c0-.11.01-.22.04-.33L9.5 8.84v3.36a5.48 5.48 0 000 4.6v.93a3.5 3.5 0 01-.8-.21l-5.76-2.3a1.5 1.5 0 01-.94-1.4V6.18zm16 0v4.08a5.48 5.48 0 00-7.5.46V8.84l7.46-2.99c.03.1.04.22.04.33zM14.5 19a4.5 4.5 0 100-9 4.5 4.5 0 000 9zm-1-3.7l2.65-2.65a.5.5 0 01.7.7l-3 3a.5.5 0 01-.7 0l-1-1a.5.5 0 01.7-.7l.65.64z",
    fill: primaryFill
  }));
};

export const BoxCheckmark20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/BoxCheckmark20FilledIcon, 'BoxCheckmark20Filled');

const BoxCheckmark20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M11.3 2.48a3.5 3.5 0 00-2.6 0l-5.76 2.3A1.5 1.5 0 002 6.18v7.64c0 .62.37 1.17.94 1.4l5.76 2.3c.44.17.9.26 1.38.25a5.5 5.5 0 01-.62-1.06 2.5 2.5 0 01-.39-.12l-5.76-2.3a.5.5 0 01-.31-.47V6.24l6.5 2.6v3.36c.25-.54.6-1.04 1-1.48V8.84l6.5-2.6V9.6c.36.18.7.4 1 .66V6.18a1.5 1.5 0 00-.94-1.4l-5.76-2.3zm-2.23.93a2.5 2.5 0 011.86 0l5.22 2.09-2.27.91-6.16-2.46 1.35-.54zm-2.7 1.08l6.16 2.46L10 7.96 3.85 5.5l2.53-1.01zm8.13 14.5a4.5 4.5 0 100-8.99 4.5 4.5 0 000 9zm-1-3.7l2.65-2.64a.5.5 0 01.7.7l-3 3a.5.5 0 01-.7 0l-1-1a.5.5 0 01.7-.7l.65.64z",
    fill: primaryFill
  }));
};

export const BoxCheckmark20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/BoxCheckmark20RegularIcon, 'BoxCheckmark20Regular');

const BoxCheckmark24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M13.4 2.51a3.75 3.75 0 00-2.8 0l-2.2.9L18 7.12l3.37-1.3c-.14-.12-.3-.2-.46-.28l-7.5-3.04zM22 7.2l-9.25 3.58v2.3A6.48 6.48 0 0122 12.8V7.19zm-10.75 3.58v4.94a6.5 6.5 0 000 3.58v2.4a3.75 3.75 0 01-.66-.2l-7.5-3.04C2.43 18.18 2 17.54 2 16.83V7.19l9.25 3.58zM2.63 5.83L12 9.45l3.92-1.52-9.55-3.7L3.1 5.54c-.17.07-.32.16-.46.28zM17.5 23a5.5 5.5 0 100-11 5.5 5.5 0 000 11zm2.65-7.85a.5.5 0 01.7.7l-4 4a.5.5 0 01-.7 0l-2-2a.5.5 0 01.7-.7l1.65 1.64 3.65-3.64z",
    fill: primaryFill
  }));
};

export const BoxCheckmark24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/BoxCheckmark24FilledIcon, 'BoxCheckmark24Filled');

const BoxCheckmark24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10.6 2.51c.9-.36 1.9-.36 2.8 0l7.5 3.04c.67.27 1.1.91 1.1 1.62v5.64a6.52 6.52 0 00-1.5-1.08V7.77l-7.75 3v2.3a6.5 6.5 0 00-1.5 2.64v-4.95L3.5 7.75v9.08c0 .1.06.2.16.23l7.5 3.04.09.04.19.07.18.06c.25.53.56 1.01.94 1.45-.66.1-1.34.02-1.97-.23l-7.5-3.04C2.43 18.18 2 17.54 2 16.83V7.17c0-.7.43-1.35 1.1-1.62l7.5-3.04zm2.25 1.4a2.25 2.25 0 00-1.7 0l-1.9.77 7.52 2.93 2.67-1.03-6.6-2.68zM4.59 6.55L12 9.45l2.7-1.04L7.21 5.5 4.59 6.56zM17.5 23a5.5 5.5 0 100-11 5.5 5.5 0 000 11zm-1-4.2l3.65-3.65a.5.5 0 01.7.7l-4 4a.5.5 0 01-.7 0l-2-2a.5.5 0 01.7-.7l1.65 1.64z",
    fill: primaryFill
  }));
};

export const BoxCheckmark24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/BoxCheckmark24RegularIcon, 'BoxCheckmark24Regular');

const BoxDismiss20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M17.42 5L14.38 6.2l-7.5-3 1.82-.73a3.5 3.5 0 012.6 0l5.76 2.3c.13.06.25.13.36.21zM10 7.95l3.03-1.21-7.5-3-2.59 1.03a1.5 1.5 0 00-.36.21L10 7.96zm-7.96-2.1c-.03.1-.04.2-.04.32v7.64c0 .62.37 1.17.94 1.4l5.76 2.3c.26.1.53.17.8.21v-.94a5.48 5.48 0 010-4.58V8.84L2.04 5.85zM18 6.17v4.08a5.48 5.48 0 00-7.5.46V8.84l7.46-2.99c.03.1.04.22.04.33zm1 8.32a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-2.65-1.15a.5.5 0 00-.7-.7l-1.15 1.14-1.15-1.14a.5.5 0 00-.7.7l1.14 1.15-1.14 1.15a.5.5 0 00.7.7l1.15-1.14 1.15 1.14a.5.5 0 00.7-.7l-1.14-1.15 1.14-1.15z",
    fill: primaryFill
  }));
};

export const BoxDismiss20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/BoxDismiss20FilledIcon, 'BoxDismiss20Filled');

const BoxDismiss20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M11.3 2.48a3.5 3.5 0 00-2.6 0l-5.76 2.3A1.5 1.5 0 002 6.18v7.64c0 .62.37 1.17.94 1.4l5.76 2.3c.44.17.9.26 1.38.25a5.5 5.5 0 01-.62-1.06 2.51 2.51 0 01-.39-.12l-5.76-2.3a.5.5 0 01-.31-.47V6.24l6.5 2.6v3.37c.25-.55.6-1.05 1-1.49V8.84l6.5-2.6V9.6c.36.18.7.4 1 .66V6.18a1.5 1.5 0 00-.94-1.4l-5.76-2.3zm-2.23.93a2.5 2.5 0 011.86 0l5.22 2.09-2.27.91-6.16-2.46 1.35-.54zm-2.7 1.08l6.16 2.46L10 7.96 3.85 5.5l2.53-1.01zM19 14.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-2.65-1.15a.5.5 0 00-.7-.7l-1.15 1.14-1.15-1.14a.5.5 0 00-.7.7l1.14 1.15-1.14 1.15a.5.5 0 00.7.7l1.15-1.14 1.15 1.14a.5.5 0 00.7-.7l-1.14-1.15 1.14-1.15z",
    fill: primaryFill
  }));
};

export const BoxDismiss20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/BoxDismiss20RegularIcon, 'BoxDismiss20Regular');

const BoxDismiss24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M13.4 2.51a3.75 3.75 0 00-2.8 0l-2.2.9L18 7.12l3.37-1.3c-.14-.12-.3-.2-.46-.28l-7.5-3.04zM22 7.2l-9.25 3.58v2.3A6.48 6.48 0 0122 12.8V7.19zm-10.75 3.58v4.94a6.5 6.5 0 000 3.58v2.4a3.75 3.75 0 01-.66-.2l-7.5-3.04C2.43 18.18 2 17.54 2 16.83V7.19l9.25 3.58zM2.63 5.83L12 9.45l3.92-1.52-9.55-3.7L3.1 5.54c-.17.07-.32.16-.46.28zM23 17.5a5.5 5.5 0 11-11 0 5.5 5.5 0 0111 0zm-7.15-2.35a.5.5 0 00-.7.7l1.64 1.65-1.64 1.65a.5.5 0 00.7.7l1.65-1.64 1.65 1.64a.5.5 0 00.7-.7l-1.64-1.65 1.64-1.65a.5.5 0 00-.7-.7l-1.65 1.64-1.65-1.64z",
    fill: primaryFill
  }));
};

export const BoxDismiss24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/BoxDismiss24FilledIcon, 'BoxDismiss24Filled');

const BoxDismiss24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10.6 2.51c.9-.36 1.9-.36 2.8 0l7.5 3.04c.67.27 1.1.91 1.1 1.62v5.64a6.52 6.52 0 00-1.5-1.08V7.77l-7.75 3v2.3a6.5 6.5 0 00-1.5 2.64v-4.95L3.5 7.75v9.08c0 .1.06.2.16.23l7.5 3.04.09.04v-.85c.26.91.71 1.73 1.3 2.43-.65.1-1.33.02-1.96-.23l-7.5-3.04C2.43 18.18 2 17.54 2 16.83V7.17c0-.7.43-1.35 1.1-1.62l7.5-3.04zm2.25 1.4a2.25 2.25 0 00-1.7 0l-1.9.77 7.52 2.93 2.67-1.03-6.6-2.68zm1.84 4.5L7.21 5.5 4.6 6.56 12 9.45l2.7-1.04zM23 17.5a5.5 5.5 0 11-11 0 5.5 5.5 0 0111 0zm-7.15-2.36a.5.5 0 00-.7.7l1.64 1.65-1.64 1.65a.5.5 0 00.7.7l1.65-1.64 1.65 1.64a.5.5 0 00.7-.7l-1.64-1.65 1.64-1.65a.5.5 0 00-.7-.7l-1.65 1.64-1.65-1.64z",
    fill: primaryFill
  }));
};

export const BoxDismiss24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/BoxDismiss24RegularIcon, 'BoxDismiss24Regular');

const BoxEdit20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M17.42 5L14.38 6.2l-7.5-3 1.82-.73a3.5 3.5 0 012.6 0l5.76 2.3c.13.06.25.13.36.21zM10 7.95l3.03-1.21-7.5-3-2.59 1.03a1.5 1.5 0 00-.36.21L10 7.96zm-7.96-2.1c-.03.1-.04.2-.04.32v7.64c0 .62.37 1.17.94 1.4l5.76 2.3.36.12.37-1.49.07-.23V8.84L2.04 5.85zM18 6.17v2.95a2.87 2.87 0 00-2.9.71l-4.6 4.6v-5.6l7.46-2.99c.03.1.04.22.04.33zm-7.02 9.2l4.83-4.83a1.87 1.87 0 112.64 2.64l-4.83 4.83a2.2 2.2 0 01-1.02.58l-1.5.37a.89.89 0 01-1.07-1.07l.37-1.5c.1-.39.3-.74.58-1.02z",
    fill: primaryFill
  }));
};

export const BoxEdit20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/BoxEdit20FilledIcon, 'BoxEdit20Filled');

const BoxEdit20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M11.3 2.48a3.5 3.5 0 00-2.6 0l-5.76 2.3A1.5 1.5 0 002 6.18v7.64c0 .62.37 1.17.94 1.4l5.76 2.3.36.12.24-.97a2.53 2.53 0 01-.23-.08l-5.76-2.3a.5.5 0 01-.31-.47V6.24l6.5 2.6v7.08c.16-.47.42-.9.77-1.25l.23-.23v-5.6l6.5-2.6V9c.34-.01.68.03 1 .13V6.18a1.5 1.5 0 00-.94-1.4l-5.76-2.3zm-2.23.93a2.5 2.5 0 011.86 0l5.22 2.09-2.27.91-6.16-2.46 1.35-.54zm-2.7 1.08l6.16 2.46L10 7.96 3.85 5.5l2.53-1.01zm4.61 10.89l4.83-4.83a1.87 1.87 0 112.64 2.64l-4.83 4.83a2.2 2.2 0 01-1.02.58l-1.5.37a.89.89 0 01-1.07-1.07l.37-1.5c.1-.39.3-.74.58-1.02z",
    fill: primaryFill
  }));
};

export const BoxEdit20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/BoxEdit20RegularIcon, 'BoxEdit20Regular');

const BoxEdit24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M13.4 2.51a3.75 3.75 0 00-2.8 0l-2.2.9L18 7.12l3.37-1.3c-.14-.12-.3-.2-.46-.28l-7.5-3.04zM22 7.2l-9.25 3.58v6.84l5.64-5.65a3.29 3.29 0 013.61-.7V7.2zm-10.75 3.58v9.9l-.19.74-.04.22a3.73 3.73 0 01-.43-.14l-7.5-3.04C2.43 18.18 2 17.54 2 16.83V7.19l9.25 3.58zM2.63 5.83L12 9.45l3.92-1.52-9.55-3.7L3.1 5.54c-.17.07-.32.16-.46.28zm16.47 6.84l-5.9 5.9c-.35.35-.6.78-.7 1.25l-.47 1.83c-.2.8.53 1.52 1.32 1.32l1.83-.46c.47-.12.9-.36 1.25-.7l5.9-5.9a2.29 2.29 0 00-3.23-3.24z",
    fill: primaryFill
  }));
};

export const BoxEdit24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/BoxEdit24FilledIcon, 'BoxEdit24Filled');

const BoxEdit24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M13.4 2.51a3.75 3.75 0 00-2.8 0L3.1 5.55c-.67.27-1.1.91-1.1 1.62v9.66c0 .71.43 1.35 1.1 1.62l7.5 3.04c.13.06.27.1.42.14l.04-.22.46-1.83c.16-.65.5-1.24.97-1.71l.26-.26v-6.84l7.75-3v3.24a3.3 3.3 0 011.5.25V7.17c0-.7-.43-1.35-1.1-1.62l-7.5-3.04zm-2.25 1.4a2.25 2.25 0 011.7 0l6.59 2.67-2.67 1.03-7.53-2.93 1.91-.78zM7.21 5.5l7.48 2.9L12 9.46 4.6 6.56 7.21 5.5zM3.5 7.75l7.75 3.01v9.38a2.13 2.13 0 01-.1-.04l-7.5-3.04a.25.25 0 01-.15-.23V7.75zm15.6 4.92l-5.9 5.9c-.35.35-.6.78-.7 1.25l-.47 1.83c-.2.8.53 1.52 1.32 1.32l1.83-.46c.47-.12.9-.36 1.25-.7l5.9-5.9a2.29 2.29 0 00-3.23-3.24z",
    fill: primaryFill
  }));
};

export const BoxEdit24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/BoxEdit24RegularIcon, 'BoxEdit24Regular');

const BoxMultiple20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M13.58 2.38a3 3 0 00-2.16 0L7.96 3.7A1.5 1.5 0 007 5.1v1.1a4 4 0 011.94.23l3.46 1.34A2.5 2.5 0 0114 10.1v4.78c0 .2-.03.4-.07.6l3.1-1.2c.59-.22.97-.78.97-1.4V5.1a1.5 1.5 0 00-.96-1.4l-3.46-1.33zm1.87 2.15a.5.5 0 11.35.94l-2.76 1.06a1.5 1.5 0 01-1.08 0L9.2 5.47a.5.5 0 01.35-.94l2.77 1.07a.5.5 0 00.36 0l2.77-1.07zM6.42 7.38a3 3 0 012.16 0l3.46 1.33c.58.22.96.78.96 1.4v4.78a1.5 1.5 0 01-.96 1.4l-3.46 1.33a3 3 0 01-2.16 0l-3.46-1.33a1.5 1.5 0 01-.96-1.4V10.1c0-.62.38-1.18.96-1.4l3.46-1.33zm4.67 2.91a.5.5 0 00-.64-.28L7.5 11.14 4.55 10a.5.5 0 10-.35.93L7 12.02v2.49a.5.5 0 001 0V12l2.8-1.07a.5.5 0 00.3-.65z",
    fill: primaryFill
  }));
};

export const BoxMultiple20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/BoxMultiple20FilledIcon, 'BoxMultiple20Filled');

const BoxMultiple20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M13.58 2.38a3 3 0 00-2.16 0L7.96 3.71A1.5 1.5 0 007 5.11v1.1a4 4 0 011 0v-1.1c0-.2.13-.4.32-.47l3.46-1.33a2 2 0 011.44 0l3.46 1.33c.2.08.32.26.32.47v7.78c0 .2-.13.4-.32.47L14 14.39v.5c0 .2-.03.4-.07.6l3.1-1.2c.59-.22.97-.78.97-1.4V5.11a1.5 1.5 0 00-.96-1.4l-3.46-1.33zm2.51 2.92a.5.5 0 00-.64-.3l-2.77 1.07a.5.5 0 01-.36 0L9.55 5.01a.5.5 0 10-.35.93l2.76 1.07c.35.13.73.13 1.08 0l2.76-1.07a.5.5 0 00.3-.64zm-5 5a.5.5 0 00-.64-.3L7.5 11.15l-2.95-1.13a.5.5 0 00-.35.93L7 12.02v2.49a.5.5 0 101 0v-2.49l2.8-1.08a.5.5 0 00.3-.64zM8.58 7.38a3 3 0 00-2.16 0L2.96 8.71a1.5 1.5 0 00-.96 1.4v4.78c0 .62.38 1.18.96 1.4l3.46 1.33a3 3 0 002.16 0l3.46-1.33c.58-.22.96-.78.96-1.4v-4.78a1.5 1.5 0 00-.96-1.4L8.58 7.38zm-1.8.93a2 2 0 011.44 0l3.46 1.33c.2.08.32.26.32.47v4.78c0 .2-.13.4-.32.47l-3.46 1.33a2 2 0 01-1.44 0l-3.46-1.33a.5.5 0 01-.32-.47v-4.78c0-.2.13-.4.32-.47l3.46-1.33z",
    fill: primaryFill
  }));
};

export const BoxMultiple20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/BoxMultiple20RegularIcon, 'BoxMultiple20Regular');

const BoxMultiple24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M16.3 2.33a3.75 3.75 0 00-2.6 0l-4.3 1.6c-.7.25-1.15.9-1.15 1.63v2.8c.8-.13 1.63-.05 2.4.23l4.3 1.6c1.08.4 1.8 1.42 1.8 2.57v5.67c0 .32-.06.64-.16.93l4.02-1.49c.68-.25 1.14-.9 1.14-1.64V5.56c0-.73-.46-1.38-1.14-1.64L16.3 2.33zm-4.53 4.88a.75.75 0 11.49-1.42l2.66.92c.05.02.1.02.16 0l2.65-.92a.75.75 0 11.5 1.42l-2.66.92c-.37.13-.77.13-1.14 0l-2.66-.92zM7.7 9.53a3.75 3.75 0 012.6 0l4.3 1.6c.7.24 1.15.9 1.15 1.63v5.67c0 .73-.46 1.39-1.14 1.64l-4.31 1.6c-.84.3-1.76.3-2.6 0l-4.3-1.6a1.75 1.75 0 01-1.15-1.64v-5.67c0-.73.46-1.39 1.14-1.64l4.31-1.6zM5.3 13.7c-.13.4.08.82.47.96l2.48.85v2.7a.75.75 0 001.5 0v-2.7l2.47-.85a.75.75 0 00-.49-1.42L9 14.2l-2.74-.95a.75.75 0 00-.95.46z",
    fill: primaryFill
  }));
};

export const BoxMultiple24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/BoxMultiple24FilledIcon, 'BoxMultiple24Filled');

const BoxMultiple24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M15.78 3.74a2.25 2.25 0 00-1.56 0l-4.3 1.59a.25.25 0 00-.17.23v2.8c-.5-.08-1-.08-1.5 0v-2.8c0-.73.46-1.38 1.14-1.64l4.31-1.59a3.75 3.75 0 012.6 0l4.3 1.6c.7.25 1.15.9 1.15 1.63v10.67c0 .74-.46 1.4-1.14 1.64l-4.02 1.49c.1-.3.16-.6.16-.93v-.73l3.34-1.23c.1-.04.16-.13.16-.24V5.56c0-.1-.07-.2-.16-.23l-4.31-1.6zm-4.01 3.93a.75.75 0 11.49-1.42l2.66.92c.05.02.1.02.16 0l2.65-.92a.75.75 0 11.5 1.42l-2.66.92c-.37.12-.77.12-1.14 0l-2.66-.92zm-6 7a.75.75 0 01.49-1.42L9 14.2l2.73-.95a.75.75 0 11.5 1.42l-2.48.85v2.7a.75.75 0 01-1.5 0v-2.7l-2.48-.85zm4.53-5.14a3.75 3.75 0 00-2.6 0l-4.3 1.6c-.7.24-1.15.9-1.15 1.63v5.67c0 .73.46 1.39 1.14 1.64l4.31 1.6c.84.3 1.76.3 2.6 0l4.3-1.6c.7-.25 1.15-.9 1.15-1.64v-5.67c0-.73-.46-1.39-1.14-1.64l-4.31-1.6zm-2.08 1.4c.5-.18 1.06-.18 1.56 0l4.3 1.6c.1.03.17.13.17.23v5.67c0 .1-.07.2-.16.24l-4.31 1.59c-.5.18-1.06.18-1.56 0l-4.3-1.6a.25.25 0 01-.17-.23v-5.67c0-.1.07-.2.16-.23l4.31-1.6z",
    fill: primaryFill
  }));
};

export const BoxMultiple24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/BoxMultiple24RegularIcon, 'BoxMultiple24Regular');

const BoxMultipleArrowLeft20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M13.58 2.38a3 3 0 00-2.16 0L7.96 3.7A1.5 1.5 0 007 5.1v1.1a4 4 0 011.94.23l3.46 1.34c.61.23 1.1.7 1.36 1.27a5.55 5.55 0 014.24 1.2V5.12a1.5 1.5 0 00-.96-1.4l-3.46-1.33zm1.87 2.15a.5.5 0 11.35.94l-2.76 1.06a1.5 1.5 0 01-1.08 0L9.2 5.47a.5.5 0 01.35-.94l2.77 1.07a.5.5 0 00.36 0l2.77-1.07zm-3.41 4.18c.3.11.54.32.71.57-.62.21-1.2.53-1.7.93a.5.5 0 00-.6-.2L7.5 11.14 4.55 10a.5.5 0 10-.35.93L7 12.02v2.49a.5.5 0 001 0V12l2.09-.8a5.48 5.48 0 00-.39 5.98l-1.12.43a3 3 0 01-2.16 0l-3.46-1.33a1.5 1.5 0 01-.96-1.4V10.1c0-.62.38-1.18.96-1.4l3.46-1.33a3 3 0 012.16 0l3.46 1.33zM19 14.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-6.85-.35a.5.5 0 00-.15.35.5.5 0 00.15.35l2 2a.5.5 0 00.7-.7L13.71 15h2.79a.5.5 0 100-1h-2.8l1.15-1.15a.5.5 0 00-.7-.7l-2 2z",
    fill: primaryFill
  }));
};

export const BoxMultipleArrowLeft20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/BoxMultipleArrowLeft20FilledIcon, 'BoxMultipleArrowLeft20Filled');

const BoxMultipleArrowLeft20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M13.58 2.38a3 3 0 00-2.16 0L7.96 3.7A1.5 1.5 0 007 5.1v1.1a4 4 0 011 0V5.1c0-.2.13-.4.32-.47l3.46-1.33a2 2 0 011.44 0l3.46 1.33c.2.08.32.26.32.47V9.6c.36.18.7.4 1 .66V5.1a1.5 1.5 0 00-.96-1.4l-3.46-1.33zM12.04 8.7c.3.11.54.32.71.57-.33.11-.65.26-.95.43a.5.5 0 00-.12-.07L8.22 8.31a2 2 0 00-1.44 0L3.32 9.64a.5.5 0 00-.32.47v4.78c0 .2.13.4.32.47l3.46 1.33a2 2 0 001.44 0l1.07-.42c.11.32.25.63.41.92l-1.12.43a3 3 0 01-2.16 0l-3.46-1.33a1.5 1.5 0 01-.96-1.4V10.1c0-.62.38-1.18.96-1.4l3.46-1.33a3 3 0 012.16 0l3.46 1.33zm-1.6 1.3a.5.5 0 01.61.2c-.36.3-.68.63-.96 1l-2.09.8v2.5a.5.5 0 01-1 0V12l-2.8-1.07a.5.5 0 11.35-.93l2.95 1.13L10.45 10zm5.65-4.72a.5.5 0 00-.64-.28l-2.77 1.06a.5.5 0 01-.36 0L9.55 5.01a.5.5 0 00-.35.93L11.96 7c.35.14.73.14 1.08 0l2.76-1.06a.5.5 0 00.3-.65zM19 14.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-6.85-.34a.5.5 0 00-.15.35.5.5 0 00.15.35l2 2a.5.5 0 00.7-.7L13.71 15h2.79a.5.5 0 100-1h-2.8l1.15-1.15a.5.5 0 00-.7-.7l-2 2z",
    fill: primaryFill
  }));
};

export const BoxMultipleArrowLeft20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/BoxMultipleArrowLeft20RegularIcon, 'BoxMultipleArrowLeft20Regular');

const BoxMultipleArrowLeft24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M16.3 2.33a3.75 3.75 0 00-2.6 0l-4.3 1.6c-.7.25-1.15.9-1.15 1.63v2.8c.8-.13 1.63-.05 2.4.23l4.3 1.6c.52.18.95.52 1.26.94a6.53 6.53 0 015.54 1.45V5.56c0-.73-.46-1.38-1.14-1.64L16.3 2.33zm-4.53 4.88a.75.75 0 11.49-1.42l2.66.92c.05.02.1.02.16 0l2.65-.92a.75.75 0 11.5 1.42l-2.66.92c-.37.13-.77.13-1.14 0l-2.66-.92zm2.84 3.91c.2.08.38.18.53.32a6.52 6.52 0 00-2.68 1.95.75.75 0 00-.73-.14L9 14.2l-2.74-.95a.75.75 0 10-.5 1.42l2.49.85v2.7a.75.75 0 001.5 0v-2.7l1.79-.62a6.48 6.48 0 00.5 6.12l-1.74.65c-.84.3-1.76.3-2.6 0l-4.3-1.6a1.75 1.75 0 01-1.15-1.64v-5.67c0-.73.46-1.39 1.14-1.64l4.31-1.6a3.75 3.75 0 012.6 0l4.3 1.6zM23 17.5a5.5 5.5 0 11-11 0 5.5 5.5 0 0111 0zm-2.5.5a.5.5 0 100-1h-4.8l1.65-1.65a.5.5 0 00-.7-.7l-2.5 2.5a.5.5 0 000 .7l2.5 2.5a.5.5 0 00.7-.7L15.71 18h4.79z",
    fill: primaryFill
  }));
};

export const BoxMultipleArrowLeft24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/BoxMultipleArrowLeft24FilledIcon, 'BoxMultipleArrowLeft24Filled');

const BoxMultipleArrowLeft24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M15.78 3.74a2.25 2.25 0 00-1.56 0l-4.3 1.59a.25.25 0 00-.17.23v2.8c-.5-.08-1-.08-1.5 0v-2.8c0-.73.46-1.38 1.14-1.64l4.31-1.59a3.75 3.75 0 012.6 0l4.3 1.6c.7.25 1.15.9 1.15 1.63v7.02a6.5 6.5 0 00-1.5-.97V5.56c0-.1-.07-.2-.16-.23l-4.31-1.6zm-1.17 7.38c.2.08.38.18.53.32-.57.22-1.1.52-1.58.9l-3.78-1.4a2.25 2.25 0 00-1.56 0l-4.3 1.59a.25.25 0 00-.17.23v5.67c0 .1.07.2.16.24l4.31 1.59c.5.18 1.06.18 1.56 0l1.6-.59c.16.48.39.93.66 1.35l-1.74.65c-.84.3-1.76.3-2.6 0l-4.3-1.6a1.75 1.75 0 01-1.15-1.64v-5.67c0-.73.46-1.39 1.14-1.64l4.31-1.6a3.75 3.75 0 012.6 0l4.3 1.6zm-2.88 2.13a.75.75 0 01.73.14 6.5 6.5 0 00-.92 1.51l-1.79.62v2.7a.75.75 0 01-1.5 0v-2.7l-2.48-.85a.75.75 0 01.49-1.42L9 14.2l2.73-.95zm.04-5.58a.75.75 0 11.49-1.42l2.66.92c.05.02.1.02.16 0l2.65-.92a.75.75 0 11.5 1.42l-2.66.92c-.37.12-.77.12-1.14 0l-2.66-.92zM23 17.5a5.5 5.5 0 11-11 0 5.5 5.5 0 0111 0zm-2.5.5a.5.5 0 100-1h-4.8l1.65-1.65a.5.5 0 00-.7-.7l-2.5 2.5a.5.5 0 000 .7l2.5 2.5a.5.5 0 00.7-.7L15.71 18h4.79z",
    fill: primaryFill
  }));
};

export const BoxMultipleArrowLeft24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/BoxMultipleArrowLeft24RegularIcon, 'BoxMultipleArrowLeft24Regular');

const BoxMultipleArrowRight20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M13.58 2.38a3 3 0 00-2.16 0L7.96 3.7A1.5 1.5 0 007 5.1v1.1a4 4 0 011.94.23l3.46 1.34c.61.23 1.1.7 1.36 1.27a5.55 5.55 0 014.24 1.2V5.12a1.5 1.5 0 00-.96-1.4l-3.46-1.33zm1.87 2.15a.5.5 0 11.35.94l-2.76 1.06a1.5 1.5 0 01-1.08 0L9.2 5.47a.5.5 0 01.35-.94l2.77 1.07a.5.5 0 00.36 0l2.77-1.07zm-3.41 4.18c.3.11.54.32.71.57-.62.21-1.2.53-1.7.93a.5.5 0 00-.6-.2L7.5 11.14 4.55 10a.5.5 0 10-.35.93L7 12.02v2.49a.5.5 0 001 0V12l2.09-.8a5.48 5.48 0 00-.39 5.98l-1.12.43a3 3 0 01-2.16 0l-3.46-1.33a1.5 1.5 0 01-.96-1.4V10.1c0-.62.38-1.18.96-1.4l3.46-1.33a3 3 0 012.16 0l3.46 1.33zM19 14.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-2.15.35a.5.5 0 00.15-.35.5.5 0 00-.15-.35l-2-2a.5.5 0 00-.7.7L15.29 14H12.5a.5.5 0 000 1h2.8l-1.15 1.15a.5.5 0 00.7.7l2-2z",
    fill: primaryFill
  }));
};

export const BoxMultipleArrowRight20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/BoxMultipleArrowRight20FilledIcon, 'BoxMultipleArrowRight20Filled');

const BoxMultipleArrowRight20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M13.58 2.38a3 3 0 00-2.16 0L7.96 3.7A1.5 1.5 0 007 5.1v1.1a4 4 0 011 0V5.1c0-.2.13-.4.32-.47l3.46-1.33a2 2 0 011.44 0l3.46 1.33c.2.08.32.26.32.47V9.6c.36.18.7.4 1 .66V5.1a1.5 1.5 0 00-.96-1.4l-3.46-1.33zM12.04 8.7c.3.11.54.32.71.57-.33.11-.65.26-.95.43a.5.5 0 00-.12-.07L8.22 8.31a2 2 0 00-1.44 0L3.32 9.64a.5.5 0 00-.32.47v4.78c0 .2.13.4.32.47l3.46 1.33a2 2 0 001.44 0l1.07-.42c.11.32.25.63.41.92l-1.12.43a3 3 0 01-2.16 0l-3.46-1.33a1.5 1.5 0 01-.96-1.4V10.1c0-.62.38-1.18.96-1.4l3.46-1.33a3 3 0 012.16 0l3.46 1.33zm-1.6 1.3a.5.5 0 01.61.2c-.36.3-.68.63-.96 1l-2.09.8v2.5a.5.5 0 01-1 0V12l-2.8-1.07a.5.5 0 11.35-.93l2.95 1.13L10.45 10zm5.65-4.72a.5.5 0 00-.64-.28l-2.77 1.06a.5.5 0 01-.36 0L9.55 5.01a.5.5 0 00-.35.93L11.96 7c.35.14.73.14 1.08 0l2.76-1.06a.5.5 0 00.3-.65zM19 14.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-2.15.36a.5.5 0 00.15-.35.5.5 0 00-.15-.35l-2-2a.5.5 0 00-.7.7L15.29 14H12.5a.5.5 0 000 1h2.8l-1.15 1.15a.5.5 0 00.7.7l2-2z",
    fill: primaryFill
  }));
};

export const BoxMultipleArrowRight20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/BoxMultipleArrowRight20RegularIcon, 'BoxMultipleArrowRight20Regular');

const BoxMultipleArrowRight24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M16.3 2.33a3.75 3.75 0 00-2.6 0l-4.3 1.6c-.7.25-1.15.9-1.15 1.63v2.8c.8-.13 1.63-.05 2.4.23l4.3 1.6c.52.18.95.52 1.26.94a6.53 6.53 0 015.54 1.45V5.56c0-.73-.46-1.38-1.14-1.64L16.3 2.33zm-4.53 4.88a.75.75 0 11.49-1.42l2.66.92c.05.02.1.02.16 0l2.65-.92a.75.75 0 11.5 1.42l-2.66.92c-.37.13-.77.13-1.14 0l-2.66-.92zm2.84 3.91c.2.08.38.18.53.32a6.52 6.52 0 00-2.68 1.95.75.75 0 00-.73-.14L9 14.2l-2.74-.95a.75.75 0 10-.5 1.42l2.49.85v2.7a.75.75 0 001.5 0v-2.7l1.79-.62a6.48 6.48 0 00.5 6.12l-1.74.65c-.84.3-1.76.3-2.6 0l-4.3-1.6a1.75 1.75 0 01-1.15-1.64v-5.67c0-.73.46-1.39 1.14-1.64l4.31-1.6a3.75 3.75 0 012.6 0l4.3 1.6zM23 17.5a5.5 5.5 0 11-11 0 5.5 5.5 0 0111 0zm-8.5-.5a.5.5 0 000 1h4.8l-1.65 1.65a.5.5 0 00.7.7l2.5-2.5a.5.5 0 000-.7l-2.5-2.5a.5.5 0 00-.7.7L19.29 17H14.5z",
    fill: primaryFill
  }));
};

export const BoxMultipleArrowRight24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/BoxMultipleArrowRight24FilledIcon, 'BoxMultipleArrowRight24Filled');

const BoxMultipleArrowRight24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M15.78 3.74a2.25 2.25 0 00-1.56 0l-4.3 1.59a.25.25 0 00-.17.23v2.8c-.5-.08-1-.08-1.5 0v-2.8c0-.73.46-1.38 1.14-1.64l4.31-1.59a3.75 3.75 0 012.6 0l4.3 1.6c.7.25 1.15.9 1.15 1.63v7.02a6.5 6.5 0 00-1.5-.97V5.56c0-.1-.07-.2-.16-.23l-4.31-1.6zm-1.17 7.38c.2.08.38.18.53.32-.57.22-1.1.52-1.58.9l-3.78-1.4a2.25 2.25 0 00-1.56 0l-4.3 1.59a.25.25 0 00-.17.23v5.67c0 .1.07.2.16.24l4.31 1.59c.5.18 1.06.18 1.56 0l1.6-.59c.16.48.39.93.66 1.35l-1.74.65c-.84.3-1.76.3-2.6 0l-4.3-1.6a1.75 1.75 0 01-1.15-1.64v-5.67c0-.73.46-1.39 1.14-1.64l4.31-1.6a3.75 3.75 0 012.6 0l4.3 1.6zm-2.88 2.13a.75.75 0 01.73.14 6.5 6.5 0 00-.92 1.51l-1.79.62v2.7a.75.75 0 01-1.5 0v-2.7l-2.48-.85a.75.75 0 01.49-1.42L9 14.2l2.73-.95zm.04-5.58a.75.75 0 11.49-1.42l2.66.92c.05.02.1.02.16 0l2.65-.92a.75.75 0 11.5 1.42l-2.66.92c-.37.12-.77.12-1.14 0l-2.66-.92zM23 17.5a5.5 5.5 0 11-11 0 5.5 5.5 0 0111 0zm-8.5-.5a.5.5 0 000 1h4.8l-1.65 1.65a.5.5 0 00.7.7l2.5-2.5a.5.5 0 000-.7l-2.5-2.5a.5.5 0 00-.7.7L19.29 17H14.5z",
    fill: primaryFill
  }));
};

export const BoxMultipleArrowRight24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/BoxMultipleArrowRight24RegularIcon, 'BoxMultipleArrowRight24Regular');

const BoxMultipleCheckmark20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M13.58 2.38a3 3 0 00-2.16 0L7.96 3.7A1.5 1.5 0 007 5.1v1.1a4 4 0 011.94.23l3.46 1.34c.61.23 1.1.7 1.36 1.27a5.55 5.55 0 014.24 1.2V5.12a1.5 1.5 0 00-.96-1.4l-3.46-1.33zm1.87 2.15a.5.5 0 11.35.94l-2.76 1.06a1.5 1.5 0 01-1.08 0L9.2 5.47a.5.5 0 01.35-.94l2.77 1.07a.5.5 0 00.36 0l2.77-1.07zm-3.41 4.18c.3.11.54.32.71.57-.62.21-1.2.53-1.7.93a.5.5 0 00-.6-.2L7.5 11.14 4.55 10a.5.5 0 10-.35.93L7 12.02v2.49a.5.5 0 001 0V12l2.09-.8a5.48 5.48 0 00-.39 5.98l-1.12.43a3 3 0 01-2.16 0l-3.46-1.33a1.5 1.5 0 01-.96-1.4V10.1c0-.62.38-1.18.96-1.4l3.46-1.33a3 3 0 012.16 0l3.46 1.33zM19 14.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-2.15-1.85a.5.5 0 00-.7 0l-2.65 2.64-.65-.64a.5.5 0 00-.7.7l1 1c.2.2.5.2.7 0l3-3a.5.5 0 000-.7z",
    fill: primaryFill
  }));
};

export const BoxMultipleCheckmark20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/BoxMultipleCheckmark20FilledIcon, 'BoxMultipleCheckmark20Filled');

const BoxMultipleCheckmark20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M13.58 2.38a3 3 0 00-2.16 0L7.96 3.7A1.5 1.5 0 007 5.1v1.1a4 4 0 011 0V5.1c0-.2.13-.4.32-.47l3.46-1.33a2 2 0 011.44 0l3.46 1.33c.2.08.32.26.32.47V9.6c.36.18.7.4 1 .66V5.1a1.5 1.5 0 00-.96-1.4l-3.46-1.33zM12.04 8.7c.3.11.54.32.71.57-.33.11-.65.26-.95.43a.5.5 0 00-.12-.07L8.22 8.31a2 2 0 00-1.44 0L3.32 9.64a.5.5 0 00-.32.47v4.78c0 .2.13.4.32.47l3.46 1.33a2 2 0 001.44 0l1.07-.42c.11.32.25.63.41.92l-1.12.43a3 3 0 01-2.16 0l-3.46-1.33a1.5 1.5 0 01-.96-1.4V10.1c0-.62.38-1.18.96-1.4l3.46-1.33a3 3 0 012.16 0l3.46 1.33zm-1.6 1.3a.5.5 0 01.61.2c-.36.3-.68.63-.96 1l-2.09.8v2.5a.5.5 0 01-1 0V12l-2.8-1.07a.5.5 0 11.35-.93l2.95 1.13L10.45 10zm5.65-4.72a.5.5 0 00-.64-.28l-2.77 1.06a.5.5 0 01-.36 0L9.55 5.01a.5.5 0 00-.35.93L11.96 7c.35.14.73.14 1.08 0l2.76-1.06a.5.5 0 00.3-.65zM19 14.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-2.15-1.84a.5.5 0 00-.7 0l-2.65 2.64-.65-.64a.5.5 0 00-.7.7l1 1c.2.2.5.2.7 0l3-3a.5.5 0 000-.7z",
    fill: primaryFill
  }));
};

export const BoxMultipleCheckmark20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/BoxMultipleCheckmark20RegularIcon, 'BoxMultipleCheckmark20Regular');

const BoxMultipleCheckmark24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M16.3 2.33a3.75 3.75 0 00-2.6 0l-4.3 1.6c-.7.25-1.15.9-1.15 1.63v2.8c.8-.13 1.63-.05 2.4.23l4.3 1.6c.52.18.95.52 1.26.94a6.53 6.53 0 015.54 1.45V5.56c0-.73-.46-1.38-1.14-1.64L16.3 2.33zm-4.53 4.88a.75.75 0 11.49-1.42l2.66.92c.05.02.1.02.16 0l2.65-.92a.75.75 0 11.5 1.42l-2.66.92c-.37.13-.77.13-1.14 0l-2.66-.92zm2.84 3.91c.2.08.38.18.53.32a6.52 6.52 0 00-2.68 1.95.75.75 0 00-.73-.14L9 14.2l-2.74-.95a.75.75 0 10-.5 1.42l2.49.85v2.7a.75.75 0 001.5 0v-2.7l1.79-.62a6.48 6.48 0 00.5 6.12l-1.74.65c-.84.3-1.76.3-2.6 0l-4.3-1.6a1.75 1.75 0 01-1.15-1.64v-5.67c0-.73.46-1.39 1.14-1.64l4.31-1.6a3.75 3.75 0 012.6 0l4.3 1.6zM23 17.5a5.5 5.5 0 11-11 0 5.5 5.5 0 0111 0zm-2.15-2.35a.5.5 0 00-.7 0l-3.65 3.64-1.65-1.64a.5.5 0 00-.7.7l2 2c.2.2.5.2.7 0l4-4a.5.5 0 000-.7z",
    fill: primaryFill
  }));
};

export const BoxMultipleCheckmark24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/BoxMultipleCheckmark24FilledIcon, 'BoxMultipleCheckmark24Filled');

const BoxMultipleCheckmark24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M15.78 3.74a2.25 2.25 0 00-1.56 0l-4.3 1.59a.25.25 0 00-.17.23v2.8c-.5-.08-1-.08-1.5 0v-2.8c0-.73.46-1.38 1.14-1.64l4.31-1.59a3.75 3.75 0 012.6 0l4.3 1.6c.7.25 1.15.9 1.15 1.63v7.02a6.5 6.5 0 00-1.5-.97V5.56c0-.1-.07-.2-.16-.23l-4.31-1.6zm-1.17 7.38c.2.08.38.18.53.32-.57.22-1.1.52-1.58.9l-3.78-1.4a2.25 2.25 0 00-1.56 0l-4.3 1.59a.25.25 0 00-.17.23v5.67c0 .1.07.2.16.24l4.31 1.59c.5.18 1.06.18 1.56 0l1.6-.59c.16.48.39.93.66 1.35l-1.74.65c-.84.3-1.76.3-2.6 0l-4.3-1.6a1.75 1.75 0 01-1.15-1.64v-5.67c0-.73.46-1.39 1.14-1.64l4.31-1.6a3.75 3.75 0 012.6 0l4.3 1.6zm-2.88 2.13a.75.75 0 01.73.14 6.5 6.5 0 00-.92 1.51l-1.79.62v2.7a.75.75 0 01-1.5 0v-2.7l-2.48-.85a.75.75 0 01.49-1.42L9 14.2l2.73-.95zm.04-5.58a.75.75 0 11.49-1.42l2.66.92c.05.02.1.02.16 0l2.65-.92a.75.75 0 11.5 1.42l-2.66.92c-.37.12-.77.12-1.14 0l-2.66-.92zM23 17.5a5.5 5.5 0 11-11 0 5.5 5.5 0 0111 0zm-2.15-2.35a.5.5 0 00-.7 0l-3.65 3.64-1.65-1.64a.5.5 0 00-.7.7l2 2c.2.2.5.2.7 0l4-4a.5.5 0 000-.7z",
    fill: primaryFill
  }));
};

export const BoxMultipleCheckmark24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/BoxMultipleCheckmark24RegularIcon, 'BoxMultipleCheckmark24Regular');

const BoxMultipleSearch20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M11.42 2.38a3 3 0 012.16 0l3.46 1.33c.58.22.96.78.96 1.4v7.78c0 .07 0 .15-.02.22A4.5 4.5 0 0013.74 9a2.5 2.5 0 00-1.34-1.23L8.94 6.44A4 4 0 007 6.21V5.1c0-.62.38-1.18.96-1.4l3.46-1.33zm4.67 2.44a.5.5 0 00-.64-.29L12.68 5.6a.5.5 0 01-.36 0L9.55 4.53a.5.5 0 00-.35.94l2.76 1.06c.35.13.73.13 1.08 0l2.76-1.06a.5.5 0 00.3-.65zM12.6 9.09a1.5 1.5 0 00-.56-.38L8.58 7.38a3 3 0 00-2.16 0L2.96 8.7A1.5 1.5 0 002 10.1v4.78c0 .62.38 1.18.96 1.4l3.46 1.33a3 3 0 002.16 0l1.94-.75a4.49 4.49 0 01-1.02-5.43l-1.5.58v2.49a.5.5 0 01-1 0V12l-2.8-1.07a.5.5 0 11.35-.93l2.95 1.13L10.45 10a.5.5 0 01.25-.03c.54-.44 1.2-.75 1.9-.9zm3.7 6.5a3.5 3.5 0 10-.7.7l2.55 2.56a.5.5 0 00.7-.7L16.3 15.6zm-.3-2.1a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0z",
    fill: primaryFill
  }));
};

export const BoxMultipleSearch20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/BoxMultipleSearch20FilledIcon, 'BoxMultipleSearch20Filled');

const BoxMultipleSearch20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M11.42 2.38a3 3 0 012.16 0l3.46 1.33c.58.22.96.78.96 1.4v7.78c0 .07 0 .15-.02.22a4.48 4.48 0 00-.98-2.44V5.11a.5.5 0 00-.32-.47l-3.46-1.33a2 2 0 00-1.44 0L8.32 4.64a.5.5 0 00-.32.47v1.1a4 4 0 00-1 0V5.1c0-.62.38-1.18.96-1.4l3.46-1.33zm1.18 6.7a1.5 1.5 0 00-.56-.37L8.58 7.38a3 3 0 00-2.16 0L2.96 8.7A1.5 1.5 0 002 10.1v4.78c0 .62.38 1.18.96 1.4l3.46 1.33a3 3 0 002.16 0l1.94-.75c-.27-.23-.5-.5-.71-.8l-1.6.62a2 2 0 01-1.43 0l-3.46-1.33a.5.5 0 01-.32-.47V10.1c0-.2.13-.4.32-.47l3.46-1.33a2 2 0 011.44 0l3.16 1.22c.38-.2.79-.35 1.22-.44zm-1.9.9a.5.5 0 00-.25.03L7.5 11.14 4.55 10a.5.5 0 10-.35.93L7 12.02v2.49a.5.5 0 001 0V12l1.5-.57c.29-.57.7-1.07 1.2-1.46zM15.45 5a.5.5 0 11.35.93L13.04 7a1.5 1.5 0 01-1.08 0L9.2 5.94A.5.5 0 019.55 5l2.77 1.06a.5.5 0 00.36 0l2.77-1.06zm.85 10.59a3.5 3.5 0 10-.7.7l2.55 2.55a.5.5 0 00.7-.7L16.3 15.6zm-.3-2.1a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0z",
    fill: primaryFill
  }));
};

export const BoxMultipleSearch20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/BoxMultipleSearch20RegularIcon, 'BoxMultipleSearch20Regular');

const BoxMultipleSearch24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M13.7 2.33a3.75 3.75 0 012.6 0l4.3 1.6c.7.25 1.15.9 1.15 1.63v9.3A5.5 5.5 0 0016.12 11c-.3-.36-.7-.65-1.17-.83l-4.3-1.59a4.75 4.75 0 00-2.4-.23v-2.8c0-.73.46-1.38 1.14-1.64l4.31-1.59zm-2.4 3.92c-.13.4.08.82.47.96l2.66.92c.37.13.77.13 1.14 0l2.65-.92a.75.75 0 00-.49-1.42l-2.65.92a.25.25 0 01-.16 0l-2.66-.92a.75.75 0 00-.95.46zm3.57 5a1.74 1.74 0 00-.26-.13l-4.31-1.6a3.75 3.75 0 00-2.6 0l-4.3 1.6c-.7.25-1.15.91-1.15 1.64v5.67c0 .73.46 1.39 1.14 1.64l4.31 1.6c.84.3 1.76.3 2.6 0l2.64-.98a5.49 5.49 0 01-1.74-5.67l-1.45.5v2.7a.75.75 0 01-1.5 0v-2.7l-2.48-.85a.75.75 0 01.49-1.42L9 14.2l2.73-.95a.75.75 0 01.36-.03 5.5 5.5 0 012.78-1.98zm5.3 7.86a4.5 4.5 0 10-1.06 1.06l2.61 2.6a.75.75 0 001.06-1.05l-2.61-2.61zm-.67-2.61a3 3 0 11-6 0 3 3 0 016 0z",
    fill: primaryFill
  }));
};

export const BoxMultipleSearch24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/BoxMultipleSearch24FilledIcon, 'BoxMultipleSearch24Filled');

const BoxMultipleSearch24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M14.22 3.74c.5-.19 1.06-.19 1.56 0l4.3 1.59c.1.04.17.13.17.23v6.92a5.5 5.5 0 011.5 2.37V5.56c0-.73-.46-1.38-1.14-1.64L16.3 2.33a3.75 3.75 0 00-2.6 0l-4.3 1.6c-.7.25-1.15.9-1.15 1.63v2.8c.5-.08 1-.08 1.5 0v-2.8c0-.1.07-.2.16-.23l4.31-1.6zm.65 7.5a1.74 1.74 0 00-.26-.12l-4.31-1.6a3.75 3.75 0 00-2.6 0l-4.3 1.6c-.7.25-1.15.91-1.15 1.64v5.67c0 .73.46 1.39 1.14 1.64l4.31 1.6c.84.3 1.76.3 2.6 0l2.64-.98c-.41-.35-.77-.75-1.06-1.2l-2.1.77c-.5.18-1.06.18-1.56 0l-4.3-1.6a.25.25 0 01-.17-.23v-5.67c0-.1.07-.2.16-.23l4.31-1.6c.5-.18 1.06-.18 1.56 0l3.33 1.24c.52-.41 1.12-.73 1.76-.93zm-2.78 1.98a.75.75 0 00-.36.03L9 14.2l-2.74-.95a.75.75 0 10-.5 1.42l2.49.85v2.7a.75.75 0 001.5 0v-2.7l1.45-.5c.18-.66.49-1.27.89-1.8zm-.78-6.5c-.14.38.07.81.46.95l2.66.92c.37.12.77.12 1.14 0l2.65-.92a.75.75 0 00-.49-1.42l-2.65.92a.25.25 0 01-.16 0l-2.66-.92a.75.75 0 00-.95.46zm8.86 12.39a4.5 4.5 0 10-1.06 1.06l2.61 2.6a.75.75 0 001.06-1.05l-2.61-2.61zm-.67-2.61a3 3 0 11-6 0 3 3 0 016 0z",
    fill: primaryFill
  }));
};

export const BoxMultipleSearch24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/BoxMultipleSearch24RegularIcon, 'BoxMultipleSearch24Regular');

const BoxSearch20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10 7.96l3.03-1.21-7.5-3-2.59 1.03a1.5 1.5 0 00-.36.21L10 7.96zm-7.96-2.1c-.03.1-.04.2-.04.32v7.64c0 .62.37 1.17.94 1.4l5.76 2.3c.26.1.53.17.8.21v-2.17a4.48 4.48 0 010-4.12v-2.6L2.04 5.85zM18 13.42V6.18c0-.11-.01-.22-.04-.33L10.5 8.84v1.3a4.5 4.5 0 017.5 3.28zm-.58-8.44l-3.04 1.22-7.5-3 1.82-.73a3.5 3.5 0 012.6 0l5.76 2.3c.13.06.25.13.36.21zM16.3 15.6a3.5 3.5 0 10-.7.7l2.55 2.56a.5.5 0 10.7-.7L16.3 15.6zm-.3-2.1a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0z",
    fill: primaryFill
  }));
};

export const BoxSearch20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/BoxSearch20FilledIcon, 'BoxSearch20Filled');

const BoxSearch20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M11.3 2.48a3.5 3.5 0 00-2.6 0l-5.76 2.3A1.5 1.5 0 002 6.18v7.64c0 .62.37 1.17.94 1.4l5.76 2.3a3.5 3.5 0 002.6 0l.1-.04a4.51 4.51 0 01-.98-.7c-.32.1-.67.08-.98-.04l-.3-.12-.07-.03-5.76-2.3a.5.5 0 01-.31-.47V6.24l6.5 2.6v2.6c.25-.5.6-.93 1-1.3v-1.3l6.5-2.6v4.43c.63.77 1 1.76 1 2.83V6.18a1.5 1.5 0 00-.94-1.4l-5.76-2.3zm-2.23.93a2.5 2.5 0 011.86 0l5.22 2.09-2.27.91-6.16-2.46 1.35-.54zm-2.7 1.08l6.16 2.46L10 7.96 3.85 5.5l2.53-1.01zm9.93 11.1a3.5 3.5 0 10-.7.7l2.55 2.56a.5.5 0 00.7-.7L16.3 15.6zM16 13.5a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0z",
    fill: primaryFill
  }));
};

export const BoxSearch20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/BoxSearch20RegularIcon, 'BoxSearch20Regular');

const BoxSearch24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M13.4 2.51a3.75 3.75 0 00-2.8 0l-2.2.9L18 7.12l3.37-1.3c-.14-.12-.3-.2-.46-.28l-7.5-3.04zM22 7.2l-9.25 3.58v1.7A5.5 5.5 0 0122 16.45V7.2zm-10.75 7.67a5.5 5.5 0 000 3.28v3.55a3.75 3.75 0 01-.66-.2l-7.5-3.04C2.43 18.18 2 17.54 2 16.83V7.19l9.25 3.58v4.09zM2.63 5.83L12 9.45l3.92-1.52-9.55-3.7L3.1 5.54c-.17.07-.32.16-.46.28zM20.17 19.1a4.5 4.5 0 10-1.06 1.06l2.61 2.61a.75.75 0 101.06-1.06l-2.61-2.61zm-.67-2.6a3 3 0 11-6 0 3 3 0 016 0z",
    fill: primaryFill
  }));
};

export const BoxSearch24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/BoxSearch24FilledIcon, 'BoxSearch24Filled');

const BoxSearch24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10.6 2.51c.9-.36 1.9-.36 2.8 0l7.5 3.04c.67.27 1.1.91 1.1 1.62v9.33c0-1.46-.57-2.79-1.5-3.77V7.77l-7.75 3v1.7a5.5 5.5 0 00-1.5 2.39v-4.1L3.5 7.75v9.08c0 .1.06.2.16.23l7.5 3.04.07.03.2.08c.34.14.7.15 1.04.04.4.42.86.78 1.37 1.07l-.43.17c-.9.37-1.92.37-2.82 0l-7.5-3.04C2.43 18.18 2 17.54 2 16.83V7.17c0-.7.43-1.35 1.1-1.62l7.5-3.04zm2.25 1.4a2.25 2.25 0 00-1.7 0l-1.9.77 7.52 2.93 2.67-1.03-6.6-2.68zm1.84 4.5L7.21 5.5 4.6 6.56 12 9.45l2.7-1.04zM22 16.56v-.06.06zm-1.83 2.55a4.5 4.5 0 10-1.06 1.06l2.61 2.61a.75.75 0 101.06-1.06l-2.61-2.61zm-.67-2.6a3 3 0 11-6 0 3 3 0 016 0z",
    fill: primaryFill
  }));
};

export const BoxSearch24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/BoxSearch24RegularIcon, 'BoxSearch24Regular');

const BoxToolbox20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M17.42 5L14.38 6.2l-7.5-3 1.82-.73a3.5 3.5 0 012.6 0l5.76 2.3c.13.06.25.13.36.21zM10 7.95l3.03-1.21-7.5-3-2.59 1.03a1.5 1.5 0 00-.36.21L10 7.96zm-7.96-2.1c-.03.1-.04.2-.04.32v7.64c0 .62.37 1.17.94 1.4l5.76 2.3.3.1V13.5c0-.56.19-1.08.5-1.5V8.84L2.04 5.85zM18 6.17v4.87h-.04A2.5 2.5 0 0015.5 9h-2a2.5 2.5 0 00-2.46 2.04c-.19.04-.37.1-.54.17V8.84l7.46-2.99c.03.1.04.22.04.33zM12 12v-.5c0-.83.67-1.5 1.5-1.5h2c.83 0 1.5.67 1.5 1.5v.5h.5c.83 0 1.5.67 1.5 1.5V15h-2v-.5a.5.5 0 00-1 0v.5h-3v-.5a.5.5 0 00-1 0v.5h-2v-1.5c0-.83.67-1.5 1.5-1.5h.5zm1-.5v.5h3v-.5a.5.5 0 00-.5-.5h-2a.5.5 0 00-.5.5zm4 5V16h2v1.5c0 .83-.67 1.5-1.5 1.5h-6a1.5 1.5 0 01-1.5-1.5V16h2v.5a.5.5 0 101 0V16h3v.5a.5.5 0 101 0z",
    fill: primaryFill
  }));
};

export const BoxToolbox20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/BoxToolbox20FilledIcon, 'BoxToolbox20Filled');

const BoxToolbox20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M11.3 2.48a3.5 3.5 0 00-2.6 0l-5.76 2.3A1.5 1.5 0 002 6.18v7.64c0 .62.37 1.17.94 1.4l5.76 2.3.3.1v-1.06L3.31 14.3a.5.5 0 01-.31-.47V6.24l6.5 2.6V12c.26-.34.6-.62 1-.8V8.85l6.5-2.6V9.5c.5.37.84.91.96 1.54l.04.01V6.18a1.5 1.5 0 00-.94-1.4l-5.76-2.3zm-2.23.93a2.5 2.5 0 011.86 0l5.22 2.09-2.27.91-6.16-2.46 1.35-.54zm-2.7 1.08l6.16 2.46L10 7.96 3.85 5.5l2.53-1.01zm5.63 7.5v-.5c0-.82.67-1.49 1.5-1.49h2c.83 0 1.5.67 1.5 1.5v.5h.5c.83 0 1.5.67 1.5 1.5V15h-2v-.5a.5.5 0 00-1 0v.5h-3v-.5a.5.5 0 00-1 0v.5h-2v-1.5c0-.83.67-1.5 1.5-1.5h.5zm3.5-1h-2a.5.5 0 00-.5.5v.5h3v-.5a.5.5 0 00-.5-.5zM17 16.5V16h2v1.5c0 .83-.67 1.5-1.5 1.5h-6a1.5 1.5 0 01-1.5-1.5V16h2v.5a.5.5 0 101 0V16h3v.5a.5.5 0 101 0z",
    fill: primaryFill
  }));
};

export const BoxToolbox20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/BoxToolbox20RegularIcon, 'BoxToolbox20Regular');

const BoxToolbox24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M13.4 2.51a3.75 3.75 0 00-2.8 0l-2.2.9L18 7.12l3.37-1.3c-.14-.12-.3-.2-.46-.28l-7.5-3.04zM22 7.2l-9.25 3.58v3.35l.25-.07V14a2.75 2.75 0 012.75-2.75h3.5A2.75 2.75 0 0122 14v-6.8zm-10.75 3.58v4.64c-.16.33-.25.7-.25 1.1v5.12a3.73 3.73 0 01-.4-.14l-7.5-3.04c-.67-.27-1.1-.91-1.1-1.62V7.19l9.25 3.58zM2.63 5.83L12 9.45l3.92-1.52-9.55-3.7L3.1 5.54c-.17.07-.32.16-.46.28zM14 15h-.5c-.83 0-1.5.67-1.5 1.5V18h2.5v-.25a.75.75 0 011.5 0V18h3v-.25a.75.75 0 011.5 0V18H23v-1.5c0-.83-.67-1.5-1.5-1.5H21v-1c0-.97-.78-1.75-1.75-1.75h-3.5c-.97 0-1.75.78-1.75 1.75v1zm1.5-1c0-.14.11-.25.25-.25h3.5c.14 0 .25.11.25.25v1h-4v-1zM12 21.5v-2h2.5v.75a.75.75 0 001.5 0v-.75h3v.75a.75.75 0 001.5 0v-.75H23v2c0 .83-.67 1.5-1.5 1.5h-8a1.5 1.5 0 01-1.5-1.5z",
    fill: primaryFill
  }));
};

export const BoxToolbox24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/BoxToolbox24FilledIcon, 'BoxToolbox24Filled');

const BoxToolbox24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M13.4 2.51a3.75 3.75 0 00-2.8 0L3.1 5.55c-.67.27-1.1.91-1.1 1.62v9.66c0 .71.43 1.35 1.1 1.62l7.5 3.04.4.14V20.04l-7.34-2.98a.25.25 0 01-.16-.23V7.75l7.75 3.01v4.65a2.5 2.5 0 011.5-1.3v-3.34l7.75-3v3.78C21.39 12 22 12.93 22 14V7.17c0-.7-.43-1.35-1.1-1.62l-7.5-3.04zm-2.25 1.4a2.25 2.25 0 011.7 0l6.59 2.67-2.67 1.03-7.53-2.93 1.91-.78zM7.21 5.5l7.48 2.9L12 9.46 4.6 6.56 7.21 5.5zM14 15h-.5c-.83 0-1.5.67-1.5 1.5V18h2.5v-.25a.75.75 0 011.5 0V18h3v-.25a.75.75 0 011.5 0V18H23v-1.5c0-.83-.67-1.5-1.5-1.5H21v-1c0-.97-.78-1.75-1.75-1.75h-3.5c-.97 0-1.75.78-1.75 1.75v1zm1.5-1c0-.14.11-.25.25-.25h3.5c.14 0 .25.11.25.25v1h-4v-1zM12 21.5v-2h2.5v.75a.75.75 0 001.5 0v-.75h3v.75a.75.75 0 001.5 0v-.75H23v2c0 .83-.67 1.5-1.5 1.5h-8a1.5 1.5 0 01-1.5-1.5z",
    fill: primaryFill
  }));
};

export const BoxToolbox24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/BoxToolbox24RegularIcon, 'BoxToolbox24Regular');

const Braces16FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4.75 2C3.51 2 2.5 3 2.5 4.25V6c0 .55-.01.76-.07.9-.03.09-.1.22-.52.43a.75.75 0 000 1.34c.41.2.49.34.52.42.06.15.07.36.07.91v1.75c0 1.24 1 2.25 2.25 2.25a.75.75 0 000-1.5.75.75 0 01-.75-.75V9.93c0-.44 0-.95-.18-1.4A1.9 1.9 0 003.5 8c.13-.16.24-.33.32-.53C4 7.02 4 6.5 4 6.07V4.26c0-.41.34-.75.75-.75a.75.75 0 000-1.5zm6.5 0c1.24 0 2.25 1 2.25 2.25V6c0 .55.01.76.07.9.03.09.1.22.52.43a.75.75 0 010 1.34c-.41.2-.49.34-.52.42-.06.15-.07.36-.07.91v1.75c0 1.24-1 2.25-2.25 2.25a.75.75 0 010-1.5c.41 0 .75-.34.75-.75V9.93c0-.44 0-.95.18-1.4.08-.2.19-.37.32-.53a1.9 1.9 0 01-.32-.53 3.73 3.73 0 01-.18-1.4V4.26a.75.75 0 00-.75-.75.75.75 0 010-1.5z",
    fill: primaryFill
  }));
};

export const Braces16Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Braces16FilledIcon, 'Braces16Filled');

const Braces16RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5 2a2 2 0 00-2 2v2c0 .53 0 .8-.09 1-.06.16-.2.33-.63.55a.5.5 0 000 .9c.44.22.57.4.63.55.08.2.09.47.09 1v2c0 1.1.9 2 2 2a.5.5 0 000-1 1 1 0 01-1-1V9.94c0-.45 0-.91-.16-1.31-.1-.25-.24-.45-.44-.63.2-.18.34-.38.44-.63.16-.4.16-.86.16-1.3V4a1 1 0 011-1 .5.5 0 000-1zm6 0a2 2 0 012 2v2c0 .53 0 .8.09 1 .06.16.2.33.63.55a.5.5 0 010 .9c-.44.22-.57.4-.63.55-.08.2-.09.47-.09 1v2a2 2 0 01-2 2 .5.5 0 010-1 1 1 0 001-1V9.94c0-.45 0-.91.16-1.31.1-.25.24-.45.44-.63-.2-.18-.34-.38-.44-.63-.16-.4-.16-.86-.16-1.3V4a1 1 0 00-1-1 .5.5 0 010-1z",
    fill: primaryFill
  }));
};

export const Braces16Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Braces16RegularIcon, 'Braces16Regular');

const Braces20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3.5 5.75A2.75 2.75 0 016.23 3a.75.75 0 110 1.5C5.55 4.5 5 5.06 5 5.75L5 8.38c0 .6-.21 1.17-.58 1.62.37.45.58 1.02.58 1.62v2.63c0 .7.56 1.25 1.25 1.25a.75.75 0 010 1.5 2.75 2.75 0 01-2.75-2.75v-2.63c0-.4-.22-.76-.57-.94a.75.75 0 010-1.36c.35-.18.57-.54.57-.94V5.75zm13 0A2.75 2.75 0 0013.77 3a.75.75 0 000 1.5c.69 0 1.25.56 1.25 1.25L15 8.38c0 .6.21 1.17.58 1.62a2.56 2.56 0 00-.58 1.62v2.63c0 .7-.56 1.25-1.25 1.25a.75.75 0 000 1.5 2.75 2.75 0 002.75-2.75v-2.63c0-.4.22-.76.57-.94a.75.75 0 000-1.36 1.06 1.06 0 01-.57-.94V5.75z",
    fill: primaryFill
  }));
};

export const Braces20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Braces20FilledIcon, 'Braces20Filled');

const Braces20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6.5 3A2.5 2.5 0 004 5.5v2.88c0 .5-.28.95-.72 1.17a.5.5 0 000 .9c.44.22.72.68.72 1.17v2.88A2.5 2.5 0 006.5 17a.5.5 0 000-1A1.5 1.5 0 015 14.5v-2.88c0-.62-.24-1.2-.66-1.62.42-.42.66-1 .66-1.62V5.5C5 4.67 5.67 4 6.5 4a.5.5 0 000-1zm7 0A2.5 2.5 0 0116 5.5v2.88c0 .5.28.95.72 1.17a.5.5 0 010 .9 1.3 1.3 0 00-.72 1.17v2.88a2.5 2.5 0 01-2.5 2.5.5.5 0 010-1c.83 0 1.5-.67 1.5-1.5v-2.88c0-.62.24-1.2.66-1.62A2.3 2.3 0 0115 8.38V5.5c0-.83-.67-1.5-1.5-1.5a.5.5 0 010-1z",
    fill: primaryFill
  }));
};

export const Braces20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Braces20RegularIcon, 'Braces20Regular');

const Braces24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4 6a3 3 0 013-3 1 1 0 010 2 1 1 0 00-1 1v3.94A3 3 0 015.18 12 3 3 0 016 14.06V18a1 1 0 001 1 1 1 0 110 2 3 3 0 01-3-3v-3.94a1 1 0 00-.76-.97l-.48-.12a1 1 0 010-1.94l.48-.12A1 1 0 004 9.94V6zm16 0a3 3 0 00-3-3 1 1 0 100 2 1 1 0 011 1v3.94a3 3 0 00.82 2.06 3 3 0 00-.82 2.06V18a1 1 0 01-1 1 1 1 0 100 2 3 3 0 003-3v-3.94a1 1 0 01.76-.97l.48-.12a1 1 0 000-1.94l-.48-.12a1 1 0 01-.76-.97V6z",
    fill: primaryFill
  }));
};

export const Braces24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Braces24FilledIcon, 'Braces24Filled');

const Braces24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4.5 5.75A2.75 2.75 0 017.25 3a.75.75 0 010 1.5C6.56 4.5 6 5.06 6 5.75v4.3c0 .75-.3 1.45-.8 1.95.5.5.8 1.2.8 1.94v4.31c0 .69.56 1.25 1.25 1.25a.75.75 0 010 1.5 2.75 2.75 0 01-2.75-2.75v-4.3c0-.55-.34-1.02-.85-1.2l-.14-.04a.75.75 0 010-1.42l.14-.05c.5-.17.85-.64.85-1.18V5.75zm15 0A2.75 2.75 0 0016.75 3a.75.75 0 000 1.5c.69 0 1.25.56 1.25 1.25v4.3c0 .75.3 1.45.8 1.95-.5.5-.8 1.2-.8 1.94v4.31c0 .69-.56 1.25-1.25 1.25a.75.75 0 000 1.5 2.75 2.75 0 002.75-2.75v-4.3c0-.55.34-1.02.85-1.2l.14-.04a.75.75 0 000-1.42l-.14-.05a1.25 1.25 0 01-.85-1.18V5.75z",
    fill: primaryFill
  }));
};

export const Braces24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Braces24RegularIcon, 'Braces24Regular');

const Braces28FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M7.5 3A3.5 3.5 0 004 6.5V11c0 .52-.01.8-.14 1.05-.12.24-.42.61-1.3 1.06a1 1 0 000 1.78c.88.45 1.15.8 1.28 1.08.15.34.16.76.16 1.6v3.93A3.5 3.5 0 007.5 25a1 1 0 100-2A1.5 1.5 0 016 21.5v-4.02c0-.71 0-1.54-.33-2.31A3.4 3.4 0 004.8 14c.37-.32.64-.67.84-1.05.35-.72.35-1.42.35-1.9V6.5C6 5.67 6.67 5 7.5 5a1 1 0 000-2zm13 0A3.5 3.5 0 0124 6.5V11c0 .52.01.8.14 1.05.12.24.42.61 1.3 1.06a1 1 0 010 1.78c-.88.45-1.15.8-1.28 1.08-.15.34-.16.76-.16 1.6v3.93a3.5 3.5 0 01-3.5 3.5 1 1 0 110-2c.83 0 1.5-.67 1.5-1.5v-4.02c0-.71 0-1.54.33-2.31.2-.44.48-.82.86-1.17a3.5 3.5 0 01-.84-1.05 4.04 4.04 0 01-.35-1.9V6.5c0-.83-.67-1.5-1.5-1.5a1 1 0 110-2z",
    fill: primaryFill
  }));
};

export const Braces28Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Braces28FilledIcon, 'Braces28Filled');

const Braces28RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M7.75 3A3.25 3.25 0 004.5 6.25V11c0 .52 0 .84-.17 1.16-.15.3-.5.71-1.42 1.17a.75.75 0 000 1.34c.92.46 1.25.85 1.4 1.2.18.4.2.87.2 1.7v4.18c0 1.8 1.45 3.25 3.24 3.25a.75.75 0 000-1.5c-.97 0-1.75-.78-1.75-1.75V17.5c0-.72 0-1.5-.31-2.22-.21-.48-.54-.9-1.02-1.27.47-.36.79-.74 1-1.16.33-.67.33-1.32.33-1.8v-4.8c0-.96.78-1.74 1.75-1.74a.75.75 0 000-1.5zm12.5 0c1.8 0 3.25 1.45 3.25 3.25V11c0 .52 0 .84.17 1.16.15.3.5.71 1.42 1.17a.75.75 0 010 1.34c-.92.46-1.25.85-1.4 1.2-.18.4-.2.87-.2 1.7v4.18c0 1.8-1.45 3.25-3.24 3.25a.75.75 0 010-1.5c.97 0 1.75-.78 1.75-1.75V17.5c0-.72 0-1.5.31-2.22.21-.48.54-.9 1.02-1.27a3.41 3.41 0 01-1-1.16 3.8 3.8 0 01-.33-1.8v-4.8c0-.96-.78-1.74-1.75-1.74a.75.75 0 010-1.5z",
    fill: primaryFill
  }));
};

export const Braces28Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Braces28RegularIcon, 'Braces28Regular');

const Braces32FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M9.25 4A3.75 3.75 0 005.5 7.75v5.03c0 .57-.02.83-.15 1.07-.12.2-.44.59-1.52.98a1.25 1.25 0 000 2.35c1.08.39 1.37.76 1.49 1 .16.32.18.74.18 1.66v4.41A3.75 3.75 0 009.25 28h.5a1.25 1.25 0 000-2.5h-.5c-.69 0-1.25-.55-1.25-1.25v-4.52c0-.76 0-1.75-.44-2.66-.2-.4-.46-.75-.8-1.06.32-.28.58-.6.77-.94.47-.85.47-1.72.47-2.23V7.75c0-.69.56-1.25 1.25-1.25h.5a1.25 1.25 0 100-2.5h-.5zm13.5 0a3.75 3.75 0 013.75 3.75v5.03c0 .57.02.83.15 1.07.12.2.44.59 1.52.98a1.25 1.25 0 010 2.35c-1.08.39-1.37.76-1.49 1-.16.32-.18.74-.18 1.66v4.41A3.75 3.75 0 0122.75 28h-.5a1.25 1.25 0 010-2.5h.5c.69 0 1.25-.55 1.25-1.25v-4.52c0-.76 0-1.75.44-2.66.2-.4.46-.75.8-1.06-.32-.28-.58-.6-.77-.94-.47-.85-.47-1.72-.47-2.23V7.75c0-.69-.56-1.25-1.25-1.25h-.5a1.25 1.25 0 110-2.5h.5z",
    fill: primaryFill
  }));
};

export const Braces32Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Braces32FilledIcon, 'Braces32Filled');

const Braces32RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M9.5 4A3.5 3.5 0 006 7.5v5.2c0 .58-.02.92-.19 1.24-.16.29-.54.71-1.65 1.12a1 1 0 000 1.88c1.1.4 1.47.82 1.63 1.15.2.4.21.91.21 1.83v4.58A3.5 3.5 0 009.5 28h.5a1 1 0 100-2h-.5A1.5 1.5 0 018 24.5v-4.67c0-.79 0-1.74-.41-2.6A3.5 3.5 0 006.6 16c.42-.33.73-.7.96-1.11.43-.8.43-1.62.43-2.15V7.5C8 6.67 8.67 6 9.5 6h.5a1 1 0 100-2h-.5zm13 0A3.5 3.5 0 0126 7.5v5.2c0 .58.02.92.19 1.24.16.29.54.71 1.65 1.12a1 1 0 010 1.88c-1.1.4-1.47.82-1.63 1.15-.2.4-.21.91-.21 1.83v4.58a3.5 3.5 0 01-3.5 3.5H22a1 1 0 110-2h.5c.83 0 1.5-.67 1.5-1.5v-4.67c0-.79 0-1.74.41-2.6.23-.47.55-.88.98-1.22-.42-.33-.73-.7-.96-1.11a4.28 4.28 0 01-.43-2.15V7.5c0-.83-.67-1.5-1.5-1.5H22a1 1 0 110-2h.5z",
    fill: primaryFill
  }));
};

export const Braces32Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Braces32RegularIcon, 'Braces32Regular');

const Braces48FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M14 6a5 5 0 00-5 5v8.05a3.4 3.4 0 01-.38 1.85c-.29.48-.94 1.13-2.6 1.68a1.5 1.5 0 000 2.84c1.65.55 2.27 1.19 2.56 1.73.34.62.42 1.43.42 2.73V37a5 5 0 005 5h.5a1.5 1.5 0 000-3H14a2 2 0 01-2-2v-7.12c0-1.28-.04-2.79-.77-4.15a5.5 5.5 0 00-1.46-1.72c.6-.46 1.07-.98 1.42-1.56.75-1.24.81-2.52.81-3.4V11c0-1.1.9-2 2-2h.5a1.5 1.5 0 000-3H14zm20 0a5 5 0 015 5v8.05c0 .77.07 1.34.38 1.85.29.48.94 1.13 2.6 1.68a1.5 1.5 0 010 2.84c-1.65.55-2.27 1.19-2.56 1.73-.34.62-.42 1.43-.42 2.73V37a5 5 0 01-5 5h-.5a1.5 1.5 0 010-3h.5a2 2 0 002-2v-7.12c0-1.28.04-2.79.77-4.15a5.5 5.5 0 011.46-1.72 5.66 5.66 0 01-1.42-1.56 6.32 6.32 0 01-.81-3.4V11a2 2 0 00-2-2h-.5a1.5 1.5 0 010-3h.5z",
    fill: primaryFill
  }));
};

export const Braces48Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Braces48FilledIcon, 'Braces48Filled');

const Braces48RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M14.25 6a4.75 4.75 0 00-4.75 4.75v8.23c0 .87-.02 1.53-.3 2.12-.27.52-.84 1.18-2.37 1.73a1.25 1.25 0 000 2.35c1.52.54 2.07 1.18 2.34 1.8.31.72.33 1.62.33 3v7.27A4.75 4.75 0 0014.25 42h.5a1.25 1.25 0 000-2.5h-.5c-1.24 0-2.25-1-2.25-2.25v-7.4c0-1.21 0-2.62-.54-3.87A4.96 4.96 0 009.92 24a5.07 5.07 0 001.51-1.8 6.9 6.9 0 00.57-3.16v-8.3c0-1.24 1-2.25 2.25-2.25h.5a1.25 1.25 0 100-2.5h-.5zm19.5 0a4.75 4.75 0 014.75 4.75v8.23c0 .87.02 1.53.3 2.12.27.52.84 1.18 2.37 1.73a1.25 1.25 0 010 2.35c-1.52.54-2.07 1.18-2.34 1.8-.31.72-.33 1.62-.33 3v7.27A4.75 4.75 0 0133.75 42h-.5a1.25 1.25 0 010-2.5h.5c1.24 0 2.25-1 2.25-2.25v-7.4c0-1.21 0-2.62.54-3.87.33-.77.84-1.42 1.54-1.97a5.07 5.07 0 01-1.51-1.8 6.9 6.9 0 01-.57-3.16v-8.3c0-1.24-1-2.25-2.25-2.25h-.5a1.25 1.25 0 110-2.5h.5z",
    fill: primaryFill
  }));
};

export const Braces48Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Braces48RegularIcon, 'Braces48Regular');

const BracesVariable20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5.75 2.5A2.75 2.75 0 003 5.25v3.13c0 .4-.22.76-.57.94a.75.75 0 000 1.36c.35.18.57.54.57.94v3.13a2.75 2.75 0 002.75 2.75.75.75 0 000-1.5c-.69 0-1.25-.56-1.25-1.25v-3.13c0-.6-.21-1.17-.58-1.62.37-.45.58-1.02.58-1.62V5.25C4.5 4.56 5.06 4 5.75 4a.75.75 0 000-1.5zm8.5 0A2.75 2.75 0 0117 5.25v3.13c0 .4.22.76.57.94a.75.75 0 010 1.36c-.35.18-.57.54-.57.94v3.13a2.75 2.75 0 01-2.75 2.75.75.75 0 010-1.5c.69 0 1.25-.56 1.25-1.25v-3.13c0-.6.21-1.17.58-1.62a2.56 2.56 0 01-.58-1.62V5.25c0-.69-.56-1.25-1.25-1.25a.75.75 0 010-1.5zM8.11 6.06a.75.75 0 10-1.22.88L9.08 10l-2.19 3.06a.75.75 0 001.22.88L10 11.29l1.89 2.65a.75.75 0 001.22-.88L10.92 10l2.19-3.06a.75.75 0 00-1.22-.88L10 8.71 8.11 6.06z",
    fill: primaryFill
  }));
};

export const BracesVariable20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/BracesVariable20FilledIcon, 'BracesVariable20Filled');

const BracesVariable20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5.5 3A2.5 2.5 0 003 5.5v2.88c0 .5-.28.95-.72 1.17a.5.5 0 000 .9c.44.22.72.68.72 1.17v2.88A2.5 2.5 0 005.5 17a.5.5 0 000-1A1.5 1.5 0 014 14.5v-2.88c0-.62-.24-1.2-.66-1.62.42-.42.66-1 .66-1.62V5.5C4 4.67 4.67 4 5.5 4a.5.5 0 000-1zm9 0A2.5 2.5 0 0117 5.5v2.88c0 .5.28.95.72 1.17a.5.5 0 010 .9 1.3 1.3 0 00-.72 1.17v2.88a2.5 2.5 0 01-2.5 2.5.5.5 0 010-1c.83 0 1.5-.67 1.5-1.5v-2.88c0-.62.24-1.2.66-1.62A2.3 2.3 0 0116 8.38V5.5c0-.83-.67-1.5-1.5-1.5a.5.5 0 010-1zM7.9 6.2a.5.5 0 00-.8.6L9.38 10l-2.3 3.2a.5.5 0 00.82.6L10 10.85l2.1 2.93a.5.5 0 00.8-.58L10.62 10l2.3-3.2a.5.5 0 10-.82-.6L10 9.15 7.9 6.21z",
    fill: primaryFill
  }));
};

export const BracesVariable20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/BracesVariable20RegularIcon, 'BracesVariable20Regular');

const BracesVariable24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3 6a3 3 0 013-3 1 1 0 010 2 1 1 0 00-1 1v3.94A3 3 0 014.18 12 3 3 0 015 14.06V18a1 1 0 001 1 1 1 0 110 2 3 3 0 01-3-3v-3.94a1 1 0 00-.76-.97l-.48-.12a1 1 0 010-1.94l.48-.12A1 1 0 003 9.94V6zm18 0a3 3 0 00-3-3 1 1 0 100 2 1 1 0 011 1v3.94a3 3 0 00.82 2.06 3 3 0 00-.82 2.06V18a1 1 0 01-1 1 1 1 0 100 2 3 3 0 003-3v-3.94a1 1 0 01.76-.97l.48-.12a1 1 0 000-1.94l-.48-.12a1 1 0 01-.76-.97V6zm-11.71.89A1 1 0 107.7 8.1L10.73 12l-3.02 3.89A1 1 0 109.3 17.1L12 13.63l2.71 3.48a1 1 0 001.58-1.22L13.27 12l3.02-3.89A1 1 0 0014.7 6.9L12 10.37 9.29 6.9z",
    fill: primaryFill
  }));
};

export const BracesVariable24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/BracesVariable24FilledIcon, 'BracesVariable24Filled');

const BracesVariable24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3.5 5.75A2.75 2.75 0 016.25 3a.75.75 0 010 1.5C5.56 4.5 5 5.06 5 5.75v4.3c0 .75-.3 1.45-.8 1.95.5.5.8 1.2.8 1.94v4.31c0 .69.56 1.25 1.25 1.25a.75.75 0 010 1.5 2.75 2.75 0 01-2.75-2.75v-4.3c0-.55-.34-1.02-.85-1.2l-.14-.04a.75.75 0 010-1.42l.14-.05c.5-.17.85-.64.85-1.18V5.75zm17 0A2.75 2.75 0 0017.75 3a.75.75 0 000 1.5c.69 0 1.25.56 1.25 1.25v4.3c0 .75.3 1.45.8 1.95-.5.5-.8 1.2-.8 1.94v4.31c0 .69-.56 1.25-1.25 1.25a.75.75 0 000 1.5 2.75 2.75 0 002.75-2.75v-4.3c0-.55.34-1.02.85-1.2l.14-.04a.75.75 0 000-1.42l-.14-.05a1.25 1.25 0 01-.85-1.18V5.75zM9.1 7.04a.75.75 0 10-1.2.92L11.06 12l-3.14 4.04a.75.75 0 001.18.92L12 13.22l2.9 3.74a.75.75 0 001.2-.92L12.94 12l3.14-4.04a.75.75 0 00-1.18-.92L12 10.78 9.1 7.04z",
    fill: primaryFill
  }));
};

export const BracesVariable24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/BracesVariable24RegularIcon, 'BracesVariable24Regular');

const BrainCircuit20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6.13 2.8A3.9 3.9 0 018.5 2a.9.9 0 01.54.21c.13.1.24.22.35.35.07.09.11.2.11.32V6.5H8.41a1.5 1.5 0 100 1H9.5v9.42a.5.5 0 01-.18.38c-.47.38-1.08.7-1.82.7-1.19 0-2.07-.6-2.64-1.31a4.06 4.06 0 01-.82-1.76c-.33-.08-.7-.25-1.05-.55A3 3 0 012 12c0-.56.04-1.06.12-1.5h3.13c.64 0 1.16.47 1.24 1.09a1.5 1.5 0 101 0A2.25 2.25 0 005.25 9.5h-2.8a1.9 1.9 0 01.83-.85c-.29-.83-.21-1.8.06-2.57.18-.49.45-.96.84-1.27.25-.2.55-.34.88-.36.14-.68.55-1.25 1.07-1.66zm4.37 11.7h.75c1.24 0 2.25-1 2.25-2.25v-1.84a1.5 1.5 0 10-1 0v1.84c0 .69-.56 1.25-1.25 1.25h-.75V2.88a.5.5 0 01.11-.32c.1-.13.22-.25.35-.35A.9.9 0 0111.5 2c.85 0 1.71.28 2.37.8.52.4.93.97 1.07 1.65.33.02.63.16.88.36.39.31.66.78.84 1.27.27.77.35 1.74.06 2.57l.21.12c.28.19.49.45.64.76.3.6.43 1.44.43 2.47a3 3 0 01-.99 2.38c-.34.3-.72.47-1.05.55-.1.56-.38 1.2-.82 1.76A3.34 3.34 0 0112.5 18c-.74 0-1.35-.32-1.82-.7a.5.5 0 01-.18-.38V14.5zM7 6.5a.5.5 0 100 1 .5.5 0 000-1zm0 6a.5.5 0 100 1 .5.5 0 000-1zm6-3a.5.5 0 100-1 .5.5 0 000 1z",
    fill: primaryFill
  }));
};

export const BrainCircuit20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/BrainCircuit20FilledIcon, 'BrainCircuit20Filled');

const BrainCircuit20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6.13 2.8A3.9 3.9 0 018.5 2a1.76 1.76 0 011.5.78A1.76 1.76 0 0111.5 2c.85 0 1.71.28 2.37.8.52.4.93.97 1.07 1.65.33.02.63.16.88.36.39.31.66.78.84 1.27.27.77.35 1.74.06 2.57l.21.12c.28.19.49.45.64.76.3.6.43 1.44.43 2.47a3 3 0 01-.99 2.38c-.34.3-.72.47-1.05.55-.1.56-.38 1.2-.82 1.76A3.34 3.34 0 0112.5 18c-.94 0-1.69-.52-2.17-1.03a4.25 4.25 0 01-.33-.38c-.1.12-.2.25-.33.38A3.06 3.06 0 017.5 18c-1.19 0-2.07-.6-2.64-1.31a4.06 4.06 0 01-.82-1.76c-.33-.08-.7-.25-1.05-.55A3 3 0 012 12c0-1.03.13-1.87.43-2.47a1.91 1.91 0 01.85-.88c-.29-.83-.21-1.8.06-2.57.18-.49.45-.96.84-1.27.25-.2.55-.34.88-.36.14-.68.55-1.25 1.07-1.66zM9.5 4.5V4.5a1.78 1.78 0 00-.02-.24 2.58 2.58 0 00-.14-.57c-.07-.2-.17-.38-.3-.5A.76.76 0 008.5 3c-.65 0-1.29.22-1.76.58C6.28 3.94 6 4.43 6 5a.5.5 0 01-.66.47c-.19-.06-.35-.02-.53.12-.2.16-.39.45-.53.83-.28.78-.25 1.73.14 2.3A.5.5 0 014.5 9h.75c1.24 0 2.25 1 2.25 2.25v.34a1.5 1.5 0 11-1 0v-.34c0-.69-.56-1.25-1.25-1.25H3.5a.5.5 0 01-.18-.03c-.2.4-.32 1.06-.32 2.03 0 .86.31 1.34.64 1.62.34.3.73.38.86.38.28 0 .5.22.5.5 0 .37.2 1.01.64 1.56.43.54 1.05.94 1.86.94.56 0 1.06-.31 1.45-.72a3.12 3.12 0 00.55-.81V7.5H8.41a1.5 1.5 0 110-1H9.5v-2zm1 10v.97l.01.03.1.2c.1.17.25.38.44.58.39.4.9.72 1.45.72.81 0 1.43-.4 1.86-.94.44-.55.64-1.2.64-1.56 0-.28.22-.5.5-.5.13 0 .52-.08.86-.38.33-.28.64-.76.64-1.62 0-.97-.12-1.63-.32-2.03-.1-.19-.2-.3-.3-.37a.66.66 0 00-.38-.1.5.5 0 01-.42-.78c.39-.57.42-1.52.14-2.3a1.89 1.89 0 00-.53-.83c-.18-.14-.34-.18-.53-.12A.5.5 0 0114 5c0-.57-.28-1.06-.74-1.42A2.91 2.91 0 0011.5 3a.76.76 0 00-.54.19c-.13.11-.23.28-.3.49a2.58 2.58 0 00-.16.81v9.01h.75c.69 0 1.25-.56 1.25-1.25v-1.84a1.5 1.5 0 111 0v1.84c0 1.24-1 2.25-2.25 2.25h-.75zM6.5 7a.5.5 0 101 0 .5.5 0 00-1 0zM13 9.5a.5.5 0 100-1 .5.5 0 000 1zm-6 3a.5.5 0 100 1 .5.5 0 000-1z",
    fill: primaryFill
  }));
};

export const BrainCircuit20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/BrainCircuit20RegularIcon, 'BrainCircuit20Regular');

const BrainCircuit24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10.14 2c.7 0 1.11.71 1.11 1.42v4.33h-.9a2 2 0 100 1.5h.9v10.9c0 .6-.25 1.19-.78 1.46A3.4 3.4 0 018.9 22a4.24 4.24 0 01-3.36-1.67 5.17 5.17 0 01-1.02-2.14c-.4-.12-.86-.34-1.27-.69A3.83 3.83 0 012 14.47c0-.76.05-1.42.19-1.97H6.4c.68 0 1.24.5 1.34 1.15a2 2 0 101.5 0A2.85 2.85 0 006.4 11H3.04a2.04 2.04 0 01.5-.3 4.9 4.9 0 01-.18-1.13c-.04-.73.07-1.5.3-2.18a4.2 4.2 0 011.03-1.77c.3-.29.68-.5 1.1-.57.2-.84.7-1.53 1.35-2.04.83-.65 1.92-1 3-1zm2.61 15h1.65a2.85 2.85 0 002.85-2.85v-1.8a2 2 0 10-1.5 0v1.8c0 .75-.6 1.35-1.35 1.35h-1.65V3.42c0-.71.4-1.41 1.11-1.41 1.08 0 2.17.35 3 1 .65.5 1.16 1.2 1.35 2.04.42.07.8.28 1.1.57.48.45.82 1.1 1.04 1.77.22.68.33 1.45.3 2.18a4.9 4.9 0 01-.18 1.13l.06.03c.37.17.67.45.9.8.42.7.57 1.68.57 2.94 0 1.44-.55 2.42-1.26 3.03-.41.35-.87.57-1.27.7-.14.68-.49 1.46-1.02 2.13A4.24 4.24 0 0115.09 22a3.4 3.4 0 01-1.56-.4c-.53-.26-.78-.86-.78-1.45V17zM8 8.5a.5.5 0 111 0 .5.5 0 01-1 0zm.5 6.5a.5.5 0 100 1 .5.5 0 000-1zm7.5-4.5a.5.5 0 101 0 .5.5 0 00-1 0z",
    fill: primaryFill
  }));
};

export const BrainCircuit24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/BrainCircuit24FilledIcon, 'BrainCircuit24Filled');

const BrainCircuit24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M7.15 3.01c.83-.65 1.92-1 3-1a2.3 2.3 0 011.86.88A2.3 2.3 0 0113.86 2c1.08 0 2.17.35 3 1 .65.5 1.16 1.2 1.35 2.04.42.07.8.28 1.1.57.48.45.82 1.1 1.04 1.77.22.68.33 1.45.3 2.18a4.9 4.9 0 01-.18 1.13l.06.03c.37.17.67.45.9.8.42.7.57 1.68.57 2.94 0 1.44-.55 2.42-1.26 3.03-.41.35-.87.57-1.27.7-.14.68-.49 1.46-1.02 2.13A4.24 4.24 0 0115.09 22a3.9 3.9 0 01-2.77-1.31 5.36 5.36 0 01-.31-.36l-.31.36a3.9 3.9 0 01-2.78 1.3 4.24 4.24 0 01-3.36-1.66 5.17 5.17 0 01-1.01-2.14c-.4-.12-.86-.34-1.27-.69A3.83 3.83 0 012 14.47c0-1.26.15-2.25.58-2.93a2.1 2.1 0 01.96-.84 4.9 4.9 0 01-.18-1.13c-.03-.73.08-1.5.3-2.18A4.2 4.2 0 014.7 5.62c.3-.29.68-.5 1.1-.57C6 4.2 6.5 3.52 7.15 3zm.92 1.19c-.54.42-.86.99-.86 1.64a.75.75 0 01-.99.7c-.14-.04-.28-.03-.49.17-.23.22-.47.61-.64 1.14-.16.52-.25 1.1-.22 1.65.02.56.16 1.02.37 1.33l.08.17H6.4c1.5 0 2.74 1.17 2.84 2.64a2 2 0 11-1.5.01A1.35 1.35 0 006.4 12.5H3.8h-.02c-.15.35-.27.95-.27 1.97s.38 1.58.74 1.9c.4.34.85.43.98.43.41 0 .75.33.75.75s.23 1.18.76 1.84c.5.64 1.23 1.1 2.18 1.1.64 0 1.23-.35 1.7-.84a3.7 3.7 0 00.63-.92V16.26v-.01-7h-.9a2 2 0 110-1.5h.9V5.22a2.06 2.06 0 00-.02-.3c-.03-.19-.07-.43-.16-.67-.1-.24-.2-.43-.35-.55a.8.8 0 00-.57-.2c-.76 0-1.52.26-2.08.7zm4.7 12.8v1.73l.11.23c.12.2.3.45.52.69.47.49 1.06.85 1.7.85.95 0 1.67-.47 2.18-1.1.53-.67.76-1.43.76-1.85 0-.42.33-.75.75-.75.13 0 .57-.1.97-.44.37-.31.74-.87.74-1.9 0-1.2-.16-1.82-.35-2.13a.6.6 0 00-.26-.25c-.1-.04-.25-.08-.49-.08a.75.75 0 01-.62-1.17c.2-.3.34-.77.36-1.33a4.84 4.84 0 00-.22-1.65c-.17-.53-.4-.92-.64-1.14-.2-.2-.35-.2-.49-.16a.75.75 0 01-.98-.71c0-.65-.32-1.22-.87-1.64a3.45 3.45 0 00-2.08-.7.8.8 0 00-.57.2c-.14.12-.25.31-.34.55a3.06 3.06 0 00-.19.96V15.5h.64c.75 0 1.35-.6 1.35-1.35v-1.8a2 2 0 111.5 0v1.8A2.85 2.85 0 0113.4 17h-.64zM8.5 8a.5.5 0 100 1 .5.5 0 000-1zM8 15.5a.5.5 0 101 0 .5.5 0 00-1 0zm7-5a.5.5 0 101 0 .5.5 0 00-1 0z",
    fill: primaryFill
  }));
};

export const BrainCircuit24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/BrainCircuit24RegularIcon, 'BrainCircuit24Regular');

const Branch20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10 5a3 3 0 01-2.15 2.88A5.76 5.76 0 0012 9.98a3 3 0 11.17 1.01A6.8 6.8 0 017.5 9v3.05a3 3 0 11-1 0V7.96A3 3 0 1110 5z",
    fill: primaryFill
  }));
};

export const Branch20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Branch20FilledIcon, 'Branch20Filled');

const Branch20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10 5a3 3 0 01-2.15 2.88A5.76 5.76 0 0012 9.98a3 3 0 11.17 1.01A6.8 6.8 0 017.5 9v3.05a3 3 0 11-1 0V7.96A3 3 0 1110 5zM7 7a2 2 0 100-4 2 2 0 000 4zm10 3a2 2 0 10-4 0 2 2 0 004 0zM7 17a2 2 0 100-4 2 2 0 000 4z",
    fill: primaryFill
  }));
};

export const Branch20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Branch20RegularIcon, 'Branch20Regular');

const Branch24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4 5.5a3.5 3.5 0 114.49 3.36 5.5 5.5 0 005.26 3.89h.33a3.5 3.5 0 110 1.5h-.33a6.99 6.99 0 01-5.5-2.67v3.5a3.5 3.5 0 11-1.5 0V8.92A3.5 3.5 0 014 5.5z",
    fill: primaryFill
  }));
};

export const Branch24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Branch24FilledIcon, 'Branch24Filled');

const Branch24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4 5.5a3.5 3.5 0 114.49 3.36 5.5 5.5 0 005.26 3.89h.33a3.5 3.5 0 110 1.5h-.33a6.99 6.99 0 01-5.5-2.67v3.5a3.5 3.5 0 11-1.5 0V8.92A3.5 3.5 0 014 5.5zm3.5-2a2 2 0 100 4 2 2 0 000-4zm0 13a2 2 0 100 4 2 2 0 000-4zm8-3a2 2 0 104 0 2 2 0 00-4 0z",
    fill: primaryFill
  }));
};

export const Branch24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Branch24RegularIcon, 'Branch24Regular');

const BranchCompare16FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M9.15 5.85a.5.5 0 10.7-.7L8.71 4h1.79c.83 0 1.5.67 1.5 1.5v4.55a2.5 2.5 0 101 0V5.5A2.5 2.5 0 0010.5 3H8.7l1.15-1.15a.5.5 0 00-.7-.7l-2 2a.5.5 0 000 .7l2 2zM6 3.5a2.5 2.5 0 01-2 2.45v4.55c0 .83.67 1.5 1.5 1.5h1.8l-1.15-1.15a.5.5 0 01.7-.7l2 2c.2.2.2.5 0 .7l-2 2a.5.5 0 01-.7-.7L7.29 13H5.5A2.5 2.5 0 013 10.5V5.95A2.5 2.5 0 116 3.5z",
    fill: primaryFill
  }));
};

export const BranchCompare16Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/BranchCompare16FilledIcon, 'BranchCompare16Filled');

const BranchCompare16RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M9.15 5.85a.5.5 0 10.7-.7L8.71 4h1.79c.83 0 1.5.67 1.5 1.5v4.55a2.5 2.5 0 101 0V5.5A2.5 2.5 0 0010.5 3H8.7l1.15-1.15a.5.5 0 00-.7-.7l-2 2a.5.5 0 000 .7l2 2zM14 12.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zm-8-9a2.5 2.5 0 01-2 2.45v4.55c0 .83.67 1.5 1.5 1.5h1.8l-1.15-1.15a.5.5 0 01.7-.7l2 2c.2.2.2.5 0 .7l-2 2a.5.5 0 01-.7-.7L7.29 13H5.5A2.5 2.5 0 013 10.5V5.95A2.5 2.5 0 116 3.5zm-1 0a1.5 1.5 0 10-3 0 1.5 1.5 0 003 0z",
    fill: primaryFill
  }));
};

export const BranchCompare16Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/BranchCompare16RegularIcon, 'BranchCompare16Regular');

const BranchCompare20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M11.15 6.85a.5.5 0 00.7-.7L10.71 5h1.79A2.5 2.5 0 0115 7.5V12a3 3 0 101 .17V7.5A3.5 3.5 0 0012.5 4h-1.8l1.15-1.15a.5.5 0 00-.7-.7l-2 2a.5.5 0 000 .7l2 2zM5 8a3 3 0 10-1-.17v4.67A3.5 3.5 0 007.5 16h1.8l-1.15 1.15a.5.5 0 00.7.7l2-2a.5.5 0 00.15-.35.5.5 0 00-.15-.35l-2-2a.5.5 0 00-.7.7L9.29 15H7.5A2.5 2.5 0 015 12.5V8z",
    fill: primaryFill
  }));
};

export const BranchCompare20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/BranchCompare20FilledIcon, 'BranchCompare20Filled');

const BranchCompare20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M11.15 6.85a.5.5 0 00.7-.7L10.71 5h1.79A2.5 2.5 0 0115 7.5V12a3 3 0 101 .17V7.5A3.5 3.5 0 0012.5 4h-1.8l1.15-1.15a.5.5 0 00-.7-.7l-2 2a.5.5 0 000 .7l2 2zM17 15a2 2 0 11-4 0 2 2 0 014 0zM8 5a3 3 0 01-3 3v4.5A2.5 2.5 0 007.5 15h1.8l-1.15-1.15a.5.5 0 01.7-.7l2 2c.2.2.2.5 0 .7l-2 2a.5.5 0 01-.7-.7L9.29 16H7.5A3.5 3.5 0 014 12.5V7.83A3 3 0 118 5zM7 5a2 2 0 10-4 0 2 2 0 004 0z",
    fill: primaryFill
  }));
};

export const BranchCompare20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/BranchCompare20RegularIcon, 'BranchCompare20Regular');

const BranchCompare24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M9 5.5a3.5 3.5 0 01-3 3.46V15a3 3 0 003 3h2.69l-.97-.97a.75.75 0 111.06-1.06l2.25 2.25c.3.3.3.77 0 1.06l-2.25 2.25a.75.75 0 11-1.06-1.06l.97-.97H9A4.5 4.5 0 014.5 15V8.86A3.5 3.5 0 119 5.5zm13 13a3.5 3.5 0 11-4-3.46V9a3 3 0 00-3-3h-1.94l.97.97a.75.75 0 01-1.06 1.06l-2.25-2.25a.75.75 0 010-1.06l2.25-2.25a.75.75 0 111.06 1.06l-.97.97H15A4.5 4.5 0 0119.5 9v6.14A3.5 3.5 0 0122 18.5z",
    fill: primaryFill
  }));
};

export const BranchCompare24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/BranchCompare24FilledIcon, 'BranchCompare24Filled');

const BranchCompare24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M9 5.5a3.5 3.5 0 01-3 3.46V15a3 3 0 003 3h2.69l-.97-.97a.75.75 0 111.06-1.06l2.25 2.25c.3.3.3.77 0 1.06l-2.25 2.25a.75.75 0 11-1.06-1.06l.97-.97H9A4.5 4.5 0 014.5 15V8.86A3.5 3.5 0 119 5.5zm-1.5 0a2 2 0 10-4 0 2 2 0 004 0zm14.5 13a3.5 3.5 0 11-4-3.46V9a3 3 0 00-3-3h-1.94l.97.97a.75.75 0 01-1.06 1.06l-2.25-2.25a.75.75 0 010-1.06l2.25-2.25a.75.75 0 111.06 1.06l-.97.97H15A4.5 4.5 0 0119.5 9v6.14A3.5 3.5 0 0122 18.5zm-1.5 0a2 2 0 10-4 0 2 2 0 004 0z",
    fill: primaryFill
  }));
};

export const BranchCompare24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/BranchCompare24RegularIcon, 'BranchCompare24Regular');

const BranchFork16FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M7 3.5a2.5 2.5 0 01-2 2.45V8h4.5c.83 0 1.5-.67 1.5-1.5v-.55a2.5 2.5 0 111 0v.55A2.5 2.5 0 019.5 9H5v1.05a2.5 2.5 0 11-1 0v-4.1A2.5 2.5 0 117 3.5z",
    fill: primaryFill
  }));
};

export const BranchFork16Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/BranchFork16FilledIcon, 'BranchFork16Filled');

const BranchFork16RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5 5.95a2.5 2.5 0 10-1 0v4.1a2.5 2.5 0 101 0V9h4.5A2.5 2.5 0 0012 6.5v-.55a2.5 2.5 0 10-1 0v.55c0 .83-.67 1.5-1.5 1.5H5V5.95zM4.5 5a1.5 1.5 0 110-3 1.5 1.5 0 010 3zm7 0a1.5 1.5 0 110-3 1.5 1.5 0 010 3zM6 12.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0z",
    fill: primaryFill
  }));
};

export const BranchFork16Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/BranchFork16RegularIcon, 'BranchFork16Regular');

const BranchFork20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M9 5a3 3 0 01-2.5 2.96V10H12c.83 0 1.5-.67 1.5-1.5v-.54a3 3 0 111 0v.54A2.5 2.5 0 0112 11H6.5v1.04a3 3 0 11-1 0V7.96A3 3 0 119 5z",
    fill: primaryFill
  }));
};

export const BranchFork20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/BranchFork20FilledIcon, 'BranchFork20Filled');

const BranchFork20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M9 5a3 3 0 10-3.5 2.96v4.08a3 3 0 101 0V11H12a2.5 2.5 0 002.5-2.5v-.54a3 3 0 10-1 0v.54c0 .83-.67 1.5-1.5 1.5H6.5V7.96A3 3 0 009 5zM6 7a2 2 0 110-4 2 2 0 010 4zm0 10a2 2 0 110-4 2 2 0 010 4zM16 5a2 2 0 11-4 0 2 2 0 014 0z",
    fill: primaryFill
  }));
};

export const BranchFork20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/BranchFork20RegularIcon, 'BranchFork20Regular');

const BranchFork24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M11 5.5a3.5 3.5 0 01-3 3.46v2.54h6.25c1.24 0 2.25-1 2.25-2.25v-.4a3.5 3.5 0 111.5.11v.29A3.75 3.75 0 0114.25 13H8v2.04a3.5 3.5 0 11-1.5.1V8.86A3.5 3.5 0 1111 5.5z",
    fill: primaryFill
  }));
};

export const BranchFork24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/BranchFork24FilledIcon, 'BranchFork24Filled');

const BranchFork24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M11 5.5a3.5 3.5 0 01-3 3.46v2.54h6.25c1.24 0 2.25-1 2.25-2.25v-.4a3.5 3.5 0 111.5.11v.29A3.75 3.75 0 0114.25 13H8v2.04a3.5 3.5 0 11-1.5.1V8.86A3.5 3.5 0 1111 5.5zm-3.5 2a2 2 0 100-4 2 2 0 000 4zm10 0a2 2 0 100-4 2 2 0 000 4zm-8 11a2 2 0 10-4 0 2 2 0 004 0z",
    fill: primaryFill
  }));
};

export const BranchFork24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/BranchFork24RegularIcon, 'BranchFork24Regular');

const BranchFork32FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10 11.9a5 5 0 10-2 0v8.2a5 5 0 102 0V18h9a5 5 0 005-5v-1.1a5 5 0 10-2 0V13a3 3 0 01-3 3h-9v-4.1z",
    fill: primaryFill
  }));
};

export const BranchFork32Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/BranchFork32FilledIcon, 'BranchFork32Filled');

const BranchFork32RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M9 10a3 3 0 110-6 3 3 0 010 6zm1 1.9a5 5 0 10-2 0v8.2a5 5 0 102 0V18h9a5 5 0 005-5v-1.1a5 5 0 10-2 0V13a3 3 0 01-3 3h-9v-4.1zM23 10a3 3 0 110-6 3 3 0 010 6zM12 25a3 3 0 11-6 0 3 3 0 016 0z",
    fill: primaryFill
  }));
};

export const BranchFork32Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/BranchFork32RegularIcon, 'BranchFork32Regular');

const BranchForkHint20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6 2a3 3 0 00-.5 5.96v3.79a.5.5 0 001 0V11H12a2.5 2.5 0 002.5-2.5v-.54a3 3 0 10-1 0v.54c0 .83-.67 1.5-1.5 1.5H6.5V7.96A3 3 0 006 2zM4.87 13.4a.5.5 0 10-.58-.8 3.02 3.02 0 00-1.12 1.54.5.5 0 10.96.3 1.99 1.99 0 01.74-1.03zm2.9-.8a.5.5 0 10-.57.8 2.02 2.02 0 01.75 1.04.5.5 0 10.95-.3 2.99 2.99 0 00-1.12-1.55zM4.3 16a.5.5 0 00-.88.5 3 3 0 001.38 1.27.5.5 0 10.42-.91 2 2 0 01-.92-.85zm4.37.5a.5.5 0 00-.87-.5 2 2 0 01-.98.88.5.5 0 10.38.92 3 3 0 001.47-1.3z",
    fill: primaryFill
  }));
};

export const BranchForkHint20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/BranchForkHint20FilledIcon, 'BranchForkHint20Filled');

const BranchForkHint20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6 2a3 3 0 00-.5 5.96v3.79a.5.5 0 001 0V11H12a2.5 2.5 0 002.5-2.5v-.54a3 3 0 10-1 0v.54c0 .83-.67 1.5-1.5 1.5H6.5V7.96A3 3 0 006 2zm8 5a2 2 0 110-4 2 2 0 010 4zM6 7a2 2 0 110-4 2 2 0 010 4zm-1.13 6.4a.5.5 0 10-.58-.8 3.02 3.02 0 00-1.12 1.54.5.5 0 10.96.3 1.99 1.99 0 01.74-1.03zm2.9-.8a.5.5 0 10-.57.8 2.02 2.02 0 01.75 1.04.5.5 0 10.95-.3 2.99 2.99 0 00-1.12-1.55zM4.3 16a.5.5 0 00-.88.5 3 3 0 001.38 1.27.5.5 0 10.42-.91 2 2 0 01-.92-.85zm4.37.5a.5.5 0 00-.87-.5 2 2 0 01-.98.88.5.5 0 10.38.92 3 3 0 001.47-1.3z",
    fill: primaryFill
  }));
};

export const BranchForkHint20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/BranchForkHint20RegularIcon, 'BranchForkHint20Regular');

const BranchForkHint24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6.5 2a3.5 3.5 0 00-1 6.86v5.39a.75.75 0 001.5 0V13h6.25A3.75 3.75 0 0017 9.25v-.29a3.5 3.5 0 10-1.5-.1v.39c0 1.24-1 2.25-2.25 2.25H7V8.96A3.5 3.5 0 006.5 2zM5.34 16.88a.75.75 0 00-.87-1.22 3.52 3.52 0 00-1.23 1.6.75.75 0 101.4.53 1.99 1.99 0 01.7-.9zm3.2-1.22a.75.75 0 00-.88 1.22 2.01 2.01 0 01.7.91.75.75 0 101.4-.54 3.49 3.49 0 00-1.23-1.59zm-3.76 3.86a.75.75 0 10-1.3.76 3.5 3.5 0 001.48 1.37.75.75 0 00.66-1.35 2 2 0 01-.84-.78zm4.74.76a.75.75 0 00-1.3-.76 2 2 0 01-.84.78.75.75 0 00.66 1.35 3.5 3.5 0 001.48-1.37z",
    fill: primaryFill
  }));
};

export const BranchForkHint24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/BranchForkHint24FilledIcon, 'BranchForkHint24Filled');

const BranchForkHint24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6.5 2a3.5 3.5 0 00-1 6.86v5.39a.75.75 0 001.5 0V13h6.25A3.75 3.75 0 0017 9.25v-.29a3.5 3.5 0 10-1.5-.1v.39c0 1.24-1 2.25-2.25 2.25H7V8.96A3.5 3.5 0 006.5 2zm-2 3.5a2 2 0 114 0 2 2 0 01-4 0zm12-2a2 2 0 110 4 2 2 0 010-4zM5.34 16.88a.75.75 0 00-.87-1.22 3.52 3.52 0 00-1.23 1.6.75.75 0 101.4.53 1.99 1.99 0 01.7-.9zm3.2-1.22a.75.75 0 00-.88 1.22 2.01 2.01 0 01.7.91.75.75 0 101.4-.54 3.49 3.49 0 00-1.23-1.59zm-3.76 3.86a.75.75 0 10-1.3.76 3.5 3.5 0 001.48 1.37.75.75 0 00.66-1.35 2 2 0 01-.84-.78zm4.74.76a.75.75 0 00-1.3-.76 2 2 0 01-.84.78.75.75 0 00.66 1.35 3.5 3.5 0 001.48-1.37z",
    fill: primaryFill
  }));
};

export const BranchForkHint24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/BranchForkHint24RegularIcon, 'BranchForkHint24Regular');

const BranchForkLink20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5.5 7.96a3 3 0 10-1 0v4.08a3 3 0 101 0V11H11a2.5 2.5 0 002.5-2.5v-.54a3 3 0 10-1 0v.54c0 .83-.67 1.5-1.5 1.5H5.5V7.96zm7 5.04a2.5 2.5 0 000 5h.5a.5.5 0 000-1h-.5a1.5 1.5 0 010-3h.5a.5.5 0 000-1h-.5zm3.5 0a.5.5 0 000 1h.5a1.5 1.5 0 010 3H16a.5.5 0 000 1h.5a2.5 2.5 0 000-5H16zm-4 2.5c0-.28.22-.5.5-.5h4a.5.5 0 010 1h-4a.5.5 0 01-.5-.5z",
    fill: primaryFill
  }));
};

export const BranchForkLink20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/BranchForkLink20FilledIcon, 'BranchForkLink20Filled');

const BranchForkLink20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5 2a3 3 0 01.5 5.96V10H11c.83 0 1.5-.67 1.5-1.5v-.54a3 3 0 111 0v.54A2.5 2.5 0 0111 11H5.5v1.04a3 3 0 11-1 0V7.96A3 3 0 015 2zM3 5a2 2 0 104 0 2 2 0 00-4 0zm0 10a2 2 0 104 0 2 2 0 00-4 0zm10-8a2 2 0 100-4 2 2 0 000 4zm-.5 6a2.5 2.5 0 000 5h.5a.5.5 0 000-1h-.5a1.5 1.5 0 010-3h.5a.5.5 0 000-1h-.5zm3.5 0a.5.5 0 000 1h.5a1.5 1.5 0 010 3H16a.5.5 0 000 1h.5a2.5 2.5 0 000-5H16zm-4 2.5c0-.28.22-.5.5-.5h4a.5.5 0 010 1h-4a.5.5 0 01-.5-.5z",
    fill: primaryFill
  }));
};

export const BranchForkLink20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/BranchForkLink20RegularIcon, 'BranchForkLink20Regular');

const BranchForkLink24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6 8.96a3.5 3.5 0 10-1.5-.1v6.28a3.5 3.5 0 101.5-.1V13h6.25A3.75 3.75 0 0016 9.25v-.29a3.5 3.5 0 10-1.5-.1v.39c0 1.24-1 2.25-2.25 2.25H6V8.96zm17 9.79A3.75 3.75 0 0019.25 15h-.1a.75.75 0 00.1 1.5h.15a2.25 2.25 0 01-.15 4.5l-.1.01a.75.75 0 00.1 1.5v-.01h.2A3.75 3.75 0 0023 18.74zm-6.5-3a.75.75 0 00-.75-.75h-.2a3.75 3.75 0 00.2 7.5h.1a.75.75 0 00-.1-1.5h-.15a2.25 2.25 0 01.15-4.5h.1a.75.75 0 00.65-.75zm3.5 3a.75.75 0 00-.75-.75h-3.6a.75.75 0 00.1 1.5h3.6a.75.75 0 00.65-.75z",
    fill: primaryFill
  }));
};

export const BranchForkLink24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/BranchForkLink24FilledIcon, 'BranchForkLink24Filled');

const BranchForkLink24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6 8.96a3.5 3.5 0 10-1.5-.1v6.28a3.5 3.5 0 101.5-.1V13h6.25A3.75 3.75 0 0016 9.25v-.29a3.5 3.5 0 10-1.5-.1v.39c0 1.24-1 2.25-2.25 2.25H6V8.96zM7.5 5.5a2 2 0 11-4 0 2 2 0 014 0zm10 0a2 2 0 11-4 0 2 2 0 014 0zm-12 11a2 2 0 110 4 2 2 0 010-4zM23 18.75A3.75 3.75 0 0019.25 15h-.1a.75.75 0 00.1 1.5h.15a2.25 2.25 0 01-.15 4.5l-.1.01a.75.75 0 00.1 1.5v-.01h.2A3.75 3.75 0 0023 18.74zm-6.5-3a.75.75 0 00-.75-.75h-.2a3.75 3.75 0 00.2 7.5h.1a.75.75 0 00-.1-1.5h-.15a2.25 2.25 0 01.15-4.5h.1a.75.75 0 00.65-.75zm3.5 3a.75.75 0 00-.75-.75h-3.6a.75.75 0 00.1 1.5h3.6a.75.75 0 00.65-.75z",
    fill: primaryFill
  }));
};

export const BranchForkLink24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/BranchForkLink24RegularIcon, 'BranchForkLink24Regular');

const BranchRequest20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M8 5a3 3 0 01-2.5 2.96v4.08a3 3 0 11-1 0V7.96A3 3 0 118 5zm3.85 1.85a.5.5 0 01-.7 0l-2-2a.5.5 0 010-.7l2-2a.5.5 0 01.7.7L10.71 4h1.79A3.5 3.5 0 0116 7.5v4.67a3 3 0 11-1-.17V7.5A2.5 2.5 0 0012.5 5h-1.8l1.15 1.15c.2.2.2.5 0 .7z",
    fill: primaryFill
  }));
};

export const BranchRequest20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/BranchRequest20FilledIcon, 'BranchRequest20Filled');

const BranchRequest20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5.5 7.96a3 3 0 10-1 0v4.08a3 3 0 101 0V7.96zM5 7a2 2 0 110-4 2 2 0 010 4zm2 8a2 2 0 11-4 0 2 2 0 014 0zm4.15-8.15a.5.5 0 00.7-.7L10.71 5h1.79A2.5 2.5 0 0115 7.5V12a3 3 0 101 .17V7.5A3.5 3.5 0 0012.5 4h-1.8l1.15-1.15a.5.5 0 00-.7-.7l-2 2a.5.5 0 000 .7l2 2zM17 15a2 2 0 11-4 0 2 2 0 014 0z",
    fill: primaryFill
  }));
};

export const BranchRequest20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/BranchRequest20RegularIcon, 'BranchRequest20Regular');

const BreakoutRoom20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3 6a3 3 0 013-3h8a3 3 0 013 3v8a3 3 0 01-3 3h-3.35A3.99 3.99 0 0012 14v-2a4 4 0 00-4-4H6c-1.2 0-2.27.52-3 1.35V6zm3 3a3 3 0 00-3 3v2a3 3 0 003 3h2a3 3 0 003-3v-2a3 3 0 00-3-3H6z",
    fill: primaryFill
  }));
};

export const BreakoutRoom20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/BreakoutRoom20FilledIcon, 'BreakoutRoom20Filled');

const BreakoutRoom20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3 6a3 3 0 013-3h8a3 3 0 013 3v8a3 3 0 01-3 3h-3.35c.32-.29.6-.62.81-1H14a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v2.54c-.38.21-.71.49-1 .81V6zm3 3a3 3 0 00-3 3v2a3 3 0 003 3h2a3 3 0 003-3v-2a3 3 0 00-3-3H6zm-2 3c0-1.1.9-2 2-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2v-2z",
    fill: primaryFill
  }));
};

export const BreakoutRoom20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/BreakoutRoom20RegularIcon, 'BreakoutRoom20Regular');

const BreakoutRoom24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3 6.25C3 4.45 4.46 3 6.25 3h11.5C19.55 3 21 4.46 21 6.25v11.5c0 1.8-1.46 3.25-3.25 3.25h-5.04c.8-.85 1.29-2 1.29-3.25v-3A4.75 4.75 0 009.25 10h-3c-1.26 0-2.4.49-3.25 1.29V6.25zm0 8.5v3C3 19.55 4.46 21 6.25 21h3c1.8 0 3.25-1.46 3.25-3.25v-3c0-1.8-1.46-3.25-3.25-3.25h-3A3.25 3.25 0 003 14.75z",
    fill: primaryFill
  }));
};

export const BreakoutRoom24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/BreakoutRoom24FilledIcon, 'BreakoutRoom24Filled');

const BreakoutRoom24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3 6.25C3 4.45 4.46 3 6.25 3h11.5C19.55 3 21 4.46 21 6.25v11.5c0 1.8-1.46 3.25-3.25 3.25h-3.54c.41-.43.74-.94.96-1.5h2.58c.97 0 1.75-.78 1.75-1.75V6.25c0-.97-.78-1.75-1.75-1.75H6.25c-.97 0-1.75.78-1.75 1.75v2.58c-.56.22-1.07.55-1.5.96V6.25zM13.49 19.5c-.58.9-1.59 1.5-2.74 1.5h-4.5A3.25 3.25 0 013 17.75v-4.5A3.25 3.25 0 016.25 10h4.5c1.8 0 3.25 1.46 3.25 3.25v4.5c0 .64-.19 1.24-.51 1.75zM4.5 13.25v4.5c0 .97.78 1.75 1.75 1.75h4.5c.97 0 1.75-.78 1.75-1.75v-4.5c0-.97-.78-1.75-1.75-1.75h-4.5c-.97 0-1.75.78-1.75 1.75z",
    fill: primaryFill
  }));
};

export const BreakoutRoom24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/BreakoutRoom24RegularIcon, 'BreakoutRoom24Regular');

const BreakoutRoom28FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3 6.75A3.75 3.75 0 016.75 3h14.5A3.75 3.75 0 0125 6.75v14.5A3.75 3.75 0 0121.25 25h-6.83A5.23 5.23 0 0016 21.25v-4c0-2.9-2.35-5.25-5.25-5.25h-4c-1.47 0-2.8.6-3.75 1.58V6.75zm0 10.5v4A3.75 3.75 0 006.75 25h4a3.75 3.75 0 003.75-3.75v-4a3.75 3.75 0 00-3.75-3.75h-4A3.75 3.75 0 003 17.25z",
    fill: primaryFill
  }));
};

export const BreakoutRoom28Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/BreakoutRoom28FilledIcon, 'BreakoutRoom28Filled');

const BreakoutRoom28RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3 6.75A3.75 3.75 0 016.75 3h14.5A3.75 3.75 0 0125 6.75v14.5A3.75 3.75 0 0121.25 25h-5.33c.44-.43.8-.94 1.07-1.5h4.26c1.24 0 2.25-1 2.25-2.25V6.75c0-1.24-1-2.25-2.25-2.25H6.75c-1.24 0-2.25 1-2.25 2.25v4.26c-.56.26-1.07.63-1.5 1.07V6.75zM15.25 23.5a3.74 3.74 0 01-3 1.5h-5.5A3.75 3.75 0 013 21.25v-5.5A3.74 3.74 0 016.75 12h5.5A3.75 3.75 0 0116 15.75v5.5c0 .84-.28 1.62-.75 2.25zM4.5 15.75v5.5c0 1.24 1 2.25 2.25 2.25h5.5c1.24 0 2.25-1 2.25-2.25v-5.5c0-1.24-1-2.25-2.25-2.25h-5.5c-1.24 0-2.25 1-2.25 2.25z",
    fill: primaryFill
  }));
};

export const BreakoutRoom28Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/BreakoutRoom28RegularIcon, 'BreakoutRoom28Regular');

const Briefcase12FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5 2a1 1 0 00-1 1v1h-.5C2.67 4 2 4.67 2 5.5v3c0 .83.67 1.5 1.5 1.5h5c.83 0 1.5-.67 1.5-1.5v-3C10 4.67 9.33 4 8.5 4H8V3a1 1 0 00-1-1H5zm2 2H5V3h2v1z",
    fill: primaryFill
  }));
};

export const Briefcase12Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Briefcase12FilledIcon, 'Briefcase12Filled');

const Briefcase12RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4 3a1 1 0 011-1h2a1 1 0 011 1v1h.5c.83 0 1.5.67 1.5 1.5v3c0 .83-.67 1.5-1.5 1.5h-5A1.5 1.5 0 012 8.5v-3C2 4.67 2.67 4 3.5 4H4V3zm3 0H5v1h2V3zM3.5 5a.5.5 0 00-.5.5v3c0 .28.22.5.5.5h5a.5.5 0 00.5-.5v-3a.5.5 0 00-.5-.5h-5z",
    fill: primaryFill
  }));
};

export const Briefcase12Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Briefcase12RegularIcon, 'Briefcase12Regular');

const Briefcase16FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5.5 2h5c.28 0 .5.22.5.5V5h1a2 2 0 012 2v5a2 2 0 01-2 2H4a2 2 0 01-2-2V7c0-1.1.9-2 2-2h1V2.5c0-.28.22-.5.5-.5zM10 5V3H6v2h4z",
    fill: primaryFill
  }));
};

export const Briefcase16Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Briefcase16FilledIcon, 'Briefcase16Filled');

const Briefcase16RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5.5 2h5c.28 0 .5.22.5.5V5h1a2 2 0 012 2v5a2 2 0 01-2 2H4a2 2 0 01-2-2V7c0-1.1.9-2 2-2h1V2.5c0-.28.22-.5.5-.5zM10 5V3H6v2h4zM4 6a1 1 0 00-1 1v5a1 1 0 001 1h8a1 1 0 001-1V7a1 1 0 00-1-1H4z",
    fill: primaryFill
  }));
};

export const Briefcase16Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Briefcase16RegularIcon, 'Briefcase16Regular');

const Briefcase20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M7 3.5c0-.28.22-.5.5-.5h5c.28 0 .5.22.5.5V6h1.5A2.5 2.5 0 0117 8.5v5a2.5 2.5 0 01-2.5 2.5h-9A2.5 2.5 0 013 13.5v-5A2.5 2.5 0 015.5 6H7V3.5zM12 6V4H8v2h4z",
    fill: primaryFill
  }));
};

export const Briefcase20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Briefcase20FilledIcon, 'Briefcase20Filled');

const Briefcase20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M7.5 3a.5.5 0 00-.5.5V6H5.5A2.5 2.5 0 003 8.5v5A2.5 2.5 0 005.5 16h9a2.5 2.5 0 002.5-2.5v-5A2.5 2.5 0 0014.5 6H13V3.5a.5.5 0 00-.5-.5h-5zM12 6H8V4h4v2zM5.5 7h9c.83 0 1.5.67 1.5 1.5v5c0 .83-.67 1.5-1.5 1.5h-9A1.5 1.5 0 014 13.5v-5C4 7.67 4.67 7 5.5 7z",
    fill: primaryFill
  }));
};

export const Briefcase20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Briefcase20RegularIcon, 'Briefcase20Regular');

const Briefcase24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M15.25 3c.41 0 .75.34.75.75V7h1.75C19.55 7 21 8.46 21 10.25v6.5c0 1.8-1.46 3.25-3.25 3.25H6.25A3.25 3.25 0 013 16.75v-6.5C3 8.45 4.46 7 6.25 7H8V3.75c0-.38.28-.7.65-.74l.1-.01h6.5zm-.75 1.5h-5V7h5V4.5z",
    fill: primaryFill
  }));
};

export const Briefcase24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Briefcase24FilledIcon, 'Briefcase24Filled');

const Briefcase24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M8.75 3h6.5c.38 0 .7.28.74.65l.01.1V7h1.75C19.55 7 21 8.46 21 10.25v6.5c0 1.8-1.46 3.25-3.25 3.25H6.25A3.25 3.25 0 013 16.75v-6.5C3 8.45 4.46 7 6.25 7H8V3.75c0-.38.28-.7.65-.74l.1-.01h6.5-6.5zm9 5.5H6.25c-.97 0-1.75.78-1.75 1.75v6.5c0 .97.78 1.75 1.75 1.75h11.5c.97 0 1.75-.78 1.75-1.75v-6.5c0-.97-.78-1.75-1.75-1.75zm-3.25-4h-5V7h5V4.5z",
    fill: primaryFill
  }));
};

export const Briefcase24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Briefcase24RegularIcon, 'Briefcase24Regular');

const Briefcase28FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M9.75 3a.75.75 0 00-.75.75V8H6.75A3.75 3.75 0 003 11.75v8.5A3.75 3.75 0 006.75 24h14.5A3.75 3.75 0 0025 20.25v-8.5A3.75 3.75 0 0021.25 8H19V3.75a.75.75 0 00-.75-.75h-8.5zm7.75 5h-7V4.5h7V8z",
    fill: primaryFill
  }));
};

export const Briefcase28Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Briefcase28FilledIcon, 'Briefcase28Filled');

const Briefcase28RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M9.75 3a.75.75 0 00-.75.75V8H6.75A3.75 3.75 0 003 11.75v8.5A3.75 3.75 0 006.75 24h14.5A3.75 3.75 0 0025 20.25v-8.5A3.75 3.75 0 0021.25 8H19V3.75a.75.75 0 00-.75-.75h-8.5zm7.75 5h-7V4.5h7V8zm-13 3.75c0-1.24 1-2.25 2.25-2.25h14.5c1.24 0 2.25 1 2.25 2.25v8.5c0 1.24-1 2.25-2.25 2.25H6.75c-1.24 0-2.25-1-2.25-2.25v-8.5z",
    fill: primaryFill
  }));
};

export const Briefcase28Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Briefcase28RegularIcon, 'Briefcase28Regular');

const Briefcase32FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M11 3a1 1 0 00-1 1v5H8a5 5 0 00-5 5v9a5 5 0 005 5h16a5 5 0 005-5v-9a5 5 0 00-5-5h-2V4a1 1 0 00-1-1H11zm9 6h-8V5h8v4z",
    fill: primaryFill
  }));
};

export const Briefcase32Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Briefcase32FilledIcon, 'Briefcase32Filled');

const Briefcase32RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M11 3a1 1 0 00-1 1v5H8a5 5 0 00-5 5v9a5 5 0 005 5h16a5 5 0 005-5v-9a5 5 0 00-5-5h-2V4a1 1 0 00-1-1H11zm9 6h-8V5h8v4zM8 11h16a3 3 0 013 3v9a3 3 0 01-3 3H8a3 3 0 01-3-3v-9a3 3 0 013-3z",
    fill: primaryFill
  }));
};

export const Briefcase32Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Briefcase32RegularIcon, 'Briefcase32Regular');

const Briefcase48FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M17.75 6c-.69 0-1.25.56-1.25 1.25V14h-4.25A6.25 6.25 0 006 20.25v13.5C6 37.2 8.8 40 12.25 40h23.5C39.2 40 42 37.2 42 33.75v-13.5C42 16.8 39.2 14 35.75 14H31.5V7.25c0-.69-.56-1.25-1.25-1.25h-12.5zM29 14H19V8.5h10V14z",
    fill: primaryFill
  }));
};

export const Briefcase48Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Briefcase48FilledIcon, 'Briefcase48Filled');

const Briefcase48RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M17.75 6c-.69 0-1.25.56-1.25 1.25V14h-4.25A6.25 6.25 0 006 20.25v13.5C6 37.2 8.8 40 12.25 40h23.5C39.2 40 42 37.2 42 33.75v-13.5C42 16.8 39.2 14 35.75 14H31.5V7.25c0-.69-.56-1.25-1.25-1.25h-12.5zM29 14H19V8.5h10V14zM8.5 20.25a3.75 3.75 0 013.75-3.75h23.5a3.75 3.75 0 013.75 3.75v13.5a3.75 3.75 0 01-3.75 3.75h-23.5a3.75 3.75 0 01-3.75-3.75v-13.5z",
    fill: primaryFill
  }));
};

export const Briefcase48Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Briefcase48RegularIcon, 'Briefcase48Regular');

const BriefcaseMedical16FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5 2.5c0-.28.22-.5.5-.5h5c.28 0 .5.22.5.5V5h1a2 2 0 012 2v5a2 2 0 01-2 2H4a2 2 0 01-2-2V7c0-1.1.9-2 2-2h1V2.5zm5 .5H6v2h4V3zM8.5 8a.5.5 0 00-1 0v1h-1a.5.5 0 000 1h1v1a.5.5 0 001 0v-1h1a.5.5 0 000-1h-1V8z",
    fill: primaryFill
  }));
};

export const BriefcaseMedical16Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/BriefcaseMedical16FilledIcon, 'BriefcaseMedical16Filled');

const BriefcaseMedical16RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M8.5 8a.5.5 0 00-1 0v1h-1a.5.5 0 000 1h1v1a.5.5 0 001 0v-1h1a.5.5 0 000-1h-1V8zM5 2.5V5H4a2 2 0 00-2 2v5c0 1.1.9 2 2 2h8a2 2 0 002-2V7a2 2 0 00-2-2h-1V2.5a.5.5 0 00-.5-.5h-5a.5.5 0 00-.5.5zm5 .5v2H6V3h4zM4 6h8a1 1 0 011 1v5a1 1 0 01-1 1H4a1 1 0 01-1-1V7a1 1 0 011-1z",
    fill: primaryFill
  }));
};

export const BriefcaseMedical16Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/BriefcaseMedical16RegularIcon, 'BriefcaseMedical16Regular');

const BriefcaseMedical20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M7.5 3a.5.5 0 00-.5.5V6H5a3 3 0 00-3 3v6a3 3 0 003 3h10a3 3 0 003-3V9a3 3 0 00-3-3h-2V3.5a.5.5 0 00-.5-.5h-5zM12 6H8V4h4v2zm-2 3c.28 0 .5.22.5.5v2h2a.5.5 0 010 1h-2v2a.5.5 0 01-1 0v-2h-2a.5.5 0 010-1h2v-2c0-.28.22-.5.5-.5z",
    fill: primaryFill
  }));
};

export const BriefcaseMedical20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/BriefcaseMedical20FilledIcon, 'BriefcaseMedical20Filled');

const BriefcaseMedical20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10.5 9.5a.5.5 0 00-1 0v2h-2a.5.5 0 000 1h2v2a.5.5 0 001 0v-2h2a.5.5 0 000-1h-2v-2zM7 3.5c0-.28.22-.5.5-.5h5c.28 0 .5.22.5.5V6h2a3 3 0 013 3v6a3 3 0 01-3 3H5a3 3 0 01-3-3V9a3 3 0 013-3h2V3.5zm5 .5H8v2h4V4zM5 7a2 2 0 00-2 2v6c0 1.1.9 2 2 2h10a2 2 0 002-2V9a2 2 0 00-2-2H5z",
    fill: primaryFill
  }));
};

export const BriefcaseMedical20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/BriefcaseMedical20RegularIcon, 'BriefcaseMedical20Regular');

const BriefcaseMedical24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M16 3.75a.75.75 0 00-.75-.75h-6.6a.75.75 0 00-.65.75V7H6.25A3.25 3.25 0 003 10.25v6.5C3 18.55 4.46 20 6.25 20h11.5c1.8 0 3.25-1.46 3.25-3.25v-6.5C21 8.45 19.54 7 17.75 7H16V3.75zm-6.5.75h5V7h-5V4.5zm2 11.25V14H9.75a.75.75 0 010-1.5h1.75v-1.75a.75.75 0 011.5 0v1.75h1.75a.75.75 0 010 1.5H13v1.75a.75.75 0 01-1.5 0z",
    fill: primaryFill
  }));
};

export const BriefcaseMedical24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/BriefcaseMedical24FilledIcon, 'BriefcaseMedical24Filled');

const BriefcaseMedical24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M11.5 12.5v-1.75a.75.75 0 011.5 0v1.75h1.75a.75.75 0 010 1.5H13v1.75a.75.75 0 01-1.5 0V14H9.75a.75.75 0 010-1.5h1.75zM8.75 3h6.5c.38 0 .7.28.74.65l.01.1V7h1.75C19.55 7 21 8.46 21 10.25v6.5c0 1.8-1.46 3.25-3.25 3.25H6.25A3.25 3.25 0 013 16.75v-6.5C3 8.45 4.46 7 6.25 7H8V3.75c0-.38.28-.7.65-.74l.1-.01zm9 5.5H6.25c-.97 0-1.75.78-1.75 1.75v6.5c0 .97.78 1.75 1.75 1.75h11.5c.97 0 1.75-.78 1.75-1.75v-6.5c0-.97-.78-1.75-1.75-1.75zm-3.25-4h-5V7h5V4.5z",
    fill: primaryFill
  }));
};

export const BriefcaseMedical24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/BriefcaseMedical24RegularIcon, 'BriefcaseMedical24Regular');

const BriefcaseMedical32FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M12 4a1 1 0 00-1 1v4H8a4 4 0 00-4 4v10a4 4 0 004 4h16a4 4 0 004-4V13a4 4 0 00-4-4h-3V5a1 1 0 00-1-1h-8zm7 5h-6V6h6v3zm-2 6v2h2a1 1 0 110 2h-2v2a1 1 0 11-2 0v-2h-2a1 1 0 110-2h2v-2a1 1 0 112 0z",
    fill: primaryFill
  }));
};

export const BriefcaseMedical32Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/BriefcaseMedical32FilledIcon, 'BriefcaseMedical32Filled');

const BriefcaseMedical32RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M17 15a1 1 0 10-2 0v2h-2a1 1 0 100 2h2v2a1 1 0 102 0v-2h2a1 1 0 100-2h-2v-2zM12 4h8a1 1 0 011 1v4h3a4 4 0 014 4v10a4 4 0 01-4 4H8a4 4 0 01-4-4V13a4 4 0 014-4h3V5a1 1 0 011-1zm7 5V6h-6v3h6zM8 11a2 2 0 00-2 2v10c0 1.1.9 2 2 2h16a2 2 0 002-2V13a2 2 0 00-2-2H8z",
    fill: primaryFill
  }));
};

export const BriefcaseMedical32Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/BriefcaseMedical32RegularIcon, 'BriefcaseMedical32Regular');

const BriefcaseOff16FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M12.77 13.48l1.38 1.37a.5.5 0 00.7-.7l-13-13a.5.5 0 10-.7.7L4.79 5.5H3.5a2 2 0 00-2 2v4c0 1.1.9 2 2 2h9c.1 0 .18 0 .27-.02zm1.73-1.98a2 2 0 01-.14.74L7.62 5.5H10V3H6v.88l-1-1V2.5c0-.28.22-.5.5-.5h5c.28 0 .5.22.5.5v3h1.5a2 2 0 012 2v4z",
    fill: primaryFill
  }));
};

export const BriefcaseOff16Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/BriefcaseOff16FilledIcon, 'BriefcaseOff16Filled');

const BriefcaseOff16RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M13.2 13.9l.95.95a.5.5 0 00.7-.7l-13-13a.5.5 0 10-.7.7L4.29 5H3.5A2.5 2.5 0 001 7.5v4A2.5 2.5 0 003.5 14h9c.24 0 .47-.03.7-.1zm-.9-.9H3.5A1.5 1.5 0 012 11.5v-4C2 6.67 2.67 6 3.5 6h1.8l7 7zm1.7-1.5c0 .12-.01.23-.04.34l.78.78c.17-.34.26-.72.26-1.12v-4A2.5 2.5 0 0012.5 5H11V2.5a.5.5 0 00-.5-.5h-5a.5.5 0 00-.5.5v.38l1 1V3h4v2H7.12l1 1h4.38c.83 0 1.5.67 1.5 1.5v4z",
    fill: primaryFill
  }));
};

export const BriefcaseOff16Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/BriefcaseOff16RegularIcon, 'BriefcaseOff16Regular');

const BriefcaseOff20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2.85 2.15a.5.5 0 10-.7.7L5.3 6.01A2.5 2.5 0 003 8.5v5A2.5 2.5 0 005.5 16h9c.24 0 .47-.03.7-.1l1.95 1.95a.5.5 0 00.7-.7l-1.73-1.74L2.85 2.15zM17 13.5c0 .4-.1.78-.26 1.12L8.12 6H12V4H8v1.88l-1-1V3.5c0-.28.22-.5.5-.5h5c.28 0 .5.22.5.5V6h1.5A2.5 2.5 0 0117 8.5v5z",
    fill: primaryFill
  }));
};

export const BriefcaseOff20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/BriefcaseOff20FilledIcon, 'BriefcaseOff20Filled');

const BriefcaseOff20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2.85 2.15a.5.5 0 10-.7.7L5.3 6.01A2.5 2.5 0 003 8.5v5A2.5 2.5 0 005.5 16h9c.24 0 .47-.03.7-.1l1.95 1.95a.5.5 0 00.7-.7l-1.73-1.74-.72-.71L2.85 2.15zM14.3 15H5.5A1.5 1.5 0 014 13.5v-5C4 7.67 4.67 7 5.5 7h.8l8 8zM16 13.5c0 .12-.01.23-.04.34l.78.78c.17-.34.26-.72.26-1.12v-5A2.5 2.5 0 0014.5 6H13V3.5a.5.5 0 00-.5-.5h-5a.5.5 0 00-.5.5v1.38l1 1V4h4v2H8.12l1 1h5.38c.83 0 1.5.67 1.5 1.5v5z",
    fill: primaryFill
  }));
};

export const BriefcaseOff20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/BriefcaseOff20RegularIcon, 'BriefcaseOff20Regular');

const BriefcaseOff24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3.28 2.22a.75.75 0 00-1.06 1.06l3.73 3.73A3.25 3.25 0 003 10.25v6.5C3 18.55 4.46 20 6.25 20h11.5c.36 0 .7-.06 1.02-.16l1.95 1.94a.75.75 0 001.06-1.06L3.28 2.22zM21 16.75c0 .32-.05.64-.14.93L10.18 7h4.32V4.5h-5v1.82L8 4.82V3.75c0-.38.28-.7.65-.74l.1-.01h6.5c.41 0 .75.34.75.75V7h1.75C19.55 7 21 8.46 21 10.25v6.5z",
    fill: primaryFill
  }));
};

export const BriefcaseOff24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/BriefcaseOff24FilledIcon, 'BriefcaseOff24Filled');

const BriefcaseOff24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3.28 2.22a.75.75 0 00-1.06 1.06l3.73 3.73A3.25 3.25 0 003 10.25v6.5C3 18.55 4.46 20 6.25 20h11.5c.36 0 .7-.06 1.02-.16l1.95 1.94a.75.75 0 001.06-1.06L3.28 2.22zM17.44 18.5H6.25c-.97 0-1.75-.78-1.75-1.75v-6.5c0-.97.78-1.75 1.75-1.75h1.19l10 10zm2.06-8.25v6.07l1.36 1.36c.1-.3.14-.6.14-.93v-6.5C21 8.45 19.55 7 17.75 7H16V3.65a.75.75 0 00-.75-.65h-6.6a.75.75 0 00-.65.75v1.07l1.5 1.5V4.5h5V7h-4.32l1.5 1.5h6.07c.97 0 1.75.78 1.75 1.75z",
    fill: primaryFill
  }));
};

export const BriefcaseOff24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/BriefcaseOff24RegularIcon, 'BriefcaseOff24Regular');

const BriefcaseOff28FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3.28 2.22a.75.75 0 00-1.06 1.06L6.94 8h-.19A3.75 3.75 0 003 11.75v8.5A3.75 3.75 0 006.75 24h14.5c.5 0 .98-.1 1.41-.28l2.06 2.06a.75.75 0 101.06-1.06L3.28 2.22zM25 20.25c0 .47-.09.91-.24 1.33L11.18 8h6.32V4.5h-7v2.82L9 5.82V3.75c0-.41.34-.75.75-.75h8.5c.41 0 .75.34.75.75V8h2.25A3.75 3.75 0 0125 11.75v8.5z",
    fill: primaryFill
  }));
};

export const BriefcaseOff28Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/BriefcaseOff28FilledIcon, 'BriefcaseOff28Filled');

const BriefcaseOff28RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3.28 2.22a.75.75 0 00-1.06 1.06L6.94 8h-.19A3.75 3.75 0 003 11.75v8.5A3.75 3.75 0 006.75 24h14.5c.5 0 .98-.1 1.41-.28l2.06 2.06a.75.75 0 101.06-1.06L3.28 2.22zm18.15 20.27l-.18.01H6.75c-1.24 0-2.25-1-2.25-2.25v-8.5c0-1.24 1-2.25 2.25-2.25h1.69l13 13zm2.07-2.24v.07l1.26 1.26c.15-.42.24-.86.24-1.33v-8.5A3.75 3.75 0 0021.25 8H19V3.75a.75.75 0 00-.75-.75h-8.5a.75.75 0 00-.75.75v2.07l1.5 1.5V4.5h7V8h-6.32l1.5 1.5h8.57c1.24 0 2.25 1 2.25 2.25v8.5z",
    fill: primaryFill
  }));
};

export const BriefcaseOff28Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/BriefcaseOff28RegularIcon, 'BriefcaseOff28Regular');

const BriefcaseOff32FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3.7 2.3a1 1 0 00-1.4 1.4l5.3 5.32A5 5 0 003 14v9a5 5 0 005 5h16c.76 0 1.47-.17 2.12-.47l2.17 2.18a1 1 0 001.42-1.42l-26-26zM29 23c0 .72-.15 1.41-.43 2.03L12.54 9H20V5h-8v3.46l-2-2V4a1 1 0 011-1h10a1 1 0 011 1v5h2a5 5 0 015 5v9z",
    fill: primaryFill
  }));
};

export const BriefcaseOff32Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/BriefcaseOff32FilledIcon, 'BriefcaseOff32Filled');

const BriefcaseOff32RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3.7 2.3a1 1 0 00-1.4 1.4l5.3 5.32A5 5 0 003 14v9a5 5 0 005 5h16c.76 0 1.47-.17 2.12-.47l2.17 2.18a1 1 0 001.42-1.42l-26-26zm20.84 23.65c-.18.03-.36.05-.54.05H8a3 3 0 01-3-3v-9a3 3 0 013-3h1.59l14.95 14.95zM29 23c0 .72-.15 1.41-.43 2.03l-1.6-1.6c.02-.14.03-.28.03-.43v-9a3 3 0 00-3-3h-9.46l-2-2H20V5h-8v3.46l-2-2V4a1 1 0 011-1h10a1 1 0 011 1v5h2a5 5 0 015 5v9z",
    fill: primaryFill
  }));
};

export const BriefcaseOff32Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/BriefcaseOff32RegularIcon, 'BriefcaseOff32Regular');

const BriefcaseOff48FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M37.87 39.63l4 4a1.25 1.25 0 001.76-1.76L6.13 4.37a1.25 1.25 0 10-1.76 1.76L12.23 14A6.25 6.25 0 006 20.25v13.5C6 37.2 8.8 40 12.25 40h23.5c.74 0 1.45-.13 2.12-.37zM42 33.75c0 .87-.18 1.7-.5 2.45L19.3 14H29V8.5H19v5.2l-2.5-2.5V7.25c0-.69.56-1.25 1.25-1.25h12.5c.69 0 1.25.56 1.25 1.25V14h4.25C39.2 14 42 16.8 42 20.25v13.5z",
    fill: primaryFill
  }));
};

export const BriefcaseOff48Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/BriefcaseOff48FilledIcon, 'BriefcaseOff48Filled');

const BriefcaseOff48RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M37.87 39.63l4 4a1.25 1.25 0 001.76-1.76L6.13 4.37a1.25 1.25 0 10-1.76 1.76L12.23 14A6.25 6.25 0 006 20.25v13.5C6 37.2 8.8 40 12.25 40h23.5c.74 0 1.45-.13 2.12-.37zm-2.14-2.13H12.25a3.75 3.75 0 01-3.75-3.75v-13.5a3.75 3.75 0 013.75-3.75h2.48l21 21zm3.77-3.75c0 .14 0 .28-.02.42l2.02 2.03c.32-.75.5-1.58.5-2.45v-13.5C42 16.8 39.2 14 35.75 14H31.5V7.25c0-.69-.56-1.25-1.25-1.25h-12.5c-.69 0-1.25.56-1.25 1.25v3.95l2.5 2.5V8.5h10V14h-9.7l2.5 2.5h13.95a3.75 3.75 0 013.75 3.75v13.5z",
    fill: primaryFill
  }));
};

export const BriefcaseOff48Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/BriefcaseOff48RegularIcon, 'BriefcaseOff48Regular');

const BrightnessHigh16FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M8.5 1.5a.5.5 0 00-1 0v1a.5.5 0 001 0v-1z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M11 8a3 3 0 11-6 0 3 3 0 016 0zM8 6v4a2 2 0 100-4z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M15 8a.5.5 0 01-.5.5h-1a.5.5 0 010-1h1c.28 0 .5.22.5.5z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M8.5 13.5a.5.5 0 00-1 0v1a.5.5 0 001 0v-1z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M3 8a.5.5 0 01-.5.5h-1a.5.5 0 010-1h1c.28 0 .5.22.5.5z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M3.85 3.15a.5.5 0 00-.7.7l1 1a.5.5 0 10.7-.7l-1-1z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M3.15 12.85c.2.2.5.2.7 0l1-1a.5.5 0 10-.7-.7l-1 1a.5.5 0 000 .7z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M12.15 3.15a.5.5 0 01.7.7l-1 1a.5.5 0 01-.7-.7l1-1z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M12.85 12.85a.5.5 0 01-.7 0l-1-1a.5.5 0 01.7-.7l1 1c.2.2.2.5 0 .7z",
    fill: primaryFill
  }));
};

export const BrightnessHigh16Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/BrightnessHigh16FilledIcon, 'BrightnessHigh16Filled');

const BrightnessHigh16RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M8 1c.28 0 .5.22.5.5v1a.5.5 0 01-1 0v-1c0-.28.22-.5.5-.5zm0 10a3 3 0 100-6 3 3 0 000 6zm0-1a2 2 0 110-4 2 2 0 010 4zm6.5-1.5a.5.5 0 000-1h-1a.5.5 0 000 1h1zM8 13c.28 0 .5.22.5.5v1a.5.5 0 01-1 0v-1c0-.28.22-.5.5-.5zM2.5 8.5a.5.5 0 000-1h-1a.5.5 0 000 1h1zm.65-5.35c.2-.2.5-.2.7 0l1 1a.5.5 0 11-.7.7l-1-1a.5.5 0 010-.7zm.7 9.7a.5.5 0 11-.7-.7l1-1a.5.5 0 11.7.7l-1 1zm9-9.7a.5.5 0 00-.7 0l-1 1a.5.5 0 00.7.7l1-1a.5.5 0 000-.7zm-.7 9.7a.5.5 0 00.7-.7l-1-1a.5.5 0 00-.7.7l1 1z",
    fill: primaryFill
  }));
};

export const BrightnessHigh16Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/BrightnessHigh16RegularIcon, 'BrightnessHigh16Regular');

const BrightnessHigh20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10.5 2.5a.5.5 0 00-1 0v1a.5.5 0 001 0v-1zM10 6a4 4 0 110 8 4 4 0 010-8zm3 4a3 3 0 00-3-3v6a3 3 0 003-3zm5 0a.5.5 0 01-.5.5h-1a.5.5 0 010-1h1c.28 0 .5.22.5.5zm-7.5 6.5a.5.5 0 00-1 0v1a.5.5 0 001 0v-1zM4 10a.5.5 0 01-.5.5H2.46a.5.5 0 010-1H3.5c.28 0 .5.22.5.5zm.85-5.85a.5.5 0 10-.7.7l1 1a.5.5 0 10.7-.7l-1-1zm-.7 11.7c.2.2.5.2.7 0l1-1a.5.5 0 00-.7-.7l-1 1a.5.5 0 000 .7zm11-11.7a.5.5 0 01.7.7l-1 1a.5.5 0 01-.7-.7l1-1zm.7 11.7a.5.5 0 01-.7 0l-1-1a.5.5 0 01.7-.7l1 1c.2.2.2.5 0 .7z",
    fill: primaryFill
  }));
};

export const BrightnessHigh20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/BrightnessHigh20FilledIcon, 'BrightnessHigh20Filled');

const BrightnessHigh20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10 2c.28 0 .5.22.5.5v1a.5.5 0 01-1 0v-1c0-.28.22-.5.5-.5zm0 12a4 4 0 100-8 4 4 0 000 8zm0-1a3 3 0 110-6 3 3 0 010 6zm7.5-2.5a.5.5 0 000-1h-1a.5.5 0 000 1h1zM10 16c.28 0 .5.22.5.5v1a.5.5 0 01-1 0v-1c0-.28.22-.5.5-.5zm-6.5-5.5a.5.5 0 000-1H2.46a.5.5 0 000 1H3.5zm.65-6.35c.2-.2.5-.2.7 0l1 1a.5.5 0 11-.7.7l-1-1a.5.5 0 010-.7zm.7 11.7a.5.5 0 01-.7-.7l1-1a.5.5 0 01.7.7l-1 1zm11-11.7a.5.5 0 00-.7 0l-1 1a.5.5 0 00.7.7l1-1a.5.5 0 000-.7zm-.7 11.7a.5.5 0 00.7-.7l-1-1a.5.5 0 00-.7.7l1 1z",
    fill: primaryFill
  }));
};

export const BrightnessHigh20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/BrightnessHigh20RegularIcon, 'BrightnessHigh20Regular');

const BrightnessHigh24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M12.75 2.75a.75.75 0 00-1.5 0v1.5a.75.75 0 001.5 0v-1.5zM17 12a5 5 0 11-10 0 5 5 0 0110 0zm-1.5 0A3.5 3.5 0 0012 8.5v7a3.5 3.5 0 003.5-3.5zm6.5 0c0 .41-.34.75-.75.75h-1.5a.75.75 0 010-1.5h1.5c.41 0 .75.34.75.75zm-9.25 7.75a.75.75 0 00-1.5 0v1.5a.75.75 0 001.5 0v-1.5zM5 12c0 .41-.34.75-.75.75h-1.5a.75.75 0 010-1.5h1.5c.41 0 .75.34.75.75zm.28-7.78a.75.75 0 10-1.06 1.06l1.5 1.5a.75.75 0 001.06-1.06l-1.5-1.5zM4.22 19.78c.3.3.77.3 1.06 0l1.5-1.5a.75.75 0 00-1.06-1.06l-1.5 1.5c-.3.3-.3.77 0 1.06zm14.5-15.56a.75.75 0 111.06 1.06l-1.5 1.5a.75.75 0 11-1.06-1.06l1.5-1.5zm1.06 15.56c-.3.3-.77.3-1.06 0l-1.5-1.5a.75.75 0 011.06-1.06l1.5 1.5c.3.3.3.77 0 1.06z",
    fill: primaryFill
  }));
};

export const BrightnessHigh24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/BrightnessHigh24FilledIcon, 'BrightnessHigh24Filled');

const BrightnessHigh24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M12 2c.41 0 .75.34.75.75v1.5a.75.75 0 01-1.5 0v-1.5c0-.41.34-.75.75-.75zm0 15a5 5 0 100-10 5 5 0 000 10zm0-1.5a3.5 3.5 0 110-7 3.5 3.5 0 010 7zm9.25-2.75a.75.75 0 000-1.5h-1.5a.75.75 0 000 1.5h1.5zM12 19c.41 0 .75.34.75.75v1.5a.75.75 0 01-1.5 0v-1.5c0-.41.34-.75.75-.75zm-7.75-6.25a.75.75 0 000-1.5h-1.5a.75.75 0 000 1.5h1.5zm-.03-8.53c.3-.3.77-.3 1.06 0l1.5 1.5a.75.75 0 01-1.06 1.06l-1.5-1.5a.75.75 0 010-1.06zm1.06 15.56a.75.75 0 11-1.06-1.06l1.5-1.5a.75.75 0 111.06 1.06l-1.5 1.5zm14.5-15.56a.75.75 0 00-1.06 0l-1.5 1.5a.75.75 0 001.06 1.06l1.5-1.5c.3-.3.3-.77 0-1.06zm-1.06 15.56a.75.75 0 101.06-1.06l-1.5-1.5a.75.75 0 10-1.06 1.06l1.5 1.5z",
    fill: primaryFill
  }));
};

export const BrightnessHigh24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/BrightnessHigh24RegularIcon, 'BrightnessHigh24Regular');

const BrightnessHigh28FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M14.75 2.75a.75.75 0 00-1.5 0v1.5a.75.75 0 001.5 0v-1.5zM20 14a6 6 0 11-12 0 6 6 0 0112 0zm-1.5 0A4.5 4.5 0 0014 9.5v9a4.5 4.5 0 004.5-4.5zm7.5 0c0 .41-.34.75-.75.75h-1.5a.75.75 0 010-1.5h1.5c.41 0 .75.34.75.75zm-11.25 9.75a.75.75 0 00-1.5 0v1.5a.75.75 0 001.5 0v-1.5zM5 14c0 .41-.34.75-.75.75h-1.5a.75.75 0 010-1.5h1.5c.41 0 .75.34.75.75zm1.28-8.78a.75.75 0 10-1.06 1.06l1.5 1.5a.75.75 0 001.06-1.06l-1.5-1.5zM5.22 22.78c.3.3.77.3 1.06 0l1.5-1.5a.75.75 0 10-1.06-1.06l-1.5 1.5c-.3.3-.3.77 0 1.06zm16.5-17.56a.75.75 0 111.06 1.06l-1.5 1.5a.75.75 0 11-1.06-1.06l1.5-1.5zm1.06 17.56c-.3.3-.77.3-1.06 0l-1.5-1.5a.75.75 0 111.06-1.06l1.5 1.5c.3.3.3.77 0 1.06z",
    fill: primaryFill
  }));
};

export const BrightnessHigh28Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/BrightnessHigh28FilledIcon, 'BrightnessHigh28Filled');

const BrightnessHigh28RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M14 2c.41 0 .75.34.75.75v1.5a.75.75 0 01-1.5 0v-1.5c0-.41.33-.75.75-.75zm0 18a6 6 0 100-12 6 6 0 000 12zm0-1.5a4.5 4.5 0 110-9 4.5 4.5 0 010 9zm11.25-3.75a.75.75 0 000-1.5h-1.5a.75.75 0 000 1.5h1.5zM14 23c.41 0 .75.34.75.75v1.5a.75.75 0 01-1.5 0v-1.5c0-.41.33-.75.75-.75zm-9.75-8.25a.75.75 0 000-1.5h-1.5a.75.75 0 000 1.5h1.5zm.97-9.53c.3-.3.77-.3 1.06 0l1.5 1.5a.75.75 0 01-1.06 1.06l-1.5-1.5a.75.75 0 010-1.06zm1.06 17.56a.75.75 0 01-1.06-1.06l1.5-1.5a.75.75 0 011.06 1.06l-1.5 1.5zm16.5-17.56a.75.75 0 00-1.06 0l-1.5 1.5a.75.75 0 001.06 1.06l1.5-1.5c.3-.3.3-.77 0-1.06zm-1.05 17.57a.75.75 0 101.06-1.06l-1.51-1.51a.75.75 0 10-1.06 1.06l1.5 1.5z",
    fill: primaryFill
  }));
};

export const BrightnessHigh28Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/BrightnessHigh28RegularIcon, 'BrightnessHigh28Regular');

const BrightnessHigh32FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M17 3a1 1 0 00-2 0v2a1 1 0 102 0V3zm6 13a7 7 0 11-14 0 7 7 0 0114 0zm-2 0a5 5 0 00-5-5v10a5 5 0 005-5zm9 0a1 1 0 01-1 1h-2a1 1 0 110-2h2a1 1 0 011 1zM17 27a1 1 0 00-2 0v2a1 1 0 102 0v-2zM6 16a1 1 0 01-1 1H3a1 1 0 110-2h2a1 1 0 011 1zm.7-10.7a1 1 0 10-1.4 1.4l2 2a1 1 0 001.4-1.4l-2-2zM5.3 26.7a1 1 0 001.4 0l2-2a1 1 0 10-1.4-1.4l-2 2a1 1 0 000 1.4zm20-21.4a1 1 0 011.4 1.4l-2 2a1 1 0 01-1.4-1.4l2-2zm0 21.4l-2-2a1 1 0 011.4-1.4l2 2a1 1 0 01-1.4 1.4z",
    fill: primaryFill
  }));
};

export const BrightnessHigh32Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/BrightnessHigh32FilledIcon, 'BrightnessHigh32Filled');

const BrightnessHigh32RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M16 2a1 1 0 011 1v2a1 1 0 01-2 0V3a1 1 0 011-1zm0 21a7 7 0 100-14 7 7 0 000 14zm0-2a5 5 0 110-10 5 5 0 010 10zm13-4a1 1 0 000-2h-2a1 1 0 100 2h2zm-13 9a1 1 0 011 1v2a1 1 0 01-2 0v-2a1 1 0 011-1zM5 17a1 1 0 100-2H3a1 1 0 100 2h2zm.3-11.7a1 1 0 011.4 0l2 2a1 1 0 01-1.4 1.4l-2-2a1 1 0 010-1.4zm1.4 21.4a1 1 0 01-1.4-1.4l2-2a1 1 0 011.4 1.4l-2 2zm20-21.4a1 1 0 00-1.4 0l-2 2a1 1 0 001.4 1.4l2-2a1 1 0 000-1.4zm-3.4 19.4l2 2a1 1 0 001.4-1.4l-2-2a1 1 0 00-1.4 1.4z",
    fill: primaryFill
  }));
};

export const BrightnessHigh32Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/BrightnessHigh32RegularIcon, 'BrightnessHigh32Regular');

const BrightnessHigh48FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M25.25 5.25a1.25 1.25 0 10-2.5 0v2.5a1.25 1.25 0 002.5 0v-2.5zm8.77 18.8a9.98 9.98 0 11-19.95 0 9.98 9.98 0 0119.95 0zm-2.5 0a7.48 7.48 0 00-7.47-7.48H24v14.95h.05a7.48 7.48 0 007.47-7.47zM44 24c0 .69-.56 1.25-1.25 1.25h-2.5a1.25 1.25 0 010-2.5h2.5c.7 0 1.25.56 1.25 1.25zM25.25 40.25a1.25 1.25 0 10-2.5 0v2.5a1.25 1.25 0 002.5 0v-2.5zM9 24c0 .69-.56 1.25-1.25 1.25h-2.5a1.25 1.25 0 010-2.5h2.5c.7 0 1.25.56 1.25 1.25zm2.13-14.63a1.25 1.25 0 10-1.76 1.76l2.5 2.5a1.25 1.25 0 001.76-1.76l-2.5-2.5zM9.37 38.63c.48.5 1.28.5 1.76 0l2.5-2.5a1.25 1.25 0 10-1.76-1.76l-2.5 2.5a1.25 1.25 0 000 1.76zm27.5-29.26a1.25 1.25 0 111.76 1.76l-2.5 2.5a1.25 1.25 0 01-1.76-1.76l2.5-2.5zm1.76 29.26c-.48.5-1.28.5-1.76 0l-2.5-2.5a1.25 1.25 0 111.76-1.76l2.5 2.5c.5.48.5 1.28 0 1.76z",
    fill: primaryFill
  }));
};

export const BrightnessHigh48Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/BrightnessHigh48FilledIcon, 'BrightnessHigh48Filled');

const BrightnessHigh48RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M24 4c.7 0 1.25.56 1.25 1.25v2.5a1.25 1.25 0 11-2.5 0v-2.5c0-.69.56-1.25 1.25-1.25zm.05 30.02a9.98 9.98 0 100-19.95 9.98 9.98 0 000 19.95zm0-2.5a7.48 7.48 0 110-14.95 7.48 7.48 0 010 14.95zm18.7-6.27a1.25 1.25 0 000-2.5h-2.5a1.25 1.25 0 000 2.5h2.5zM24 39c.7 0 1.25.56 1.25 1.25v2.5a1.25 1.25 0 01-2.5 0v-2.5c0-.7.56-1.25 1.25-1.25zM7.75 25.25a1.25 1.25 0 000-2.5h-2.5a1.25 1.25 0 100 2.5h2.5zM9.37 9.37a1.25 1.25 0 011.76 0l2.5 2.5a1.25 1.25 0 11-1.76 1.76l-2.5-2.5a1.25 1.25 0 010-1.76zm1.76 29.26a1.25 1.25 0 01-1.76-1.76l2.5-2.5a1.25 1.25 0 111.76 1.76l-2.5 2.5zm27.5-29.26a1.25 1.25 0 00-1.76 0l-2.5 2.5a1.25 1.25 0 101.76 1.76l2.5-2.5c.5-.48.5-1.28 0-1.76zm-1.76 29.26a1.25 1.25 0 001.76-1.76l-2.5-2.5a1.25 1.25 0 10-1.76 1.76l2.5 2.5z",
    fill: primaryFill
  }));
};

export const BrightnessHigh48Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/BrightnessHigh48RegularIcon, 'BrightnessHigh48Regular');

const BrightnessLow16FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M8.5 2.5a.5.5 0 00-1 0v1a.5.5 0 001 0v-1zM8 5a3 3 0 110 6 3 3 0 010-6zm2 3a2 2 0 00-2-2v4a2 2 0 002-2zm4 0a.5.5 0 01-.5.5h-1a.5.5 0 010-1h1c.28 0 .5.22.5.5zm-5.5 4.5a.5.5 0 00-1 0v1a.5.5 0 001 0v-1zM4 8a.5.5 0 01-.5.5h-1a.5.5 0 010-1h1c.28 0 .5.22.5.5zm.35-4.35a.5.5 0 00-.7.7l.5.5a.5.5 0 10.7-.7l-.5-.5zm-.7 8.7c.2.2.5.2.7 0l.5-.5a.5.5 0 10-.7-.7l-.5.5a.5.5 0 000 .7zm8-8.7a.5.5 0 01.7.7l-.5.5a.5.5 0 01-.7-.7l.5-.5zm0 8.7l-.5-.5a.5.5 0 01.7-.7l.5.5a.5.5 0 01-.7.7z",
    fill: primaryFill
  }));
};

export const BrightnessLow16Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/BrightnessLow16FilledIcon, 'BrightnessLow16Filled');

const BrightnessLow16RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M8 2c.28 0 .5.22.5.5v1a.5.5 0 01-1 0v-1c0-.28.22-.5.5-.5zm0 9a3 3 0 100-6 3 3 0 000 6zm0-1a2 2 0 110-4 2 2 0 010 4zm5.5-1.5a.5.5 0 000-1h-1a.5.5 0 000 1h1zM8 12c.28 0 .5.22.5.5v1a.5.5 0 01-1 0v-1c0-.28.22-.5.5-.5zM3.5 8.5a.5.5 0 000-1h-1a.5.5 0 000 1h1zm.15-4.85c.2-.2.5-.2.7 0l.5.5a.5.5 0 11-.7.7l-.5-.5a.5.5 0 010-.7zm.7 8.7a.5.5 0 11-.7-.7l.5-.5a.5.5 0 11.7.7l-.5.5zm8-8.7a.5.5 0 00-.7 0l-.5.5a.5.5 0 00.7.7l.5-.5a.5.5 0 000-.7zm-1.2 8.2l.5.5a.5.5 0 00.7-.7l-.5-.5a.5.5 0 00-.7.7z",
    fill: primaryFill
  }));
};

export const BrightnessLow16Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/BrightnessLow16RegularIcon, 'BrightnessLow16Regular');

const BrightnessLow20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10 3c.28 0 .5.22.5.5v1a.5.5 0 01-1 0v-1c0-.28.22-.5.5-.5zm0 3a4 4 0 100 8 4 4 0 000-8zm0 7V7a3 3 0 110 6zm6.5-2.5a.5.5 0 000-1h-1a.5.5 0 000 1h1zM10 15c.28 0 .5.22.5.5v1a.5.5 0 01-1 0v-1c0-.28.22-.5.5-.5zm-5.5-4.5a.5.5 0 000-1h-1a.5.5 0 000 1h1zm.65-5.35c.2-.2.5-.2.7 0l.5.5a.5.5 0 11-.7.7l-.5-.5a.5.5 0 010-.7zm.7 9.7a.5.5 0 01-.7-.7l.5-.5a.5.5 0 01.7.7l-.5.5zm9-9.7a.5.5 0 00-.7 0l-.5.5a.5.5 0 00.7.7l.5-.5a.5.5 0 000-.7zm-.7 9.7a.5.5 0 00.7-.7l-.5-.5a.5.5 0 00-.7.7l.5.5z",
    fill: primaryFill
  }));
};

export const BrightnessLow20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/BrightnessLow20FilledIcon, 'BrightnessLow20Filled');

const BrightnessLow20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10.5 3.5a.5.5 0 00-1 0v1a.5.5 0 001 0v-1zM10 6a4 4 0 100 8 4 4 0 000-8zm-3 4a3 3 0 116 0 3 3 0 01-6 0zm10 0a.5.5 0 01-.5.5h-1a.5.5 0 010-1h1c.28 0 .5.22.5.5zm-6.5 5.5a.5.5 0 00-1 0v1a.5.5 0 001 0v-1zM5 10a.5.5 0 01-.5.5h-1a.5.5 0 010-1h1c.28 0 .5.22.5.5zm.85-4.85a.5.5 0 10-.7.7l.5.5a.5.5 0 10.7-.7l-.5-.5zm-.7 9.7c.2.2.5.2.7 0l.5-.5a.5.5 0 00-.7-.7l-.5.5a.5.5 0 000 .7zm9-9.7a.5.5 0 01.7.7l-.5.5a.5.5 0 01-.7-.7l.5-.5zm.7 9.7a.5.5 0 01-.7 0l-.5-.5a.5.5 0 01.7-.7l.5.5c.2.2.2.5 0 .7z",
    fill: primaryFill
  }));
};

export const BrightnessLow20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/BrightnessLow20RegularIcon, 'BrightnessLow20Regular');

const BrightnessLow24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M12.75 4.25a.75.75 0 00-1.5 0v1a.75.75 0 001.5 0v-1zM17 12a5 5 0 11-10 0 5 5 0 0110 0zm-1.5 0A3.5 3.5 0 0012 8.5v7a3.5 3.5 0 003.5-3.5zm5 0c0 .41-.34.75-.75.75h-1a.75.75 0 010-1.5h1c.41 0 .75.34.75.75zm-7.75 6.75a.75.75 0 00-1.5 0v1a.75.75 0 001.5 0v-1zM6 12c0 .41-.34.75-.75.75h-1a.75.75 0 010-1.5h1c.41 0 .75.34.75.75zm1.28-5.78a.75.75 0 00-1.06 1.06l.5.5a.75.75 0 001.06-1.06l-.5-.5zM6.22 17.78c.3.3.77.3 1.06 0l.5-.5a.75.75 0 10-1.06-1.06l-.5.5c-.3.3-.3.77 0 1.06zm10.5-11.56a.75.75 0 111.06 1.06l-.5.5a.75.75 0 11-1.06-1.06l.5-.5zm1.06 11.56c-.3.3-.77.3-1.06 0l-.5-.5a.75.75 0 111.06-1.06l.5.5c.3.3.3.77 0 1.06z",
    fill: primaryFill
  }));
};

export const BrightnessLow24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/BrightnessLow24FilledIcon, 'BrightnessLow24Filled');

const BrightnessLow24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M12 3.5c.41 0 .75.34.75.75v1a.75.75 0 01-1.5 0v-1c0-.41.34-.75.75-.75zM12 17a5 5 0 100-10 5 5 0 000 10zm0-1.5a3.5 3.5 0 110-7 3.5 3.5 0 010 7zm7.75-2.75a.75.75 0 000-1.5h-1a.75.75 0 000 1.5h1zM12 18c.41 0 .75.34.75.75v1a.75.75 0 01-1.5 0v-1c0-.41.34-.75.75-.75zm-6.75-5.25a.75.75 0 000-1.5h-1a.75.75 0 000 1.5h1zm.97-6.53c.3-.3.77-.3 1.06 0l.5.5a.75.75 0 01-1.06 1.06l-.5-.5a.75.75 0 010-1.06zm1.06 11.56a.75.75 0 01-1.06-1.06l.5-.5a.75.75 0 011.06 1.06l-.5.5zm10.5-11.56a.75.75 0 00-1.06 0l-.5.5a.75.75 0 001.06 1.06l.5-.5c.3-.3.3-.77 0-1.06zm-1.06 11.56a.75.75 0 101.06-1.06l-.5-.5a.75.75 0 10-1.06 1.06l.5.5z",
    fill: primaryFill
  }));
};

export const BrightnessLow24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/BrightnessLow24RegularIcon, 'BrightnessLow24Regular');

const BrightnessLow28FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M14.75 4.75a.75.75 0 00-1.5 0v1.5a.75.75 0 001.5 0v-1.5zM20 14a6 6 0 11-12 0 6 6 0 0112 0zm-1.5 0A4.5 4.5 0 0014 9.5v9a4.5 4.5 0 004.5-4.5zm5.5 0c0 .41-.34.75-.75.75h-1.5a.75.75 0 010-1.5h1.5c.41 0 .75.34.75.75zm-9.25 7.75a.75.75 0 00-1.5 0v1.5a.75.75 0 001.5 0v-1.5zM7 14c0 .41-.34.75-.75.75h-1.5a.75.75 0 010-1.5h1.5c.41 0 .75.34.75.75zm.78-7.28a.75.75 0 00-1.06 1.06l1 1a.75.75 0 001.06-1.06l-1-1zM6.72 21.28c.3.3.77.3 1.06 0l1-1a.75.75 0 10-1.06-1.06l-1 1c-.3.3-.3.77 0 1.06zm13.5-14.56a.75.75 0 111.06 1.06l-1 1a.75.75 0 11-1.06-1.06l1-1zm1.06 14.56c-.3.3-.77.3-1.06 0l-.99-.99a.75.75 0 111.06-1.06l.99.99c.3.3.3.77 0 1.06z",
    fill: primaryFill
  }));
};

export const BrightnessLow28Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/BrightnessLow28FilledIcon, 'BrightnessLow28Filled');

const BrightnessLow28RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M14 4c.41 0 .75.34.75.75v1.5a.75.75 0 01-1.5 0v-1.5c0-.41.33-.75.75-.75zm0 16a6 6 0 100-12 6 6 0 000 12zm0-1.5a4.5 4.5 0 110-9 4.5 4.5 0 010 9zm9.25-3.75a.75.75 0 000-1.5h-1.5a.75.75 0 000 1.5h1.5zM14 21c.41 0 .75.34.75.75v1.5a.75.75 0 01-1.5 0v-1.5c0-.41.33-.75.75-.75zm-7.75-6.25a.75.75 0 000-1.5h-1.5a.75.75 0 000 1.5h1.5zm.47-8.03c.3-.3.77-.3 1.06 0l1 1a.75.75 0 01-1.06 1.06l-1-1a.75.75 0 010-1.06zm1.06 14.56a.75.75 0 01-1.06-1.06l1-1a.75.75 0 011.06 1.06l-1 1zm13.5-14.56a.75.75 0 00-1.06 0l-1 1a.75.75 0 001.06 1.06l1-1c.3-.3.3-.77 0-1.06zm-1.06 14.56a.75.75 0 101.06-1.06l-.99-.99a.75.75 0 10-1.06 1.06l.99.99z",
    fill: primaryFill
  }));
};

export const BrightnessLow28Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/BrightnessLow28RegularIcon, 'BrightnessLow28Regular');

const BrightnessLow32FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M17 5a1 1 0 00-2 0v2a1 1 0 102 0V5zm6 11a7 7 0 11-14 0 7 7 0 0114 0zm-2 0a5 5 0 00-5-5v10a5 5 0 005-5zm7 0a1 1 0 01-1 1h-2a1 1 0 110-2h2a1 1 0 011 1zm-11 9a1 1 0 00-2 0v2a1 1 0 102 0v-2zm-9-9a1 1 0 01-1 1H5a1 1 0 110-2h2a1 1 0 011 1zm.7-8.7a1 1 0 00-1.4 1.4l1 1a1 1 0 001.4-1.4l-1-1zM7.3 24.7a1 1 0 001.4 0l1-1a1 1 0 10-1.4-1.4l-1 1a1 1 0 000 1.4zm16-17.4a1 1 0 011.4 1.4l-1 1a1 1 0 01-1.4-1.4l1-1zm0 17.4l-1-1a1 1 0 011.4-1.4l1 1a1 1 0 01-1.4 1.4z",
    fill: primaryFill
  }));
};

export const BrightnessLow32Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/BrightnessLow32FilledIcon, 'BrightnessLow32Filled');

const BrightnessLow32RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M16 4a1 1 0 011 1v2a1 1 0 01-2 0V5a1 1 0 011-1zm0 19a7 7 0 100-14 7 7 0 000 14zm0-2a5 5 0 110-10 5 5 0 010 10zm11-4a1 1 0 000-2h-2a1 1 0 100 2h2zm-11 7a1 1 0 011 1v2a1 1 0 01-2 0v-2a1 1 0 011-1zm-9-7a1 1 0 100-2H5a1 1 0 100 2h2zm.3-9.7a1 1 0 011.4 0l1 1a1 1 0 11-1.4 1.4l-1-1a1 1 0 010-1.4zm1.4 17.4a1 1 0 01-1.4-1.4l1-1a1 1 0 011.4 1.4l-1 1zm16-17.4a1 1 0 00-1.4 0l-1 1a1 1 0 001.4 1.4l1-1a1 1 0 000-1.4zm-2.4 16.4l1 1a1 1 0 001.4-1.4l-1-1a1 1 0 00-1.4 1.4z",
    fill: primaryFill
  }));
};

export const BrightnessLow32Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/BrightnessLow32RegularIcon, 'BrightnessLow32Regular');

const BrightnessLow48FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M25.25 8.25a1.25 1.25 0 10-2.5 0v2.5a1.25 1.25 0 002.5 0v-2.5zm8.77 15.8a9.98 9.98 0 11-19.95 0 9.98 9.98 0 0119.95 0zm-2.5 0a7.48 7.48 0 00-7.47-7.48H24v14.95h.05a7.48 7.48 0 007.47-7.47zM41 24c0 .69-.56 1.25-1.25 1.25h-2.5a1.25 1.25 0 010-2.5h2.5c.7 0 1.25.56 1.25 1.25zM25.25 37.25a1.25 1.25 0 10-2.5 0v2.5a1.25 1.25 0 002.5 0v-2.5zM12 24c0 .69-.56 1.25-1.25 1.25h-2.5a1.25 1.25 0 110-2.5h2.5c.7 0 1.25.56 1.25 1.25zm2.13-11.63a1.25 1.25 0 00-1.76 1.76l1.5 1.5a1.25 1.25 0 001.76-1.76l-1.5-1.5zm-1.76 23.26c.48.5 1.28.5 1.76 0l1.5-1.5a1.25 1.25 0 10-1.76-1.76l-1.5 1.5a1.25 1.25 0 000 1.76zm21.5-23.26a1.25 1.25 0 011.76 1.76l-1.5 1.5a1.25 1.25 0 01-1.76-1.76l1.5-1.5zm1.76 23.26c-.48.5-1.28.5-1.76 0l-1.5-1.5a1.25 1.25 0 111.76-1.76l1.5 1.5c.5.48.5 1.28 0 1.76z",
    fill: primaryFill
  }));
};

export const BrightnessLow48Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/BrightnessLow48FilledIcon, 'BrightnessLow48Filled');

const BrightnessLow48RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M24 7c.7 0 1.25.56 1.25 1.25v2.5a1.25 1.25 0 11-2.5 0v-2.5c0-.69.56-1.25 1.25-1.25zm.05 27.02a9.98 9.98 0 100-19.95 9.98 9.98 0 000 19.95zm0-2.5a7.48 7.48 0 110-14.95 7.48 7.48 0 010 14.95zm15.7-6.27a1.25 1.25 0 100-2.5h-2.5a1.25 1.25 0 000 2.5h2.5zM24 36c.7 0 1.25.56 1.25 1.25v2.5a1.25 1.25 0 01-2.5 0v-2.5c0-.69.56-1.25 1.25-1.25zM10.75 25.25a1.25 1.25 0 100-2.5h-2.5a1.25 1.25 0 100 2.5h2.5zm1.62-12.88a1.25 1.25 0 011.76 0l1.5 1.5a1.25 1.25 0 11-1.76 1.76l-1.5-1.5a1.25 1.25 0 010-1.76zm1.76 23.26a1.25 1.25 0 01-1.76-1.76l1.5-1.5a1.25 1.25 0 011.76 1.76l-1.5 1.5zm21.5-23.26a1.25 1.25 0 00-1.76 0l-1.5 1.5a1.25 1.25 0 101.76 1.76l1.5-1.5c.5-.48.5-1.28 0-1.76zm-1.76 23.26a1.25 1.25 0 001.76-1.76l-1.5-1.5a1.25 1.25 0 00-1.76 1.76l1.5 1.5z",
    fill: primaryFill
  }));
};

export const BrightnessLow48Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/BrightnessLow48RegularIcon, 'BrightnessLow48Regular');

const BroadActivityFeed16FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2.5 2C1.67 2 1 2.67 1 3.5v3C1 7.33 1.67 8 2.5 8h11c.83 0 1.5-.67 1.5-1.5v-3c0-.83-.67-1.5-1.5-1.5h-11zm0 8c-.83 0-1.5.67-1.5 1.5v1c0 .83.67 1.5 1.5 1.5h3c.83 0 1.5-.67 1.5-1.5v-1c0-.83-.67-1.5-1.5-1.5h-3zm8 0c-.83 0-1.5.67-1.5 1.5v1c0 .83.67 1.5 1.5 1.5h3c.83 0 1.5-.67 1.5-1.5v-1c0-.83-.67-1.5-1.5-1.5h-3z",
    fill: primaryFill
  }));
};

export const BroadActivityFeed16Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/BroadActivityFeed16FilledIcon, 'BroadActivityFeed16Filled');

const BroadActivityFeed16RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M1 3.5C1 2.67 1.67 2 2.5 2h11c.83 0 1.5.67 1.5 1.5v3c0 .83-.67 1.5-1.5 1.5h-11A1.5 1.5 0 011 6.5v-3zM2.5 3a.5.5 0 00-.5.5v3c0 .28.22.5.5.5h11a.5.5 0 00.5-.5v-3a.5.5 0 00-.5-.5h-11zM1 11.5c0-.83.67-1.5 1.5-1.5h3c.83 0 1.5.67 1.5 1.5v1c0 .83-.67 1.5-1.5 1.5h-3A1.5 1.5 0 011 12.5v-1zm1.5-.5a.5.5 0 00-.5.5v1c0 .28.22.5.5.5h3a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5h-3zm8-1c-.83 0-1.5.67-1.5 1.5v1c0 .83.67 1.5 1.5 1.5h3c.83 0 1.5-.67 1.5-1.5v-1c0-.83-.67-1.5-1.5-1.5h-3zm-.5 1.5c0-.28.22-.5.5-.5h3c.28 0 .5.22.5.5v1a.5.5 0 01-.5.5h-3a.5.5 0 01-.5-.5v-1z",
    fill: primaryFill
  }));
};

export const BroadActivityFeed16Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/BroadActivityFeed16RegularIcon, 'BroadActivityFeed16Regular');

const BroadActivityFeed20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3.5 3C2.67 3 2 3.67 2 4.5v4c0 .83.67 1.5 1.5 1.5h13c.83 0 1.5-.67 1.5-1.5v-4c0-.83-.67-1.5-1.5-1.5h-13zm0 9c-.83 0-1.5.67-1.5 1.5v2c0 .83.67 1.5 1.5 1.5h4c.83 0 1.5-.67 1.5-1.5v-2c0-.83-.67-1.5-1.5-1.5h-4zm9 0c-.83 0-1.5.67-1.5 1.5v2c0 .83.67 1.5 1.5 1.5h4c.83 0 1.5-.67 1.5-1.5v-2c0-.83-.67-1.5-1.5-1.5h-4z",
    fill: primaryFill
  }));
};

export const BroadActivityFeed20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/BroadActivityFeed20FilledIcon, 'BroadActivityFeed20Filled');

const BroadActivityFeed20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2 4.5C2 3.67 2.67 3 3.5 3h13c.83 0 1.5.67 1.5 1.5v4c0 .83-.67 1.5-1.5 1.5h-13A1.5 1.5 0 012 8.5v-4zM3.5 4a.5.5 0 00-.5.5v4c0 .28.22.5.5.5h13a.5.5 0 00.5-.5v-4a.5.5 0 00-.5-.5h-13zM2 13.5c0-.83.67-1.5 1.5-1.5h4c.83 0 1.5.67 1.5 1.5v2c0 .83-.67 1.5-1.5 1.5h-4A1.5 1.5 0 012 15.5v-2zm1.5-.5a.5.5 0 00-.5.5v2c0 .28.22.5.5.5h4a.5.5 0 00.5-.5v-2a.5.5 0 00-.5-.5h-4zm9-1c-.83 0-1.5.67-1.5 1.5v2c0 .83.67 1.5 1.5 1.5h4c.83 0 1.5-.67 1.5-1.5v-2c0-.83-.67-1.5-1.5-1.5h-4zm-.5 1.5c0-.28.22-.5.5-.5h4c.28 0 .5.22.5.5v2a.5.5 0 01-.5.5h-4a.5.5 0 01-.5-.5v-2z",
    fill: primaryFill
  }));
};

export const BroadActivityFeed20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/BroadActivityFeed20RegularIcon, 'BroadActivityFeed20Regular');

const BroadActivityFeed24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M9.25 14c.96 0 1.75.78 1.75 1.75v3.5c0 .97-.79 1.75-1.75 1.75h-5.5C2.78 21 2 20.22 2 19.25v-3.5c0-.97.78-1.75 1.75-1.75h5.5zm11 0c.97 0 1.75.78 1.75 1.75v3.5c0 .97-.78 1.75-1.75 1.75h-5.5c-.96 0-1.75-.78-1.75-1.75v-3.5c0-.97.79-1.75 1.75-1.75h5.5zm0-11c.97 0 1.75.78 1.75 1.75v5.5c0 .97-.78 1.75-1.75 1.75H3.75C2.78 12 2 11.22 2 10.25v-5.5c0-.92.7-1.68 1.6-1.75h16.65z",
    fill: primaryFill
  }));
};

export const BroadActivityFeed24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/BroadActivityFeed24FilledIcon, 'BroadActivityFeed24Filled');

const BroadActivityFeed24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M9.25 14c.97 0 1.76.79 1.76 1.75v3.5c0 .97-.79 1.75-1.76 1.75h-5.5C2.78 21 2 20.22 2 19.25v-3.5C2 14.8 2.78 14 3.75 14h5.5zm11 0c.97 0 1.75.79 1.75 1.75v3.5c0 .97-.78 1.75-1.75 1.75h-5.5c-.97 0-1.76-.78-1.76-1.75v-3.5c0-.96.79-1.75 1.75-1.75h5.51zm-11 1.5h-5.5a.25.25 0 00-.25.25v3.5c0 .14.11.25.25.25h5.5c.14 0 .25-.1.25-.25v-3.5a.25.25 0 00-.25-.25zm11 0h-5.5a.25.25 0 00-.26.25v3.5c0 .14.12.25.25.25h5.51c.14 0 .25-.1.25-.25v-3.5a.25.25 0 00-.25-.25zm0-12.5c.97 0 1.75.78 1.75 1.75v5.5c0 .97-.78 1.75-1.75 1.75H3.75C2.78 12 2 11.22 2 10.25v-5.5c0-.92.7-1.67 1.6-1.74L3.76 3h16.5zm0 1.5H3.69a.25.25 0 00-.19.25v5.5c0 .14.11.25.25.25h16.5c.14 0 .25-.11.25-.25v-5.5a.25.25 0 00-.25-.25z",
    fill: primaryFill
  }));
};

export const BroadActivityFeed24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/BroadActivityFeed24RegularIcon, 'BroadActivityFeed24Regular');

const Broom16FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M14.85 1.15c.2.2.2.5 0 .7L10.9 5.81a4.78 4.78 0 00-.71-.7l3.96-3.96c.2-.2.5-.2.7 0zM4.65 6.19l-.39.36 5.2 5.2.4-.4a3.67 3.67 0 10-5.2-5.16zM1.3 8.04l2.1-.95 5.52 5.52-.95 2.1a.5.5 0 01-.81.14l-6-6a.5.5 0 01.14-.8z",
    fill: primaryFill
  }));
};

export const Broom16Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Broom16FilledIcon, 'Broom16Filled');

const Broom16RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M14.85 1.15a.5.5 0 00-.7 0L9.48 5.82a3.68 3.68 0 00-4.83.37l-.68.64-2.68 1.21a.5.5 0 00-.14.81l6 6a.5.5 0 00.8-.14l1.22-2.67.68-.69a3.67 3.67 0 00.33-4.83l4.67-4.67a.5.5 0 000-.7zm-10.7 6.7l4 4-.8 1.79-4.99-4.98 1.78-.81zm4.6 3.2L4.97 7.25l.37-.34.01-.02a2.67 2.67 0 113.8 3.75l-.4.4z",
    fill: primaryFill
  }));
};

export const Broom16Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Broom16RegularIcon, 'Broom16Regular');

const Broom20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M17.91 2.18c.2.2.2.51 0 .7L13.3 7.5a5.6 5.6 0 00-.7-.7l4.6-4.62c.2-.2.51-.2.71 0zm-5.66 5.66a4.5 4.5 0 00-6.36 0l-.42.42 6.36 6.36.42-.42a4.5 4.5 0 000-6.36zm-10.5 2.75l2.9-1.74 6.5 6.5a.5.5 0 00.1.08L9.5 18.35a.5.5 0 01-.78.1l-7.07-7.08a.5.5 0 01.1-.78z",
    fill: primaryFill
  }));
};

export const Broom20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Broom20FilledIcon, 'Broom20Filled');

const Broom20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M17.91 2.18c.2.2.2.51 0 .7l-5.32 5.33a4.5 4.5 0 01-.34 6l-.66.66-2.09 3.48a.5.5 0 01-.78.1l-7.07-7.08a.5.5 0 01.1-.78L5.22 8.5l.66-.66a4.5 4.5 0 015.99-.34l5.32-5.32c.2-.2.51-.2.71 0zM6.24 8.9l4.95 4.95.36-.35A3.5 3.5 0 106.6 8.55l-.36.35zm-.78.63L2.8 11.12l6.16 6.17 1.6-2.66-5.11-5.1z",
    fill: primaryFill
  }));
};

export const Broom20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Broom20RegularIcon, 'Broom20Regular');

const Broom24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M22.45 1.92c.3.3.3.77 0 1.06L16.14 9.3a6.81 6.81 0 00-1.07-1.06l6.32-6.32c.3-.29.77-.29 1.06 0zm-7.42 7.43a5.75 5.75 0 00-8.13 0l-.25.24 8.13 8.13.25-.24a5.75 5.75 0 000-8.13zM1.88 12.97l3.62-2.41 8.32 8.32-2.41 3.61a.75.75 0 01-1.15.12l-8.49-8.49a.75.75 0 01.11-1.15z",
    fill: primaryFill
  }));
};

export const Broom24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Broom24FilledIcon, 'Broom24Filled');

const Broom24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M22.45 1.92c.3.3.3.77 0 1.06l-6.93 6.93a5.75 5.75 0 01-.5 7.57l-.82.83-2.79 4.18a.75.75 0 01-1.15.12l-8.49-8.49a.75.75 0 01.11-1.15l4.19-2.8.83-.82a5.75 5.75 0 017.56-.5l6.93-6.93c.3-.29.77-.29 1.06 0zM7.6 10.76l6.01 6.01.36-.35a4.25 4.25 0 00-6.01-6.01l-.36.35zm-1.15.97L3.48 13.7l7.19 7.19 1.98-2.97-6.2-6.2z",
    fill: primaryFill
  }));
};

export const Broom24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Broom24RegularIcon, 'Broom24Regular');

const Broom28FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M25.78 2.22c.3.3.3.77 0 1.06l-8.26 8.26a6.75 6.75 0 01-.5 8.98l-.21.22-9.56-9.55.23-.22a6.75 6.75 0 018.98-.5l8.26-8.25c.3-.3.77-.3 1.06 0zM6.05 12.11l-3.7 2.25a.75.75 0 00-.13 1.17l10.25 10.25a.75.75 0 001.17-.14l2.25-3.69-9.84-9.84z",
    fill: primaryFill
  }));
};

export const Broom28Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Broom28FilledIcon, 'Broom28Filled');

const Broom28RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M25.78 3.28a.75.75 0 10-1.06-1.06l-8.26 8.26a6.75 6.75 0 00-8.98.5l-.7.67-4.42 2.71a.75.75 0 00-.14 1.17l10.25 10.25a.75.75 0 001.17-.14l2.7-4.43.69-.69a6.75 6.75 0 00.5-8.98l8.25-8.26zM3.95 15.14l3.19-1.94 7.66 7.66-1.94 3.19-8.9-8.9zm12.01 4.32l-.22.22-7.42-7.42.21-.22a5.25 5.25 0 117.43 7.42z",
    fill: primaryFill
  }));
};

export const Broom28Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Broom28RegularIcon, 'Broom28Regular');

const Bug16FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M7.3 1.5a.5.5 0 00-1 0v.8c0 .29.07.56.2.8a2.5 2.5 0 00-1.74 1.85A1.1 1.1 0 014 3.9V2.5a.5.5 0 00-1 0v1.4a2.1 2.1 0 001.7 2.06V7H2.5a.5.5 0 000 1h2.2v1.7c0 .1 0 .21.02.32A2 2 0 003 12v1.5a.5.5 0 001 0V12a1 1 0 01.97-1 3.3 3.3 0 006.06 0 1 1 0 01.97 1v1.5a.5.5 0 001 0V12a2 2 0 00-1.72-1.98l.02-.32V8h2.2a.5.5 0 000-1h-2.2V5.96A2.1 2.1 0 0013 3.9V2.5a.5.5 0 00-1 0v1.4c0 .49-.32.9-.76 1.05A2.5 2.5 0 009.5 3.1c.13-.24.2-.51.2-.8v-.8a.5.5 0 00-1 0v.8a.7.7 0 11-1.4 0v-.8z",
    fill: primaryFill
  }));
};

export const Bug16Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Bug16FilledIcon, 'Bug16Filled');

const Bug16RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M7.3 1.5a.5.5 0 00-1 0v.8c0 .29.07.56.2.8a2.5 2.5 0 00-1.74 1.85A1.1 1.1 0 014 3.9V2.5a.5.5 0 00-1 0v1.4a2.1 2.1 0 001.7 2.06V7H2.5a.5.5 0 000 1h2.2v1.7c0 .1 0 .21.02.32A2 2 0 003 12v1.5a.5.5 0 001 0V12a1 1 0 01.97-1 3.3 3.3 0 006.06 0 1 1 0 01.97 1v1.5a.5.5 0 001 0V12a2 2 0 00-1.72-1.98l.02-.32V8h2.2a.5.5 0 000-1h-2.2V5.96A2.1 2.1 0 0013 3.9V2.5a.5.5 0 00-1 0v1.4c0 .49-.32.9-.76 1.05A2.5 2.5 0 009.5 3.1c.13-.24.2-.51.2-.8v-.8a.5.5 0 00-1 0v.8a.7.7 0 11-1.4 0v-.8zm-1.6 6v-2c0-.83.67-1.5 1.5-1.5h1.6c.83 0 1.5.67 1.5 1.5v4.2a2.3 2.3 0 01-4.6 0V7.5z",
    fill: primaryFill
  }));
};

export const Bug16Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Bug16RegularIcon, 'Bug16Regular');

const Bug20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M9 2.5a.5.5 0 00-1 0V3c0 .4.12.77.32 1.08A3 3 0 006 7h-.5A1.5 1.5 0 014 5.5v-2a.5.5 0 00-1 0v2A2.5 2.5 0 005.5 8H6v1.5H2.5a.5.5 0 000 1H6V12h-.5A2.5 2.5 0 003 14.5v2a.5.5 0 001 0v-2c0-.83.67-1.5 1.5-1.5H6a4 4 0 008 0h.5c.83 0 1.5.67 1.5 1.5v2a.5.5 0 001 0v-2a2.5 2.5 0 00-2.5-2.5H14v-1.5h3.5a.5.5 0 000-1H14V8h.5A2.5 2.5 0 0017 5.5v-2a.5.5 0 00-1 0v2c0 .83-.67 1.5-1.5 1.5H14a3 3 0 00-2.32-2.92A2 2 0 0012 3v-.5a.5.5 0 00-1 0V3a1 1 0 11-2 0v-.5z",
    fill: primaryFill
  }));
};

export const Bug20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Bug20FilledIcon, 'Bug20Filled');

const Bug20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M9 2.5a.5.5 0 00-1 0V3c0 .4.12.77.32 1.08A3 3 0 006 7h-.5A1.5 1.5 0 014 5.5v-2a.5.5 0 00-1 0v2A2.5 2.5 0 005.5 8H6v1.5H2.5a.5.5 0 000 1H6V12h-.5A2.5 2.5 0 003 14.5v2a.5.5 0 001 0v-2c0-.83.67-1.5 1.5-1.5H6a4 4 0 008 0h.5c.83 0 1.5.67 1.5 1.5v2a.5.5 0 001 0v-2a2.5 2.5 0 00-2.5-2.5H14v-1.5h3.5a.5.5 0 000-1H14V8h.5A2.5 2.5 0 0017 5.5v-2a.5.5 0 00-1 0v2c0 .83-.67 1.5-1.5 1.5H14a3 3 0 00-2.32-2.92A2 2 0 0012 3v-.5a.5.5 0 00-1 0V3a1 1 0 11-2 0v-.5zM13 7v6a3 3 0 11-6 0V7c0-1.1.9-2 2-2h2a2 2 0 012 2z",
    fill: primaryFill
  }));
};

export const Bug20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Bug20RegularIcon, 'Bug20Regular');

const Bug24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M14.25 2c.38 0 .7.28.74.65l.01.1v.75c0 .64-.2 1.22-.53 1.7a3.75 3.75 0 012.52 3.3h.26a2.25 2.25 0 002.24-2.26V4.75a.75.75 0 011.5 0v1.48c0 2-1.56 3.65-3.54 3.76H17v1.51h4.25c.38 0 .7.28.75.65v.1c0 .38-.28.7-.65.74l-.1.01H17v2H17.45a3.75 3.75 0 013.53 3.57v1.68a.75.75 0 01-1.5.1v-1.59c.01-1.2-.9-2.17-2.08-2.25h-.15l-.48-.01a5 5 0 01-9.54 0h-.49a2.25 2.25 0 00-2.24 2.26v1.49a.75.75 0 11-1.5 0v-1.48c0-2 1.56-3.65 3.54-3.76h.21L7 15v-2H2.75a.75.75 0 01-.74-.65l-.01-.1c0-.38.28-.7.65-.74h.1L7 11.5V10H6.54A3.75 3.75 0 013 6.42V4.75a.75.75 0 011.5-.1v1.59c0 1.19.92 2.17 2.09 2.25H7a3.75 3.75 0 012.52-3.28c-.3-.43-.48-.94-.52-1.5L9 3.51v-.76a.75.75 0 011.5-.1v.85a1.5 1.5 0 003 .15v-.9c0-.41.34-.75.75-.75z",
    fill: primaryFill
  }));
};

export const Bug24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Bug24FilledIcon, 'Bug24Filled');

const Bug24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10.5 2.75a.75.75 0 00-1.5 0v.75c0 .64.2 1.22.53 1.7a3.75 3.75 0 00-2.52 3.3h-.25A2.25 2.25 0 014.5 6.22V4.75a.75.75 0 10-1.5-.01v1.49a3.75 3.75 0 003.74 3.76H7v1.51H2.75a.75.75 0 000 1.5H7v2h-.25A3.75 3.75 0 003 18.75v1.48a.75.75 0 001.5 0v-1.49c0-1.24 1-2.25 2.24-2.26h.48a5 5 0 009.54 0h.47a2.25 2.25 0 012.25 2.26v1.49a.75.75 0 001.5 0v-1.48a3.75 3.75 0 00-3.74-3.77H17V13h4.25a.75.75 0 000-1.5H17V10h.25C19.32 9.97 21 8.3 21 6.22V4.74a.75.75 0 10-1.5 0v1.5c0 1.23-1 2.25-2.24 2.25h-.26a3.75 3.75 0 00-2.52-3.28c.33-.49.53-1.07.53-1.7v-.76a.75.75 0 00-1.5 0v.75a1.5 1.5 0 01-3 0v-.75zm-2 6c0-1.24 1-2.25 2.25-2.25h2.5c1.24 0 2.25 1.01 2.25 2.25V15a3.5 3.5 0 11-7 0V8.75z",
    fill: primaryFill
  }));
};

export const Bug24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Bug24RegularIcon, 'Bug24Regular');

const BugArrowCounterclockwise20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M17 3.5a.5.5 0 00-1 0v2A1.5 1.5 0 0114.5 7H14a3 3 0 00-2.31-2.92A2 2 0 0012 3v-.5a.5.5 0 00-1 0V3a1 1 0 01-2 0v-.5a.5.5 0 10-1 0V3c0 .38.1.76.31 1.08A3 3 0 006 7h-.5A1.5 1.5 0 014 5.5v-2a.5.5 0 10-1 0v2A2.5 2.5 0 005.5 8H6v1.5H2.5a.5.5 0 100 1H6V12h-.5A2.5 2.5 0 003 14.5v2a.5.5 0 001 0v-2A1.5 1.5 0 015.5 13H6a3.99 3.99 0 003.59 3.96A5.49 5.49 0 0114 9.02V8h.5A2.5 2.5 0 0017 5.5v-2zM14.5 10a4.5 4.5 0 100 9 4.5 4.5 0 000-9zm0 7.25a2.74 2.74 0 01-2.05-.92.5.5 0 11.75-.66 1.75 1.75 0 10.4-2.67h.4a.5.5 0 010 1h-1.5a.5.5 0 01-.5-.63V12a.5.5 0 011 0v.2a2.75 2.75 0 111.5 5.05z",
    fill: primaryFill
  }));
};

export const BugArrowCounterclockwise20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/BugArrowCounterclockwise20FilledIcon, 'BugArrowCounterclockwise20Filled');

const BugArrowCounterclockwise20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M17 3.5a.5.5 0 00-1 0v2A1.5 1.5 0 0114.5 7H14a3 3 0 00-2.31-2.92A2 2 0 0012 3v-.5a.5.5 0 00-1 0V3a1 1 0 01-2 0v-.5a.5.5 0 10-1 0V3c0 .38.1.76.31 1.08A3 3 0 006 7h-.5A1.5 1.5 0 014 5.5v-2a.5.5 0 10-1 0v2A2.5 2.5 0 005.5 8H6v1.5H2.5a.5.5 0 100 1H6V12h-.5A2.5 2.5 0 003 14.5v2a.5.5 0 001 0v-2A1.5 1.5 0 015.5 13H6a3.99 3.99 0 003.59 3.96 5.46 5.46 0 01-.41-1.09A2.99 2.99 0 017 13V7a2 2 0 012-2h2a2 2 0 012 2v2.21c.33-.09.66-.15 1-.19V8h.5A2.5 2.5 0 0017 5.5v-2zM14.5 10a4.5 4.5 0 100 9 4.5 4.5 0 000-9zm0 7.25a2.74 2.74 0 01-2.05-.92.5.5 0 11.75-.66 1.75 1.75 0 10.4-2.67h.4a.5.5 0 010 1h-1.5a.5.5 0 01-.5-.63V12a.5.5 0 011 0v.2a2.75 2.75 0 111.5 5.05z",
    fill: primaryFill
  }));
};

export const BugArrowCounterclockwise20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/BugArrowCounterclockwise20RegularIcon, 'BugArrowCounterclockwise20Regular');

const BugProhibited20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M14.5 10a4.5 4.5 0 100 9 4.5 4.5 0 000-9zM11 14.5a3.5 3.5 0 015.6-2.8l-4.9 4.9c-.46-.6-.7-1.34-.7-2.1zm3.5 3.5c-.76 0-1.5-.24-2.1-.7l4.9-4.9a3.48 3.48 0 01-.33 4.57A3.5 3.5 0 0114.5 18zM17 3.5a.5.5 0 00-1 0v2A1.5 1.5 0 0114.5 7H14a3 3 0 00-2.31-2.92A2 2 0 0012 3v-.5a.5.5 0 00-1 0V3a1 1 0 01-2 0v-.5a.5.5 0 10-1 0V3c0 .38.1.76.31 1.08A3 3 0 006 7h-.5A1.5 1.5 0 014 5.5v-2a.5.5 0 10-1 0v2A2.5 2.5 0 005.5 8H6v1.5H2.5a.5.5 0 100 1H6V12h-.5A2.5 2.5 0 003 14.5v2a.5.5 0 001 0v-2A1.5 1.5 0 015.5 13H6a3.99 3.99 0 003.59 3.96 5.46 5.46 0 01.85-6.17A5.5 5.5 0 0114 9.03V8h.5A2.5 2.5 0 0017 5.5v-2z",
    fill: primaryFill
  }));
};

export const BugProhibited20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/BugProhibited20FilledIcon, 'BugProhibited20Filled');

const BugProhibited20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M9.18 15.87c.1.38.23.74.4 1.09A3.99 3.99 0 016 13h-.5A1.5 1.5 0 004 14.5v2a.5.5 0 01-1 0v-2A2.5 2.5 0 015.5 12H6v-1.5H2.5a.5.5 0 010-1H6V8h-.5A2.5 2.5 0 013 5.5v-2a.5.5 0 011 0v2A1.5 1.5 0 005.5 7H6a3 3 0 012.31-2.92A2 2 0 018 3v-.5a.5.5 0 011 0V3a1 1 0 002 0v-.5a.5.5 0 011 0V3a2 2 0 01-.31 1.08A3 3 0 0114 7h.5A1.5 1.5 0 0016 5.5v-2a.5.5 0 011 0v2A2.5 2.5 0 0114.5 8H14v1.03c-.34.03-.67.09-1 .18V7a2 2 0 00-2-2H9a2 2 0 00-2 2v6a2.99 2.99 0 002.18 2.87zM19 14.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-7.3 2.1l4.9-4.9a3.48 3.48 0 00-4.57.33 3.5 3.5 0 00-.33 4.57zm6.3-2.1c0-.76-.24-1.5-.7-2.1l-4.9 4.9a3.48 3.48 0 004.57-.33A3.5 3.5 0 0018 14.5z",
    fill: primaryFill
  }));
};

export const BugProhibited20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/BugProhibited20RegularIcon, 'BugProhibited20Regular');

const Building16FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5.5 2C4.67 2 4 2.67 4 3.5v10c0 .28.22.5.5.5H6v-2.5c0-.28.22-.5.5-.5h4c.28 0 .5.22.5.5V14h1.5a.5.5 0 00.5-.5v-5c0-.83-.67-1.5-1.5-1.5H11V3.5c0-.83-.67-1.5-1.5-1.5h-4zM7 4.5a.5.5 0 11-1 0 .5.5 0 011 0zM7 7a.5.5 0 11-1 0 .5.5 0 011 0zm0 2.5a.5.5 0 11-1 0 .5.5 0 011 0zm2-5a.5.5 0 11-1 0 .5.5 0 011 0zM9 7a.5.5 0 11-1 0 .5.5 0 011 0zm0 2.5a.5.5 0 11-1 0 .5.5 0 011 0zm2 0a.5.5 0 11-1 0 .5.5 0 011 0zM10 14v-2H9v2h1zm-2 0v-2H7v2h1z",
    fill: primaryFill
  }));
};

export const Building16Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Building16FilledIcon, 'Building16Filled');

const Building16RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6.5 5a.5.5 0 100-1 .5.5 0 000 1zM7 7a.5.5 0 11-1 0 .5.5 0 011 0zm-.5 3a.5.5 0 100-1 .5.5 0 000 1zM9 4.5a.5.5 0 11-1 0 .5.5 0 011 0zm-.5 3a.5.5 0 100-1 .5.5 0 000 1zm.5 2a.5.5 0 11-1 0 .5.5 0 011 0zm1.5.5a.5.5 0 100-1 .5.5 0 000 1zm-5-8C4.67 2 4 2.67 4 3.5v10c0 .28.22.5.5.5h8a.5.5 0 00.5-.5v-5c0-.83-.67-1.5-1.5-1.5H11V3.5c0-.83-.67-1.5-1.5-1.5h-4zM5 3.5c0-.28.22-.5.5-.5h4c.28 0 .5.22.5.5v4c0 .28.22.5.5.5h1c.28 0 .5.22.5.5V13h-1v-1.5a.5.5 0 00-.5-.5h-4a.5.5 0 00-.5.5V13H5V3.5zm5 8.5v1H9v-1h1zm-2 0v1H7v-1h1z",
    fill: primaryFill
  }));
};

export const Building16Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Building16RegularIcon, 'Building16Regular');

const Building20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4 3.5C4 2.67 4.67 2 5.5 2h6c.83 0 1.5.67 1.5 1.5V8h1.5c.83 0 1.5.67 1.5 1.5v8a.5.5 0 01-.5.5H13v-3.5a.5.5 0 00-.5-.5h-5a.5.5 0 00-.5.5V18H4.5a.5.5 0 01-.5-.5v-14zm2.75 3a.75.75 0 100-1.5.75.75 0 000 1.5zm.75 2.25a.75.75 0 10-1.5 0 .75.75 0 001.5 0zm-.75 3.75a.75.75 0 100-1.5.75.75 0 000 1.5zm3.75-6.75a.75.75 0 10-1.5 0 .75.75 0 001.5 0zM9.75 9.5a.75.75 0 100-1.5.75.75 0 000 1.5zm.75 2.25a.75.75 0 10-1.5 0 .75.75 0 001.5 0zm2.25.75a.75.75 0 100-1.5.75.75 0 000 1.5zM12 15v3h-1.5v-3H12zm-2.5 0H8v3h1.5v-3z",
    fill: primaryFill
  }));
};

export const Building20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Building20FilledIcon, 'Building20Filled');

const Building20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6.75 6.5a.75.75 0 100-1.5.75.75 0 000 1.5zm.75 2.25a.75.75 0 11-1.5 0 .75.75 0 011.5 0zm-.75 3.75a.75.75 0 100-1.5.75.75 0 000 1.5zm3.75-6.75a.75.75 0 11-1.5 0 .75.75 0 011.5 0zM9.75 9.5a.75.75 0 100-1.5.75.75 0 000 1.5zm.75 2.25a.75.75 0 11-1.5 0 .75.75 0 011.5 0zm2.25.75a.75.75 0 100-1.5.75.75 0 000 1.5zM4.5 18a.5.5 0 01-.5-.5v-14C4 2.67 4.67 2 5.5 2h6c.83 0 1.5.67 1.5 1.5V8h1.5c.83 0 1.5.67 1.5 1.5v8a.5.5 0 01-.5.5h-11zM5 3.5V17h2v-2.5c0-.28.22-.5.5-.5h5c.28 0 .5.22.5.5V17h2V9.5a.5.5 0 00-.5-.5h-2a.5.5 0 01-.5-.5v-5a.5.5 0 00-.5-.5h-6a.5.5 0 00-.5.5zM12 15h-1.5v2H12v-2zm-2.5 0H8v2h1.5v-2z",
    fill: primaryFill
  }));
};

export const Building20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Building20RegularIcon, 'Building20Regular');

const Building24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6.75 2C5.51 2 4.5 3 4.5 4.25v16.5c0 .41.34.75.75.75H7.5v-4.25c0-.41.34-.75.75-.75h7.5c.41 0 .75.34.75.75v4.25h2.25c.41 0 .75-.34.75-.75v-9c0-1.24-1-2.25-2.25-2.25h-.75V4.25c0-1.24-1-2.25-2.25-2.25h-7.5zm.75 4.5a1 1 0 112 0 1 1 0 01-2 0zm1 6a1 1 0 110 2 1 1 0 010-2zm-1-2.5a1 1 0 112 0 1 1 0 01-2 0zM12 5.5a1 1 0 110 2 1 1 0 010-2zm-1 8a1 1 0 112 0 1 1 0 01-2 0zm4.5-1a1 1 0 110 2 1 1 0 010-2zM11 10a1 1 0 112 0 1 1 0 01-2 0zm4 11.5V18h-2.25v3.5H15zm-3.75 0V18H9v3.5h2.25z",
    fill: primaryFill
  }));
};

export const Building24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Building24FilledIcon, 'Building24Filled');

const Building24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M8.5 5.5a1 1 0 100 2 1 1 0 000-2zm-1 8a1 1 0 112 0 1 1 0 01-2 0zm1-4.5a1 1 0 100 2 1 1 0 000-2zM11 6.5a1 1 0 112 0 1 1 0 01-2 0zm1 6a1 1 0 100 2 1 1 0 000-2zm2.5 1a1 1 0 112 0 1 1 0 01-2 0zM12 9a1 1 0 100 2 1 1 0 000-2zM6.25 2C5.01 2 4 3 4 4.25v16.5c0 .41.34.75.75.75h14.5c.42 0 .75-.34.75-.75v-9c0-1.24-1-2.25-2.25-2.25H16.5V4.25c0-1.24-1-2.25-2.25-2.25h-8zM5.5 4.25c0-.41.34-.75.75-.75h8c.41 0 .75.34.75.75v6c0 .41.34.75.75.75h2c.42 0 .75.34.75.75V20h-2v-2.75a.75.75 0 00-.75-.75h-7.5a.75.75 0 00-.75.75V20h-2V4.25zM15 18v2h-2.25v-2H15zm-3.75 0v2H9v-2h2.25z",
    fill: primaryFill
  }));
};

export const Building24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Building24RegularIcon, 'Building24Regular');

const BuildingBank16FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M7.3 1.71c.41-.32 1-.32 1.4 0l4.97 3.8c.63.48.3 1.49-.5 1.49H2.83a.83.83 0 01-.5-1.5l4.96-3.79zM8 5.25a.75.75 0 100-1.5.75.75 0 000 1.5zM3.5 8v3H5V8H3.5zM6 8v3h1.5V8H6zm2.5 0v3H10V8H8.5zM11 8v3h1.5V8H11zm-9 5.25c0-.69.56-1.25 1.25-1.25h9.5c.69 0 1.25.56 1.25 1.25v.25a.5.5 0 01-.5.5h-11a.5.5 0 01-.5-.5v-.25z",
    fill: primaryFill
  }));
};

export const BuildingBank16Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/BuildingBank16FilledIcon, 'BuildingBank16Filled');

const BuildingBank16RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M8 5a.75.75 0 100-1.5A.75.75 0 008 5zm.74-3.55a1.17 1.17 0 00-1.48 0l-5 4.07A.83.83 0 002.8 7H3v4.2c-.6.3-1 .92-1 1.63v.67c0 .28.22.5.5.5h11a.5.5 0 00.5-.5v-.67c0-.7-.4-1.33-1-1.63V7h.21a.83.83 0 00.53-1.48l-5-4.07zm-.84.78a.17.17 0 01.2 0L12.75 6H3.26L7.9 2.23zM12 11h-1V7h1v4zm-2 0H8.5V7H10v4zm-2.5 0H6V7h1.5v4zm4.67 1c.46 0 .83.37.83.83V13H3v-.17c0-.46.37-.83.83-.83h8.34zM5 11H4V7h1v4z",
    fill: primaryFill
  }));
};

export const BuildingBank16Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/BuildingBank16RegularIcon, 'BuildingBank16Regular');

const BuildingBank20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M9.23 2.18a1.33 1.33 0 011.54 0l5.85 4.15A.92.92 0 0116.1 8H3.9a.92.92 0 01-.52-1.67l5.85-4.15zm.77 3.7a.83.83 0 100-1.67.83.83 0 000 1.66zM4.5 9v4h2V9h-2zM3 16.17c0-1.2.97-2.17 2.17-2.17h9.66c1.2 0 2.17.97 2.17 2.17v.33a.5.5 0 01-.5.5h-13a.5.5 0 01-.5-.5v-.33zM15.5 9v4h-2V9h2zm-3 0v4h-2V9h2zm-3 0v4h-2V9h2z",
    fill: primaryFill
  }));
};

export const BuildingBank20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/BuildingBank20FilledIcon, 'BuildingBank20Filled');

const BuildingBank20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10 5.87a.83.83 0 100-1.66.83.83 0 000 1.66zm6 7.47V8h.1a.92.92 0 00.52-1.67l-5.85-4.15a1.33 1.33 0 00-1.54 0L3.38 6.33A.92.92 0 003.9 8H4v5.34c-.6.38-1 1.06-1 1.83v1.33c0 .28.22.5.5.5h13a.5.5 0 00.5-.5v-1.33c0-.77-.4-1.45-1-1.83zM9.8 3a.33.33 0 01.4 0l5.63 4H4.17L9.8 3zM15 8v5h-2V8h2zM5 13V8h2v5H5zm.17 1h9.66c.65 0 1.17.52 1.17 1.17V16H4v-.83c0-.65.52-1.17 1.17-1.17zm4.33-1H8V8h1.5v5zm1 0V8H12v5h-1.5z",
    fill: primaryFill
  }));
};

export const BuildingBank20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/BuildingBank20RegularIcon, 'BuildingBank20Regular');

const BuildingBank24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10.97 2.32a1.75 1.75 0 012.06 0l7.42 5.42c.98.71.48 2.26-.73 2.26H4.28a1.25 1.25 0 01-.73-2.26l7.42-5.42zM13 6.25a1 1 0 10-2 0 1 1 0 002 0zM11.25 16h-2v-5h2v5zm3.5 0h-2v-5h2v5zm3.75 0h-2.25v-5h2.25v5zm.25 1H5.25C4.01 17 3 18 3 19.25v.5c0 .41.34.75.75.75h16.5c.41 0 .75-.34.75-.75v-.5c0-1.24-1-2.25-2.25-2.25zm-11-1H5.5v-5h2.25v5z",
    fill: primaryFill
  }));
};

export const BuildingBank24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/BuildingBank24FilledIcon, 'BuildingBank24Filled');

const BuildingBank24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M13 6.25a1 1 0 11-2 0 1 1 0 012 0zm.03-3.93a1.75 1.75 0 00-2.06 0L3.55 7.74c-.98.71-.48 2.26.73 2.26h.22v5.8A2.75 2.75 0 003 18.25v1.5c0 .41.34.75.75.75h16.5c.41 0 .75-.34.75-.75v-1.5c0-1.07-.61-2-1.5-2.45V10h.22c1.2 0 1.71-1.55.73-2.26l-7.42-5.42zm-1.18 1.22c.09-.07.21-.07.3 0l6.8 4.96H5.05l6.8-4.96zM18 10v5.5h-2V10h2zm-3.5 0v5.5h-1.75V10h1.75zm-3.25 0v5.5H9.5V10h1.75zm-5.5 7h12.5c.69 0 1.25.56 1.25 1.25V19h-15v-.75c0-.69.56-1.25 1.25-1.25zM6 15.5V10h2v5.5H6z",
    fill: primaryFill
  }));
};

export const BuildingBank24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/BuildingBank24RegularIcon, 'BuildingBank24Regular');

const BuildingBank28FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M13.11 2.3a1.5 1.5 0 011.78 0l9.5 7a1.5 1.5 0 01-.74 2.7H4.35a1.5 1.5 0 01-.74-2.7l9.5-7zM14 9a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm5.5 4H22v6h-2.5v-6zm-2 6v-6H15v6h2.5zM13 19v-6h-2.5v6H13zm-4.5 0v-6H6v6h2.5zm-2.25 1A3.25 3.25 0 003 23.25v.5c0 .41.34.75.75.75h20.5c.41 0 .75-.34.75-.75v-.5c0-1.8-1.46-3.25-3.25-3.25H6.25z",
    fill: primaryFill
  }));
};

export const BuildingBank28Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/BuildingBank28FilledIcon, 'BuildingBank28Filled');

const BuildingBank28RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M14 9a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm.89-6.7a1.5 1.5 0 00-1.78 0l-9.5 7a1.5 1.5 0 00.9 2.7H5v7.25c-1.17.49-2 1.65-2 3v1.5c0 .41.34.75.75.75h20.5c.41 0 .75-.34.75-.75v-1.5c0-1.35-.83-2.51-2-3V12h.5a1.5 1.5 0 00.89-2.71l-9.5-7zM6.5 19v-7H9v7H6.5zm15-7v7H19v-7h2.5zm-4 0v7h-2.75v-7h2.75zm-4.25 0v7H10.5v-7h2.75zM4.5 10.5l9.5-7 9.5 7h-19zm0 11.75c0-.97.78-1.75 1.75-1.75h15.5c.97 0 1.75.78 1.75 1.75V23h-19v-.75z",
    fill: primaryFill
  }));
};

export const BuildingBank28Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/BuildingBank28RegularIcon, 'BuildingBank28Regular');

const BuildingBank48FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M25.35 4.45c-.8-.6-1.9-.6-2.7 0L6.71 16.35a1.75 1.75 0 001.05 3.15h32.48c1.69 0 2.4-2.14 1.05-3.15L25.35 4.45zM24 14a2 2 0 110-4 2 2 0 010 4zM6 38.25C6 35.35 8.35 33 11.25 33h25.5c2.9 0 5.25 2.35 5.25 5.25v1.5c0 .69-.56 1.25-1.25 1.25H7.25C6.56 41 6 40.44 6 39.75v-1.5zM14 31h-4v-9.5h4V31zm4-9.5V31h4v-9.5h-4zm8 0V31h4v-9.5h-4zm8 0V31h4v-9.5h-4z",
    fill: primaryFill
  }));
};

export const BuildingBank48Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/BuildingBank48FilledIcon, 'BuildingBank48Filled');

const BuildingBank48RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M24 14a2 2 0 100-4 2 2 0 000 4zm1.35-9.55c-.8-.6-1.9-.6-2.7 0L6.71 16.35a1.75 1.75 0 001.05 3.15H9v12c-1.77.85-3 2.66-3 4.75v3.5c0 .69.56 1.25 1.25 1.25h33.5c.69 0 1.25-.56 1.25-1.25v-3.5c0-2.1-1.23-3.9-3-4.74v-12h1.24c1.69 0 2.4-2.15 1.05-3.16L25.35 4.45zM36.5 31H32V19.5h4.5V31zm-7 0h-4.25V19.5h4.25V31zm-6.75 0H18.5V19.5h4.25V31zM16 31h-4.5V19.5H16V31zm-5.99-14L24 6.56 37.99 17H10zM8.5 36.25a2.75 2.75 0 012.75-2.75h25.5a2.75 2.75 0 012.75 2.75v2.25h-31v-2.25z",
    fill: primaryFill
  }));
};

export const BuildingBank48Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/BuildingBank48RegularIcon, 'BuildingBank48Regular');

const BuildingBankLink16FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M7.3 1.71c.41-.32 1-.32 1.4 0l4.97 3.8c.63.48.3 1.49-.5 1.49H2.83a.83.83 0 01-.5-1.5l4.96-3.79zM8 5.25a.75.75 0 100-1.5.75.75 0 000 1.5zM3.5 8v3H5V8H3.5zM6 8v2.05a3.5 3.5 0 011.5-.9V8H6zm-2.75 4h1.79a3.53 3.53 0 00.3 2H2.5a.5.5 0 01-.5-.5v-.25c0-.69.56-1.25 1.25-1.25zm9.25-4v1H11V8h1.5zM10 8v1H8.5V8H10zm-1.5 2a2.5 2.5 0 000 5H9a.5.5 0 100-1h-.5a1.5 1.5 0 110-3H9a.5.5 0 100-1h-.5zm3.5 0a.5.5 0 000 1h.5a1.5 1.5 0 010 3H12a.5.5 0 000 1h.5a2.5 2.5 0 100-5H12zm-4 2.5c0-.28.22-.5.5-.5h4a.5.5 0 010 1h-4a.5.5 0 01-.5-.5z",
    fill: primaryFill
  }));
};

export const BuildingBankLink16Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/BuildingBankLink16FilledIcon, 'BuildingBankLink16Filled');

const BuildingBankLink16RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M8 5a.75.75 0 100-1.5A.75.75 0 008 5zm.74-3.55a1.17 1.17 0 00-1.48 0l-5 4.07A.83.83 0 002.8 7H3v4.2c-.6.3-1 .92-1 1.63v.67c0 .28.22.5.5.5h2.84a3.48 3.48 0 01-.3-1H3v-.17c0-.46.37-.83.83-.83h1.2c.11-.75.46-1.43.97-1.95V7h1.5v2.15c.32-.1.65-.15 1-.15V7H10v2h1V7h1v2h.5c.17 0 .34.01.5.04V7h.21a.83.83 0 00.53-1.48l-5-4.07zm-.84.78a.17.17 0 01.2 0L12.75 6H3.26L7.9 2.23zM5 11H4V7h1v4zm3.5-1a2.5 2.5 0 100 5H9a.5.5 0 000-1h-.5a1.5 1.5 0 010-3H9a.5.5 0 000-1h-.5zm3.5 0a.5.5 0 100 1h.5a1.5 1.5 0 110 3H12a.5.5 0 100 1h.5a2.5 2.5 0 000-5H12zm-4 2.5c0-.28.22-.5.5-.5h4a.5.5 0 110 1h-4a.5.5 0 01-.5-.5z",
    fill: primaryFill
  }));
};

export const BuildingBankLink16Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/BuildingBankLink16RegularIcon, 'BuildingBankLink16Regular');

const BuildingBankLink20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M9.23 2.18a1.33 1.33 0 011.54 0l5.85 4.15A.92.92 0 0116.1 8H3.9a.92.92 0 01-.52-1.67l5.85-4.15zm.77 3.7a.83.83 0 100-1.67.83.83 0 000 1.66zM4.5 9v4h2V9h-2zM3 16.17c0-1.2.97-2.17 2.17-2.17h3.17a3.49 3.49 0 000 3H3.5a.5.5 0 01-.5-.5v-.33zM9.05 13c.14-.14.29-.26.45-.37V9h-2v4h1.55zm2.45-1h1V9h-2v3.14c.32-.09.65-.14 1-.14zm2 0h2V9h-2v3zm-2 1a2.5 2.5 0 000 5h.5a.5.5 0 000-1h-.5a1.5 1.5 0 010-3h.5a.5.5 0 000-1h-.5zm3.5 0a.5.5 0 100 1h.5a1.5 1.5 0 010 3H15a.5.5 0 100 1h.5a2.5 2.5 0 000-5H15zm-4 2.5c0-.28.22-.5.5-.5h4a.5.5 0 110 1h-4a.5.5 0 01-.5-.5z",
    fill: primaryFill
  }));
};

export const BuildingBankLink20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/BuildingBankLink20FilledIcon, 'BuildingBankLink20Filled');

const BuildingBankLink20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10 5.87a.83.83 0 100-1.66.83.83 0 000 1.66zM3.5 17h4.84a3.48 3.48 0 01-.3-1H4v-.83c0-.65.52-1.17 1.17-1.17h3.17c.17-.38.42-.71.71-1H8V8h1.5v4.63c.3-.21.64-.38 1-.49V8H12v4h1V8h2v4h.5c.17 0 .34.01.5.03V8h.1a.92.92 0 00.52-1.67l-5.85-4.15a1.33 1.33 0 00-1.54 0L3.38 6.33A.92.92 0 003.9 8H4v5.34c-.6.38-1 1.06-1 1.83v1.33c0 .28.22.5.5.5zM9.8 3a.33.33 0 01.4 0l5.63 4H4.17L9.8 3zM5 13V8h2v5H5zm6.5 0a2.5 2.5 0 000 5h.5a.5.5 0 100-1h-.5a1.5 1.5 0 010-3h.5a.5.5 0 100-1h-.5zm3.5 0a.5.5 0 100 1h.5a1.5 1.5 0 110 3H15a.5.5 0 100 1h.5a2.5 2.5 0 000-5H15zm-4 2.5c0-.28.22-.5.5-.5h4a.5.5 0 110 1h-4a.5.5 0 01-.5-.5z",
    fill: primaryFill
  }));
};

export const BuildingBankLink20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/BuildingBankLink20RegularIcon, 'BuildingBankLink20Regular');

const BuildingBankLink24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10.97 2.32a1.75 1.75 0 012.06 0l7.42 5.42c.98.71.48 2.26-.73 2.26H4.28a1.25 1.25 0 01-.73-2.26l7.42-5.42zM13 6.25a1 1 0 10-2 0 1 1 0 002 0zM11.25 16h-2v-5h2v5zm1.5-.43c.57-.47 1.25-.8 2-.96V11h-2v4.57zm3.5-1.07h2.25V11h-2.25v3.5zM11 19.25c0-.81.2-1.58.57-2.25H5.25C4.01 17 3 18 3 19.25v.5c0 .41.34.75.75.75h7.42c-.11-.4-.17-.82-.17-1.25zM7.75 16H5.5v-5h2.25v5zM23 19.25a3.75 3.75 0 00-3.75-3.75h-.1a.75.75 0 00.1 1.5h.15a2.25 2.25 0 01-.15 4.5l-.1.01a.75.75 0 00.1 1.5V23h.2A3.75 3.75 0 0023 19.25zm-6.5-3a.75.75 0 00-.75-.75h-.2a3.75 3.75 0 00.2 7.5h.1a.75.75 0 00-.1-1.5h-.15a2.25 2.25 0 01.15-4.5h.1a.75.75 0 00.65-.75zm3.5 3a.75.75 0 00-.75-.75h-3.6a.75.75 0 00.1 1.5h3.6a.75.75 0 00.65-.75z",
    fill: primaryFill
  }));
};

export const BuildingBankLink24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/BuildingBankLink24FilledIcon, 'BuildingBankLink24Filled');

const BuildingBankLink24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M13 6.25a1 1 0 11-2 0 1 1 0 012 0zm.03-3.93a1.75 1.75 0 00-2.06 0L3.55 7.74c-.98.71-.48 2.26.73 2.26h.22v5.8A2.75 2.75 0 003 18.25v1.5c0 .41.34.75.75.75h7.42A4.75 4.75 0 0111 19H4.5v-.75c0-.69.56-1.25 1.25-1.25h5.82c.31-.58.74-1.1 1.26-1.5h-.08V10h1.75v4.67c.4-.11.82-.17 1.25-.17H16V10h2v4.5h1.5V10h.22c1.2 0 1.71-1.55.73-2.26l-7.42-5.42zm-1.18 1.22c.09-.07.21-.07.3 0l6.8 4.96H5.05l6.8-4.96zm-.6 6.46v5.5H9.5V10h1.75zM6 15.5V10h2v5.5H6zm17 3.75a3.75 3.75 0 00-3.75-3.75h-.1a.75.75 0 00.1 1.5h.15a2.25 2.25 0 01-.15 4.5l-.1.01a.75.75 0 00.1 1.5V23h.2A3.75 3.75 0 0023 19.25zm-6.5-3a.75.75 0 00-.75-.75h-.2a3.75 3.75 0 00.2 7.5h.1a.75.75 0 00-.1-1.5h-.15a2.25 2.25 0 01.15-4.5h.1a.75.75 0 00.65-.75zm3.5 3a.75.75 0 00-.75-.75h-3.6a.75.75 0 00.1 1.5h3.6a.75.75 0 00.65-.75z",
    fill: primaryFill
  }));
};

export const BuildingBankLink24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/BuildingBankLink24RegularIcon, 'BuildingBankLink24Regular');

const BuildingBankLink28FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M13.11 2.3a1.5 1.5 0 011.78 0l9.5 7a1.5 1.5 0 01-.74 2.7H4.35a1.5 1.5 0 01-.74-2.7l9.5-7zm.9 6.7a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm5.5 4H22v5h-2.5v-5zM13 22.75c0-1.03.32-1.97.87-2.75H6.25A3.25 3.25 0 003 23.25v.5c0 .41.34.75.75.75h9.58a4.74 4.74 0 01-.33-1.75zm2-3.87c.7-.51 1.56-.83 2.5-.87V13H15v5.88zM13 19v-6h-2.5v6H13zm-4.5-6v6H6v-6h2.5zm9.24 7.5a2.25 2.25 0 000 4.5h.5a.75.75 0 010 1.5h-.5a3.75 3.75 0 010-7.5h.5a.75.75 0 010 1.5h-.5zM17 22.75c0-.41.34-.75.75-.75h5.5a.75.75 0 010 1.5h-5.5a.75.75 0 01-.75-.75zM23.25 25a2.25 2.25 0 000-4.5h-.5a.75.75 0 010-1.5h.5a3.75 3.75 0 010 7.5h-.5a.75.75 0 010-1.5h.5z",
    fill: primaryFill
  }));
};

export const BuildingBankLink28Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/BuildingBankLink28FilledIcon, 'BuildingBankLink28Filled');

const BuildingBankLink28RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M14 9a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm.9-6.7a1.5 1.5 0 00-1.79 0l-9.5 7a1.5 1.5 0 00.9 2.7H5v7.25c-1.18.49-2 1.65-2 3v1.5c0 .41.33.75.74.75h9.58c-.18-.47-.3-.97-.32-1.5H4.5v-.75c0-.97.78-1.75 1.74-1.75h7.32c.31-.58.75-1.1 1.27-1.5h-.09v-7h2.75v6H19v-6h2.5v6H23v-6h.5a1.5 1.5 0 00.89-2.7l-9.5-7zM6.5 19v-7H9v7H6.5zm6.75-7v7H10.5v-7h2.75zM4.5 10.5l9.5-7 9.5 7h-19zm13.25 10a2.25 2.25 0 000 4.5h.5a.75.75 0 010 1.5h-.5a3.75 3.75 0 010-7.5h.5a.75.75 0 010 1.5h-.5zM17 22.75c0-.41.34-.75.75-.75h5.5a.75.75 0 010 1.5h-5.5a.75.75 0 01-.75-.75zM23.25 25a2.25 2.25 0 000-4.5h-.5a.75.75 0 010-1.5h.5a3.75 3.75 0 010 7.5h-.5a.75.75 0 010-1.5h.5z",
    fill: primaryFill
  }));
};

export const BuildingBankLink28Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/BuildingBankLink28RegularIcon, 'BuildingBankLink28Regular');

const BuildingBankLink48FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M25.35 4.45c-.8-.6-1.9-.6-2.7 0L6.71 16.35a1.75 1.75 0 001.05 3.15h32.48c1.69 0 2.4-2.14 1.05-3.15L25.35 4.45zM24 14a2 2 0 110-4 2 2 0 010 4zM6 38.25C6 35.35 8.35 33 11.25 33h11.9a8.4 8.4 0 00-.28 8H7.25C6.56 41 6 40.44 6 39.75v-1.5zm20-8.15a7.78 7.78 0 014-1.1v-7.5h-4v8.6zm8-1.1h4v-7.5h-4V29zm-20 2h-4v-9.5h4V31zm4-9.5V31h4v-9.5h-4zM30.25 31a6.25 6.25 0 100 12.5h1.5a1.25 1.25 0 100-2.5h-1.5a3.75 3.75 0 110-7.5h1.5a1.25 1.25 0 100-2.5h-1.5zm9.5 0a6.25 6.25 0 110 12.5h-1.5a1.25 1.25 0 110-2.5h1.5a3.75 3.75 0 100-7.5h-1.5a1.25 1.25 0 110-2.5h1.5zM29 37.25c0-.69.56-1.25 1.25-1.25h9.5a1.25 1.25 0 110 2.5h-9.5c-.69 0-1.25-.56-1.25-1.25z",
    fill: primaryFill
  }));
};

export const BuildingBankLink48Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/BuildingBankLink48FilledIcon, 'BuildingBankLink48Filled');

const BuildingBankLink48RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M24 14a2 2 0 100-4 2 2 0 000 4zm1.35-9.55c-.8-.6-1.9-.6-2.7 0L6.71 16.35a1.75 1.75 0 001.05 3.15H9v12c-1.77.85-3 2.66-3 4.75v3.5c0 .7.56 1.25 1.25 1.25h15.62a8.38 8.38 0 01-.78-2.5H8.5v-2.25a2.75 2.75 0 012.75-2.75h11.62a8.22 8.22 0 012.38-2.89v-11.1h4.25V29H32v-9.5h4.5V29H39v-9.5h1.24c1.69 0 2.4-2.15 1.05-3.16L25.35 4.45zM22.75 31H18.5V19.5h4.25V31zM16 31h-4.5V19.5H16V31zm-5.99-14L24 6.56 37.99 17H10zm20.24 14a6.25 6.25 0 100 12.5h1.5a1.25 1.25 0 100-2.5h-1.5a3.75 3.75 0 110-7.5h1.5a1.25 1.25 0 100-2.5h-1.5zm9.5 0a6.25 6.25 0 110 12.5h-1.5a1.25 1.25 0 110-2.5h1.5a3.75 3.75 0 100-7.5h-1.5a1.25 1.25 0 110-2.5h1.5zM29 37.25c0-.69.56-1.25 1.25-1.25h9.5a1.25 1.25 0 110 2.5h-9.5c-.69 0-1.25-.56-1.25-1.25z",
    fill: primaryFill
  }));
};

export const BuildingBankLink48Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/BuildingBankLink48RegularIcon, 'BuildingBankLink48Regular');

const BuildingBankToolbox20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M8.23 2.18a1.33 1.33 0 011.54 0l5.85 4.15A.92.92 0 0115.1 8H2.9a.92.92 0 01-.52-1.67l5.85-4.15zM9 5.88A.83.83 0 109 4.2a.83.83 0 000 1.66zM3.5 9v4h2V9h-2zm.67 5C2.97 14 2 14.97 2 16.17v.33c0 .28.22.5.5.5H9v-3H4.17zm7.33-4V9h-2v3c.37-.5.91-.84 1.54-.96.07-.38.23-.74.46-1.04zm-3 3V9h-2v4h2zm3.5-1v-.5c0-.83.67-1.5 1.5-1.5h2c.83 0 1.5.67 1.5 1.5v.5h.5c.83 0 1.5.67 1.5 1.5V15h-2v-.5a.5.5 0 00-1 0v.5h-3v-.5a.5.5 0 00-1 0v.5h-2v-1.5c0-.83.67-1.5 1.5-1.5h.5zm1-.5v.5h3v-.5a.5.5 0 00-.5-.5h-2a.5.5 0 00-.5.5zm4 4.5h2v1.5c0 .83-.67 1.5-1.5 1.5h-6a1.5 1.5 0 01-1.5-1.5V16h2v.5a.5.5 0 101 0V16h3v.5a.5.5 0 101 0V16z",
    fill: primaryFill
  }));
};

export const BuildingBankToolbox20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/BuildingBankToolbox20FilledIcon, 'BuildingBankToolbox20Filled');

const BuildingBankToolbox20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M9 5.87a.83.83 0 100-1.66.83.83 0 000 1.66zM2.5 17H9v-1H3v-.83c0-.65.52-1.17 1.17-1.17H9v-.5c0-.56.19-1.08.5-1.5V8H11v3.05h.04A2.5 2.5 0 0112 9.5V8h2v1h1V8h.1a.92.92 0 00.52-1.67L9.77 2.18a1.33 1.33 0 00-1.54 0L2.38 6.33A.92.92 0 002.9 8H3v5.34c-.6.38-1 1.06-1 1.83v1.33c0 .28.22.5.5.5zM8.8 3a.33.33 0 01.4 0l5.63 4H3.17L8.8 3zM4 13V8h2v5H4zm4.5 0H7V8h1.5v5zm3.5-1v-.5c0-.83.67-1.5 1.5-1.5h2c.83 0 1.5.67 1.5 1.5v.5h.5c.83 0 1.5.67 1.5 1.5V15h-2v-.5a.5.5 0 10-1 0v.5h-3v-.5a.5.5 0 10-1 0v.5h-2v-1.5c0-.83.67-1.5 1.5-1.5h.5zm1-.5v.5h3v-.5a.5.5 0 00-.5-.5h-2a.5.5 0 00-.5.5zm4 4.5h2v1.5c0 .83-.67 1.5-1.5 1.5h-6a1.5 1.5 0 01-1.5-1.5V16h2v.5a.5.5 0 101 0V16h3v.5a.5.5 0 101 0V16z",
    fill: primaryFill
  }));
};

export const BuildingBankToolbox20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/BuildingBankToolbox20RegularIcon, 'BuildingBankToolbox20Regular');

const BuildingBankToolbox24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M13.03 2.34a1.75 1.75 0 00-2.06 0l-7.42 5.4c-.98.72-.48 2.26.73 2.27H16V10H19.72c1.2 0 1.71-1.54.73-2.25l-7.42-5.41zM12 5.26a1 1 0 110 2 1 1 0 010-2zm-.75 10.15c-.1.19-.16.38-.2.6h-1.8v-5h2v4.4zm3.5-3.97A2.75 2.75 0 0013 14v.05l-.25.06v-3.1h2v.43zM11 17v3.5H3.75a.75.75 0 01-.75-.75v-.5C3 18.01 4 17 5.25 17H11zm-5.5-1h2.25v-5H5.5v5zm8.5-1h-.5c-.83 0-1.5.67-1.5 1.5V18h2.5v-.25a.75.75 0 011.5 0V18h3v-.25a.75.75 0 011.5 0V18H23v-1.5c0-.83-.67-1.5-1.5-1.5H21v-1c0-.97-.78-1.75-1.75-1.75h-3.5c-.97 0-1.75.78-1.75 1.75v1zm1.5-1c0-.14.11-.25.25-.25h3.5c.14 0 .25.11.25.25v1h-4v-1zm-2 9a1.5 1.5 0 01-1.5-1.5v-2h2.5v.75a.75.75 0 001.5 0v-.75h3v.75a.75.75 0 001.5 0v-.75H23v2c0 .83-.67 1.5-1.5 1.5h-8z",
    fill: primaryFill
  }));
};

export const BuildingBankToolbox24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/BuildingBankToolbox24FilledIcon, 'BuildingBankToolbox24Filled');

const BuildingBankToolbox24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M13 6.26a1 1 0 11-2 0 1 1 0 012 0zm.03-3.92a1.75 1.75 0 00-2.06 0l-7.42 5.4c-.98.72-.48 2.27.73 2.27h.22v5.8A2.75 2.75 0 003 18.24v1.5c0 .41.34.75.75.75H11V19H4.5v-.75c0-.69.56-1.25 1.25-1.25H11v-.5c0-.35.07-.7.2-1H9.5V10h1.75v5.4a2.5 2.5 0 011.5-1.29v-4.1h1.75v1.54c.38-.2.8-.3 1.25-.3H16v-1.24h2v1.24h1.25l.25.01v-1.25h.22c1.2 0 1.71-1.55.73-2.26l-7.42-5.41zm-1.18 1.2c.09-.06.21-.06.3 0l6.8 4.97H5.05l6.8-4.96zM6 15.5V10h2v5.5H6zm8-.5h-.5c-.83 0-1.5.67-1.5 1.5V18h2.5v-.25a.75.75 0 011.5 0V18h3v-.25a.75.75 0 011.5 0V18H23v-1.5c0-.83-.67-1.5-1.5-1.5H21v-1c0-.97-.78-1.75-1.75-1.75h-3.5c-.97 0-1.75.78-1.75 1.75v1zm1.5-1c0-.14.11-.25.25-.25h3.5c.14 0 .25.11.25.25v1h-4v-1zm-2 9a1.5 1.5 0 01-1.5-1.5v-2h2.5v.75a.75.75 0 001.5 0v-.75h3v.75a.75.75 0 001.5 0v-.75H23v2c0 .83-.67 1.5-1.5 1.5h-8z",
    fill: primaryFill
  }));
};

export const BuildingBankToolbox24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/BuildingBankToolbox24RegularIcon, 'BuildingBankToolbox24Regular');

const BuildingFactory16FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M1.46 2.44c.03-.8.7-1.44 1.5-1.44h1.08c.8 0 1.47.64 1.5 1.44l.42 11A1.5 1.5 0 014.46 15H2.54a1.5 1.5 0 01-1.5-1.56l.42-11zm5 12.56c.33-.44.52-1 .5-1.6L6.7 6.82l3.48-2.71a.5.5 0 01.81.39v2.4l3.17-2.78a.5.5 0 01.83.38v9c0 .83-.67 1.5-1.5 1.5H6.46zM13 14v-3.5a.5.5 0 00-.5-.5h-3a.5.5 0 00-.5.5V14h4z",
    fill: primaryFill
  }));
};

export const BuildingFactory16Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/BuildingFactory16FilledIcon, 'BuildingFactory16Filled');

const BuildingFactory16RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M1.46 2.44c.03-.8.7-1.44 1.5-1.44h1.08c.8 0 1.47.64 1.5 1.44l.42 11A1.5 1.5 0 014.46 15H2.54a1.5 1.5 0 01-1.5-1.56l.42-11zM2.96 2a.5.5 0 00-.5.48l-.42 11a.5.5 0 00.5.52h1.92a.5.5 0 00.5-.52l-.42-11a.5.5 0 00-.5-.48H2.96zM13.5 15c.83 0 1.5-.67 1.5-1.5v-9a.5.5 0 00-.85-.35L11 7.29V4.5a.5.5 0 00-.83-.37L6.72 7.19l.05 1.3L10 5.6V8.5a.5.5 0 00.85.35L14 5.71v7.79a.5.5 0 01-.5.5H13v-3a1 1 0 00-1-1H9a1 1 0 00-1 1v3H6.91c-.07.37-.23.7-.45 1h7.04zM9 14v-3h3v3H9z",
    fill: primaryFill
  }));
};

export const BuildingFactory16Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/BuildingFactory16RegularIcon, 'BuildingFactory16Regular');

const BuildingFactory20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2.94 3.4c.05-.79.7-1.4 1.5-1.4h1.12c.8 0 1.45.61 1.5 1.4l.87 13a1.5 1.5 0 01-1.5 1.6H3.57a1.5 1.5 0 01-1.5-1.6l.87-13zM8.44 18c.34-.46.53-1.04.49-1.67L8.4 8.51l3.76-3.38a.5.5 0 01.84.37v3.38l4.16-3.75a.5.5 0 01.84.37v11c0 .83-.67 1.5-1.5 1.5H8.43zM16 17v-4.2a.8.8 0 00-.8-.8h-3.4a.8.8 0 00-.8.8V17h5z",
    fill: primaryFill
  }));
};

export const BuildingFactory20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/BuildingFactory20FilledIcon, 'BuildingFactory20Filled');

const BuildingFactory20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4.44 2a1.5 1.5 0 00-1.5 1.4l-.87 13a1.5 1.5 0 001.5 1.6h2.86a1.5 1.5 0 001.5-1.6l-.87-13A1.5 1.5 0 005.56 2H4.44zm-.5 1.47a.5.5 0 01.5-.47h1.12c.27 0 .49.2.5.47l.87 13a.5.5 0 01-.5.53H3.57a.5.5 0 01-.5-.53l.87-13zM16.5 18H8.43c.22-.3.38-.63.45-1H10v-4a1 1 0 011-1h4a1 1 0 011 1v4h.5a.5.5 0 00.5-.5V6.62l-4.17 3.75A.5.5 0 0112 10V6.62L8.49 9.78 8.4 8.51l3.76-3.38a.5.5 0 01.84.37v3.38l4.16-3.75a.5.5 0 01.84.37v11c0 .83-.67 1.5-1.5 1.5zM11 17h4v-4h-4v4z",
    fill: primaryFill
  }));
};

export const BuildingFactory20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/BuildingFactory20RegularIcon, 'BuildingFactory20Regular');

const BuildingFactory24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2.92 4.13A2.25 2.25 0 015.17 2h1.16c1.2 0 2.18.93 2.24 2.13l.84 15.5A2.25 2.25 0 017.17 22H4.33a2.25 2.25 0 01-2.24-2.37l.83-15.5zM9.52 22h10.23c1.24 0 2.25-1 2.25-2.25V6a.75.75 0 00-1.26-.55l-5.24 4.84V6a.75.75 0 00-1.26-.55L9.87 9.49l.54 10.08c.05.94-.3 1.8-.9 2.43zM13 16a1 1 0 011-1h4a1 1 0 011 1v4.5h-6V16z",
    fill: primaryFill
  }));
};

export const BuildingFactory24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/BuildingFactory24FilledIcon, 'BuildingFactory24Filled');

const BuildingFactory24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5.17 2c-1.2 0-2.18.93-2.25 2.13l-.83 15.5A2.25 2.25 0 004.33 22h2.84a2.25 2.25 0 002.24-2.37l-.84-15.5A2.25 2.25 0 006.33 2H5.17zm-.75 2.21c.02-.4.35-.71.75-.71h1.16c.4 0 .73.31.75.71l.83 15.5c.03.43-.31.79-.74.79H4.33a.75.75 0 01-.75-.8l.84-15.49zM9.52 22c.39-.41.67-.93.8-1.5h1.18v-4.25c0-.97.78-1.75 1.75-1.75h4c.97 0 1.75.78 1.75 1.75v4.25h.75c.41 0 .75-.34.75-.75V7.71l-5.24 4.84A.75.75 0 0114 12V7.71l-4.03 3.72-.1-1.94 4.37-4.04A.75.75 0 0115.5 6v4.29l5.24-4.84A.75.75 0 0122 6v13.75c0 1.24-1 2.25-2.25 2.25H9.5zM13 16.25v4.25h4.5v-4.25a.25.25 0 00-.25-.25h-4a.25.25 0 00-.25.25z",
    fill: primaryFill
  }));
};

export const BuildingFactory24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/BuildingFactory24RegularIcon, 'BuildingFactory24Regular');

const BuildingFactory28FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2.94 4.15A2.25 2.25 0 015.19 2h2.13c1.2 0 2.19.95 2.24 2.15l.87 19.5A2.25 2.25 0 018.18 26H4.32a2.25 2.25 0 01-2.25-2.35l.87-19.5zM10.53 26c.59-.62.94-1.47.9-2.4l-.54-12.1 5.86-5.3a.75.75 0 011.25.55v5.56l6.75-6.12a.75.75 0 011.25.56v16.5A2.75 2.75 0 0123.25 26H10.53zM22 24.5v-6.25c0-.69-.56-1.25-1.25-1.25h-4.5c-.69 0-1.25.56-1.25 1.25v6.25h7z",
    fill: primaryFill
  }));
};

export const BuildingFactory28Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/BuildingFactory28FilledIcon, 'BuildingFactory28Filled');

const BuildingFactory28RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5.19 2c-1.2 0-2.2.95-2.25 2.15l-.87 19.5A2.25 2.25 0 004.32 26h3.86c1.28 0 2.3-1.07 2.25-2.35l-.87-19.5A2.25 2.25 0 007.32 2H5.19zm-.75 2.22c.01-.4.34-.72.75-.72h2.13c.4 0 .73.32.74.72l.87 19.5a.75.75 0 01-.75.78H4.32a.75.75 0 01-.75-.78l.87-19.5zM10.53 26c.4-.41.68-.93.82-1.5H13v-6.75c0-.69.56-1.25 1.25-1.25h7c.7 0 1.25.56 1.25 1.25v6.75h.75c.7 0 1.25-.56 1.25-1.25V8.45l-6.75 6.1A.75.75 0 0116.5 14V8.44l-5.52 5-.09-1.94 5.86-5.3a.75.75 0 011.25.55v5.56l6.75-6.12a.75.75 0 011.25.56v16.5A2.75 2.75 0 0123.25 26H10.53zm3.97-1.5H21V18h-6.5v6.5z",
    fill: primaryFill
  }));
};

export const BuildingFactory28Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/BuildingFactory28RegularIcon, 'BuildingFactory28Regular');

const BuildingFactory32FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2.82 4.9a3 3 0 013-2.9h2.36a3 3 0 013 2.9l.75 22a3 3 0 01-3 3.1H5.07a3 3 0 01-3-3.1l.75-22zM11.58 30c.86-.76 1.4-1.9 1.35-3.14l-.47-13.73 6.83-6.84A1 1 0 0121 7v6.59l7.3-7.3A1 1 0 0130 7v19.5a3.5 3.5 0 01-3.48 3.5H11.58zM25 20.5c0-.83-.67-1.5-1.5-1.5h-5c-.83 0-1.5.67-1.5 1.5V28h8v-7.5z",
    fill: primaryFill
  }));
};

export const BuildingFactory32Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/BuildingFactory32FilledIcon, 'BuildingFactory32Filled');

const BuildingFactory32RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5.82 2a3 3 0 00-3 2.9l-.75 22a3 3 0 003 3.1h3.86a3 3 0 003-3.1l-.75-22a3 3 0 00-3-2.9H5.82zm-1 2.97a1 1 0 011-.97h2.36a1 1 0 011 .97l.75 22a1 1 0 01-1 1.03H5.07a1 1 0 01-1-1.03l.75-22zM11.58 30H26.5a3.5 3.5 0 003.5-3.5V7a1 1 0 00-1.7-.7L21 13.58V7a1 1 0 00-1.7-.7l-6.84 6.83.1 2.73L19 9.41V16a1 1 0 001.7.7L28 9.42V26.5c0 .83-.67 1.5-1.5 1.5H26v-7.5c0-.83-.67-1.5-1.5-1.5h-8c-.83 0-1.5.67-1.5 1.5V28h-2.2a4 4 0 01-1.22 2zM17 28v-7h7v7h-7z",
    fill: primaryFill
  }));
};

export const BuildingFactory32Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/BuildingFactory32RegularIcon, 'BuildingFactory32Regular');

const BuildingFactory48FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5.6 7.78a4.25 4.25 0 014.24-4.03h3.31a4.25 4.25 0 014.25 4.03l1.68 31.75A4.25 4.25 0 0114.84 44H8.16a4.25 4.25 0 01-4.24-4.47L5.6 7.78zM19.42 44a6.23 6.23 0 001.66-4.58L20 19.22l9.1-9.1a1.25 1.25 0 012.14.88v9.98l10.87-10.86a1.25 1.25 0 012.13.89l-.22 27.78A5.25 5.25 0 0138.78 44H19.42zm18.08-2.5v-9.75c0-.97-.78-1.75-1.75-1.75h-8c-.97 0-1.75.78-1.75 1.75v9.75h11.5z",
    fill: primaryFill
  }));
};

export const BuildingFactory48Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/BuildingFactory48FilledIcon, 'BuildingFactory48Filled');

const BuildingFactory48RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M9.84 3.75A4.25 4.25 0 005.6 7.78L3.92 39.53A4.25 4.25 0 008.16 44h6.68a4.25 4.25 0 004.24-4.47L17.4 7.78a4.25 4.25 0 00-4.25-4.03h-3.3zM8.1 7.91c.05-.93.81-1.66 1.74-1.66h3.31c.93 0 1.7.73 1.75 1.66l1.68 31.75c.06 1-.74 1.84-1.74 1.84H8.16c-1 0-1.8-.84-1.75-1.84L8.1 7.9zM19.42 44a6.25 6.25 0 001.42-2.5h2.66V31.25c0-.97.78-1.75 1.75-1.75h11c.97 0 1.75.78 1.75 1.75V41.5h.78a2.75 2.75 0 002.75-2.73l.2-24.73-10.85 10.84a1.25 1.25 0 01-2.13-.88v-9.98l-8.56 8.56-.18-3.36 9.1-9.1a1.25 1.25 0 012.14.88v9.98l10.87-10.86a1.25 1.25 0 012.13.89l-.22 27.78A5.25 5.25 0 0138.78 44H19.42zM26 41.5h9.5V32H26v9.5z",
    fill: primaryFill
  }));
};

export const BuildingFactory48Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/BuildingFactory48RegularIcon, 'BuildingFactory48Regular');

const BuildingGovernment20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M9.5 2a.5.5 0 00-.5.5v2.6A5 5 0 005 10v1H4a2 2 0 00-2 2v4a1 1 0 001 1h4.5a.5.5 0 00.5-.5v-2c0-.28.22-.5.5-.5h3c.28 0 .5.22.5.5v2c0 .28.22.5.5.5H17a1 1 0 001-1v-4a2 2 0 00-2-2h-1v-1a5 5 0 00-5-5V4h2.5a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5h-3zM6 13.5v2a.5.5 0 01-1 0v-2a.5.5 0 011 0zm8.5-.5c.28 0 .5.22.5.5v2a.5.5 0 01-1 0v-2c0-.28.22-.5.5-.5zM9 9.5v2a.5.5 0 01-1 0v-2a.5.5 0 011 0zm2.5-.5c.28 0 .5.22.5.5v2a.5.5 0 01-1 0v-2c0-.28.22-.5.5-.5z",
    fill: primaryFill
  }));
};

export const BuildingGovernment20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/BuildingGovernment20FilledIcon, 'BuildingGovernment20Filled');

const BuildingGovernment20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M9 2.5c0-.28.22-.5.5-.5h3c.28 0 .5.22.5.5v1a.5.5 0 01-.5.5H10v1a5 5 0 015 5v1h1a2 2 0 012 2v4a1 1 0 01-1 1H3a1 1 0 01-1-1v-4c0-1.1.9-2 2-2h1v-1a5 5 0 014-4.9V2.5zm7 9.5h-1.5a.5.5 0 01-.5-.5V10a4 4 0 00-8 0v1.5a.5.5 0 01-.5.5H4a1 1 0 00-1 1v4h5v-2a1 1 0 011-1h2a1 1 0 011 1v2h5v-4a1 1 0 00-1-1zM6 13.5a.5.5 0 00-1 0v2a.5.5 0 001 0v-2zm9 0a.5.5 0 00-1 0v2a.5.5 0 001 0v-2zM8.5 9a.5.5 0 00-.5.5v2a.5.5 0 001 0v-2a.5.5 0 00-.5-.5zm3.5.5a.5.5 0 00-1 0v2a.5.5 0 001 0v-2zM9 17h2v-2H9v2z",
    fill: primaryFill
  }));
};

export const BuildingGovernment20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/BuildingGovernment20RegularIcon, 'BuildingGovernment20Regular');

const BuildingGovernment24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M15.5 2h-3.75a.75.75 0 00-.75.75v3.32A7 7 0 005 13h-.75C3.01 13 2 14 2 15.25v6c0 .41.34.75.75.75H10c.14 0 .25-.11.25-.25v-3c0-.28.22-.5.5-.5h2.5c.28 0 .5.22.5.5v3c0 .14.11.25.25.25h7.25c.41 0 .75-.34.75-.75v-6c0-1.24-1-2.25-2.25-2.25H19a7 7 0 00-6.5-6.98V5h3a.5.5 0 00.5-.5v-2a.5.5 0 00-.5-.5zm0 9.75v2a.75.75 0 01-1.5 0v-2a.75.75 0 011.5 0zM11.75 11c.41 0 .75.34.75.75v2a.75.75 0 01-1.5 0v-2c0-.41.34-.75.75-.75zm-2.25.75v2a.75.75 0 01-1.5 0v-2a.75.75 0 011.5 0zM5.75 15.5c.41 0 .75.34.75.75v2.5a.75.75 0 01-1.5 0v-2.5c0-.41.34-.75.75-.75zm13.25.75v2.5a.75.75 0 01-1.5 0v-2.5a.75.75 0 011.5 0z",
    fill: primaryFill
  }));
};

export const BuildingGovernment24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/BuildingGovernment24FilledIcon, 'BuildingGovernment24Filled');

const BuildingGovernment24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M15.5 11.75a.75.75 0 00-1.5 0v2a.75.75 0 001.5 0v-2zM11.75 11c.41 0 .75.34.75.75v2a.75.75 0 01-1.5 0v-2c0-.41.34-.75.75-.75zm-2.25.75a.75.75 0 00-1.5 0v2a.75.75 0 001.5 0v-2zM5.75 15.5c.41 0 .75.34.75.75v2.5a.75.75 0 01-1.5 0v-2.5c0-.41.34-.75.75-.75zm13.25.75a.75.75 0 00-1.5 0v2.5a.75.75 0 001.5 0v-2.5zM11.75 2h3.75c.28 0 .5.22.5.5v2a.5.5 0 01-.5.5h-3v1.02A7 7 0 0119 13h.75c1.24 0 2.25 1 2.25 2.25v6c0 .41-.34.75-.75.75H2.75a.75.75 0 01-.75-.75v-6C2 14.01 3 13 4.25 13H5a7 7 0 016-6.93V2.75c0-.41.34-.75.75-.75zM12 7.5A5.5 5.5 0 006.5 13v.75c0 .41-.34.75-.75.75h-1.5a.75.75 0 00-.75.75v5.25h6v-2.75c0-.41.34-.75.75-.75h3.5c.41 0 .75.34.75.75v2.75h6v-5.25a.75.75 0 00-.75-.75h-1.5a.75.75 0 01-.75-.75V13A5.5 5.5 0 0012 7.5zm1 11h-2v2h2v-2z",
    fill: primaryFill
  }));
};

export const BuildingGovernment24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/BuildingGovernment24RegularIcon, 'BuildingGovernment24Regular');

const BuildingGovernment32FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M20.67 2H16a1 1 0 00-1 1v4.05A9 9 0 007 16H5a3 3 0 00-3 3v9a1 1 0 001 1h10v-4a1 1 0 011-1h4a1 1 0 011 1v4h10a1 1 0 001-1v-9a3 3 0 00-3-3h-2a9 9 0 00-8-8.95V6h3.67c.37 0 .66-.3.66-.67V2.67c0-.37-.3-.67-.66-.67zM12 13a1 1 0 011 1v3a1 1 0 11-2 0v-3a1 1 0 011-1zm8 0a1 1 0 011 1v3a1 1 0 11-2 0v-3a1 1 0 011-1zm-3 1v3a1 1 0 11-2 0v-3a1 1 0 112 0zm-9 6a1 1 0 011 1v3a1 1 0 01-2 0v-3a1 1 0 011-1zm16 0a1 1 0 011 1v3a1 1 0 01-2 0v-3a1 1 0 011-1z",
    fill: primaryFill
  }));
};

export const BuildingGovernment32Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/BuildingGovernment32FilledIcon, 'BuildingGovernment32Filled');

const BuildingGovernment32RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M21 14a1 1 0 10-2 0v3a1 1 0 102 0v-3zm-5-1a1 1 0 011 1v3a1 1 0 11-2 0v-3a1 1 0 011-1zm-3 1a1 1 0 10-2 0v3a1 1 0 102 0v-3zm-5 6a1 1 0 011 1v3a1 1 0 01-2 0v-3a1 1 0 011-1zm17 1a1 1 0 10-2 0v3a1 1 0 002 0v-3zM16 2h4.67c.37 0 .66.3.66.67v2.66c0 .37-.3.67-.66.67H17v1.05A9 9 0 0125 16h2a3 3 0 013 3v9a1 1 0 01-1 1H3a1 1 0 01-1-1v-9a3 3 0 013-3h2a9 9 0 018-8.95V3a1 1 0 011-1zm0 7a7 7 0 00-7 7v1a1 1 0 01-1 1H5a1 1 0 00-1 1v8h8.5v-3a1 1 0 011-1h5a1 1 0 011 1v3H28v-8a1 1 0 00-1-1h-3a1 1 0 01-1-1v-1a7 7 0 00-7-7zm1.5 16h-3v2h3v-2z",
    fill: primaryFill
  }));
};

export const BuildingGovernment32Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/BuildingGovernment32RegularIcon, 'BuildingGovernment32Regular');

const BuildingHome16FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3.25 1C2.56 1 2 1.56 2 2.25v8.5c0 .69.56 1.25 1.25 1.25H5v-1.57c0-.7.29-1.35.8-1.83l.65-.6A.5.5 0 117 7.49l1.64-1.52A2 2 0 0111 5.7a1.25 1.25 0 00-1.25-1.2h-.5A.25.25 0 019 4.25v-2C9 1.56 8.44 1 7.75 1h-4.5zM4.5 4a.5.5 0 110-1 .5.5 0 010 1zM5 5.5a.5.5 0 11-1 0 .5.5 0 011 0zM4.5 8a.5.5 0 110-1 .5.5 0 010 1zM7 3.5a.5.5 0 11-1 0 .5.5 0 011 0zM6.5 6a.5.5 0 110-1 .5.5 0 010 1zm4.18.7a1 1 0 00-1.36 0L6.48 9.34c-.3.28-.48.68-.48 1.1V14a1 1 0 001 1h1.5a1 1 0 001-1v-1h1v1a1 1 0 001 1H13a1 1 0 001-1v-3.56c0-.42-.17-.82-.48-1.1L10.68 6.7zm-3.52 3.37L10 7.43l2.84 2.64c.1.1.16.23.16.37V14h-1.5v-1a1 1 0 00-1-1h-1a1 1 0 00-1 1v1H7v-3.56a.5.5 0 01.16-.37z",
    fill: primaryFill
  }));
};

export const BuildingHome16Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/BuildingHome16FilledIcon, 'BuildingHome16Filled');

const BuildingHome16RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3.25 2a.25.25 0 00-.25.25v8.5c0 .14.11.25.25.25H5v1H3.25C2.55 12 2 11.44 2 10.75v-8.5C2 1.55 2.56 1 3.25 1h4.5C8.45 1 9 1.56 9 2.25v2c0 .14.11.25.25.25h.5c.67 0 1.22.53 1.25 1.2a2 2 0 00-1.52-.2h-.23C8.56 5.5 8 4.94 8 4.25v-2A.25.25 0 007.75 2h-4.5zm7.43 4.7a1 1 0 00-1.36 0L6.48 9.34c-.3.28-.48.68-.48 1.1V14a1 1 0 001 1h1.5a1 1 0 001-1v-1h1v1a1 1 0 001 1H13a1 1 0 001-1v-3.56c0-.42-.17-.82-.48-1.1L10.68 6.7zm-3.52 3.37L10 7.43l2.84 2.64c.1.1.16.23.16.37V14h-1.5v-1a1 1 0 00-1-1h-1a1 1 0 00-1 1v1H7v-3.56a.5.5 0 01.16-.37zM5 3.5a.5.5 0 11-1 0 .5.5 0 011 0zM4.5 6a.5.5 0 100-1 .5.5 0 000 1zM5 7.5a.5.5 0 11-1 0 .5.5 0 011 0zM6.5 4a.5.5 0 100-1 .5.5 0 000 1zM7 5.5a.5.5 0 11-1 0 .5.5 0 011 0zM6.5 8a.5.5 0 100-1 .5.5 0 000 1z",
    fill: primaryFill
  }));
};

export const BuildingHome16Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/BuildingHome16RegularIcon, 'BuildingHome16Regular');

const BuildingHome20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3.25 2C2.56 2 2 2.56 2 3.25v10.5c0 .69.56 1.25 1.25 1.25H7.5v-1.74c0-.68.3-1.33.82-1.78l3.47-2.96c.35-.3.78-.47 1.21-.52v-.75C13 6.56 12.44 6 11.75 6h-1.5a.25.25 0 01-.25-.25v-2.5C10 2.56 9.44 2 8.75 2h-5.5zm1.5 3.5a.75.75 0 110-1.5.75.75 0 010 1.5zM5.5 7A.75.75 0 114 7a.75.75 0 011.5 0zm-.75 3a.75.75 0 110-1.5.75.75 0 010 1.5zM8 4.75a.75.75 0 11-1.5 0 .75.75 0 011.5 0zm-.75 3a.75.75 0 110-1.5.75.75 0 010 1.5zM8 9.25a.75.75 0 11-1.5 0 .75.75 0 011.5 0zm6.06.03c-.47-.4-1.15-.4-1.62 0l-3.47 2.96c-.3.26-.47.63-.47 1.02v4.61C8.5 18.5 9 19 9.63 19h1.74c.63 0 1.13-.5 1.13-1.13v-1.75c0-.06.06-.12.13-.12h1.24c.07 0 .13.06.13.13v1.74c0 .63.5 1.13 1.13 1.13h1.74c.63 0 1.13-.5 1.13-1.13v-4.61c0-.4-.17-.76-.47-1.02l-3.47-2.96zm-.97.77c.1-.08.23-.08.32 0L16.88 13c.08.07.12.16.12.26v4.61c0 .07-.06.13-.13.13h-1.75a.12.12 0 01-.12-.13v-1.75c0-.62-.5-1.12-1.13-1.12h-1.24c-.63 0-1.13.5-1.13 1.13v1.74c0 .07-.06.13-.13.13H9.63a.12.12 0 01-.13-.13v-4.61c0-.1.04-.2.12-.26l3.47-2.95z",
    fill: primaryFill
  }));
};

export const BuildingHome20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/BuildingHome20FilledIcon, 'BuildingHome20Filled');

const BuildingHome20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3.25 3a.25.25 0 00-.25.25v10.5c0 .14.11.25.25.25H7.5v1H3.25C2.56 15 2 14.44 2 13.75V3.25C2 2.56 2.56 2 3.25 2h5.5C9.44 2 10 2.56 10 3.25v2.5c0 .14.11.25.25.25h1.5c.69 0 1.25.56 1.25 1.25V8c-.35.04-.7.16-1 .37V7.25a.25.25 0 00-.25-.25h-1.5C9.56 7 9 6.44 9 5.75v-2.5A.25.25 0 008.75 3h-5.5zm10.81 6.28c-.47-.4-1.15-.4-1.62 0l-3.47 2.96c-.3.26-.47.63-.47 1.02v4.61C8.5 18.5 9 19 9.63 19h1.74c.63 0 1.13-.5 1.13-1.13v-1.75c0-.06.06-.12.13-.12h1.24c.07 0 .13.06.13.13v1.74c0 .63.5 1.13 1.13 1.13h1.74c.63 0 1.13-.5 1.13-1.13v-4.61c0-.4-.17-.76-.47-1.02l-3.47-2.96zm-.97.77c.1-.08.23-.08.32 0L16.88 13c.08.07.12.16.12.26v4.61c0 .07-.06.13-.13.13h-1.75a.12.12 0 01-.12-.13v-1.75c0-.62-.5-1.12-1.13-1.12h-1.24c-.63 0-1.13.5-1.13 1.13v1.74c0 .07-.06.13-.13.13H9.63a.12.12 0 01-.13-.13v-4.61c0-.1.04-.2.12-.26l3.47-2.95zM5.5 4.75a.75.75 0 11-1.5 0 .75.75 0 011.5 0zm-.75 3a.75.75 0 100-1.5.75.75 0 000 1.5zm.75 1.5a.75.75 0 11-1.5 0 .75.75 0 011.5 0zM7.25 5.5a.75.75 0 100-1.5.75.75 0 000 1.5zM8 7a.75.75 0 11-1.5 0A.75.75 0 018 7zm-.75 3a.75.75 0 100-1.5.75.75 0 000 1.5z",
    fill: primaryFill
  }));
};

export const BuildingHome20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/BuildingHome20RegularIcon, 'BuildingHome20Regular');

const BuildingHome24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3.5 2C2.67 2 2 2.67 2 3.5v13c0 .83.67 1.5 1.5 1.5H9v-3.32c0-.76.32-1.49.87-2L14 8.81V8.5c0-.83-.67-1.5-1.5-1.5H11V3.5c0-.83-.67-1.5-1.5-1.5h-6zM6 5.75a.75.75 0 11-1.5 0 .75.75 0 011.5 0zM5.25 9.5a.75.75 0 110-1.5.75.75 0 010 1.5zM6 11.75a.75.75 0 11-1.5 0 .75.75 0 011.5 0zM7.75 6.5a.75.75 0 110-1.5.75.75 0 010 1.5zm.75 2.25a.75.75 0 11-1.5 0 .75.75 0 011.5 0zm-.75 3.75a.75.75 0 110-1.5.75.75 0 010 1.5zm9.44-3.06a1.75 1.75 0 00-2.38 0l-4.25 3.97c-.36.33-.56.79-.56 1.27v5.82c0 .83.67 1.5 1.5 1.5h2c.83 0 1.5-.67 1.5-1.5V18h2v2.5c0 .83.67 1.5 1.5 1.5h2c.83 0 1.5-.67 1.5-1.5v-5.82c0-.48-.2-.94-.56-1.27L17.2 9.44zm-1.36 1.1c.1-.1.24-.1.34 0l4.25 3.96c.05.05.08.12.08.18v5.82h-2V18c0-.83-.67-1.5-1.5-1.5h-2c-.83 0-1.5.67-1.5 1.5v2.5h-2v-5.82c0-.06.03-.13.08-.18l4.25-3.96zM9.25 2h-5.5z",
    fill: primaryFill
  }));
};

export const BuildingHome24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/BuildingHome24FilledIcon, 'BuildingHome24Filled');

const BuildingHome24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3.75 3.5a.25.25 0 00-.25.25v12.5c0 .14.11.25.25.25H9V18H3.75C2.78 18 2 17.22 2 16.25V3.75C2 2.78 2.78 2 3.75 2h5.5c.97 0 1.75.78 1.75 1.75v3c0 .14.11.25.25.25h1c.97 0 1.75.78 1.75 1.75v.07l-1.5 1.4V8.75a.25.25 0 00-.25-.25h-1c-.97 0-1.75-.78-1.75-1.75v-3a.25.25 0 00-.25-.25h-5.5zM6 5.75a.75.75 0 11-1.5 0 .75.75 0 011.5 0zM5.25 9.5a.75.75 0 100-1.5.75.75 0 000 1.5zM6 11.75a.75.75 0 11-1.5 0 .75.75 0 011.5 0zM7.75 6.5a.75.75 0 100-1.5.75.75 0 000 1.5zm.75 2.25a.75.75 0 11-1.5 0 .75.75 0 011.5 0zm-.75 3.75a.75.75 0 100-1.5.75.75 0 000 1.5zm9.44-3.06a1.75 1.75 0 00-2.38 0l-4.25 3.97c-.36.33-.56.79-.56 1.27v5.82c0 .83.67 1.5 1.5 1.5h2c.83 0 1.5-.67 1.5-1.5V18h2v2.5c0 .83.67 1.5 1.5 1.5h2c.83 0 1.5-.67 1.5-1.5v-5.82c0-.48-.2-.94-.56-1.27L17.2 9.44zm-1.36 1.1c.1-.1.24-.1.34 0l4.25 3.96c.05.05.08.12.08.18v5.82h-2V18c0-.83-.67-1.5-1.5-1.5h-2c-.83 0-1.5.67-1.5 1.5v2.5h-2v-5.82c0-.06.03-.13.08-.18l4.25-3.96z",
    fill: primaryFill
  }));
};

export const BuildingHome24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/BuildingHome24RegularIcon, 'BuildingHome24Regular');

const BuildingLighthouse20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M9.25 2.07a.5.5 0 00-.5 0L5.57 3.88A1.13 1.13 0 006 6v2.2a2 2 0 00-1.15 1.59l-.79 7.11a1 1 0 001 1.11h7.88a1 1 0 001-1.11l-.8-7.11A2 2 0 0012 8.18v-.17V6a1.13 1.13 0 00.43-2.12L9.25 2.07zM11 8H7V6h4v2zm-5.48 4.88l6.76-1.8.22 1.9-7.2 1.92.22-2.02zM16.5 7h-2a.5.5 0 110-1h2a.5.5 0 010 1zm-.65-3.15a.5.5 0 10-.7-.7l-1 1a.5.5 0 00.7.7l1-1zm0 6a.5.5 0 000-.7l-1-1a.5.5 0 10-.7.7l1 1c.2.2.5.2.7 0z",
    fill: primaryFill
  }));
};

export const BuildingLighthouse20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/BuildingLighthouse20FilledIcon, 'BuildingLighthouse20Filled');

const BuildingLighthouse20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M8.75 2.07a.5.5 0 01.5 0l3.18 1.81A1.13 1.13 0 0112 6v2.2a2 2 0 011.15 1.59l.79 7.11a1 1 0 01-1 1.11H5.06a1 1 0 01-1-1.11l.8-7.11A2 2 0 016 8.18V6a1.13 1.13 0 01-.43-2.1l3.18-1.82zm.25 1L6.07 4.76a.13.13 0 00.06.25h5.74a.13.13 0 00.06-.25L9 3.08zM11.16 9H6.84a1 1 0 00-1 .89l-.2 1.92 6.53-1.74-.02-.18a1 1 0 00-.99-.89zM11 8V6H7v2h4zm-5.7 6.9l7.2-1.92-.22-1.9-6.76 1.8-.23 2.02zm-.13 1.07L5.06 17h7.88l-.33-3.01-7.44 1.98zM14.5 7h2a.5.5 0 000-1h-2a.5.5 0 100 1zm1.35-3.85c.2.2.2.5 0 .7l-1 1a.5.5 0 11-.7-.7l1-1c.2-.2.5-.2.7 0zm0 6a.5.5 0 11-.7.7l-1-1a.5.5 0 01.7-.7l1 1z",
    fill: primaryFill
  }));
};

export const BuildingLighthouse20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/BuildingLighthouse20RegularIcon, 'BuildingLighthouse20Regular');

const BuildingMultiple20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4 2a2 2 0 00-2 2v13a1 1 0 001 1h7.5a.5.5 0 00.5-.5v-2c0-.28.22-.5.5-.5h3c.28 0 .5.22.5.5v2c0 .28.22.5.5.5H17a1 1 0 001-1V7a2 2 0 00-2-2h-4V4a2 2 0 00-2-2H4zm7 3h-1a2 2 0 00-2 2v10H3V4a1 1 0 011-1h6a1 1 0 011 1v1zM5.25 9.5a.75.75 0 100-1.5.75.75 0 000 1.5zM6 5.75a.75.75 0 11-1.5 0 .75.75 0 011.5 0zm-.75 9.75a.75.75 0 100-1.5.75.75 0 000 1.5zM6 11.75a.75.75 0 11-1.5 0 .75.75 0 011.5 0zm5.25-2.25a.75.75 0 110-1.5.75.75 0 010 1.5zm.75 2.25a.75.75 0 11-1.5 0 .75.75 0 011.5 0zm2.75-2.25a.75.75 0 110-1.5.75.75 0 010 1.5zm.75 2.25a.75.75 0 11-1.5 0 .75.75 0 011.5 0z",
    fill: primaryFill
  }));
};

export const BuildingMultiple20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/BuildingMultiple20FilledIcon, 'BuildingMultiple20Filled');

const BuildingMultiple20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2 4c0-1.1.9-2 2-2h6a2 2 0 012 2v1h4a2 2 0 012 2v10a1 1 0 01-1 1H3a1 1 0 01-1-1V4zm10 13h2v-2h-2v2zm3 0h2V7a1 1 0 00-1-1h-6a1 1 0 00-1 1v10h2v-2a1 1 0 011-1h2a1 1 0 011 1v2zM11 4a1 1 0 00-1-1H4a1 1 0 00-1 1v13h5V7c0-1.1.9-2 2-2h1V4zm1 4.75a.75.75 0 11-1.5 0 .75.75 0 011.5 0zm-6.75.75a.75.75 0 100-1.5.75.75 0 000 1.5zM6 5.75a.75.75 0 11-1.5 0 .75.75 0 011.5 0zm5.25 6.75a.75.75 0 100-1.5.75.75 0 000 1.5zM6 14.75a.75.75 0 11-1.5 0 .75.75 0 011.5 0zm-.75-2.25a.75.75 0 100-1.5.75.75 0 000 1.5zM15.5 8.75a.75.75 0 11-1.5 0 .75.75 0 011.5 0zm-.75 3.75a.75.75 0 100-1.5.75.75 0 000 1.5z",
    fill: primaryFill
  }));
};

export const BuildingMultiple20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/BuildingMultiple20RegularIcon, 'BuildingMultiple20Regular');

const BuildingMultiple24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M7 16a1 1 0 100-2 1 1 0 000 2zm1 2a1 1 0 11-2 0 1 1 0 012 0zm-1-5a1 1 0 100-2 1 1 0 000 2zm1-4a1 1 0 11-2 0 1 1 0 012 0zM7 7a1 1 0 100-2 1 1 0 000 2zm7-2.75V5h4.75C19.99 5 21 6 21 7.25v13.5c0 .41-.34.75-.75.75h-3v-2.75a.5.5 0 00-.5-.5h-2.5a.5.5 0 00-.5.5v2.75h-10a.75.75 0 01-.75-.75V4.25C3 3.01 4 2 5.25 2h6.5C12.99 2 14 3 14 4.25zM5.25 3.5a.75.75 0 00-.75.75V20H10V7.25C10 6.01 11 5 12.25 5h.25v-.75a.75.75 0 00-.75-.75h-6.5zM18 15a1 1 0 10-2 0 1 1 0 002 0zm-4 1a1 1 0 100-2 1 1 0 000 2zm4-4a1 1 0 10-2 0 1 1 0 002 0zm-4 1a1 1 0 100-2 1 1 0 000 2zm4-4a1 1 0 10-2 0 1 1 0 002 0zm-4 1a1 1 0 100-2 1 1 0 000 2z",
    fill: primaryFill
  }));
};

export const BuildingMultiple24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/BuildingMultiple24FilledIcon, 'BuildingMultiple24Filled');

const BuildingMultiple24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M8 6a1 1 0 11-2 0 1 1 0 012 0zm-1 4a1 1 0 100-2 1 1 0 000 2zm1 2a1 1 0 11-2 0 1 1 0 012 0zm0 3a1 1 0 11-2 0 1 1 0 012 0zm-1 4a1 1 0 100-2 1 1 0 000 2zm7-3a1 1 0 100-2 1 1 0 000 2zm3 0a1 1 0 100-2 1 1 0 000 2zm0-3a1 1 0 100-2 1 1 0 000 2zm-2-1a1 1 0 11-2 0 1 1 0 012 0zm2-2a1 1 0 100-2 1 1 0 000 2zm-2-1a1 1 0 11-2 0 1 1 0 012 0zm-1-4v-.75C14 3.01 13 2 11.75 2h-6.5C4.01 2 3 3 3 4.25v16.5c0 .41.34.75.75.75h16.5c.41 0 .75-.34.75-.75V7.25C21 6.01 20 5 18.75 5H14zm-9.5-.75c0-.41.34-.75.75-.75h6.5c.41 0 .75.34.75.75V5h-.25C11.01 5 10 6 10 7.25V20H4.5V4.25zM14.5 20v-1.5h2V20h-2zm3.5-2.25a.75.75 0 00-.75-.75h-3.5a.75.75 0 00-.75.75V20h-1.5V7.25c0-.41.34-.75.75-.75h6.5c.41 0 .75.34.75.75V20H18v-2.25z",
    fill: primaryFill
  }));
};

export const BuildingMultiple24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/BuildingMultiple24RegularIcon, 'BuildingMultiple24Regular');

const BuildingRetail20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6 10V8h8v2H6zm6 4v-1h2v1h-2zm6-9.5c0 .65-.42 1.2-1 1.41V16.5a.5.5 0 01-.5.5H10v-4.5a.5.5 0 00-.5-.5h-4a.5.5 0 00-.5.5V17H3.5a.5.5 0 01-.5-.5V5.91A1.5 1.5 0 013.5 3h13c.83 0 1.5.67 1.5 1.5zm-15 0c0 .28.22.5.5.5h13a.5.5 0 000-1h-13a.5.5 0 00-.5.5zM5.5 7a.5.5 0 00-.5.5v3c0 .28.22.5.5.5h9a.5.5 0 00.5-.5v-3a.5.5 0 00-.5-.5h-9zm6 5a.5.5 0 00-.5.5v2c0 .28.22.5.5.5h3a.5.5 0 00.5-.5v-2a.5.5 0 00-.5-.5h-3zM6 17h3v-4H6v4z",
    fill: primaryFill
  }));
};

export const BuildingRetail20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/BuildingRetail20FilledIcon, 'BuildingRetail20Filled');

const BuildingRetail20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5.5 7a.5.5 0 00-.5.5v3c0 .28.22.5.5.5h9a.5.5 0 00.5-.5v-3a.5.5 0 00-.5-.5h-9zm.5 3V8h8v2H6zm5.5 2a.5.5 0 00-.5.5v2c0 .28.22.5.5.5h3a.5.5 0 00.5-.5v-2a.5.5 0 00-.5-.5h-3zm.5 2v-1h2v1h-2zM2 4.5C2 3.67 2.67 3 3.5 3h13a1.5 1.5 0 01.5 2.91V16.5a.5.5 0 01-.5.5h-13a.5.5 0 01-.5-.5V5.91c-.58-.2-1-.76-1-1.41zM3.5 4a.5.5 0 000 1h13a.5.5 0 000-1h-13zM4 6v10h1v-3.5c0-.28.22-.5.5-.5h4c.28 0 .5.22.5.5V16h6V6H4zm2 10h3v-3H6v3z",
    fill: primaryFill
  }));
};

export const BuildingRetail20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/BuildingRetail20RegularIcon, 'BuildingRetail20Regular');

const BuildingRetail24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M7.5 11.5v-2h9v2h-9zM4 3a2 2 0 00-1 3.73v13.52c0 .41.34.75.75.75H6v-5.25c0-.41.34-.75.75-.75h4c.41 0 .75.34.75.75V21h8.75c.41 0 .75-.34.75-.75V6.73A2 2 0 0020 3H4zm-.5 2c0-.28.22-.5.5-.5h16a.5.5 0 010 1H4a.5.5 0 01-.5-.5zm3.25 3h10.5c.41 0 .75.34.75.75v3.5c0 .41-.34.75-.75.75H6.75a.75.75 0 01-.75-.75v-3.5c0-.41.34-.75.75-.75zm8 7h2.5c.41 0 .75.34.75.75v2.5c0 .41-.34.75-.75.75h-2.5a.75.75 0 01-.75-.75v-2.5c0-.41.34-.75.75-.75zM10 16.5V21H7.5v-4.5H10z",
    fill: primaryFill
  }));
};

export const BuildingRetail24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/BuildingRetail24FilledIcon, 'BuildingRetail24Filled');

const BuildingRetail24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6.75 8a.75.75 0 00-.75.75v3.5c0 .41.34.75.75.75h10.5c.41 0 .75-.34.75-.75v-3.5a.75.75 0 00-.75-.75H6.75zm.75 3.5v-2h9v2h-9zm6.25 2.5a.75.75 0 00-.75.75v2.5c0 .41.34.75.75.75h3.5c.41 0 .75-.34.75-.75v-2.5a.75.75 0 00-.75-.75h-3.5zm.75 2.5v-1h2v1h-2zM4 3a2 2 0 00-1 3.73v13.52c0 .41.34.75.75.75h16.5c.41 0 .75-.34.75-.75V6.73A2 2 0 0020 3H4zm15.5 4v12.5h-8v-4.75a.75.75 0 00-.75-.75h-4a.75.75 0 00-.75.75v4.75H4.5V7h15zm-16-2c0-.28.22-.5.5-.5h16a.5.5 0 010 1H4a.5.5 0 01-.5-.5zM10 19.5H7.5v-4H10v4z",
    fill: primaryFill
  }));
};

export const BuildingRetail24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/BuildingRetail24RegularIcon, 'BuildingRetail24Regular');

const BuildingRetailMoney20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6 10V8h8v2H6zm11-4.09A1.5 1.5 0 0016.5 3h-13A1.5 1.5 0 003 5.91V16.5c0 .28.22.5.5.5H5v-4.5c0-.28.22-.5.5-.5h4c.2 0 .38.12.46.3.3-.2.66-.3 1.04-.3h6V5.91zM3.5 4h13a.5.5 0 010 1h-13a.5.5 0 010-1zM5 7.5c0-.28.22-.5.5-.5h9c.28 0 .5.22.5.5v3a.5.5 0 01-.5.5h-9a.5.5 0 01-.5-.5v-3zM9 13v4H6v-4h3zm8.5 0c.83 0 1.5.67 1.5 1.5v3c0 .83-.67 1.5-1.5 1.5h-6a1.5 1.5 0 01-1.5-1.5v-3c0-.83.67-1.5 1.5-1.5h6zm0 5c0-.28.22-.5.5-.5v-1c-.83 0-1.5.67-1.5 1.5h1zm.5-3.5a.5.5 0 01-.5-.5h-1c0 .83.67 1.5 1.5 1.5v-1zm-6.5-.5a.5.5 0 01-.5.5v1c.83 0 1.5-.67 1.5-1.5h-1zm-.5 3.5c.28 0 .5.22.5.5h1c0-.83-.67-1.5-1.5-1.5v1zm3.5-3a1.5 1.5 0 100 3 1.5 1.5 0 000-3z",
    fill: primaryFill
  }));
};

export const BuildingRetailMoney20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/BuildingRetailMoney20FilledIcon, 'BuildingRetailMoney20Filled');

const BuildingRetailMoney20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2 4.5C2 3.67 2.67 3 3.5 3h13a1.5 1.5 0 01.5 2.91V12h-1V6H4v10h1v-3.5c0-.28.22-.5.5-.5h4c.2 0 .38.12.46.3A2 2 0 009 14v-1H6v3h3v1H3.5a.5.5 0 01-.5-.5V5.91c-.58-.2-1-.76-1-1.41zM3.5 4a.5.5 0 000 1h13a.5.5 0 000-1h-13zm2 3a.5.5 0 00-.5.5v3c0 .28.22.5.5.5h9a.5.5 0 00.5-.5v-3a.5.5 0 00-.5-.5h-9zm.5 3V8h8v2H6zm13 4.5v3c0 .83-.67 1.5-1.5 1.5h-6a1.5 1.5 0 01-1.5-1.5v-3c0-.83.67-1.5 1.5-1.5h6c.83 0 1.5.67 1.5 1.5zM17.5 18c0-.28.22-.5.5-.5v-1c-.83 0-1.5.67-1.5 1.5h1zm.5-3.5a.5.5 0 01-.5-.5h-1c0 .83.67 1.5 1.5 1.5v-1zm-6.5-.5a.5.5 0 01-.5.5v1c.83 0 1.5-.67 1.5-1.5h-1zm-.5 3.5c.28 0 .5.22.5.5h1c0-.83-.67-1.5-1.5-1.5v1zm3.5-3a1.5 1.5 0 100 3 1.5 1.5 0 000-3z",
    fill: primaryFill
  }));
};

export const BuildingRetailMoney20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/BuildingRetailMoney20RegularIcon, 'BuildingRetailMoney20Regular');

const BuildingRetailMoney24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M7.5 11.5v-2h9v2h-9zM4 3a2 2 0 00-1 3.73v13.52c0 .41.34.75.75.75H6v-5.25c0-.41.34-.75.75-.75h4c.41 0 .75.34.75.75V16c.46-.6 1.18-1 2-1H21V6.73A2 2 0 0020 3H4zm-.5 2c0-.28.22-.5.5-.5h16a.5.5 0 010 1H4a.5.5 0 01-.5-.5zm3.25 3h10.5c.41 0 .75.34.75.75v3.5c0 .41-.34.75-.75.75H6.75a.75.75 0 01-.75-.75v-3.5c0-.41.34-.75.75-.75zM10 16.5V21H7.5v-4.5H10zm2 1c0-.83.67-1.5 1.5-1.5h8c.83 0 1.5.67 1.5 1.5v4c0 .83-.67 1.5-1.5 1.5h-8a1.5 1.5 0 01-1.5-1.5v-4zm10 .5a1 1 0 01-1-1h-1c0 1.1.9 2 2 2v-1zm0 2a2 2 0 00-2 2h1a1 1 0 011-1v-1zm-8-3a1 1 0 01-1 1v1a2 2 0 002-2h-1zm1 5a2 2 0 00-2-2v1a1 1 0 011 1h1zm4.25-2.5a1.75 1.75 0 10-3.5 0 1.75 1.75 0 003.5 0z",
    fill: primaryFill
  }));
};

export const BuildingRetailMoney24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/BuildingRetailMoney24FilledIcon, 'BuildingRetailMoney24Filled');

const BuildingRetailMoney24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6.75 8a.75.75 0 00-.75.75v3.5c0 .41.34.75.75.75h10.5c.41 0 .75-.34.75-.75v-3.5a.75.75 0 00-.75-.75H6.75zm.75 3.5v-2h9v2h-9zm6.25 2.5a.75.75 0 00-.75.75v.3c.16-.03.33-.05.5-.05H18v-.25a.75.75 0 00-.75-.75h-3.5zm-2.25.75V16c-.31.42-.5.94-.5 1.5V21H3.75a.75.75 0 01-.75-.75V6.73A2 2 0 014 3h16a2 2 0 011 3.73V15h-1.5V7h-15v12.5H6v-4.75c0-.41.34-.75.75-.75h4c.41 0 .75.34.75.75zM3.5 5c0 .28.22.5.5.5h16a.5.5 0 000-1H4a.5.5 0 00-.5.5zM10 19.5v-4H7.5v4H10zm2-2c0-.83.67-1.5 1.5-1.5h8c.83 0 1.5.67 1.5 1.5v4c0 .83-.67 1.5-1.5 1.5h-8a1.5 1.5 0 01-1.5-1.5v-4zm10 .5a1 1 0 01-1-1h-1c0 1.1.9 2 2 2v-1zm0 2a2 2 0 00-2 2h1a1 1 0 011-1v-1zm-8-3a1 1 0 01-1 1v1a2 2 0 002-2h-1zm1 5a2 2 0 00-2-2v1a1 1 0 011 1h1zm4.25-2.5a1.75 1.75 0 10-3.5 0 1.75 1.75 0 003.5 0z",
    fill: primaryFill
  }));
};

export const BuildingRetailMoney24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/BuildingRetailMoney24RegularIcon, 'BuildingRetailMoney24Regular');

const BuildingRetailMore20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4 3.3a1 1 0 01.7-.3h10.6a1 1 0 01.7.3l2.64 2.63c.76.77.22 2.07-.85 2.07H2.2a1.21 1.21 0 01-.85-2.07L4 3.3zM17 9H3v6c0 1.1.9 2 2 2h10a2 2 0 002-2V9zM7 13a1 1 0 110-2 1 1 0 010 2zm3 0a1 1 0 110-2 1 1 0 010 2zm3 0a1 1 0 110-2 1 1 0 010 2z",
    fill: primaryFill
  }));
};

export const BuildingRetailMore20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/BuildingRetailMore20FilledIcon, 'BuildingRetailMore20Filled');

const BuildingRetailMore20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M7 13a1 1 0 100-2 1 1 0 000 2zm4-1a1 1 0 11-2 0 1 1 0 012 0zm2 1a1 1 0 100-2 1 1 0 000 2zM4 3.3a1 1 0 01.7-.3h10.6a1 1 0 01.7.3l2.64 2.63c.76.77.22 2.07-.85 2.07H17v7a2 2 0 01-2 2H5a2 2 0 01-2-2V8h-.79a1.21 1.21 0 01-.85-2.07L4 3.3zM16 15V8H4v7a1 1 0 001 1h10a1 1 0 001-1zm1.79-8c.18 0 .28-.23.14-.36L15.3 4H4.71L2.07 6.64A.21.21 0 002.2 7H17.8z",
    fill: primaryFill
  }));
};

export const BuildingRetailMore20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/BuildingRetailMore20RegularIcon, 'BuildingRetailMore20Regular');

const BuildingRetailMore24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6.22 3c-.52 0-1.01.23-1.35.63L1.3 7.95c-.67.82-.1 2.05.96 2.05h19.5c1.05 0 1.63-1.23.96-2.05l-3.58-4.32c-.33-.4-.83-.63-1.35-.63H6.22zM3 11.5v7.25a2.5 2.5 0 002.5 2.5h13a2.5 2.5 0 002.5-2.5V11.5H3zm6 3.75a1.25 1.25 0 11-2.5 0 1.25 1.25 0 012.5 0zm3 1.25a1.25 1.25 0 110-2.5 1.25 1.25 0 010 2.5zm5.5-1.25a1.25 1.25 0 11-2.5 0 1.25 1.25 0 012.5 0z",
    fill: primaryFill
  }));
};

export const BuildingRetailMore24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/BuildingRetailMore24FilledIcon, 'BuildingRetailMore24Filled');

const BuildingRetailMore24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M7.75 16a1.25 1.25 0 100-2.5 1.25 1.25 0 000 2.5zm5.5-1.25a1.25 1.25 0 11-2.5 0 1.25 1.25 0 012.5 0zm3 1.25a1.25 1.25 0 100-2.5 1.25 1.25 0 000 2.5zM4.87 3.63c.34-.4.83-.63 1.35-.63h11.56c.52 0 1.02.23 1.35.63l3.58 4.32c.67.82.1 2.05-.96 2.05H21v8.75a2.5 2.5 0 01-2.5 2.5h-13a2.5 2.5 0 01-2.5-2.5V10h-.75a1.25 1.25 0 01-.96-2.05l3.58-4.32zm1.35.87a.25.25 0 00-.2.09L2.8 8.5H21.2l-3.24-3.91a.25.25 0 00-.19-.09H6.22zM4.5 10v8.75a1 1 0 001 1h13a1 1 0 001-1V10h-15z",
    fill: primaryFill
  }));
};

export const BuildingRetailMore24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/BuildingRetailMore24RegularIcon, 'BuildingRetailMore24Regular');

const BuildingRetailMore32FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6.13 4.09A3 3 0 018.44 3h15.12a3 3 0 012.31 1.09l4.67 5.63A2 2 0 0128.99 13H3.01a2 2 0 01-1.55-3.28L6.13 4.1zM4 15v10.75C4 27.55 5.46 29 7.25 29h17.5c1.8 0 3.25-1.46 3.25-3.25V15H4zm8 5a2 2 0 11-4 0 2 2 0 014 0zm4 2a2 2 0 110-4 2 2 0 010 4zm8-2a2 2 0 11-4 0 2 2 0 014 0z",
    fill: primaryFill
  }));
};

export const BuildingRetailMore32Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/BuildingRetailMore32FilledIcon, 'BuildingRetailMore32Filled');

const BuildingRetailMore32RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10 22a2 2 0 100-4 2 2 0 000 4zm8-2a2 2 0 11-4 0 2 2 0 014 0zm4 2a2 2 0 100-4 2 2 0 000 4zM6.13 4.09A3 3 0 018.44 3h15.12a3 3 0 012.31 1.09l4.67 5.63A2 2 0 0128.99 13H28v12.75c0 1.8-1.46 3.25-3.25 3.25H7.25A3.25 3.25 0 014 25.75V13H3a2 2 0 01-1.54-3.28L6.13 4.1zM6 13v12.75c0 .69.56 1.25 1.25 1.25h17.5c.69 0 1.25-.56 1.25-1.25V13H6zm2.44-8a1 1 0 00-.77.36L3.01 11h25.98l-4.66-5.64a1 1 0 00-.77-.36H8.44z",
    fill: primaryFill
  }));
};

export const BuildingRetailMore32Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/BuildingRetailMore32RegularIcon, 'BuildingRetailMore32Regular');

const BuildingRetailShield20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M18 4.5c0 .65-.42 1.2-1 1.41v3.36c-.34-.24-.63-.5-.85-.73A1.6 1.6 0 0015 8.06V7.5a.5.5 0 00-.5-.5h-9a.5.5 0 00-.5.5v3c0 .28.22.5.5.5h4.58a1.5 1.5 0 00-.08.5V13v-.5a.5.5 0 00-.5-.5h-4a.5.5 0 00-.5.5V17H3.5a.5.5 0 01-.5-.5V5.91A1.5 1.5 0 013.5 3h13c.83 0 1.5.67 1.5 1.5zm-15 0c0 .28.22.5.5.5h13a.5.5 0 000-1h-13a.5.5 0 00-.5.5zM14 8v.4l-.15.14A4.71 4.71 0 0111.22 10H6V8h8zm-5 5H6v4h3v-4zm9.5-2.04a5.69 5.69 0 01-3.06-1.72.62.62 0 00-.88 0 5.7 5.7 0 01-3.06 1.72c-.27.04-.5.26-.5.54V14c0 3.47 3.18 4.73 3.87 4.96a.4.4 0 00.26 0c.69-.23 3.87-1.5 3.87-4.96v-2.5c0-.28-.23-.5-.5-.54z",
    fill: primaryFill
  }));
};

export const BuildingRetailShield20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/BuildingRetailShield20FilledIcon, 'BuildingRetailShield20Filled');

const BuildingRetailShield20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3.5 3A1.5 1.5 0 003 5.91V16.5c0 .28.22.5.5.5H10v-4.5a.5.5 0 00-.5-.5h-4a.5.5 0 00-.5.5V16H4V6h12v2.4l.15.14c.22.23.51.49.85.73V5.9A1.5 1.5 0 0016.5 3h-13zM3 4.5c0-.28.22-.5.5-.5h13a.5.5 0 010 1h-13a.5.5 0 01-.5-.5zM9 16H6v-3h3v3zm6-7.94V7.5a.5.5 0 00-.5-.5h-9a.5.5 0 00-.5.5v3c0 .28.22.5.5.5h4.58a1.6 1.6 0 011.14-1H6V8h8v.4c.29-.22.64-.34 1-.34zm3.5 2.9a5.69 5.69 0 01-3.06-1.72.62.62 0 00-.88 0 5.7 5.7 0 01-3.06 1.72c-.27.04-.5.26-.5.54V14c0 3.47 3.18 4.73 3.87 4.96a.4.4 0 00.26 0c.69-.23 3.87-1.5 3.87-4.96v-2.5c0-.28-.23-.5-.5-.54z",
    fill: primaryFill
  }));
};

export const BuildingRetailShield20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/BuildingRetailShield20RegularIcon, 'BuildingRetailShield20Regular');

const BuildingRetailShield24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M7.5 11.5v-2h9v1.21c-.36.27-.81.55-1.33.79H7.5zM18 8.75v1.22c.37 0 .74.12 1.04.38.4.34 1.1.86 1.96 1.22V6.73A2 2 0 0020 3H4a2 2 0 00-1 3.73v13.52c0 .41.34.75.75.75H6v-5.25c0-.41.34-.75.75-.75h4c.41 0 .75.34.75.75V21h1.82A6.5 6.5 0 0112 17v-3.5c0-.18.03-.35.08-.5H6.75a.75.75 0 01-.75-.75v-3.5c0-.41.34-.75.75-.75h10.5c.41 0 .75.34.75.75zM3.5 5c0-.28.22-.5.5-.5h16a.5.5 0 010 1H4a.5.5 0 01-.5-.5zM10 16.5V21H7.5v-4.5H10zm12.5-3.52a7.7 7.7 0 01-4.11-1.87.6.6 0 00-.77 0c-.69.58-2.21 1.7-4.12 1.87a.54.54 0 00-.5.52V17c0 4.22 4.1 5.72 4.87 5.96.09.03.17.03.26 0C18.9 22.72 23 21.22 23 17v-3.5c0-.28-.22-.5-.5-.52z",
    fill: primaryFill
  }));
};

export const BuildingRetailShield24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/BuildingRetailShield24FilledIcon, 'BuildingRetailShield24Filled');

const BuildingRetailShield24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M11.5 19.5h.97c.22.56.51 1.06.85 1.5H3.75a.75.75 0 01-.75-.75V6.73A2 2 0 014 3h16a2 2 0 011 3.73v4.84c-.6-.25-1.1-.57-1.5-.86V7h-15v12.5H6v-4.75c0-.41.34-.75.75-.75h4c.41 0 .75.34.75.75v4.75zM3.5 5c0 .28.22.5.5.5h16a.5.5 0 000-1H4a.5.5 0 00-.5.5zm4 10.5v4H10v-4H7.5zM6.75 8a.75.75 0 00-.75.75v3.5c0 .41.34.75.75.75h5.33c.2-.58.75-.97 1.33-1.02a5.49 5.49 0 001.76-.48H7.5v-2h9v1.21c.18-.13.34-.25.46-.36.3-.26.67-.38 1.04-.38V8.75a.75.75 0 00-.75-.75H6.75zm11.64 3.1a7.7 7.7 0 004.11 1.88c.28.02.5.24.5.52V17c0 4.22-4.1 5.72-4.87 5.96a.42.42 0 01-.26 0C17.1 22.72 13 21.22 13 17v-3.5c0-.28.22-.5.5-.52a7.71 7.71 0 004.12-1.87.6.6 0 01.77 0z",
    fill: primaryFill
  }));
};

export const BuildingRetailShield24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/BuildingRetailShield24RegularIcon, 'BuildingRetailShield24Regular');

const BuildingRetailToolbox20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M17 5.91A1.5 1.5 0 0016.5 3h-13A1.5 1.5 0 003 5.91V16.5c0 .28.22.5.5.5H5v-4.5c0-.28.22-.5.5-.5h4c.37-.5.91-.84 1.54-.96l.01-.04H5.5a.5.5 0 01-.5-.5v-3c0-.28.22-.5.5-.5h9c.28 0 .5.22.5.5V9h.5c.56 0 1.08.19 1.5.5V5.91zM3.5 4h13a.5.5 0 010 1h-13a.5.5 0 010-1zM9 13v4H6v-4h3zm4.5-4h.5V8H6v2h5.5c.46-.6 1.18-1 2-1zM12 12v-.5c0-.83.67-1.5 1.5-1.5h2c.83 0 1.5.67 1.5 1.5v.5h.5c.83 0 1.5.67 1.5 1.5V15h-2v-.5a.5.5 0 00-1 0v.5h-3v-.5a.5.5 0 00-1 0v.5h-2v-1.5c0-.83.67-1.5 1.5-1.5h.5zm1-.5v.5h3v-.5a.5.5 0 00-.5-.5h-2a.5.5 0 00-.5.5zm4 5V16h2v1.5c0 .83-.67 1.5-1.5 1.5h-6a1.5 1.5 0 01-1.5-1.5V16h2v.5a.5.5 0 001 0V16h3v.5a.5.5 0 001 0z",
    fill: primaryFill
  }));
};

export const BuildingRetailToolbox20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/BuildingRetailToolbox20FilledIcon, 'BuildingRetailToolbox20Filled');

const BuildingRetailToolbox20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2 4.5C2 3.67 2.67 3 3.5 3h13a1.5 1.5 0 01.5 2.91V9.5c-.3-.22-.63-.38-1-.45V6H4v10h1v-3.5c0-.28.22-.5.5-.5h4c-.31.42-.5.94-.5 1.5V13H6v3h3v1H3.5a.5.5 0 01-.5-.5V5.91c-.58-.2-1-.76-1-1.41zM3.5 4a.5.5 0 000 1h13a.5.5 0 000-1h-13zM15 7.5V9h-1V8H6v2h5.5c-.22.3-.38.63-.45 1H5.5a.5.5 0 01-.5-.5v-3c0-.28.22-.5.5-.5h9c.28 0 .5.22.5.5zM12 12v-.5c0-.83.67-1.5 1.5-1.5h2c.83 0 1.5.67 1.5 1.5v.5h.5c.83 0 1.5.67 1.5 1.5V15h-2v-.5a.5.5 0 00-1 0v.5h-3v-.5a.5.5 0 00-1 0v.5h-2v-1.5c0-.83.67-1.5 1.5-1.5h.5zm1-.5v.5h3v-.5a.5.5 0 00-.5-.5h-2a.5.5 0 00-.5.5zm4 5V16h2v1.5c0 .83-.67 1.5-1.5 1.5h-6a1.5 1.5 0 01-1.5-1.5V16h2v.5a.5.5 0 001 0V16h3v.5a.5.5 0 001 0z",
    fill: primaryFill
  }));
};

export const BuildingRetailToolbox20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/BuildingRetailToolbox20RegularIcon, 'BuildingRetailToolbox20Regular');

const BuildingRetailToolbox24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M7.5 11.5v-2h9v1.75h-.75c-.4 0-.8.09-1.15.25H7.5zM18 8.75v2.5h1.25c.66 0 1.27.24 1.75.63V6.73A2 2 0 0020 3H4a2 2 0 00-1 3.73v13.52c0 .41.34.75.75.75H6v-5.25c0-.41.34-.75.75-.75h4c.23 0 .44.1.57.27A2.5 2.5 0 0113 14.05V14c0-.35.07-.69.19-1H6.75a.75.75 0 01-.75-.75v-3.5c0-.41.34-.75.75-.75h10.5c.41 0 .75.34.75.75zM3.5 5c0-.28.22-.5.5-.5h16a.5.5 0 010 1H4a.5.5 0 01-.5-.5zM10 16.5V21H7.5v-4.5H10zm4-1.5h-.5c-.83 0-1.5.67-1.5 1.5V18h2.5v-.25a.75.75 0 011.5 0V18h3v-.25a.75.75 0 011.5 0V18H23v-1.5c0-.83-.67-1.5-1.5-1.5H21v-1c0-.97-.78-1.75-1.75-1.75h-3.5c-.97 0-1.75.78-1.75 1.75v1zm1.5-1c0-.14.11-.25.25-.25h3.5c.14 0 .25.11.25.25v1h-4v-1zM12 21.5v-2h2.5v.75a.75.75 0 001.5 0v-.75h3v.75a.75.75 0 001.5 0v-.75H23v2c0 .83-.67 1.5-1.5 1.5h-8a1.5 1.5 0 01-1.5-1.5z",
    fill: primaryFill
  }));
};

export const BuildingRetailToolbox24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/BuildingRetailToolbox24FilledIcon, 'BuildingRetailToolbox24Filled');

const BuildingRetailToolbox24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6.75 8a.75.75 0 00-.75.75v3.5c0 .41.34.75.75.75h6.44c.26-.66.77-1.2 1.41-1.5H7.5v-2h9v1.75H18v-2.5a.75.75 0 00-.75-.75H6.75zm4.75 6.75V15c-.31.42-.5.94-.5 1.5V21H3.75a.75.75 0 01-.75-.75V6.73A2 2 0 014 3h16a2 2 0 011 3.73v5.15a2.74 2.74 0 00-1.5-.62V7h-15v12.5H6v-4.75c0-.41.34-.75.75-.75h4c.41 0 .75.34.75.75zM3.5 5c0 .28.22.5.5.5h16a.5.5 0 000-1H4a.5.5 0 00-.5.5zM10 19.5v-4H7.5v4H10zm4-4.5h-.5c-.83 0-1.5.67-1.5 1.5V18h2.5v-.25a.75.75 0 011.5 0V18h3v-.25a.75.75 0 011.5 0V18H23v-1.5c0-.83-.67-1.5-1.5-1.5H21v-1c0-.97-.78-1.75-1.75-1.75h-3.5c-.97 0-1.75.78-1.75 1.75v1zm1.5-1c0-.14.11-.25.25-.25h3.5c.14 0 .25.11.25.25v1h-4v-1zM12 21.5v-2h2.5v.75a.75.75 0 001.5 0v-.75h3v.75a.75.75 0 001.5 0v-.75H23v2c0 .83-.67 1.5-1.5 1.5h-8a1.5 1.5 0 01-1.5-1.5z",
    fill: primaryFill
  }));
};

export const BuildingRetailToolbox24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/BuildingRetailToolbox24RegularIcon, 'BuildingRetailToolbox24Regular');

const BuildingShop16FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10 10v1h1v-1h-1zM4.19 1.11l-2.5 2c-.17.13-.19.36-.19.56V5.5c0 .56.19 1.08.5 1.5v7.5c0 .28.22.5.5.5H4V9.5c0-.28.22-.5.5-.5h3c.28 0 .5.22.5.5V15h5.5a.5.5 0 00.5-.5V7c.31-.42.5-.94.5-1.5V3.67c0-.2-.02-.43-.19-.56l-2.5-2A.5.5 0 0011.5 1h-7a.5.5 0 00-.31.11zM2.5 5.5V4h3v1.5a1.5 1.5 0 11-3 0zm4 0V4h3v1.5a1.5 1.5 0 11-3 0zm4 0V4h3v1.5a1.5 1.5 0 01-3 0zM3.43 3l1.25-1h1.35l-.38 1H3.43zm3.3 0l.37-1h1.79l.33 1h-2.5zm3.21-1h1.38l1.25 1h-2.3l-.33-1zM9 9.5c0-.28.22-.5.5-.5h2c.28 0 .5.22.5.5v2a.5.5 0 01-.5.5h-2a.5.5 0 01-.5-.5v-2zM5 15h2v-5H5v5z",
    fill: primaryFill
  }));
};

export const BuildingShop16Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/BuildingShop16FilledIcon, 'BuildingShop16Filled');

const BuildingShop16RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M9 9.5c0-.28.22-.5.5-.5h2c.28 0 .5.22.5.5v2a.5.5 0 01-.5.5h-2a.5.5 0 01-.5-.5v-2zm1 1.5h1v-1h-1v1zM4.19 1.11l-2.5 2c-.17.13-.19.36-.19.56V5.5c0 .56.19 1.08.5 1.5v7.5c0 .28.22.5.5.5h11a.5.5 0 00.5-.5V7c.31-.42.5-.94.5-1.5V3.67c0-.2-.02-.43-.19-.56l-2.5-2A.5.5 0 0011.5 1h-7a.5.5 0 00-.31.11zM5.5 4v1.5a1.5 1.5 0 11-3 0V4h3zm4 0v1.5a1.5 1.5 0 11-3 0V4h3zm4 0v1.5a1.5 1.5 0 01-3 0V4h3zM6.03 2l-.38 1H3.43l1.25-1h1.35zm.7 1l.37-1h1.79l.33 1h-2.5zm3.21-1h1.38l1.25 1h-2.3l-.33-1zM13 7.8V14H8V9.5a.5.5 0 00-.5-.5h-3a.5.5 0 00-.5.5V14H3V7.8A2.5 2.5 0 006 7a2.5 2.5 0 004 0 2.5 2.5 0 003 .8zM7 14H5v-4h2v4z",
    fill: primaryFill
  }));
};

export const BuildingShop16Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/BuildingShop16RegularIcon, 'BuildingShop16Regular');

const BuildingShop20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M12 12h2v2h-2v-2zM5 2h10a.5.5 0 01.38.18l2.5 3c.12.14.12.21.12.3V7a3 3 0 01-1 2.24v8.26a.5.5 0 01-.5.5H10v-6.5a.5.5 0 00-.5-.5h-4a.5.5 0 00-.5.5V18H3.5a.5.5 0 01-.5-.5V9.24A3 3 0 012 7V5.5a.5.5 0 01.12-.32l2.5-3A.5.5 0 015 2zM3 6v1a2 2 0 104 0V6H3zm5 0v1a2 2 0 104 0V6H8zm5 0v1a2 2 0 104 0V6h-4zM5.23 3L3.57 5h3.57l.67-2H5.23zm6.58 2l-.67-2H8.86l-.67 2h3.62zm1.05 0h3.57l-1.66-2h-2.58l.67 2zM11 11.5v3c0 .28.22.5.5.5h3a.5.5 0 00.5-.5v-3a.5.5 0 00-.5-.5h-3a.5.5 0 00-.5.5zM9 18v-6H6v6h3z",
    fill: primaryFill
  }));
};

export const BuildingShop20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/BuildingShop20FilledIcon, 'BuildingShop20Filled');

const BuildingShop20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M11 11.5v3c0 .28.22.5.5.5h3a.5.5 0 00.5-.5v-3a.5.5 0 00-.5-.5h-3a.5.5 0 00-.5.5zm1 2.5v-2h2v2h-2zM5 2a.5.5 0 00-.38.18l-2.5 3A.5.5 0 002 5.5V7a3 3 0 001 2.24v8.26c0 .28.22.5.5.5h13a.5.5 0 00.5-.5V9.24A3 3 0 0018 7V5.5v-.02c0-.09 0-.16-.12-.3l-2.5-3A.5.5 0 0015 2H5zm0 7a2 2 0 01-2-2V6h4v1a2 2 0 01-2 2zm5 0a2 2 0 01-2-2V6h4v1a2 2 0 01-2 2zm5 0a2 2 0 01-2-2V6h4v1a2 2 0 01-2 2zM5 17H4V9.83a3 3 0 003.5-1.17 3 3 0 005 0A3 3 0 0016 9.83V17h-6v-5.5a.5.5 0 00-.5-.5h-4a.5.5 0 00-.5.5V17zM7.14 5H3.57l1.66-2h2.58l-.67 2zm4.67 0H8.19l.67-2h2.28l.67 2zm1.05 0l-.67-2h2.58l1.66 2h-3.57zM6 17v-5h3v5H6z",
    fill: primaryFill
  }));
};

export const BuildingShop20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/BuildingShop20RegularIcon, 'BuildingShop20Regular');

const BuildingShop24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10.5 14.5V22h-3v-7.5h3zm6.76-1.5h-3.5a.75.75 0 00-.76.75v3.5c0 .42.34.75.75.75h3.5c.42 0 .76-.33.76-.75v-3.5a.75.75 0 00-.75-.75zm-.76 1.5v2h-2v-2h2zM8.17 7H3.5v1.17c0 1.18.88 2.15 2.02 2.3l.15.02h.16c1.24 0 2.25-.95 2.33-2.16V7zm6.16 0H9.67v1.17c0 1.18.87 2.15 2.01 2.3l.16.02H12c1.23 0 2.24-.95 2.33-2.16V7zm6.17 0h-4.67v1.17c0 1.18.88 2.15 2.02 2.3l.16.02h.16c1.23 0 2.24-.95 2.32-2.16V7zM9.06 3.5H6.33l-1.86 2h3.98l.61-2zm4.3 0h-2.73l-.62 2h3.97l-.61-2zm4.31 0h-2.73l.61 2h3.98l-1.86-2zM2.2 5.74l3.25-3.5c.12-.13.28-.2.45-.23L6 2h12c.17 0 .34.06.47.17l.08.07 3.27 3.53.03.04c.1.13.15.29.15.44v1.92c0 1-.38 1.9-1 2.58v10.5c0 .38-.28.7-.65.74l-.1.01H12v-8.25a.75.75 0 00-.75-.75h-4.5a.75.75 0 00-.75.75V22H3.75a.75.75 0 01-.74-.65v-10.6a3.82 3.82 0 01-1-2.39V6.3c-.02-.14.01-.28.09-.4l.05-.08.05-.07z",
    fill: primaryFill
  }));
};

export const BuildingShop24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/BuildingShop24FilledIcon, 'BuildingShop24Filled');

const BuildingShop24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M18 2c.17 0 .34.06.47.17l.08.07 3.27 3.53.03.04c.1.13.15.29.15.44v1.92c0 1-.38 1.9-1 2.58v10.5c0 .38-.28.7-.65.74l-.1.01H3.75a.75.75 0 01-.74-.65v-10.6a3.82 3.82 0 01-1-2.36V6.3c-.02-.14.01-.28.09-.4l.06-.1.04-.05 3.25-3.5c.12-.13.28-.2.45-.23L6 2h12zm-2.92 8.44l-.01.02a3.83 3.83 0 01-6.15-.02 3.82 3.82 0 01-4.42 1.32v8.74H6v-6.75c0-.38.28-.7.65-.74h4.6c.38 0 .69.27.74.64v6.85h7.5v-8.74a3.82 3.82 0 01-4.4-1.32zM10.5 14.5h-3v6h3v-6zm6.76-1.5c.37 0 .69.28.74.65v3.6c0 .38-.28.7-.64.75h-3.6a.75.75 0 01-.75-.65v-3.6c0-.38.28-.7.64-.74h3.6zm-.76 1.5h-2v2h2v-2zM8.17 7H3.5V8.34l.04.23.03.16.05.17.05.15.04.09.1.2.1.16.06.07.13.16.14.14.1.09.04.03c.32.25.7.42 1.11.48l.18.02h.16c1.24 0 2.25-.95 2.33-2.16V7zm6.16 0H9.67v1.17c0 1.18.87 2.15 2.01 2.3l.16.02H12c1.23 0 2.24-.95 2.33-2.16V7zm6.17 0h-4.67v1.17c0 1.18.88 2.15 2.02 2.3l.16.02h.16c.56 0 1.08-.2 1.48-.52l.1-.08.1-.12.15-.17c.06-.06.1-.14.15-.21l.1-.19.07-.14.06-.15.03-.1.04-.15.03-.16.01-.16V7zM9.06 3.5H6.33l-1.86 2h3.98l.61-2zm4.3 0h-2.73l-.62 2h3.97l-.61-2zm4.31 0h-2.73l.61 2h3.98l-1.86-2z",
    fill: primaryFill
  }));
};

export const BuildingShop24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/BuildingShop24RegularIcon, 'BuildingShop24Regular');

const BuildingSkyscraper16FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6.75 1h-.5a.25.25 0 00-.25.25V2h1v-.75A.25.25 0 006.75 1zM8.5 3h-4a.5.5 0 00-.5.5V4h5v-.5a.5.5 0 00-.5-.5zm3 9a.5.5 0 100-1 .5.5 0 000 1zm.5-2.5a.5.5 0 11-1 0 .5.5 0 011 0zM3 6.45c0-.61.32-1.15.81-1.45H9.2c.49.3.81.84.81 1.45v.05h.3a3.7 3.7 0 013.7 3.7v3.3a.5.5 0 01-.5.5H7v-2.1a.4.4 0 00-.4-.4h-.2a.4.4 0 00-.4.4V14H3.5a.5.5 0 01-.5-.5V6.45zm10 3.75c0-1.5-1.2-2.7-2.7-2.7H10V13h3v-2.8zM6 7.5a.5.5 0 10-1 0 .5.5 0 001 0zm1.5.5a.5.5 0 100-1 .5.5 0 000 1zM6 9.5a.5.5 0 10-1 0 .5.5 0 001 0zm1.5.5a.5.5 0 100-1 .5.5 0 000 1z",
    fill: primaryFill
  }));
};

export const BuildingSkyscraper16Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/BuildingSkyscraper16FilledIcon, 'BuildingSkyscraper16Filled');

const BuildingSkyscraper16RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6 7.5a.5.5 0 11-1 0 .5.5 0 011 0zm1.5.5a.5.5 0 100-1 .5.5 0 000 1zM6 9.5a.5.5 0 11-1 0 .5.5 0 011 0zm1.5.5a.5.5 0 100-1 .5.5 0 000 1zm4.5 1.5a.5.5 0 11-1 0 .5.5 0 011 0zm-.5-1.5a.5.5 0 100-1 .5.5 0 000 1zm-6-9a.5.5 0 00-.5.5V3h-.5a.5.5 0 00-.5.5v1.65c-.59.27-1 .86-1 1.55v6.8c0 .28.22.5.5.5h10a.5.5 0 00.5-.5v-3.3a3.7 3.7 0 00-3.7-3.7h-.31A1.7 1.7 0 009 5.15V3.5a.5.5 0 00-.5-.5H8V1.5a.5.5 0 00-.5-.5h-2zM8 5H5V4h3v1zm1 1.7V13H8v-1.1c0-.5-.4-.9-.9-.9H5.9c-.5 0-.9.4-.9.9V13H4V6.7c0-.39.31-.7.7-.7h3.6c.39 0 .7.31.7.7zM6 13v-1h1v1H6zm4 0V7.5h.3c1.5 0 2.7 1.2 2.7 2.7V13h-3zM7 3H6V2h1v1z",
    fill: primaryFill
  }));
};

export const BuildingSkyscraper16Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/BuildingSkyscraper16RegularIcon, 'BuildingSkyscraper16Regular');

const BuildingSkyscraper20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M7 2.5c0-.28.22-.5.5-.5h1c.28 0 .5.22.5.5V3H7v-.5zM5.46 4a.5.5 0 00-.46.5V5h6v-.5a.5.5 0 00-.46-.5H5.46zm8.29 11a.75.75 0 100-1.5.75.75 0 000 1.5zm.75-3.25a.75.75 0 11-1.5 0 .75.75 0 011.5 0zM5 6h6v.02c.6.34 1 .99 1 1.73V8h.5a4.5 4.5 0 014.5 4.5v4a.5.5 0 01-.5.5H9v-2.5a.5.5 0 00-.5-.5h-1a.5.5 0 00-.5.5V17H4.5a.5.5 0 01-.5-.5V7.75a2 2 0 011-1.73V6zm7 10h4v-3.5A3.5 3.5 0 0012.5 9H12v7zM7.5 8.75a.75.75 0 10-1.5 0 .75.75 0 001.5 0zm1.75.75a.75.75 0 100-1.5.75.75 0 000 1.5zM7.5 11.25a.75.75 0 10-1.5 0 .75.75 0 001.5 0zm1.75.75a.75.75 0 100-1.5.75.75 0 000 1.5z",
    fill: primaryFill
  }));
};

export const BuildingSkyscraper20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/BuildingSkyscraper20FilledIcon, 'BuildingSkyscraper20Filled');

const BuildingSkyscraper20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M7.5 8.75a.75.75 0 11-1.5 0 .75.75 0 011.5 0zm1.75.75a.75.75 0 100-1.5.75.75 0 000 1.5zM7.5 11.25a.75.75 0 11-1.5 0 .75.75 0 011.5 0zm1.75.75a.75.75 0 100-1.5.75.75 0 000 1.5zm5.25 2.25a.75.75 0 11-1.5 0 .75.75 0 011.5 0zm-.75-1.75a.75.75 0 100-1.5.75.75 0 000 1.5zM7 2a.5.5 0 00-.5.5V4h-.94a.5.5 0 00-.5.5v1.74A2 2 0 004 8v8.5c0 .27.22.5.5.5h12a.5.5 0 00.5-.5v-4A4.5 4.5 0 0012.5 8H12a2 2 0 00-.94-1.7V4.5a.5.5 0 00-.5-.5H9.5V2.5A.5.5 0 009 2H7zm3 4H6.06V5h4v1H10zm1 10h-1v-2a1 1 0 00-1-1H7a1 1 0 00-1 1v2H5V8a1 1 0 011-1h4a1 1 0 011 1v8zm-4 0v-2h2v2H7zm9 0h-4V9h.5a3.5 3.5 0 013.5 3.5V16zM8.5 4h-1V3h1v1z",
    fill: primaryFill
  }));
};

export const BuildingSkyscraper20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/BuildingSkyscraper20RegularIcon, 'BuildingSkyscraper20Regular');

const BuildingSkyscraper24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M8.75 2a.75.75 0 00-.75.75V4h3V2.75a.75.75 0 00-.75-.75h-1.5zM11 5H6.75a.75.75 0 00-.75.75V7h7V5.75a.75.75 0 00-.75-.75H11zm6 11a1 1 0 100-2 1 1 0 000 2zm1 2a1 1 0 11-2 0 1 1 0 012 0zM4 10a2 2 0 011.96-2h7.08A2 2 0 0115 10a5.75 5.75 0 015.5 5.75v5c0 .41-.34.75-.75.75h-8.5v-3a.5.5 0 00-.5-.5h-2.5a.5.5 0 00-.5.5v3h-3a.75.75 0 01-.75-.75V10zm15 5.75a4.25 4.25 0 00-4-4.24V20h4v-4.25zM12.25 11a1 1 0 10-2 0 1 1 0 002 0zm-1 4.25a1 1 0 100-2 1 1 0 000 2zM8.75 11a1 1 0 10-2 0 1 1 0 002 0zm-1 4.25a1 1 0 100-2 1 1 0 000 2z",
    fill: primaryFill
  }));
};

export const BuildingSkyscraper24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/BuildingSkyscraper24FilledIcon, 'BuildingSkyscraper24Filled');

const BuildingSkyscraper24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M12 11a1 1 0 11-2 0 1 1 0 012 0zm-1 4a1 1 0 100-2 1 1 0 000 2zm-2-4a1 1 0 11-2 0 1 1 0 012 0zm-1 4a1 1 0 100-2 1 1 0 000 2zm10 0a1 1 0 11-2 0 1 1 0 012 0zm-1 4a1 1 0 100-2 1 1 0 000 2zM8.25 2a.75.75 0 00-.75.75V5H6.25a.75.75 0 00-.75.75V7.8A2.75 2.75 0 004 10.25v10.5c0 .41.34.75.75.75h15c.41 0 .75-.34.75-.75v-5c0-3.1-2.45-5.62-5.51-5.74a2.75 2.75 0 00-1.49-2.2V5.74a.75.75 0 00-.75-.75H11.5V2.75a.75.75 0 00-.75-.75h-2.5zM12 7.5H7v-1h5v1zM13.5 20H12v-2.75a.75.75 0 00-.75-.75h-3.5a.75.75 0 00-.75.75V20H5.5v-9.75C5.5 9.56 6.06 9 6.75 9h5.5c.69 0 1.25.56 1.25 1.25V20zm-5 0v-2h2v2h-2zm6.5 0v-8.5c2.23.14 4 1.99 4 4.25V20h-4zM10 5H9V3.5h1V5z",
    fill: primaryFill
  }));
};

export const BuildingSkyscraper24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/BuildingSkyscraper24RegularIcon, 'BuildingSkyscraper24Regular');

const Calculator20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M13.5 2h-7A2.5 2.5 0 004 4.5v11A2.5 2.5 0 006.5 18h7a2.5 2.5 0 002.5-2.5v-11A2.5 2.5 0 0013.5 2zm-6 2h5c.83 0 1.5.67 1.5 1.5v1c0 .83-.67 1.5-1.5 1.5h-5A1.5 1.5 0 016 6.5v-1C6 4.67 6.67 4 7.5 4zm.5 7a1 1 0 11-2 0 1 1 0 012 0zm0 3a1 1 0 11-2 0 1 1 0 012 0zm5-2a1 1 0 110-2 1 1 0 010 2zm1 2a1 1 0 11-2 0 1 1 0 012 0zm-4-2a1 1 0 110-2 1 1 0 010 2zm1 2a1 1 0 11-2 0 1 1 0 012 0z",
    fill: primaryFill
  }));
};

export const Calculator20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Calculator20FilledIcon, 'Calculator20Filled');

const Calculator20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M8 11a1 1 0 11-2 0 1 1 0 012 0zm0 3a1 1 0 11-2 0 1 1 0 012 0zm5-2a1 1 0 100-2 1 1 0 000 2zm1 2a1 1 0 11-2 0 1 1 0 012 0zm-4-2a1 1 0 100-2 1 1 0 000 2zm1 2a1 1 0 11-2 0 1 1 0 012 0zM7.5 4C6.67 4 6 4.67 6 5.5v1C6 7.33 6.67 8 7.5 8h5c.83 0 1.5-.67 1.5-1.5v-1c0-.83-.67-1.5-1.5-1.5h-5zM7 5.5c0-.28.22-.5.5-.5h5c.28 0 .5.22.5.5v1a.5.5 0 01-.5.5h-5a.5.5 0 01-.5-.5v-1zm9 10a2.5 2.5 0 01-2.5 2.5h-7A2.5 2.5 0 014 15.5v-11A2.5 2.5 0 016.5 2h7A2.5 2.5 0 0116 4.5v11zm-1-11c0-.83-.67-1.5-1.5-1.5h-7C5.67 3 5 3.67 5 4.5v11c0 .83.67 1.5 1.5 1.5h7c.83 0 1.5-.67 1.5-1.5v-11z",
    fill: primaryFill
  }));
};

export const Calculator20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Calculator20RegularIcon, 'Calculator20Regular');

const Calculator24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4 5.25C4 3.45 5.46 2 7.25 2h9.5C18.55 2 20 3.46 20 5.25v13.5c0 1.8-1.46 3.25-3.25 3.25h-9.5A3.25 3.25 0 014 18.75V5.25zM9 5a2 2 0 00-2 2v1c0 1.1.9 2 2 2h6a2 2 0 002-2V7a2 2 0 00-2-2H9zm.5 8.25a1.25 1.25 0 10-2.5 0 1.25 1.25 0 002.5 0zM8.25 18.5a1.25 1.25 0 100-2.5 1.25 1.25 0 000 2.5zM17 13.25a1.25 1.25 0 10-2.5 0 1.25 1.25 0 002.5 0zm-1.25 5.25a1.25 1.25 0 100-2.5 1.25 1.25 0 000 2.5zm-2.5-5.25a1.25 1.25 0 10-2.5 0 1.25 1.25 0 002.5 0zM12 18.5a1.25 1.25 0 100-2.5 1.25 1.25 0 000 2.5z",
    fill: primaryFill
  }));
};

export const Calculator24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Calculator24FilledIcon, 'Calculator24Filled');

const Calculator24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M7 7c0-1.1.9-2 2-2h6a2 2 0 012 2v1a2 2 0 01-2 2H9a2 2 0 01-2-2V7zm2-.5a.5.5 0 00-.5.5v1c0 .28.22.5.5.5h6a.5.5 0 00.5-.5V7a.5.5 0 00-.5-.5H9zm-.75 8a1.25 1.25 0 100-2.5 1.25 1.25 0 000 2.5zm1.25 2.75a1.25 1.25 0 11-2.5 0 1.25 1.25 0 012.5 0zm6.25-2.75a1.25 1.25 0 100-2.5 1.25 1.25 0 000 2.5zM17 17.25a1.25 1.25 0 11-2.5 0 1.25 1.25 0 012.5 0zm-5-2.75a1.25 1.25 0 100-2.5 1.25 1.25 0 000 2.5zm1.25 2.75a1.25 1.25 0 11-2.5 0 1.25 1.25 0 012.5 0zM7.25 2A3.25 3.25 0 004 5.25v13.5C4 20.55 5.46 22 7.25 22h9.5c1.8 0 3.25-1.46 3.25-3.25V5.25C20 3.45 18.54 2 16.75 2h-9.5zM5.5 5.25c0-.97.78-1.75 1.75-1.75h9.5c.97 0 1.75.78 1.75 1.75v13.5c0 .97-.78 1.75-1.75 1.75h-9.5c-.97 0-1.75-.78-1.75-1.75V5.25z",
    fill: primaryFill
  }));
};

export const Calculator24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Calculator24RegularIcon, 'Calculator24Regular');

const CalculatorArrowClockwise20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M13.5 2h-7A2.5 2.5 0 004 4.5v11A2.5 2.5 0 006.5 18h3.77a5.48 5.48 0 01-.64-6.07 1 1 0 111.17-1.52A5.48 5.48 0 0116 9.19V4.5A2.5 2.5 0 0013.5 2zm-6 2h5c.83 0 1.5.67 1.5 1.5v1c0 .83-.67 1.5-1.5 1.5h-5A1.5 1.5 0 016 6.5v-1C6 4.67 6.67 4 7.5 4zm.5 7a1 1 0 11-2 0 1 1 0 012 0zm0 3a1 1 0 11-2 0 1 1 0 012 0zm9.5-1.52a.5.5 0 00.5-.5v-2a.5.5 0 00-1 0v.76a4.5 4.5 0 102 3.74.5.5 0 10-1 0 3.5 3.5 0 11-1.7-3h-.8a.5.5 0 100 1h2z",
    fill: primaryFill
  }));
};

export const CalculatorArrowClockwise20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalculatorArrowClockwise20FilledIcon, 'CalculatorArrowClockwise20Filled');

const CalculatorArrowClockwise20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M7 12a1 1 0 100-2 1 1 0 000 2zm0 3a1 1 0 100-2 1 1 0 000 2zm2.63-3.07c.3-.58.7-1.1 1.17-1.52a1 1 0 10-1.17 1.52zM6.5 17h3.11c.18.36.4.7.66 1H6.5A2.5 2.5 0 014 15.5v-11A2.5 2.5 0 016.5 2h7A2.5 2.5 0 0116 4.5v4.69c-.32-.1-.66-.16-1-.19V4.5c0-.83-.67-1.5-1.5-1.5h-7C5.67 3 5 3.67 5 4.5v11c0 .83.67 1.5 1.5 1.5zM6 5.5C6 4.67 6.67 4 7.5 4h5c.83 0 1.5.67 1.5 1.5v1c0 .83-.67 1.5-1.5 1.5h-5A1.5 1.5 0 016 6.5v-1zM7.5 5a.5.5 0 00-.5.5v1c0 .28.22.5.5.5h5a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5h-5zm10 7.48a.5.5 0 00.5-.5v-2a.5.5 0 00-1 0v.76a4.5 4.5 0 102 3.74.5.5 0 10-1 0 3.5 3.5 0 11-1.7-3h-.8a.5.5 0 100 1h2z",
    fill: primaryFill
  }));
};

export const CalculatorArrowClockwise20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalculatorArrowClockwise20RegularIcon, 'CalculatorArrowClockwise20Regular');

const CalculatorArrowClockwise24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4 5.25C4 3.45 5.46 2 7.25 2h9.5C18.55 2 20 3.46 20 5.25v5.03a1.76 1.76 0 00-.23.29A7 7 0 0012.1 22H7.25A3.25 3.25 0 014 18.75V5.25zM9 5a2 2 0 00-2 2v1c0 1.1.9 2 2 2h6a2 2 0 002-2V7a2 2 0 00-2-2H9zm.5 8.25a1.25 1.25 0 10-2.5 0 1.25 1.25 0 002.5 0zM8.25 18.5a1.25 1.25 0 100-2.5 1.25 1.25 0 000 2.5zm13-3.5c.41 0 .75-.34.75-.75V11.5a.75.75 0 00-1.5 0v.63A6 6 0 1023 17a.75.75 0 00-1.5 0 4.5 4.5 0 11-1.69-3.51h.01v.01H18.5a.75.75 0 000 1.5h2.75z",
    fill: primaryFill
  }));
};

export const CalculatorArrowClockwise24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalculatorArrowClockwise24FilledIcon, 'CalculatorArrowClockwise24Filled');

const CalculatorArrowClockwise24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M7 7c0-1.1.9-2 2-2h6a2 2 0 012 2v1a2 2 0 01-2 2H9a2 2 0 01-2-2V7zm2-.5a.5.5 0 00-.5.5v1c0 .28.22.5.5.5h6a.5.5 0 00.5-.5V7a.5.5 0 00-.5-.5H9zm-.75 8a1.25 1.25 0 100-2.5 1.25 1.25 0 000 2.5zm1.25 2.75a1.25 1.25 0 11-2.5 0 1.25 1.25 0 012.5 0zM7.25 22h4.85a7.03 7.03 0 01-1.16-1.5H7.25c-.97 0-1.75-.78-1.75-1.75V5.25c0-.97.78-1.75 1.75-1.75h9.5c.97 0 1.75.78 1.75 1.75v4.91c.44.1.86.23 1.27.4a1.76 1.76 0 01.23-.28V5.25C20 3.45 18.54 2 16.75 2h-9.5A3.25 3.25 0 004 5.25v13.5C4 20.55 5.46 22 7.25 22zm14-7c.41 0 .75-.34.75-.75V11.5a.75.75 0 00-1.5 0v.63A6 6 0 1023 17a.75.75 0 00-1.5 0 4.5 4.5 0 11-1.69-3.51h.01v.01H18.5a.75.75 0 000 1.5h2.75z",
    fill: primaryFill
  }));
};

export const CalculatorArrowClockwise24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalculatorArrowClockwise24RegularIcon, 'CalculatorArrowClockwise24Regular');

const CalculatorMultiple20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5.5 2A2.5 2.5 0 003 4.5v9A2.5 2.5 0 005.5 16h7a2.5 2.5 0 002.5-2.5v-9A2.5 2.5 0 0012.5 2h-7zM5 5a1 1 0 011-1h6a1 1 0 011 1v2a1 1 0 01-1 1H6a1 1 0 01-1-1V5zm0 5a1 1 0 112 0 1 1 0 01-2 0zm4-1a1 1 0 110 2 1 1 0 010-2zm0 2.75a1 1 0 110 2 1 1 0 010-2zM11 10a1 1 0 112 0 1 1 0 01-2 0zm1 1.75a1 1 0 110 2 1 1 0 010-2zm-6 0a1 1 0 110 2 1 1 0 010-2zM7.5 18a2.5 2.5 0 01-2-1h7a3.5 3.5 0 003.5-3.5v-9c.6.46 1 1.18 1 2v7a4.5 4.5 0 01-4.5 4.5h-5z",
    fill: primaryFill
  }));
};

export const CalculatorMultiple20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalculatorMultiple20FilledIcon, 'CalculatorMultiple20Filled');

const CalculatorMultiple20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6 4a1 1 0 00-1 1v2a1 1 0 001 1h6a1 1 0 001-1V5a1 1 0 00-1-1H6zm0 1h6v2H6V5zm2 5a1 1 0 112 0 1 1 0 01-2 0zm1 1.75a1 1 0 100 2 1 1 0 000-2zM11 10a1 1 0 112 0 1 1 0 01-2 0zm1 1.75a1 1 0 100 2 1 1 0 000-2zM5 10a1 1 0 112 0 1 1 0 01-2 0zm1 1.75a1 1 0 100 2 1 1 0 000-2zM5.5 2A2.5 2.5 0 003 4.5v9A2.5 2.5 0 005.5 16h7a2.5 2.5 0 002.5-2.5v-9A2.5 2.5 0 0012.5 2h-7zM4 4.5C4 3.67 4.67 3 5.5 3h7c.83 0 1.5.67 1.5 1.5v9c0 .83-.67 1.5-1.5 1.5h-7A1.5 1.5 0 014 13.5v-9zM7.5 18a2.5 2.5 0 01-2-1h7a3.5 3.5 0 003.5-3.5v-9c.6.46 1 1.18 1 2v7a4.5 4.5 0 01-4.5 4.5h-5z",
    fill: primaryFill
  }));
};

export const CalculatorMultiple20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalculatorMultiple20RegularIcon, 'CalculatorMultiple20Regular');

const CalculatorMultiple24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6.14 2A3.14 3.14 0 003 5.14v11.22c0 1.74 1.4 3.14 3.14 3.14h8.72c1.74 0 3.14-1.4 3.14-3.14V5.14C18 3.4 16.6 2 14.86 2H6.14zm1.61 3h5.5c.97 0 1.75.78 1.75 1.75v1c0 .97-.78 1.75-1.75 1.75h-5.5C6.78 9.5 6 8.72 6 7.75v-1C6 5.78 6.78 5 7.75 5zm-2 7a1.25 1.25 0 112.5 0 1.25 1.25 0 01-2.5 0zm4.75-1.25a1.25 1.25 0 110 2.5 1.25 1.25 0 010-2.5zm0 3.5a1.25 1.25 0 110 2.5 1.25 1.25 0 010-2.5zm-3.5 0a1.25 1.25 0 110 2.5 1.25 1.25 0 010-2.5zM12.75 12a1.25 1.25 0 112.5 0 1.25 1.25 0 01-2.5 0zM14 14.25a1.25 1.25 0 110 2.5 1.25 1.25 0 010-2.5zm-8.2 6.24c.45.9 1.38 1.51 2.46 1.51h6.99c2.9 0 5.25-2.35 5.25-5.25v-9.5c0-1.07-.62-2-1.51-2.46l.01.35V16.75a3.75 3.75 0 01-3.75 3.75H6.14l-.34-.01z",
    fill: primaryFill
  }));
};

export const CalculatorMultiple24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalculatorMultiple24FilledIcon, 'CalculatorMultiple24Filled');

const CalculatorMultiple24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M7.75 5C6.78 5 6 5.78 6 6.75v1c0 .97.78 1.75 1.75 1.75h5.5c.97 0 1.75-.78 1.75-1.75v-1C15 5.78 14.22 5 13.25 5h-5.5zM7.5 6.75c0-.14.11-.25.25-.25h5.5c.14 0 .25.11.25.25v1c0 .14-.11.25-.25.25h-5.5a.25.25 0 01-.25-.25v-1zm3 4a1.25 1.25 0 100 2.5 1.25 1.25 0 000-2.5zM9.25 15.5a1.25 1.25 0 112.5 0 1.25 1.25 0 01-2.5 0zM7 10.75a1.25 1.25 0 100 2.5 1.25 1.25 0 000-2.5zM5.75 15.5a1.25 1.25 0 112.5 0 1.25 1.25 0 01-2.5 0zM14 10.75a1.25 1.25 0 100 2.5 1.25 1.25 0 000-2.5zm-1.25 4.75a1.25 1.25 0 112.5 0 1.25 1.25 0 01-2.5 0zM6.14 2A3.14 3.14 0 003 5.14v11.22c0 1.74 1.4 3.14 3.14 3.14h8.72c1.74 0 3.14-1.4 3.14-3.14V5.14C18 3.4 16.6 2 14.86 2H6.14zM4.5 5.14c0-.9.73-1.64 1.64-1.64h8.72c.9 0 1.64.73 1.64 1.64v11.22c0 .9-.73 1.64-1.64 1.64H6.14c-.9 0-1.64-.73-1.64-1.64V5.14zm1.3 15.35c.45.9 1.38 1.51 2.46 1.51h6.99c2.9 0 5.25-2.35 5.25-5.25v-9.5c0-1.07-.62-2-1.51-2.46l.01.35V16.75a3.75 3.75 0 01-3.75 3.75H6.14l-.34-.01z",
    fill: primaryFill
  }));
};

export const CalculatorMultiple24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalculatorMultiple24RegularIcon, 'CalculatorMultiple24Regular');

const Calendar3Day16FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M14 11.5a2.5 2.5 0 01-2.5 2.5h-7A2.5 2.5 0 012 11.5v-7A2.5 2.5 0 014.5 2h7A2.5 2.5 0 0114 4.5v7zm-8-6a.5.5 0 00-1 0v5a.5.5 0 001 0v-5zm2.5 0a.5.5 0 00-1 0v5a.5.5 0 001 0v-5zm2.5 0a.5.5 0 00-1 0v5a.5.5 0 001 0v-5z",
    fill: primaryFill
  }));
};

export const Calendar3Day16Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Calendar3Day16FilledIcon, 'Calendar3Day16Filled');

const Calendar3Day16RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6 5.5a.5.5 0 00-1 0v5a.5.5 0 001 0v-5zm2.5 0a.5.5 0 00-1 0v5a.5.5 0 001 0v-5zm2.5 0a.5.5 0 00-1 0v5a.5.5 0 001 0v-5zm3-1A2.5 2.5 0 0011.5 2h-7A2.5 2.5 0 002 4.5v7A2.5 2.5 0 004.5 14h7a2.5 2.5 0 002.5-2.5v-7zm-11 7v-7C3 3.67 3.67 3 4.5 3h7c.83 0 1.5.67 1.5 1.5v7c0 .83-.67 1.5-1.5 1.5h-7A1.5 1.5 0 013 11.5z",
    fill: primaryFill
  }));
};

export const Calendar3Day16Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Calendar3Day16RegularIcon, 'Calendar3Day16Regular');

const Calendar3Day20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M14.5 3A2.5 2.5 0 0117 5.5v9a2.5 2.5 0 01-2.5 2.5h-9A2.5 2.5 0 013 14.5v-9A2.5 2.5 0 015.5 3h9zm-8 3a.5.5 0 00-.5.41v7.18a.5.5 0 001 0V6.41A.5.5 0 006.5 6zM10 6a.5.5 0 00-.5.41v7.18a.5.5 0 001 0V6.41A.5.5 0 0010 6zm3.5 0a.5.5 0 00-.5.41v7.18a.5.5 0 001 0V6.41a.5.5 0 00-.5-.41z",
    fill: primaryFill
  }));
};

export const Calendar3Day20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Calendar3Day20FilledIcon, 'Calendar3Day20Filled');

const Calendar3Day20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M14.5 3A2.5 2.5 0 0117 5.5v9a2.5 2.5 0 01-2.5 2.5h-9A2.5 2.5 0 013 14.5v-9A2.5 2.5 0 015.5 3h9zm0 1h-9C4.67 4 4 4.67 4 5.5v9c0 .83.67 1.5 1.5 1.5h9c.83 0 1.5-.67 1.5-1.5v-9c0-.83-.67-1.5-1.5-1.5zm-8 2a.5.5 0 01.5.41v7.09a.5.5 0 01-1 .09V6.5c0-.28.22-.5.5-.5zM10 6a.5.5 0 01.5.41v7.09a.5.5 0 01-1 .09V6.5c0-.28.22-.5.5-.5zm3.5 0a.5.5 0 01.5.41v7.09a.5.5 0 01-1 .09V6.5c0-.28.22-.5.5-.5z",
    fill: primaryFill
  }));
};

export const Calendar3Day20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Calendar3Day20RegularIcon, 'Calendar3Day20Regular');

const Calendar3Day24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M17.75 3C19.55 3 21 4.46 21 6.25v11.5c0 1.8-1.46 3.25-3.25 3.25H6.25A3.25 3.25 0 013 17.75V6.25C3 4.45 4.46 3 6.25 3h11.5zm-10 4c-.38 0-.7.28-.74.65l-.01.1v8.6a.75.75 0 001.5 0v-8.7A.75.75 0 007.74 7zm8.5 0c-.38 0-.7.28-.74.65l-.01.1v8.6a.75.75 0 001.5 0v-8.7a.75.75 0 00-.75-.65zM12 7c-.38 0-.7.28-.74.65l-.01.1v8.6a.75.75 0 001.5 0v-8.7A.75.75 0 0012 7z",
    fill: primaryFill
  }));
};

export const Calendar3Day24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Calendar3Day24FilledIcon, 'Calendar3Day24Filled');

const Calendar3Day24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M17.75 3C19.55 3 21 4.46 21 6.25v11.5c0 1.8-1.46 3.25-3.25 3.25H6.25A3.25 3.25 0 013 17.75V6.25C3 4.45 4.46 3 6.25 3h11.5zm0 1.5H6.25c-.97 0-1.75.78-1.75 1.75v11.5c0 .97.78 1.75 1.75 1.75h11.5c.97 0 1.75-.78 1.75-1.75V6.25c0-.97-.78-1.75-1.75-1.75zM7.75 7c.38 0 .7.28.74.65l.01.1v8.5a.75.75 0 01-1.5.1v-8.6c0-.41.34-.75.75-.75zm8.5 0c.38 0 .7.28.74.65l.01.1v8.5a.75.75 0 01-1.5.1v-8.6c0-.41.34-.75.75-.75zM12 7c.38 0 .7.28.74.65l.01.1v8.5a.75.75 0 01-1.5.1v-8.6c0-.41.34-.75.75-.75z",
    fill: primaryFill
  }));
};

export const Calendar3Day24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Calendar3Day24RegularIcon, 'Calendar3Day24Regular');

const Calendar3Day28FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M21.75 3C23.55 3 25 4.46 25 6.25v15.5c0 1.8-1.46 3.25-3.25 3.25H6.25A3.25 3.25 0 013 21.75V6.25C3 4.45 4.46 3 6.25 3h15.5zM14 8.25c-.38 0-.7.28-.74.65l-.01.1v10.1a.75.75 0 001.5 0V8.9a.75.75 0 00-.75-.65zm5.25 0c-.38 0-.7.28-.74.65l-.01.1v10.1a.75.75 0 001.5 0V8.9a.75.75 0 00-.75-.65zm-10.5 0c-.38 0-.7.28-.74.65L8 9v10.1a.75.75 0 001.5 0V8.9a.75.75 0 00-.75-.65z",
    fill: primaryFill
  }));
};

export const Calendar3Day28Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Calendar3Day28FilledIcon, 'Calendar3Day28Filled');

const Calendar3Day28RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M21.75 3C23.55 3 25 4.46 25 6.25v15.5c0 1.8-1.46 3.25-3.25 3.25H6.25A3.25 3.25 0 013 21.75V6.25C3 4.45 4.46 3 6.25 3h15.5zm0 1.5H6.25c-.97 0-1.75.78-1.75 1.75v15.5c0 .97.78 1.75 1.75 1.75h15.5c.97 0 1.75-.78 1.75-1.75V6.25c0-.97-.78-1.75-1.75-1.75zM14 8.25c.38 0 .7.28.74.65l.01.1v10a.75.75 0 01-1.5.1V9c0-.41.34-.75.75-.75zm5.25 0c.38 0 .7.28.74.65L20 9v10a.75.75 0 01-1.5.1V9c0-.41.34-.75.75-.75zm-10.5 0c.38 0 .7.28.74.65l.01.1v10a.75.75 0 01-1.5.1V9c0-.41.34-.75.75-.75z",
    fill: primaryFill
  }));
};

export const Calendar3Day28Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Calendar3Day28RegularIcon, 'Calendar3Day28Regular');

const CalendarAdd16FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6.26 14H4.5A2.5 2.5 0 012 11.5V6h5.34a5.5 5.5 0 00-1.08 8zM2 5h12v-.5A2.5 2.5 0 0011.5 2h-7A2.5 2.5 0 002 4.5V5zm13 5.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-4-2a.5.5 0 00-1 0V10H8.5a.5.5 0 000 1H10v1.5a.5.5 0 001 0V11h1.5a.5.5 0 000-1H11V8.5z",
    fill: primaryFill
  }));
};

export const CalendarAdd16Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarAdd16FilledIcon, 'CalendarAdd16Filled');

const CalendarAdd16RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M11.5 2A2.5 2.5 0 0114 4.5v1.76a5.5 5.5 0 00-1-.66V4.5c0-.83-.67-1.5-1.5-1.5h-7C3.67 3 3 3.67 3 4.5V5h7v.02c-.99.1-1.9.44-2.66.98H3v5.5c0 .83.67 1.5 1.5 1.5h1.1c.18.36.4.7.66 1H4.5A2.5 2.5 0 012 11.5v-7A2.5 2.5 0 014.5 2h7zm-1 13a4.5 4.5 0 100-9 4.5 4.5 0 000 9zm0-7c.28 0 .5.22.5.5V10h1.5a.5.5 0 010 1H11v1.5a.5.5 0 01-1 0V11H8.5a.5.5 0 010-1H10V8.5c0-.28.22-.5.5-.5z",
    fill: primaryFill
  }));
};

export const CalendarAdd16Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarAdd16RegularIcon, 'CalendarAdd16Regular');

const CalendarAdd20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M17 7v2.6A5.5 5.5 0 009.6 17H5.5A2.5 2.5 0 013 14.5V7h14zm-2.5-4A2.5 2.5 0 0117 5.5V6H3v-.5A2.5 2.5 0 015.5 3h9zM19 14.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-4-2a.5.5 0 00-1 0V14h-1.5a.5.5 0 000 1H14v1.5a.5.5 0 001 0V15h1.5a.5.5 0 000-1H15v-1.5z",
    fill: primaryFill
  }));
};

export const CalendarAdd20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarAdd20FilledIcon, 'CalendarAdd20Filled');

const CalendarAdd20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M14.5 3A2.5 2.5 0 0117 5.5v4.1c-.32-.16-.65-.3-1-.4V7H4v7.5c0 .83.67 1.5 1.5 1.5h3.7c.1.35.24.68.4 1H5.5A2.5 2.5 0 013 14.5v-9A2.5 2.5 0 015.5 3h9zm0 1h-9C4.67 4 4 4.67 4 5.5V6h12v-.5c0-.83-.67-1.5-1.5-1.5zM19 14.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-4-2a.5.5 0 00-1 0V14h-1.5a.5.5 0 000 1H14v1.5a.5.5 0 001 0V15h1.5a.5.5 0 000-1H15v-1.5z",
    fill: primaryFill
  }));
};

export const CalendarAdd20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarAdd20RegularIcon, 'CalendarAdd20Regular');

const CalendarAdd24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M17.5 12a5.5 5.5 0 110 11 5.5 5.5 0 010-11zM21 8.5v3.52A6.5 6.5 0 0012.02 21H6.25A3.25 3.25 0 013 17.75V8.5h18zM17.5 14h-.09a.5.5 0 00-.4.41l-.01.09V17h-2.59a.5.5 0 00-.4.41l-.01.09v.09c.05.2.2.36.41.4l.09.01H17v2.59c.05.2.2.36.41.4l.09.01h.09a.5.5 0 00.4-.41l.01-.09V18h2.59a.5.5 0 00.4-.41l.01-.09v-.09a.5.5 0 00-.41-.4L20.5 17H18v-2.59a.5.5 0 00-.41-.4L17.5 14zm.25-11C19.55 3 21 4.46 21 6.25V7H3v-.75C3 4.45 4.46 3 6.25 3h11.5z",
    fill: primaryFill
  }));
};

export const CalendarAdd24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarAdd24FilledIcon, 'CalendarAdd24Filled');

const CalendarAdd24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M17.5 12a5.5 5.5 0 110 11 5.5 5.5 0 010-11zm.25-9C19.55 3 21 4.46 21 6.25v5.77c-.46-.3-.97-.53-1.5-.7V8.5h-15v9.25c0 .97.78 1.75 1.75 1.75h5.06c.18.53.42 1.04.71 1.5H6.25A3.25 3.25 0 013 17.75V6.25C3 4.45 4.46 3 6.25 3h11.5zm-.25 11h-.09a.5.5 0 00-.4.41l-.01.09V17h-2.59a.5.5 0 00-.4.41l-.01.09v.09c.05.2.2.36.41.4l.09.01H17v2.59c.05.2.2.36.41.4l.09.01h.09a.5.5 0 00.4-.41l.01-.09V18h2.59a.5.5 0 00.4-.41l.01-.09v-.09a.5.5 0 00-.41-.4L20.5 17H18v-2.59a.5.5 0 00-.41-.4L17.5 14zm.25-9.5H6.25c-.97 0-1.75.78-1.75 1.75V7h15v-.75c0-.97-.78-1.75-1.75-1.75z",
    fill: primaryFill
  }));
};

export const CalendarAdd24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarAdd24RegularIcon, 'CalendarAdd24Regular');

const CalendarAdd28FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M25 14.5v-5H3v12.25C3 23.55 4.46 25 6.25 25h8.25A7.5 7.5 0 0125 14.5zm0-8.25C25 4.45 23.54 3 21.75 3H6.25A3.25 3.25 0 003 6.25V8h22V6.25zm2 14.25a6.5 6.5 0 11-13 0 6.5 6.5 0 0113 0zm-6-4a.5.5 0 00-1 0V20h-3.5a.5.5 0 000 1H20v3.5a.5.5 0 001 0V21h3.5a.5.5 0 000-1H21v-3.5z",
    fill: primaryFill
  }));
};

export const CalendarAdd28Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarAdd28FilledIcon, 'CalendarAdd28Filled');

const CalendarAdd28RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M25 6.25C25 4.45 23.54 3 21.75 3H6.25A3.25 3.25 0 003 6.25v15.5C3 23.55 4.46 25 6.25 25h8.25a7.49 7.49 0 01-.88-1.5H6.25c-.97 0-1.75-.78-1.75-1.75V9.5h19v4.12c.54.24 1.04.53 1.5.88V6.25zM6.25 4.5h15.5c.97 0 1.75.78 1.75 1.75V8h-19V6.25c0-.97.78-1.75 1.75-1.75zM27 20.5a6.5 6.5 0 11-13 0 6.5 6.5 0 0113 0zm-6-4a.5.5 0 00-1 0V20h-3.5a.5.5 0 000 1H20v3.5a.5.5 0 001 0V21h3.5a.5.5 0 000-1H21v-3.5z",
    fill: primaryFill
  }));
};

export const CalendarAdd28Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarAdd28RegularIcon, 'CalendarAdd28Regular');

const CalendarAgenda20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M17 14.5a2.5 2.5 0 01-2.5 2.5h-9A2.5 2.5 0 013 14.5v-9A2.5 2.5 0 015.5 3h9A2.5 2.5 0 0117 5.5v9zm-3-8a.5.5 0 00-.41-.5H6.41a.5.5 0 000 1h7.18a.5.5 0 00.41-.5zm0 3.5a.5.5 0 00-.41-.5H6.41a.5.5 0 000 1h7.18A.5.5 0 0014 10zm0 3.5a.5.5 0 00-.41-.5H6.41a.5.5 0 000 1h7.18a.5.5 0 00.41-.5z",
    fill: primaryFill
  }));
};

export const CalendarAgenda20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarAgenda20FilledIcon, 'CalendarAgenda20Filled');

const CalendarAgenda20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M17 14.5a2.5 2.5 0 01-2.5 2.5h-9A2.5 2.5 0 013 14.5v-9A2.5 2.5 0 015.5 3h9A2.5 2.5 0 0117 5.5v9zm-1 0v-9c0-.83-.67-1.5-1.5-1.5h-9C4.67 4 4 4.67 4 5.5v9c0 .83.67 1.5 1.5 1.5h9c.83 0 1.5-.67 1.5-1.5zm-2-8a.5.5 0 01-.41.5H6.5a.5.5 0 01-.09-1h7.09c.28 0 .5.22.5.5zm0 3.5a.5.5 0 01-.41.5H6.5a.5.5 0 01-.09-1h7.09c.28 0 .5.22.5.5zm0 3.5a.5.5 0 01-.41.5H6.5a.5.5 0 01-.09-1h7.09c.28 0 .5.22.5.5z",
    fill: primaryFill
  }));
};

export const CalendarAgenda20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarAgenda20RegularIcon, 'CalendarAgenda20Regular');

const CalendarAgenda24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M21 17.75c0 1.8-1.46 3.25-3.25 3.25H6.25A3.25 3.25 0 013 17.75V6.25C3 4.45 4.46 3 6.25 3h11.5C19.55 3 21 4.46 21 6.25v11.5zm-4-10c0-.38-.28-.7-.65-.74l-.1-.01h-8.6a.75.75 0 000 1.5h8.7a.75.75 0 00.65-.75zm0 8.5c0-.38-.28-.7-.65-.74l-.1-.01h-8.6a.75.75 0 000 1.5h8.7a.75.75 0 00.65-.75zM17 12c0-.38-.28-.7-.65-.74l-.1-.01h-8.6a.75.75 0 000 1.5h8.7A.75.75 0 0017 12z",
    fill: primaryFill
  }));
};

export const CalendarAgenda24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarAgenda24FilledIcon, 'CalendarAgenda24Filled');

const CalendarAgenda24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M21 17.75c0 1.8-1.46 3.25-3.25 3.25H6.25A3.25 3.25 0 013 17.75V6.25C3 4.45 4.46 3 6.25 3h11.5C19.55 3 21 4.46 21 6.25v11.5zm-1.5 0V6.25c0-.97-.78-1.75-1.75-1.75H6.25c-.97 0-1.75.78-1.75 1.75v11.5c0 .97.78 1.75 1.75 1.75h11.5c.97 0 1.75-.78 1.75-1.75zm-2.5-10c0 .38-.28.7-.65.74l-.1.01h-8.5a.75.75 0 01-.1-1.5h8.6c.41 0 .75.34.75.75zm0 8.5c0 .38-.28.7-.65.74l-.1.01h-8.5a.75.75 0 01-.1-1.5h8.6c.41 0 .75.34.75.75zM17 12c0 .38-.28.7-.65.74l-.1.01h-8.5a.75.75 0 01-.1-1.5h8.6c.41 0 .75.34.75.75z",
    fill: primaryFill
  }));
};

export const CalendarAgenda24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarAgenda24RegularIcon, 'CalendarAgenda24Regular');

const CalendarAgenda28FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M25 21.75c0 1.8-1.46 3.25-3.25 3.25H6.25A3.25 3.25 0 013 21.75V6.25C3 4.45 4.46 3 6.25 3h15.5C23.55 3 25 4.46 25 6.25v15.5zM19.75 14c0-.38-.28-.7-.65-.74l-.1-.01H8.9a.75.75 0 000 1.5h10.2a.75.75 0 00.65-.75zm0 5.25c0-.38-.28-.7-.65-.74l-.1-.01H8.9a.75.75 0 000 1.5h10.2a.75.75 0 00.65-.75zm0-10.5c0-.38-.28-.7-.65-.74L19 8H8.9a.75.75 0 000 1.5h10.2a.75.75 0 00.65-.75z",
    fill: primaryFill
  }));
};

export const CalendarAgenda28Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarAgenda28FilledIcon, 'CalendarAgenda28Filled');

const CalendarAgenda28RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M25 21.75c0 1.8-1.46 3.25-3.25 3.25H6.25A3.25 3.25 0 013 21.75V6.25C3 4.45 4.46 3 6.25 3h15.5C23.55 3 25 4.46 25 6.25v15.5zm-1.5 0V6.25c0-.97-.78-1.75-1.75-1.75H6.25c-.97 0-1.75.78-1.75 1.75v15.5c0 .97.78 1.75 1.75 1.75h15.5c.97 0 1.75-.78 1.75-1.75zM19.75 14c0 .38-.28.7-.65.74l-.1.01H9a.75.75 0 01-.1-1.5H19c.41 0 .75.34.75.75zm0 5.25c0 .38-.28.7-.65.74L19 20H9a.75.75 0 01-.1-1.5H19c.41 0 .75.34.75.75zm0-10.5c0 .38-.28.7-.65.74l-.1.01H9A.75.75 0 018.9 8H19c.41 0 .75.34.75.75z",
    fill: primaryFill
  }));
};

export const CalendarAgenda28Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarAgenda28RegularIcon, 'CalendarAgenda28Regular');

const CalendarArrowDown20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5.5 3A2.5 2.5 0 003 5.5V6h14v-.5A2.5 2.5 0 0014.5 3h-9zM17 7H3v7.5A2.5 2.5 0 005.5 17h4.1A5.5 5.5 0 0117 9.6V7zm2 7.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-4.85 2.35a.5.5 0 00.35.15.5.5 0 00.35-.15l2-2a.5.5 0 00-.7-.7L15 15.29V12.5a.5.5 0 00-1 0v2.8l-1.15-1.15a.5.5 0 00-.7.7l2 2z",
    fill: primaryFill
  }));
};

export const CalendarArrowDown20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarArrowDown20FilledIcon, 'CalendarArrowDown20Filled');

const CalendarArrowDown20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5.5 3A2.5 2.5 0 003 5.5v9A2.5 2.5 0 005.5 17h4.1c-.16-.32-.3-.65-.4-1H5.5A1.5 1.5 0 014 14.5V7h12v2.2c.35.1.68.24 1 .4V5.5A2.5 2.5 0 0014.5 3h-9zM4 5.5C4 4.67 4.67 4 5.5 4h9c.83 0 1.5.67 1.5 1.5V6H4v-.5zm15 9a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-4.85 2.35a.5.5 0 00.35.15.5.5 0 00.35-.15l2-2a.5.5 0 00-.7-.7L15 15.29V12.5a.5.5 0 00-1 0v2.8l-1.15-1.15a.5.5 0 00-.7.7l2 2z",
    fill: primaryFill
  }));
};

export const CalendarArrowDown20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarArrowDown20RegularIcon, 'CalendarArrowDown20Regular');

const CalendarArrowDown24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M21 8.5v3.52A6.5 6.5 0 0012.02 21H6.25A3.25 3.25 0 013 17.75V8.5h18zM17.75 3C19.55 3 21 4.46 21 6.25V7H3v-.75C3 4.45 4.46 3 6.25 3h11.5zM23 17.5a5.5 5.5 0 11-11 0 5.5 5.5 0 0111 0zm-5-3a.5.5 0 00-1 0v4.8l-1.65-1.65a.5.5 0 00-.7.7l2.5 2.5c.2.2.5.2.7 0l2.5-2.5a.5.5 0 00-.7-.7L18 19.29V14.5z",
    fill: primaryFill
  }));
};

export const CalendarArrowDown24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarArrowDown24FilledIcon, 'CalendarArrowDown24Filled');

const CalendarArrowDown24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M17.75 3C19.55 3 21 4.46 21 6.25v5.77c-.46-.3-.97-.53-1.5-.7V8.5h-15v9.25c0 .97.78 1.75 1.75 1.75h5.06c.18.53.42 1.04.71 1.5H6.25A3.25 3.25 0 013 17.75V6.25C3 4.45 4.46 3 6.25 3h11.5zm0 1.5H6.25c-.97 0-1.75.78-1.75 1.75V7h15v-.75c0-.97-.78-1.75-1.75-1.75zm5.25 13a5.5 5.5 0 11-11 0 5.5 5.5 0 0111 0zm-5-3a.5.5 0 00-1 0v4.8l-1.65-1.65a.5.5 0 00-.7.7l2.5 2.5c.2.2.5.2.7 0l2.5-2.5a.5.5 0 00-.7-.7L18 19.29V14.5z",
    fill: primaryFill
  }));
};

export const CalendarArrowDown24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarArrowDown24RegularIcon, 'CalendarArrowDown24Regular');

const CalendarArrowRight16FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4.5 14h1.76a5.48 5.48 0 011.08-8H2v5.5A2.5 2.5 0 004.5 14zM14 5H2v-.5A2.5 2.5 0 014.5 2h7A2.5 2.5 0 0114 4.5V5zm-3.5 10a4.5 4.5 0 100-9 4.5 4.5 0 000 9zm.35-2.15a.5.5 0 01-.7-.7L11.29 11H8.5a.5.5 0 010-1h2.8l-1.15-1.15a.5.5 0 01.7-.7l2 2a.5.5 0 01.15.35.5.5 0 01-.14.35l-2 2z",
    fill: primaryFill
  }));
};

export const CalendarArrowRight16Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarArrowRight16FilledIcon, 'CalendarArrowRight16Filled');

const CalendarArrowRight16RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M11.5 2A2.5 2.5 0 0114 4.5v1.76A5.48 5.48 0 0010.5 5H13v-.5c0-.83-.67-1.5-1.5-1.5h-7C3.67 3 3 3.67 3 4.5V5h7.5c-1.18 0-2.27.37-3.16 1H3v5.5c0 .83.67 1.5 1.5 1.5h1.1c.18.36.4.7.66 1H4.5A2.5 2.5 0 012 11.5v-7A2.5 2.5 0 014.5 2h7zm-1 13a4.5 4.5 0 100-9 4.5 4.5 0 000 9zm.35-2.15a.5.5 0 01-.7-.7L11.29 11H8.5a.5.5 0 010-1h2.8l-1.15-1.15a.5.5 0 01.7-.7l2 2a.5.5 0 01.15.35.5.5 0 01-.14.35l-2 2z",
    fill: primaryFill
  }));
};

export const CalendarArrowRight16Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarArrowRight16RegularIcon, 'CalendarArrowRight16Regular');

const CalendarArrowRight20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M17 5.5A2.5 2.5 0 0014.5 3h-9A2.5 2.5 0 003 5.5V6h14v-.5zm0 4.1V7H3v7.5A2.5 2.5 0 005.5 17h4.1A5.5 5.5 0 0117 9.6zm2 4.9a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-2.15.35a.5.5 0 00.15-.35.5.5 0 00-.15-.35l-2-2a.5.5 0 00-.7.7L15.29 14H12.5a.5.5 0 000 1h2.8l-1.15 1.15a.5.5 0 00.7.7l2-2z",
    fill: primaryFill
  }));
};

export const CalendarArrowRight20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarArrowRight20FilledIcon, 'CalendarArrowRight20Filled');

const CalendarArrowRight20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M17 5.5A2.5 2.5 0 0014.5 3h-9A2.5 2.5 0 003 5.5v9A2.5 2.5 0 005.5 17h4.1c-.16-.32-.3-.65-.4-1H5.5A1.5 1.5 0 014 14.5V7h12v2.2c.35.1.68.24 1 .4V5.5zM5.5 4h9c.83 0 1.5.67 1.5 1.5V6H4v-.5C4 4.67 4.67 4 5.5 4zM19 14.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-2.15.35a.5.5 0 00.15-.35.5.5 0 00-.15-.35l-2-2a.5.5 0 00-.7.7L15.29 14H12.5a.5.5 0 000 1h2.8l-1.15 1.15a.5.5 0 00.7.7l2-2z",
    fill: primaryFill
  }));
};

export const CalendarArrowRight20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarArrowRight20RegularIcon, 'CalendarArrowRight20Regular');

const CalendarArrowRight24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M21 8.5v3.52A6.5 6.5 0 0012.02 21H6.25A3.25 3.25 0 013 17.75V8.5h18zM17.75 3C19.55 3 21 4.46 21 6.25V7H3v-.75C3 4.45 4.46 3 6.25 3h11.5zM23 17.5a5.5 5.5 0 11-11 0 5.5 5.5 0 0111 0zm-8.5-.5a.5.5 0 000 1h4.8l-1.65 1.65a.5.5 0 00.7.7l2.5-2.5a.5.5 0 000-.7l-2.5-2.5a.5.5 0 00-.7.7L19.29 17H14.5z",
    fill: primaryFill
  }));
};

export const CalendarArrowRight24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarArrowRight24FilledIcon, 'CalendarArrowRight24Filled');

const CalendarArrowRight24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M21 6a3 3 0 00-3-3H6a3 3 0 00-3 3v12a3 3 0 003 3h6.02c-.3-.46-.53-.97-.7-1.5H6A1.5 1.5 0 014.5 18V8.5h15v2.81c.53.18 1.04.42 1.5.71V6zM6 4.5h12c.83 0 1.5.67 1.5 1.5v1h-15V6c0-.83.67-1.5 1.5-1.5zm17 13a5.5 5.5 0 10-11 0 5.5 5.5 0 0011 0zm-5.35-2.15a.5.5 0 01.7-.7l2.5 2.5c.2.2.2.5 0 .7l-2.5 2.5a.5.5 0 01-.7-.7L19.29 18H14.5a.5.5 0 010-1h4.8l-1.65-1.65z",
    fill: primaryFill
  }));
};

export const CalendarArrowRight24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarArrowRight24RegularIcon, 'CalendarArrowRight24Regular');

const CalendarAssistant16FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4.5 14h1.76a5.48 5.48 0 011.08-8H2v5.5A2.5 2.5 0 004.5 14zM14 5H2v-.5A2.5 2.5 0 014.5 2h7A2.5 2.5 0 0114 4.5V5zm-3.5 10a4.5 4.5 0 100-9 4.5 4.5 0 000 9zM9.4 7.83a.5.5 0 01.48-.33h1.18a.5.5 0 01.47.66l-.28.84H12a.5.5 0 01.42.77l-2.25 3.5a.5.5 0 01-.9-.4l.5-1.87H9a.5.5 0 01-.47-.67l.88-2.5z",
    fill: primaryFill
  }));
};

export const CalendarAssistant16Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarAssistant16FilledIcon, 'CalendarAssistant16Filled');

const CalendarAssistant16RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M11.5 2A2.5 2.5 0 0114 4.5v1.76A5.48 5.48 0 0010.5 5H13v-.5c0-.83-.67-1.5-1.5-1.5h-7C3.67 3 3 3.67 3 4.5V5h7.5c-1.18 0-2.27.37-3.16 1H3v5.5c0 .83.67 1.5 1.5 1.5h1.1c.18.36.4.7.66 1H4.5A2.5 2.5 0 012 11.5v-7A2.5 2.5 0 014.5 2h7zm-1 13a4.5 4.5 0 100-9 4.5 4.5 0 000 9zM9.4 7.83a.5.5 0 01.48-.33h1.18a.5.5 0 01.47.66l-.28.84H12a.5.5 0 01.42.77l-2.25 3.5a.5.5 0 01-.9-.4l.5-1.87H9a.5.5 0 01-.47-.67l.88-2.5z",
    fill: primaryFill
  }));
};

export const CalendarAssistant16Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarAssistant16RegularIcon, 'CalendarAssistant16Regular');

const CalendarAssistant20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M17 7v2.6A5.5 5.5 0 009.6 17H5.5A2.5 2.5 0 013 14.5V7h14zm-2.5-4A2.5 2.5 0 0117 5.5V6H3v-.5A2.5 2.5 0 015.5 3h9zm0 16a4.5 4.5 0 100-9 4.5 4.5 0 000 9zm-1.1-7.17a.5.5 0 01.48-.33h1.18a.5.5 0 01.47.66l-.28.84H16a.5.5 0 01.42.77l-2.25 3.5a.5.5 0 01-.9-.4l.5-1.87H13a.5.5 0 01-.47-.67l.88-2.5z",
    fill: primaryFill
  }));
};

export const CalendarAssistant20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarAssistant20FilledIcon, 'CalendarAssistant20Filled');

const CalendarAssistant20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M17 5.5A2.5 2.5 0 0014.5 3h-9A2.5 2.5 0 003 5.5v9A2.5 2.5 0 005.5 17h4.1c-.16-.32-.3-.65-.4-1H5.5A1.5 1.5 0 014 14.5V7h12v2.2c.35.1.68.24 1 .4V5.5zM5.5 4h9c.83 0 1.5.67 1.5 1.5V6H4v-.5C4 4.67 4.67 4 5.5 4zM19 14.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-5.12-3a.5.5 0 00-.47.33l-.88 2.5A.5.5 0 0013 15h.78l-.51 1.87a.5.5 0 00.9.4l2.25-3.5A.5.5 0 0016 13h-.75l.28-.84a.5.5 0 00-.47-.66h-1.18z",
    fill: primaryFill
  }));
};

export const CalendarAssistant20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarAssistant20RegularIcon, 'CalendarAssistant20Regular');

const CalendarAssistant24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M21 8.5v3.52A6.5 6.5 0 0012.02 21H6.25A3.25 3.25 0 013 17.75V8.5h18z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M17.75 3C19.55 3 21 4.46 21 6.25V7H3v-.75C3 4.45 4.46 3 6.25 3h11.5z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M17.5 23a5.5 5.5 0 100-11 5.5 5.5 0 000 11zm-.4-9h1.43c.35 0 .59.35.47.68L18.5 16h.63c.38 0 .6.41.4.73l-2.63 4.03a.52.52 0 01-.92-.44l.77-2.32h-.78a.5.5 0 01-.47-.68l1.13-3a.5.5 0 01.47-.32z",
    fill: primaryFill
  }));
};

export const CalendarAssistant24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarAssistant24FilledIcon, 'CalendarAssistant24Filled');

const CalendarAssistant24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M17.75 3C19.55 3 21 4.46 21 6.25v5.77c-.46-.3-.97-.53-1.5-.7V8.5h-15v9.25c0 .97.78 1.75 1.75 1.75h5.06c.18.53.42 1.04.71 1.5H6.25A3.25 3.25 0 013 17.75V6.25C3 4.45 4.46 3 6.25 3h11.5zm0 1.5H6.25c-.97 0-1.75.78-1.75 1.75V7h15v-.75c0-.97-.78-1.75-1.75-1.75zM17.5 23a5.5 5.5 0 100-11 5.5 5.5 0 000 11zm-.4-9h1.43c.35 0 .59.35.47.68L18.5 16h.63c.38 0 .6.41.4.73l-2.63 4.03a.52.52 0 01-.92-.44l.77-2.32h-.78a.5.5 0 01-.47-.68l1.13-3a.5.5 0 01.47-.32z",
    fill: primaryFill
  }));
};

export const CalendarAssistant24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarAssistant24RegularIcon, 'CalendarAssistant24Regular');

const CalendarCancel16FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4.5 14h1.76a5.48 5.48 0 011.08-8H2v5.5A2.5 2.5 0 004.5 14zM14 5H2v-.5A2.5 2.5 0 014.5 2h7A2.5 2.5 0 0114 4.5V5zm1 5.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-2.65-1.15a.5.5 0 00-.7-.7L10.5 9.79 9.35 8.65a.5.5 0 10-.7.7l1.14 1.15-1.14 1.15a.5.5 0 00.7.7l1.15-1.14 1.15 1.14a.5.5 0 00.7-.7l-1.14-1.15 1.14-1.15z",
    fill: primaryFill
  }));
};

export const CalendarCancel16Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarCancel16FilledIcon, 'CalendarCancel16Filled');

const CalendarCancel16RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M11.5 2A2.5 2.5 0 0114 4.5v1.76A5.48 5.48 0 0010.5 5H13v-.5c0-.83-.67-1.5-1.5-1.5h-7C3.67 3 3 3.67 3 4.5V5h7.5c-1.18 0-2.27.37-3.16 1H3v5.5c0 .83.67 1.5 1.5 1.5h1.1c.18.36.4.7.66 1H4.5A2.5 2.5 0 012 11.5v-7A2.5 2.5 0 014.5 2h7zm3.5 8.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-2.65-1.15a.5.5 0 00-.7-.7L10.5 9.79 9.35 8.65a.5.5 0 10-.7.7l1.14 1.15-1.14 1.15a.5.5 0 00.7.7l1.15-1.14 1.15 1.14a.5.5 0 00.7-.7l-1.14-1.15 1.14-1.15z",
    fill: primaryFill
  }));
};

export const CalendarCancel16Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarCancel16RegularIcon, 'CalendarCancel16Regular');

const CalendarCancel20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M17 7v2.6A5.5 5.5 0 009.6 17H5.5A2.5 2.5 0 013 14.5V7h14zm-2.5-4A2.5 2.5 0 0117 5.5V6H3v-.5A2.5 2.5 0 015.5 3h9zM19 14.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-4.5.7l1.15 1.15a.5.5 0 00.7-.7l-1.14-1.15 1.14-1.15a.5.5 0 00-.7-.7l-1.15 1.14-1.15-1.14a.5.5 0 00-.7.7l1.14 1.15-1.14 1.15a.5.5 0 00.7.7l1.15-1.14z",
    fill: primaryFill
  }));
};

export const CalendarCancel20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarCancel20FilledIcon, 'CalendarCancel20Filled');

const CalendarCancel20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M14.5 3A2.5 2.5 0 0117 5.5v4.1c-.32-.16-.65-.3-1-.4V7H4v7.5c0 .83.67 1.5 1.5 1.5h3.7c.1.35.24.68.4 1H5.5A2.5 2.5 0 013 14.5v-9A2.5 2.5 0 015.5 3h9zm0 1h-9C4.67 4 4 4.67 4 5.5V6h12v-.5c0-.83-.67-1.5-1.5-1.5zM19 14.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-4.5.7l1.15 1.15a.5.5 0 00.7-.7l-1.14-1.15 1.14-1.15a.5.5 0 00-.7-.7l-1.15 1.14-1.15-1.14a.5.5 0 00-.7.7l1.14 1.15-1.14 1.15a.5.5 0 00.7.7l1.15-1.14z",
    fill: primaryFill
  }));
};

export const CalendarCancel20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarCancel20RegularIcon, 'CalendarCancel20Regular');

const CalendarCancel24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M17.5 12a5.5 5.5 0 110 11 5.5 5.5 0 010-11zm-2.48 3.02a.5.5 0 000 .71l1.77 1.77-1.76 1.77a.5.5 0 10.7.7l1.77-1.76 1.77 1.77a.5.5 0 10.7-.71l-1.76-1.77 1.77-1.77a.5.5 0 00-.7-.7l-1.78 1.76-1.77-1.77a.5.5 0 00-.7 0zM21 8.5v3.52A6.5 6.5 0 0012.02 21H6.25A3.25 3.25 0 013 17.75V8.5h18zM17.75 3C19.55 3 21 4.46 21 6.25V7H3v-.75C3 4.45 4.46 3 6.25 3h11.5z",
    fill: primaryFill
  }));
};

export const CalendarCancel24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarCancel24FilledIcon, 'CalendarCancel24Filled');

const CalendarCancel24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M17.5 12a5.5 5.5 0 110 11 5.5 5.5 0 010-11zm-2.48 3.02a.5.5 0 000 .71l1.77 1.77-1.76 1.77a.5.5 0 10.7.7l1.77-1.76 1.77 1.77a.5.5 0 10.7-.71l-1.76-1.77 1.77-1.77a.5.5 0 00-.7-.7l-1.78 1.76-1.77-1.77a.5.5 0 00-.7 0zM17.75 3C19.55 3 21 4.46 21 6.25v5.77c-.46-.3-.97-.53-1.5-.7V8.5h-15v9.25c0 .97.78 1.75 1.75 1.75h5.06c.18.53.42 1.04.71 1.5H6.25A3.25 3.25 0 013 17.75V6.25C3 4.45 4.46 3 6.25 3h11.5zm0 1.5H6.25c-.97 0-1.75.78-1.75 1.75V7h15v-.75c0-.97-.78-1.75-1.75-1.75z",
    fill: primaryFill
  }));
};

export const CalendarCancel24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarCancel24RegularIcon, 'CalendarCancel24Regular');

const CalendarChat20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5.5 3A2.5 2.5 0 003 5.5V6h14v-.5A2.5 2.5 0 0014.5 3h-9zM17 7H3v7.5A2.5 2.5 0 005.5 17h3.92l.07-.23A5.48 5.48 0 0114.5 9c.9 0 1.75.22 2.5.6V7zm-7 7.5c0 .8.2 1.54.56 2.18l-.54 1.8c-.1.3.2.6.51.5l1.79-.54A4.5 4.5 0 1010 14.5zm2.5-1.5h4a.5.5 0 010 1h-4a.5.5 0 110-1zm-.5 2.5c0-.28.22-.5.5-.5h2a.5.5 0 010 1h-2a.5.5 0 01-.5-.5z",
    fill: primaryFill
  }));
};

export const CalendarChat20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarChat20FilledIcon, 'CalendarChat20Filled');

const CalendarChat20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5.5 16h3.7c.08.27.18.52.29.77l-.07.23H5.5A2.5 2.5 0 013 14.5v-9A2.5 2.5 0 015.5 3h9A2.5 2.5 0 0117 5.5v4.1c-.32-.16-.65-.3-1-.4V7H4v7.5c0 .83.67 1.5 1.5 1.5zm0-12C4.67 4 4 4.67 4 5.5V6h12v-.5c0-.83-.67-1.5-1.5-1.5h-9zm5.06 12.68l-.54 1.8c-.1.3.2.6.5.5l1.8-.54a4.5 4.5 0 10-1.76-1.75zM12.5 16a.5.5 0 010-1h2a.5.5 0 110 1h-2zm0-3h4a.5.5 0 110 1h-4a.5.5 0 010-1z",
    fill: primaryFill
  }));
};

export const CalendarChat20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarChat20RegularIcon, 'CalendarChat20Regular');

const CalendarChat24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M21 8.5v3.52a6.48 6.48 0 00-10 5.48c0 .99.22 1.92.61 2.76l-.22.74H6.25A3.25 3.25 0 013 17.75V8.5h18zM17.75 3C19.55 3 21 4.46 21 6.25V7H3v-.75C3 4.45 4.46 3 6.25 3h11.5zM21 13.26A5.48 5.48 0 0017.5 12a5.5 5.5 0 00-4.81 8.17l-.67 2.19a.5.5 0 00.63.62l2.18-.67A5.5 5.5 0 0021 13.25zM15.5 17a.5.5 0 110-1h4a.5.5 0 110 1h-4zm2 2h-2a.5.5 0 110-1h2a.5.5 0 110 1z",
    fill: primaryFill
  }));
};

export const CalendarChat24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarChat24FilledIcon, 'CalendarChat24Filled');

const CalendarChat24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M17.75 3C19.55 3 21 4.46 21 6.25v5.77c-.46-.3-.97-.53-1.5-.7V8.5h-15v9.25c0 .97.78 1.75 1.75 1.75h5.06c.09.26.19.52.3.76l-.22.74H6.25A3.25 3.25 0 013 17.75V6.25C3 4.45 4.46 3 6.25 3h11.5zm0 1.5H6.25c-.97 0-1.75.78-1.75 1.75V7h15v-.75c0-.97-.78-1.75-1.75-1.75zm1.75 7.87a5.5 5.5 0 11-4.67 9.94l-2.18.67a.5.5 0 01-.63-.62l.67-2.2A5.5 5.5 0 0117.48 12l.02.01c.7 0 1.38.13 2 .37zm0 4.63a.5.5 0 100-1h-4a.5.5 0 100 1h4zm-4 2h2a.5.5 0 100-1h-2a.5.5 0 100 1z",
    fill: primaryFill
  }));
};

export const CalendarChat24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarChat24RegularIcon, 'CalendarChat24Regular');

const CalendarCheckmark16FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4.5 14h1.76a5.48 5.48 0 011.08-8H2v5.5A2.5 2.5 0 004.5 14zM14 5H2v-.5A2.5 2.5 0 014.5 2h7A2.5 2.5 0 0114 4.5V5zm1 5.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-2.15-1.85a.5.5 0 00-.7 0L9.5 11.29l-.65-.64a.5.5 0 00-.7.7l1 1c.2.2.5.2.7 0l3-3a.5.5 0 000-.7z",
    fill: primaryFill
  }));
};

export const CalendarCheckmark16Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarCheckmark16FilledIcon, 'CalendarCheckmark16Filled');

const CalendarCheckmark16RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M11.5 2A2.5 2.5 0 0114 4.5v1.76A5.48 5.48 0 0010.5 5H13v-.5c0-.83-.67-1.5-1.5-1.5h-7C3.67 3 3 3.67 3 4.5V5h7.5c-1.18 0-2.27.37-3.16 1H3v5.5c0 .83.67 1.5 1.5 1.5h1.1c.18.36.4.7.66 1H4.5A2.5 2.5 0 012 11.5v-7A2.5 2.5 0 014.5 2h7zm3.5 8.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-2.15-1.85a.5.5 0 00-.7 0L9.5 11.29l-.65-.64a.5.5 0 00-.7.7l1 1c.2.2.5.2.7 0l3-3a.5.5 0 000-.7z",
    fill: primaryFill
  }));
};

export const CalendarCheckmark16Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarCheckmark16RegularIcon, 'CalendarCheckmark16Regular');

const CalendarCheckmark20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M17 7v2.6A5.5 5.5 0 009.6 17H5.5A2.5 2.5 0 013 14.5V7h14zm-2.5-4A2.5 2.5 0 0117 5.5V6H3v-.5A2.5 2.5 0 015.5 3h9zM19 14.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-2.15-1.85a.5.5 0 00-.7 0l-2.65 2.64-.65-.64a.5.5 0 00-.7.7l1 1c.2.2.5.2.7 0l3-3a.5.5 0 000-.7z",
    fill: primaryFill
  }));
};

export const CalendarCheckmark20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarCheckmark20FilledIcon, 'CalendarCheckmark20Filled');

const CalendarCheckmark20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M14.5 3A2.5 2.5 0 0117 5.5v4.1c-.32-.16-.65-.3-1-.4V7H4v7.5c0 .83.67 1.5 1.5 1.5h3.7c.1.35.24.68.4 1H5.5A2.5 2.5 0 013 14.5v-9A2.5 2.5 0 015.5 3h9zm0 1h-9C4.67 4 4 4.67 4 5.5V6h12v-.5c0-.83-.67-1.5-1.5-1.5zM19 14.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-2.15-1.85a.5.5 0 00-.7 0l-2.65 2.64-.65-.64a.5.5 0 00-.7.7l1 1c.2.2.5.2.7 0l3-3a.5.5 0 000-.7z",
    fill: primaryFill
  }));
};

export const CalendarCheckmark20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarCheckmark20RegularIcon, 'CalendarCheckmark20Regular');

const CalendarCheckmark24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M21 8.5v3.52A6.5 6.5 0 0012.02 21H6.25A3.25 3.25 0 013 17.75V8.5h18zM17.75 3C19.55 3 21 4.46 21 6.25V7H3v-.75C3 4.45 4.46 3 6.25 3h11.5zM23 17.5a5.5 5.5 0 11-11 0 5.5 5.5 0 0111 0zm-2.15-2.35a.5.5 0 00-.7 0l-3.65 3.64-1.65-1.64a.5.5 0 00-.7.7l2 2c.2.2.5.2.7 0l4-4a.5.5 0 000-.7z",
    fill: primaryFill
  }));
};

export const CalendarCheckmark24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarCheckmark24FilledIcon, 'CalendarCheckmark24Filled');

const CalendarCheckmark24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M17.75 3C19.55 3 21 4.46 21 6.25v5.77c-.46-.3-.97-.53-1.5-.7V8.5h-15v9.25c0 .97.78 1.75 1.75 1.75h5.06c.18.53.42 1.04.71 1.5H6.25A3.25 3.25 0 013 17.75V6.25C3 4.45 4.46 3 6.25 3h11.5zm0 1.5H6.25c-.97 0-1.75.78-1.75 1.75V7h15v-.75c0-.97-.78-1.75-1.75-1.75zm5.25 13a5.5 5.5 0 11-11 0 5.5 5.5 0 0111 0zm-2.15-2.35a.5.5 0 00-.7 0l-3.65 3.64-1.65-1.64a.5.5 0 00-.7.7l2 2c.2.2.5.2.7 0l4-4a.5.5 0 000-.7z",
    fill: primaryFill
  }));
};

export const CalendarCheckmark24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarCheckmark24RegularIcon, 'CalendarCheckmark24Regular');

const CalendarCheckmark28FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M25 9.5v5A7.5 7.5 0 0014.5 25H6.25A3.25 3.25 0 013 21.75V9.5h22zM21.75 3C23.55 3 25 4.46 25 6.25V8H3V6.25C3 4.45 4.46 3 6.25 3h15.5zM27 20.5a6.5 6.5 0 11-13 0 6.5 6.5 0 0113 0zm-2.65-2.85a.5.5 0 00-.7 0L19 22.29l-1.65-1.64a.5.5 0 00-.7.7l2 2c.2.2.5.2.7 0l5-5a.5.5 0 000-.7z",
    fill: primaryFill
  }));
};

export const CalendarCheckmark28Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarCheckmark28FilledIcon, 'CalendarCheckmark28Filled');

const CalendarCheckmark28RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M21.75 3C23.55 3 25 4.46 25 6.25v8.25a7.49 7.49 0 00-1.5-.88V9.5h-19v12.25c0 .97.78 1.75 1.75 1.75h7.37c.24.54.53 1.04.88 1.5H6.25A3.25 3.25 0 013 21.75V6.25C3 4.45 4.46 3 6.25 3h15.5zm0 1.5H6.25c-.97 0-1.75.78-1.75 1.75V8h19V6.25c0-.97-.78-1.75-1.75-1.75zm5.25 16a6.5 6.5 0 11-13 0 6.5 6.5 0 0113 0zm-2.65-2.85a.5.5 0 00-.7 0L19 22.29l-1.65-1.64a.5.5 0 00-.7.7l2 2c.2.2.5.2.7 0l5-5a.5.5 0 000-.7z",
    fill: primaryFill
  }));
};

export const CalendarCheckmark28Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarCheckmark28RegularIcon, 'CalendarCheckmark28Regular');

const CalendarClock16FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4.5 14h1.76a5.48 5.48 0 011.08-8H2v5.5A2.5 2.5 0 004.5 14zM14 5H2v-.5A2.5 2.5 0 014.5 2h7A2.5 2.5 0 0114 4.5V5zm-3.5 10a4.5 4.5 0 100-9 4.5 4.5 0 000 9zM10 8.5a.5.5 0 011 0V10h1a.5.5 0 010 1h-1.5a.5.5 0 01-.5-.5v-2z",
    fill: primaryFill
  }));
};

export const CalendarClock16Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarClock16FilledIcon, 'CalendarClock16Filled');

const CalendarClock16RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M11.5 2A2.5 2.5 0 0114 4.5v1.76A5.48 5.48 0 0010.5 5H13v-.5c0-.83-.67-1.5-1.5-1.5h-7C3.67 3 3 3.67 3 4.5V5h7.5c-1.18 0-2.27.37-3.16 1H3v5.5c0 .83.67 1.5 1.5 1.5h1.1c.18.36.4.7.66 1H4.5A2.5 2.5 0 012 11.5v-7A2.5 2.5 0 014.5 2h7zm-1 13a4.5 4.5 0 100-9 4.5 4.5 0 000 9zM10 8.5a.5.5 0 011 0V10h1a.5.5 0 010 1h-1.5a.5.5 0 01-.5-.5v-2z",
    fill: primaryFill
  }));
};

export const CalendarClock16Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarClock16RegularIcon, 'CalendarClock16Regular');

const CalendarClock20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M17 5.5A2.5 2.5 0 0014.5 3h-9A2.5 2.5 0 003 5.5V6h14v-.5zm0 4.1V7H3v7.5A2.5 2.5 0 005.5 17h4.1A5.5 5.5 0 0117 9.6zM14.5 19a4.5 4.5 0 100-9 4.5 4.5 0 000 9zm-.5-6.5a.5.5 0 011 0V14h1a.5.5 0 010 1h-1.5a.5.5 0 01-.5-.5v-2z",
    fill: primaryFill
  }));
};

export const CalendarClock20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarClock20FilledIcon, 'CalendarClock20Filled');

const CalendarClock20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M17 5.5A2.5 2.5 0 0014.5 3h-9A2.5 2.5 0 003 5.5v9A2.5 2.5 0 005.5 17h4.1c-.16-.32-.3-.65-.4-1H5.5A1.5 1.5 0 014 14.5V7h12v2.2c.35.1.68.24 1 .4V5.5zM5.5 4h9c.83 0 1.5.67 1.5 1.5V6H4v-.5C4 4.67 4.67 4 5.5 4zm9 15a4.5 4.5 0 100-9 4.5 4.5 0 000 9zm-.5-6.5a.5.5 0 011 0V14h1a.5.5 0 010 1h-1.5a.5.5 0 01-.5-.5v-2z",
    fill: primaryFill
  }));
};

export const CalendarClock20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarClock20RegularIcon, 'CalendarClock20Regular');

const CalendarClock24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M17.75 3C19.55 3 21 4.46 21 6.25V7H3v-.75C3 4.45 4.46 3 6.25 3h11.5zM21 8.5v3.52A6.5 6.5 0 0012.02 21H6.25A3.25 3.25 0 013 17.75V8.5h18zm2 9a5.5 5.5 0 10-11 0 5.5 5.5 0 0011 0zm-5.5 0h2a.5.5 0 110 1H17a.5.5 0 01-.5-.5v-3a.5.5 0 011 0v2.5z",
    fill: primaryFill
  }));
};

export const CalendarClock24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarClock24FilledIcon, 'CalendarClock24Filled');

const CalendarClock24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M21 6.25C21 4.45 19.54 3 17.75 3H6.25A3.25 3.25 0 003 6.25v11.5C3 19.55 4.46 21 6.25 21h5.77c-.3-.46-.53-.97-.7-1.5H6.24c-.97 0-1.75-.78-1.75-1.75V8.5h15v2.81c.53.18 1.04.42 1.5.71V6.25zM6.25 4.5h11.5c.97 0 1.75.78 1.75 1.75V7h-15v-.75c0-.97.78-1.75 1.75-1.75zM23 17.5a5.5 5.5 0 10-11 0 5.5 5.5 0 0011 0zm-5.5 0h2a.5.5 0 010 1H17a.5.5 0 01-.5-.5v-3a.5.5 0 011 0v2.5z",
    fill: primaryFill
  }));
};

export const CalendarClock24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarClock24RegularIcon, 'CalendarClock24Regular');

const CalendarDataBar16FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M12 6h2v2a2 2 0 00-2-2zM2 6h10a2 2 0 00-2 2v2.27A2 2 0 007 12v2H4.5A2.5 2.5 0 012 11.5V6zm9.5-4A2.5 2.5 0 0114 4.5V5H2v-.5A2.5 2.5 0 014.5 2h7zm.5 5a1 1 0 00-1 1v7a1 1 0 102 0V8a1 1 0 00-1-1zm-3 4a1 1 0 00-1 1v3a1 1 0 102 0v-3a1 1 0 00-1-1zm5-1a1 1 0 112 0v5a1 1 0 11-2 0v-5z",
    fill: primaryFill
  }));
};

export const CalendarDataBar16Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarDataBar16FilledIcon, 'CalendarDataBar16Filled');

const CalendarDataBar16RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M14 4.5A2.5 2.5 0 0011.5 2h-7A2.5 2.5 0 002 4.5v7A2.5 2.5 0 004.5 14H7v-1H4.5A1.5 1.5 0 013 11.5V6h10v.27c.6.34 1 .99 1 1.73V4.5zM4.5 3h7c.83 0 1.5.67 1.5 1.5V5H3v-.5C3 3.67 3.67 3 4.5 3zM12 7a1 1 0 00-1 1v7a1 1 0 102 0V8a1 1 0 00-1-1zm-3 4a1 1 0 00-1 1v3a1 1 0 102 0v-3a1 1 0 00-1-1zm5-1a1 1 0 112 0v5a1 1 0 11-2 0v-5z",
    fill: primaryFill
  }));
};

export const CalendarDataBar16Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarDataBar16RegularIcon, 'CalendarDataBar16Regular');

const CalendarDataBar20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5.5 17H10v-2a2 2 0 013-1.73V11a2 2 0 114 0V7H3v7.5A2.5 2.5 0 005.5 17zm9-14A2.5 2.5 0 0117 5.5V6H3v-.5A2.5 2.5 0 015.5 3h9zm.5 7a1 1 0 00-1 1v7a1 1 0 102 0v-7a1 1 0 00-1-1zm-3 4a1 1 0 00-1 1v3a1 1 0 102 0v-3a1 1 0 00-1-1zm5-1a1 1 0 112 0v5a1 1 0 11-2 0v-5z",
    fill: primaryFill
  }));
};

export const CalendarDataBar20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarDataBar20FilledIcon, 'CalendarDataBar20Filled');

const CalendarDataBar20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M17 5.5A2.5 2.5 0 0014.5 3h-9A2.5 2.5 0 003 5.5v9A2.5 2.5 0 005.5 17H10v-1H5.5A1.5 1.5 0 014 14.5V7h12v2.27c.6.34 1 .99 1 1.73V5.5zM5.5 4h9c.83 0 1.5.67 1.5 1.5V6H4v-.5C4 4.67 4.67 4 5.5 4zm9.5 6a1 1 0 00-1 1v7a1 1 0 102 0v-7a1 1 0 00-1-1zm-3 4a1 1 0 00-1 1v3a1 1 0 102 0v-3a1 1 0 00-1-1zm5-1a1 1 0 112 0v5a1 1 0 11-2 0v-5z",
    fill: primaryFill
  }));
};

export const CalendarDataBar20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarDataBar20RegularIcon, 'CalendarDataBar20Regular');

const CalendarDataBar24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M21 8.5v4.55c-.37.07-.7.23-1 .45a2.5 2.5 0 00-5 0v2a2.5 2.5 0 00-4 2V21H6.25A3.25 3.25 0 013 17.75V8.5h18zM17.75 3C19.55 3 21 4.46 21 6.25V7H3v-.75C3 4.45 4.46 3 6.25 3h11.5zm-.25 9c-.83 0-1.5.67-1.5 1.5v8a1.5 1.5 0 003 0v-8c0-.83-.67-1.5-1.5-1.5zm-4 4c-.83 0-1.5.67-1.5 1.5v4a1.5 1.5 0 003 0v-4c0-.83-.67-1.5-1.5-1.5zm6.5-.5a1.5 1.5 0 013 0v6a1.5 1.5 0 01-3 0v-6z",
    fill: primaryFill
  }));
};

export const CalendarDataBar24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarDataBar24FilledIcon, 'CalendarDataBar24Filled');

const CalendarDataBar24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M17.75 3C19.55 3 21 4.46 21 6.25v6.8c-.37.07-.7.23-1 .45 0-.56-.19-1.08-.5-1.5V8.5h-15v9.25c0 .97.78 1.75 1.75 1.75H11V21H6.25A3.25 3.25 0 013 17.75V6.25C3 4.45 4.46 3 6.25 3h11.5zm0 1.5H6.25c-.97 0-1.75.78-1.75 1.75V7h15v-.75c0-.97-.78-1.75-1.75-1.75zM17.5 12c-.83 0-1.5.67-1.5 1.5v8a1.5 1.5 0 003 0v-8c0-.83-.67-1.5-1.5-1.5zm-4 4c-.83 0-1.5.67-1.5 1.5v4a1.5 1.5 0 003 0v-4c0-.83-.67-1.5-1.5-1.5zm6.5-.5a1.5 1.5 0 013 0v6a1.5 1.5 0 01-3 0v-6z",
    fill: primaryFill
  }));
};

export const CalendarDataBar24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarDataBar24RegularIcon, 'CalendarDataBar24Regular');

const CalendarDataBar28FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M25 9.5v6.55a2.51 2.51 0 00-2 .45v-1a2.5 2.5 0 00-5 0v4a2.5 2.5 0 00-4 2V25H6.25A3.25 3.25 0 013 21.75V9.5h22zM21.75 3C23.55 3 25 4.46 25 6.25V8H3V6.25C3 4.45 4.46 3 6.25 3h15.5zM20.5 14c-.83 0-1.5.67-1.5 1.5v10a1.5 1.5 0 003 0v-10c0-.83-.67-1.5-1.5-1.5zm-4 6c-.83 0-1.5.67-1.5 1.5v4a1.5 1.5 0 003 0v-4c0-.83-.67-1.5-1.5-1.5zm6.5-1.5a1.5 1.5 0 013 0v7a1.5 1.5 0 01-3 0v-7z",
    fill: primaryFill
  }));
};

export const CalendarDataBar28Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarDataBar28FilledIcon, 'CalendarDataBar28Filled');

const CalendarDataBar28RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M21.75 3C23.55 3 25 4.46 25 6.25v9.8a2.51 2.51 0 00-1.5.16V9.5h-19v12.24c0 .97.78 1.75 1.75 1.75H14V25H6.25A3.25 3.25 0 013 21.75V6.25C3 4.45 4.46 3 6.25 3h15.5zm0 1.5H6.25c-.97 0-1.75.78-1.75 1.75V8h19V6.25c0-.97-.78-1.75-1.75-1.75zM20.5 14c-.83 0-1.5.67-1.5 1.5v10a1.5 1.5 0 003 0v-10c0-.83-.67-1.5-1.5-1.5zm-4 6c-.83 0-1.5.67-1.5 1.5v4a1.5 1.5 0 003 0v-4c0-.83-.67-1.5-1.5-1.5zm6.5-1.5a1.5 1.5 0 013 0v7a1.5 1.5 0 01-3 0v-7z",
    fill: primaryFill
  }));
};

export const CalendarDataBar28Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarDataBar28RegularIcon, 'CalendarDataBar28Regular');

const CalendarDay16FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6 10V9h4v1H6zm8 1.5a2.5 2.5 0 01-2.5 2.5h-7A2.5 2.5 0 012 11.5v-7A2.5 2.5 0 014.5 2h7A2.5 2.5 0 0114 4.5v7zM5.5 5a.5.5 0 000 1h5a.5.5 0 000-1h-5zm0 3a.5.5 0 00-.5.5v2c0 .28.22.5.5.5h5a.5.5 0 00.5-.5v-2a.5.5 0 00-.5-.5h-5z",
    fill: primaryFill
  }));
};

export const CalendarDay16Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarDay16FilledIcon, 'CalendarDay16Filled');

const CalendarDay16RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5.5 5a.5.5 0 000 1h5a.5.5 0 000-1h-5zm0 3a.5.5 0 00-.5.5v2c0 .28.22.5.5.5h5a.5.5 0 00.5-.5v-2a.5.5 0 00-.5-.5h-5zm.5 2V9h4v1H6zm8-5.5A2.5 2.5 0 0011.5 2h-7A2.5 2.5 0 002 4.5v7A2.5 2.5 0 004.5 14h7a2.5 2.5 0 002.5-2.5v-7zm-11 7v-7C3 3.67 3.67 3 4.5 3h7c.83 0 1.5.67 1.5 1.5v7c0 .83-.67 1.5-1.5 1.5h-7A1.5 1.5 0 013 11.5z",
    fill: primaryFill
  }));
};

export const CalendarDay16Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarDay16RegularIcon, 'CalendarDay16Regular');

const CalendarDay20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M14.5 3A2.5 2.5 0 0117 5.5v9a2.5 2.5 0 01-2.5 2.5h-9A2.5 2.5 0 013 14.5v-9A2.5 2.5 0 015.5 3h9zm-1.78 6H7.28c-.44 0-.6.05-.77.13a.9.9 0 00-.38.38c-.07.14-.12.29-.13.62v2.59c0 .44.05.6.13.77.1.16.22.29.38.38.14.07.29.12.62.13H12.72c.44 0 .6-.05.77-.13a.9.9 0 00.38-.38c.07-.14.12-.29.13-.62v-2.59c0-.44-.05-.6-.13-.77a.9.9 0 00-.38-.38 1.24 1.24 0 00-.62-.13h-.15zm.2 1h.07V13H7.01v-2.98h5.9zm.58-4H6.41a.5.5 0 000 1h7.18a.5.5 0 000-1h-.09z",
    fill: primaryFill
  }));
};

export const CalendarDay20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarDay20FilledIcon, 'CalendarDay20Filled');

const CalendarDay20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M14.5 3A2.5 2.5 0 0117 5.5v9a2.5 2.5 0 01-2.5 2.5h-9A2.5 2.5 0 013 14.5v-9A2.5 2.5 0 015.5 3h9zm0 1h-9C4.67 4 4 4.67 4 5.5v9c0 .83.67 1.5 1.5 1.5h9c.83 0 1.5-.67 1.5-1.5v-9c0-.83-.67-1.5-1.5-1.5zm-1.78 5c.44 0 .6.05.77.13.16.1.29.22.38.38.08.16.13.33.13.77v2.44c0 .44-.05.6-.13.77a.9.9 0 01-.38.38c-.16.08-.33.13-.77.13H7.28c-.44 0-.6-.05-.77-.13a.9.9 0 01-.38-.38c-.08-.16-.13-.33-.13-.77v-2.44c0-.44.05-.6.13-.77a.9.9 0 01.38-.38c.16-.08.33-.13.77-.13h5.44zm.2 1H7V13h5.98v-2.98h-.08zm.58-4a.5.5 0 01.09 1H6.5a.5.5 0 01-.09-1h7.09z",
    fill: primaryFill
  }));
};

export const CalendarDay20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarDay20RegularIcon, 'CalendarDay20Regular');

const CalendarDay24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M17.75 3C19.55 3 21 4.46 21 6.25v11.5c0 1.8-1.46 3.25-3.25 3.25H6.25A3.25 3.25 0 013 17.75V6.25C3 4.45 4.46 3 6.25 3h11.5zm-1.5 8h-8.5c-.38 0-.7.28-.74.65l-.01.1v4.5c0 .38.28.7.65.74l.1.01h8.5c.38 0 .7-.28.74-.65l.01-.1v-4.5c0-.38-.28-.7-.65-.74l-.1-.01zm-.75 1.5v3h-7v-3h7zm.75-5.25h-8.5a.75.75 0 000 1.5h8.5a.75.75 0 000-1.5z",
    fill: primaryFill
  }));
};

export const CalendarDay24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarDay24FilledIcon, 'CalendarDay24Filled');

const CalendarDay24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M17.75 3C19.55 3 21 4.46 21 6.25v11.5c0 1.8-1.46 3.25-3.25 3.25H6.25A3.25 3.25 0 013 17.75V6.25C3 4.45 4.46 3 6.25 3h11.5zm0 1.5H6.25c-.97 0-1.75.78-1.75 1.75v11.5c0 .97.78 1.75 1.75 1.75h11.5c.97 0 1.75-.78 1.75-1.75V6.25c0-.97-.78-1.75-1.75-1.75zm-1.5 6.5c.41 0 .75.34.75.75v4.5c0 .41-.34.75-.75.75h-8.5a.75.75 0 01-.75-.75v-4.5c0-.41.34-.75.75-.75h8.5zm-.75 1.5h-7v3h7v-3zM7.75 7.25h8.5a.75.75 0 01.1 1.5h-8.6a.75.75 0 01-.1-1.5h8.6-8.5z",
    fill: primaryFill
  }));
};

export const CalendarDay24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarDay24RegularIcon, 'CalendarDay24Regular');

const CalendarDay28FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M21.75 3C23.55 3 25 4.46 25 6.25v15.5c0 1.8-1.46 3.25-3.25 3.25H6.25A3.25 3.25 0 013 21.75V6.25C3 4.45 4.46 3 6.25 3h15.5zM19 12H9a1 1 0 00-1 .88V19a1 1 0 00.88 1H19a1 1 0 001-.88V13a1 1 0 00-.88-1H19zm-.5 1.5v5h-9v-5h9zM19 8H8.9a.75.75 0 000 1.5h10.2a.75.75 0 000-1.5H19z",
    fill: primaryFill
  }));
};

export const CalendarDay28Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarDay28FilledIcon, 'CalendarDay28Filled');

const CalendarDay28RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M21.75 3C23.55 3 25 4.46 25 6.25v15.5c0 1.8-1.46 3.25-3.25 3.25H6.25A3.25 3.25 0 013 21.75V6.25C3 4.45 4.46 3 6.25 3h15.5zm0 1.5H6.25c-.97 0-1.75.78-1.75 1.75v15.5c0 .97.78 1.75 1.75 1.75h15.5c.97 0 1.75-.78 1.75-1.75V6.25c0-.97-.78-1.75-1.75-1.75zM19 12a1 1 0 011 1v6a1 1 0 01-1 1H9a1 1 0 01-1-1v-6a1 1 0 011-1h10zm-.5 1.5h-9v5h9v-5zM19 8a.75.75 0 01.1 1.5H9A.75.75 0 018.9 8H19z",
    fill: primaryFill
  }));
};

export const CalendarDay28Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarDay28RegularIcon, 'CalendarDay28Regular');

const CalendarEdit16FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M7.32 13.03c.12-.49.37-.93.73-1.29l4.29-4.29a1.55 1.55 0 012.2 0c.61.61.61 1.6 0 2.21l-4.28 4.29c-.36.35-.8.6-1.3.73l-1.2.3a.6.6 0 01-.74-.74l.3-1.2zM14 5v-.5A2.5 2.5 0 0011.5 2h-7A2.5 2.5 0 002 4.5V5h12zm-1 1.04V6H2v5.5A2.5 2.5 0 004.5 14h1.55l.3-1.21c.16-.67.5-1.27 1-1.76l4.28-4.28c.39-.39.87-.63 1.37-.71z",
    fill: primaryFill
  }));
};

export const CalendarEdit16Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarEdit16FilledIcon, 'CalendarEdit16Filled');

const CalendarEdit16RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M11.5 2A2.5 2.5 0 0114 4.5V6H3v5.5c0 .83.67 1.5 1.5 1.5h1.8l-.25 1H4.5A2.5 2.5 0 012 11.5v-7A2.5 2.5 0 014.5 2h7zm0 1h-7C3.67 3 3 3.67 3 4.5V5h10v-.5c0-.83-.67-1.5-1.5-1.5zm1.86 4a1.57 1.57 0 011.18.45c.61.61.61 1.6 0 2.21l-4.28 4.29c-.36.35-.8.6-1.3.73l-1.2.3a.6.6 0 01-.74-.74l.3-1.2V13c.13-.48.38-.91.73-1.26l4.29-4.29A1.55 1.55 0 0113.36 7z",
    fill: primaryFill
  }));
};

export const CalendarEdit16Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarEdit16RegularIcon, 'CalendarEdit16Regular');

const CalendarEdit20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M17 7v2c-.7.03-1.37.31-1.9.84l-4.83 4.83c-.4.4-.7.92-.84 1.48l-.21.85H5.5A2.5 2.5 0 013 14.5V7h14zm-2.5-4A2.5 2.5 0 0117 5.5V6H3v-.5A2.5 2.5 0 015.5 3h9zm-3.52 12.38l4.83-4.83a1.87 1.87 0 112.64 2.64l-4.83 4.83a2.2 2.2 0 01-1.02.58l-1.5.37a.89.89 0 01-1.07-1.08l.37-1.5c.1-.38.3-.73.58-1.01z",
    fill: primaryFill
  }));
};

export const CalendarEdit20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarEdit20FilledIcon, 'CalendarEdit20Filled');

const CalendarEdit20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M14.5 3A2.5 2.5 0 0117 5.5V9c-.34.02-.68.1-1 .23V7H4v7.5c0 .83.67 1.5 1.5 1.5h3.97l-.04.15-.21.85H5.5A2.5 2.5 0 013 14.5v-9A2.5 2.5 0 015.5 3h9zm0 1h-9C4.67 4 4 4.67 4 5.5V6h12v-.5c0-.83-.67-1.5-1.5-1.5zm-3.52 11.38l4.83-4.83a1.87 1.87 0 112.64 2.64l-4.83 4.83a2.2 2.2 0 01-1.02.58l-1.5.37a.89.89 0 01-1.07-1.08l.37-1.5c.1-.38.3-.73.58-1.01z",
    fill: primaryFill
  }));
};

export const CalendarEdit20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarEdit20RegularIcon, 'CalendarEdit20Regular');

const CalendarEdit24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M11.52 19.58L11.16 21H6.25A3.25 3.25 0 013 17.75V8.5h18v2.51c-.93-.08-1.9.24-2.6.95l-5.91 5.9c-.47.48-.8 1.07-.97 1.72zM21 6.25C21 4.45 19.54 3 17.75 3H6.25A3.25 3.25 0 003 6.25V7h18v-.75zm-1.9 6.42l-5.9 5.9c-.35.34-.6.78-.71 1.25l-.46 1.83c-.2.8.52 1.52 1.32 1.32l1.83-.46c.47-.12.9-.36 1.25-.7l5.9-5.9a2.29 2.29 0 00-3.23-3.24z",
    fill: primaryFill
  }));
};

export const CalendarEdit24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarEdit24FilledIcon, 'CalendarEdit24Filled');

const CalendarEdit24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M21 6.25C21 4.45 19.54 3 17.75 3H6.25A3.25 3.25 0 003 6.25v11.5C3 19.55 4.45 21 6.25 21h4.91l.36-1.42.02-.08H6.25c-.97 0-1.75-.78-1.75-1.75V8.5h15v2.73c.48-.19 1-.26 1.5-.22V6.25zM6.25 4.5h11.5c.97 0 1.75.78 1.75 1.75V7h-15v-.75c0-.97.78-1.75 1.75-1.75zm12.85 8.17l-5.9 5.9c-.35.34-.6.78-.71 1.25l-.46 1.83c-.2.8.52 1.52 1.32 1.32l1.83-.46c.47-.12.9-.36 1.25-.7l5.9-5.9a2.29 2.29 0 00-3.23-3.24z",
    fill: primaryFill
  }));
};

export const CalendarEdit24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarEdit24RegularIcon, 'CalendarEdit24Regular');

const CalendarEmpty16FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M14 6v5.5a2.5 2.5 0 01-2.5 2.5h-7A2.5 2.5 0 012 11.5V6h12zm-2.5-4A2.5 2.5 0 0114 4.5V5H2v-.5A2.5 2.5 0 014.5 2h7z",
    fill: primaryFill
  }));
};

export const CalendarEmpty16Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarEmpty16FilledIcon, 'CalendarEmpty16Filled');

const CalendarEmpty16RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M11.5 2A2.5 2.5 0 0114 4.5v7a2.5 2.5 0 01-2.5 2.5h-7A2.5 2.5 0 012 11.5v-7A2.5 2.5 0 014.5 2h7zM13 6H3v5.5c0 .83.67 1.5 1.5 1.5h7c.83 0 1.5-.67 1.5-1.5V6zm-1.5-3h-7C3.67 3 3 3.67 3 4.5V5h10v-.5c0-.83-.67-1.5-1.5-1.5z",
    fill: primaryFill
  }));
};

export const CalendarEmpty16Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarEmpty16RegularIcon, 'CalendarEmpty16Regular');

const CalendarEmpty20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M17 7v7.5a2.5 2.5 0 01-2.5 2.5h-9A2.5 2.5 0 013 14.5V7h14zm-2.5-4A2.5 2.5 0 0117 5.5V6H3v-.5A2.5 2.5 0 015.5 3h9z",
    fill: primaryFill
  }));
};

export const CalendarEmpty20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarEmpty20FilledIcon, 'CalendarEmpty20Filled');

const CalendarEmpty20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M14.5 3A2.5 2.5 0 0117 5.5v9a2.5 2.5 0 01-2.5 2.5h-9A2.5 2.5 0 013 14.5v-9A2.5 2.5 0 015.5 3h9zM16 7H4v7.5c0 .83.67 1.5 1.5 1.5h9c.83 0 1.5-.67 1.5-1.5V7zm-1.5-3h-9C4.67 4 4 4.67 4 5.5V6h12v-.5c0-.83-.67-1.5-1.5-1.5z",
    fill: primaryFill
  }));
};

export const CalendarEmpty20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarEmpty20RegularIcon, 'CalendarEmpty20Regular');

const CalendarEmpty24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M21 8.5v9.25c0 1.8-1.46 3.25-3.25 3.25H6.25A3.25 3.25 0 013 17.75V8.5h18zM17.75 3C19.55 3 21 4.46 21 6.25V7H3v-.75C3 4.45 4.46 3 6.25 3h11.5z",
    fill: primaryFill
  }));
};

export const CalendarEmpty24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarEmpty24FilledIcon, 'CalendarEmpty24Filled');

const CalendarEmpty24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M17.75 3C19.55 3 21 4.46 21 6.25v11.5c0 1.8-1.46 3.25-3.25 3.25H6.25A3.25 3.25 0 013 17.75V6.25C3 4.45 4.46 3 6.25 3h11.5zm1.75 5.5h-15v9.25c0 .97.78 1.75 1.75 1.75h11.5c.97 0 1.75-.78 1.75-1.75V8.5zm-1.75-4H6.25c-.97 0-1.75.78-1.75 1.75V7h15v-.75c0-.97-.78-1.75-1.75-1.75z",
    fill: primaryFill
  }));
};

export const CalendarEmpty24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarEmpty24RegularIcon, 'CalendarEmpty24Regular');

const CalendarEmpty28FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M25 9.5v12.25c0 1.8-1.46 3.25-3.25 3.25H6.25A3.25 3.25 0 013 21.75V9.5h22zM21.75 3C23.55 3 25 4.46 25 6.25V8H3V6.25C3 4.45 4.46 3 6.25 3h15.5z",
    fill: primaryFill
  }));
};

export const CalendarEmpty28Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarEmpty28FilledIcon, 'CalendarEmpty28Filled');

const CalendarEmpty28RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M21.75 3C23.55 3 25 4.46 25 6.25v15.5c0 1.8-1.46 3.25-3.25 3.25H6.25A3.25 3.25 0 013 21.75V6.25C3 4.45 4.46 3 6.25 3h15.5zm1.75 6.5h-19v12.25c0 .97.78 1.75 1.75 1.75h15.5c.97 0 1.75-.78 1.75-1.75V9.5zm-1.75-5H6.25c-.97 0-1.75.78-1.75 1.75V8h19V6.25c0-.97-.78-1.75-1.75-1.75z",
    fill: primaryFill
  }));
};

export const CalendarEmpty28Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarEmpty28RegularIcon, 'CalendarEmpty28Regular');

const CalendarEmpty32FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M7.5 3A4.5 4.5 0 003 7.5V9h26V7.5A4.5 4.5 0 0024.5 3h-17zM29 11H3v13.5A4.5 4.5 0 007.5 29h17a4.5 4.5 0 004.5-4.5V11z",
    fill: primaryFill
  }));
};

export const CalendarEmpty32Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarEmpty32FilledIcon, 'CalendarEmpty32Filled');

const CalendarEmpty32RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M7.5 3A4.5 4.5 0 003 7.5v17A4.5 4.5 0 007.5 29h17a4.5 4.5 0 004.5-4.5v-17A4.5 4.5 0 0024.5 3h-17zM5 7.5A2.5 2.5 0 017.5 5h17A2.5 2.5 0 0127 7.5V9H5V7.5zM5 11h22v13.5a2.5 2.5 0 01-2.5 2.5h-17A2.5 2.5 0 015 24.5V11z",
    fill: primaryFill
  }));
};

export const CalendarEmpty32Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarEmpty32RegularIcon, 'CalendarEmpty32Regular');

const CalendarError20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5.5 3A2.5 2.5 0 003 5.5V6h14v-.5A2.5 2.5 0 0014.5 3h-9zM17 7H3v7.5A2.5 2.5 0 005.5 17h4.1A5.5 5.5 0 0117 9.6V7zm2 7.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zM14.5 12a.5.5 0 00-.5.5v2a.5.5 0 001 0v-2a.5.5 0 00-.5-.5zm0 5.13a.62.62 0 100-1.25.62.62 0 000 1.24z",
    fill: primaryFill
  }));
};

export const CalendarError20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarError20FilledIcon, 'CalendarError20Filled');

const CalendarError20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5.5 3A2.5 2.5 0 003 5.5v9A2.5 2.5 0 005.5 17h4.1c-.16-.32-.3-.65-.4-1H5.5A1.5 1.5 0 014 14.5V7h12v2.2c.35.1.68.24 1 .4V5.5A2.5 2.5 0 0014.5 3h-9zM4 5.5C4 4.67 4.67 4 5.5 4h9c.83 0 1.5.67 1.5 1.5V6H4v-.5zm15 9a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zM14.5 12a.5.5 0 00-.5.5v2a.5.5 0 001 0v-2a.5.5 0 00-.5-.5zm0 5.13a.62.62 0 100-1.25.62.62 0 000 1.24z",
    fill: primaryFill
  }));
};

export const CalendarError20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarError20RegularIcon, 'CalendarError20Regular');

const CalendarError24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M21 12.02V8.5H3v9.25C3 19.55 4.46 21 6.25 21h5.77A6.5 6.5 0 0121 12.02zm0-5.77C21 4.45 19.54 3 17.75 3H6.25A3.25 3.25 0 003 6.25V7h18v-.75zm2 11.25a5.5 5.5 0 10-11 0 5.5 5.5 0 0011 0zm-6-3a.5.5 0 011 0v4a.5.5 0 01-1 0v-4zm1.13 6a.62.62 0 11-1.25 0 .62.62 0 011.25 0z",
    fill: primaryFill
  }));
};

export const CalendarError24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarError24FilledIcon, 'CalendarError24Filled');

const CalendarError24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M17.75 3C19.55 3 21 4.46 21 6.25v5.77c-.46-.3-.97-.53-1.5-.7V8.5h-15v9.25c0 .97.78 1.75 1.75 1.75h5.06c.18.53.42 1.04.71 1.5H6.25A3.25 3.25 0 013 17.75V6.25C3 4.45 4.46 3 6.25 3h11.5zm0 1.5H6.25c-.97 0-1.75.78-1.75 1.75V7h15v-.75c0-.97-.78-1.75-1.75-1.75zm5.25 13a5.5 5.5 0 11-11 0 5.5 5.5 0 0111 0zM17.5 14a.5.5 0 00-.5.5v4a.5.5 0 001 0v-4a.5.5 0 00-.5-.5zm0 7.13a.62.62 0 100-1.25.62.62 0 000 1.25z",
    fill: primaryFill
  }));
};

export const CalendarError24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarError24RegularIcon, 'CalendarError24Regular');

const CalendarInfo16FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6.26 14H4.5A2.5 2.5 0 012 11.5V6h5.34a5.5 5.5 0 00-1.08 8zM14 5v-.5A2.5 2.5 0 0011.5 2h-7A2.5 2.5 0 002 4.5V5h12zM9.87 8.5a.62.62 0 111.25 0 .62.62 0 01-1.24 0zm1.13 4a.5.5 0 01-1 0v-2a.5.5 0 011 0v2zm-5-2a4.5 4.5 0 119 0 4.5 4.5 0 01-9 0zm1 0a3.5 3.5 0 107 0 3.5 3.5 0 00-7 0z",
    fill: primaryFill
  }));
};

export const CalendarInfo16Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarInfo16FilledIcon, 'CalendarInfo16Filled');

const CalendarInfo16RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M14 4.5A2.5 2.5 0 0011.5 2h-7A2.5 2.5 0 002 4.5v7A2.5 2.5 0 004.5 14h1.76a5.5 5.5 0 01-.66-1H4.5A1.5 1.5 0 013 11.5V6h4.34a5.47 5.47 0 016.66.26V4.5zm-3.5.5H3v-.5C3 3.67 3.67 3 4.5 3h7c.83 0 1.5.67 1.5 1.5V5h-2.5zm-.63 3.5a.62.62 0 111.25 0 .62.62 0 01-1.24 0zm1.13 4a.5.5 0 01-1 0v-2a.5.5 0 011 0v2zm-5-2a4.5 4.5 0 119 0 4.5 4.5 0 01-9 0zm1 0a3.5 3.5 0 107 0 3.5 3.5 0 00-7 0z",
    fill: primaryFill
  }));
};

export const CalendarInfo16Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarInfo16RegularIcon, 'CalendarInfo16Regular');

const CalendarInfo20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M17 7v2.6A5.5 5.5 0 009.6 17H5.5A2.5 2.5 0 013 14.5V7h14zm-2.5-4A2.5 2.5 0 0117 5.5V6H3v-.5A2.5 2.5 0 015.5 3h9zm-.63 9.5a.62.62 0 111.25 0 .62.62 0 01-1.24 0zm1.13 4a.5.5 0 01-1 0v-2a.5.5 0 011 0v2zm-5-2a4.5 4.5 0 119 0 4.5 4.5 0 01-9 0zm1 0a3.5 3.5 0 107 0 3.5 3.5 0 00-7 0z",
    fill: primaryFill
  }));
};

export const CalendarInfo20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarInfo20FilledIcon, 'CalendarInfo20Filled');

const CalendarInfo20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M14.5 3A2.5 2.5 0 0117 5.5v4.1c-.32-.16-.65-.3-1-.4V7H4v7.5c0 .83.67 1.5 1.5 1.5h3.7c.1.35.24.68.4 1H5.5A2.5 2.5 0 013 14.5v-9A2.5 2.5 0 015.5 3h9zm0 1h-9C4.67 4 4 4.67 4 5.5V6h12v-.5c0-.83-.67-1.5-1.5-1.5zm-.63 8.5a.62.62 0 111.25 0 .62.62 0 01-1.24 0zm1.13 4a.5.5 0 01-1 0v-2a.5.5 0 011 0v2zm-5-2a4.5 4.5 0 119 0 4.5 4.5 0 01-9 0zm1 0a3.5 3.5 0 107 0 3.5 3.5 0 00-7 0z",
    fill: primaryFill
  }));
};

export const CalendarInfo20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarInfo20RegularIcon, 'CalendarInfo20Regular');

const CalendarLtr12FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M1.05 3A2.5 2.5 0 013.5 1h5c1.2 0 2.22.86 2.45 2h-9.9zM1 4v4.5A2.5 2.5 0 003.5 11h5A2.5 2.5 0 0011 8.5V4H1zm2 1.5a.5.5 0 111 0 .5.5 0 01-1 0zm0 2a.5.5 0 111 0 .5.5 0 01-1 0zM5.5 5a.5.5 0 110 1 .5.5 0 010-1zM5 7.5a.5.5 0 111 0 .5.5 0 01-1 0zM7.5 5a.5.5 0 110 1 .5.5 0 010-1z",
    fill: primaryFill
  }));
};

export const CalendarLtr12Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarLtr12FilledIcon, 'CalendarLtr12Filled');

const CalendarLtr12RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3 5.5a.5.5 0 111 0 .5.5 0 01-1 0zM3.5 7a.5.5 0 100 1 .5.5 0 000-1zM5 5.5a.5.5 0 111 0 .5.5 0 01-1 0zM5.5 7a.5.5 0 100 1 .5.5 0 000-1zM7 5.5a.5.5 0 111 0 .5.5 0 01-1 0zm-6-2A2.5 2.5 0 013.5 1h5A2.5 2.5 0 0111 3.5v5A2.5 2.5 0 018.5 11h-5A2.5 2.5 0 011 8.5v-5zM3.5 2c-.65 0-1.2.42-1.41 1H9.9c-.2-.58-.76-1-1.41-1h-5zM10 4H2v4.5c0 .83.67 1.5 1.5 1.5h5c.83 0 1.5-.67 1.5-1.5V4z",
    fill: primaryFill
  }));
};

export const CalendarLtr12Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarLtr12RegularIcon, 'CalendarLtr12Regular');

const CalendarLtr16FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M14 11.5V6H2v5.5A2.5 2.5 0 004.5 14h7a2.5 2.5 0 002.5-2.5zM6 8.25a.75.75 0 11-1.5 0 .75.75 0 011.5 0zm0 2.5a.75.75 0 11-1.5 0 .75.75 0 011.5 0zm2.75-2.5a.75.75 0 11-1.5 0 .75.75 0 011.5 0zm0 2.5a.75.75 0 11-1.5 0 .75.75 0 011.5 0zm2.75-2.5a.75.75 0 11-1.5 0 .75.75 0 011.5 0zM14 4.5A2.5 2.5 0 0011.5 2h-7A2.5 2.5 0 002 4.5V5h12v-.5z",
    fill: primaryFill
  }));
};

export const CalendarLtr16Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarLtr16FilledIcon, 'CalendarLtr16Filled');

const CalendarLtr16RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5.25 9a.75.75 0 100-1.5.75.75 0 000 1.5zM6 10.75a.75.75 0 11-1.5 0 .75.75 0 011.5 0zM8 9a.75.75 0 100-1.5A.75.75 0 008 9zm.75 1.75a.75.75 0 11-1.5 0 .75.75 0 011.5 0zm2-1.75a.75.75 0 100-1.5.75.75 0 000 1.5zM14 4.5A2.5 2.5 0 0011.5 2h-7A2.5 2.5 0 002 4.5v7A2.5 2.5 0 004.5 14h7a2.5 2.5 0 002.5-2.5v-7zM3 6h10v5.5c0 .83-.67 1.5-1.5 1.5h-7A1.5 1.5 0 013 11.5V6zm1.5-3h7c.83 0 1.5.67 1.5 1.5V5H3v-.5C3 3.67 3.67 3 4.5 3z",
    fill: primaryFill
  }));
};

export const CalendarLtr16Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarLtr16RegularIcon, 'CalendarLtr16Regular');

const CalendarLtr20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5.5 3A2.5 2.5 0 003 5.5V6h14v-.5A2.5 2.5 0 0014.5 3h-9zM17 7H3v7.5A2.5 2.5 0 005.5 17h9a2.5 2.5 0 002.5-2.5V7zm-9 3a1 1 0 11-2 0 1 1 0 012 0zm-1 4a1 1 0 110-2 1 1 0 010 2zm4-4a1 1 0 11-2 0 1 1 0 012 0zm-1 4a1 1 0 110-2 1 1 0 010 2zm4-4a1 1 0 11-2 0 1 1 0 012 0z",
    fill: primaryFill
  }));
};

export const CalendarLtr20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarLtr20FilledIcon, 'CalendarLtr20Filled');

const CalendarLtr20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M7 11a1 1 0 100-2 1 1 0 000 2zm1 2a1 1 0 11-2 0 1 1 0 012 0zm2-2a1 1 0 100-2 1 1 0 000 2zm1 2a1 1 0 11-2 0 1 1 0 012 0zm2-2a1 1 0 100-2 1 1 0 000 2zm4-5.5A2.5 2.5 0 0014.5 3h-9A2.5 2.5 0 003 5.5v9A2.5 2.5 0 005.5 17h9a2.5 2.5 0 002.5-2.5v-9zM4 7h12v7.5c0 .83-.67 1.5-1.5 1.5h-9A1.5 1.5 0 014 14.5V7zm1.5-3h9c.83 0 1.5.67 1.5 1.5V6H4v-.5C4 4.67 4.67 4 5.5 4z",
    fill: primaryFill
  }));
};

export const CalendarLtr20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarLtr20RegularIcon, 'CalendarLtr20Regular');

const CalendarLtr24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M21 8.5v9.25c0 1.8-1.46 3.25-3.25 3.25H6.25A3.25 3.25 0 013 17.75V8.5h18zM7.25 15a1.25 1.25 0 100 2.5 1.25 1.25 0 000-2.5zM12 15a1.25 1.25 0 100 2.5 1.25 1.25 0 000-2.5zm-4.75-4.5a1.25 1.25 0 100 2.5 1.25 1.25 0 000-2.5zm4.75 0a1.25 1.25 0 100 2.5 1.25 1.25 0 000-2.5zm4.75 0a1.25 1.25 0 100 2.5 1.25 1.25 0 000-2.5zm1-7.5C19.55 3 21 4.46 21 6.25V7H3v-.75C3 4.45 4.46 3 6.25 3h11.5z",
    fill: primaryFill
  }));
};

export const CalendarLtr24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarLtr24FilledIcon, 'CalendarLtr24Filled');

const CalendarLtr24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M17.75 3C19.55 3 21 4.46 21 6.25v11.5c0 1.8-1.46 3.25-3.25 3.25H6.25A3.25 3.25 0 013 17.75V6.25C3 4.45 4.46 3 6.25 3h11.5zm1.75 5.5h-15v9.25c0 .97.78 1.75 1.75 1.75h11.5c.97 0 1.75-.78 1.75-1.75V8.5zm-11.75 6a1.25 1.25 0 110 2.5 1.25 1.25 0 010-2.5zm4.25 0a1.25 1.25 0 110 2.5 1.25 1.25 0 010-2.5zm-4.25-4a1.25 1.25 0 110 2.5 1.25 1.25 0 010-2.5zm4.25 0a1.25 1.25 0 110 2.5 1.25 1.25 0 010-2.5zm4.25 0a1.25 1.25 0 110 2.5 1.25 1.25 0 010-2.5zm1.5-6H6.25c-.97 0-1.75.78-1.75 1.75V7h15v-.75c0-.97-.78-1.75-1.75-1.75z",
    fill: primaryFill
  }));
};

export const CalendarLtr24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarLtr24RegularIcon, 'CalendarLtr24Regular');

const CalendarLtr28FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M25 9.5v12.25c0 1.8-1.46 3.25-3.25 3.25H6.25A3.25 3.25 0 013 21.75V9.5h22zm-16.26 8a1.25 1.25 0 100 2.5 1.25 1.25 0 000-2.5zm5.26 0a1.25 1.25 0 100 2.5 1.25 1.25 0 000-2.5zm-5.26-5a1.25 1.25 0 100 2.5 1.25 1.25 0 000-2.5zm5.26 0a1.25 1.25 0 100 2.5 1.25 1.25 0 000-2.5zm5.25 0a1.25 1.25 0 100 2.5 1.25 1.25 0 000-2.5zm2.5-9.5C23.55 3 25 4.46 25 6.25V8H3V6.25C3 4.45 4.46 3 6.25 3h15.5z",
    fill: primaryFill
  }));
};

export const CalendarLtr28Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarLtr28FilledIcon, 'CalendarLtr28Filled');

const CalendarLtr28RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M21.75 3C23.55 3 25 4.46 25 6.25v15.5c0 1.8-1.46 3.25-3.25 3.25H6.25A3.25 3.25 0 013 21.75V6.25C3 4.45 4.46 3 6.25 3h15.5zm1.75 6.5h-19v12.25c0 .97.78 1.75 1.75 1.75h15.5c.97 0 1.75-.78 1.75-1.75V9.5zm-14.75 8a1.25 1.25 0 110 2.5 1.25 1.25 0 010-2.5zm5.25 0a1.25 1.25 0 110 2.5 1.25 1.25 0 010-2.5zm-5.25-5a1.25 1.25 0 110 2.5 1.25 1.25 0 010-2.5zm5.25 0a1.25 1.25 0 110 2.5 1.25 1.25 0 010-2.5zm5.26 0a1.25 1.25 0 110 2.5 1.25 1.25 0 010-2.5zm2.49-8H6.25c-.97 0-1.75.78-1.75 1.75V8h19V6.25c0-.97-.78-1.75-1.75-1.75z",
    fill: primaryFill
  }));
};

export const CalendarLtr28Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarLtr28RegularIcon, 'CalendarLtr28Regular');

const CalendarLtr32FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M9 4a5 5 0 00-5 5v1h24V9a5 5 0 00-5-5H9zM4 23V12h24v11a5 5 0 01-5 5H9a5 5 0 01-5-5zm6.5-5a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm1.5 3.5a1.5 1.5 0 10-3 0 1.5 1.5 0 003 0zm4 1.5a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm1.5-6.5a1.5 1.5 0 10-3 0 1.5 1.5 0 003 0zm4 1.5a1.5 1.5 0 100-3 1.5 1.5 0 000 3z",
    fill: primaryFill
  }));
};

export const CalendarLtr32Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarLtr32FilledIcon, 'CalendarLtr32Filled');

const CalendarLtr32RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10.5 18a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm1.5 3.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zm4 1.5a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm1.5-6.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zm4 1.5a1.5 1.5 0 100-3 1.5 1.5 0 000 3zM4 9a5 5 0 015-5h14a5 5 0 015 5v14a5 5 0 01-5 5H9a5 5 0 01-5-5V9zm5-3a3 3 0 00-3 3v1h20V9a3 3 0 00-3-3H9zM6 23a3 3 0 003 3h14a3 3 0 003-3V12H6v11z",
    fill: primaryFill
  }));
};

export const CalendarLtr32Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarLtr32RegularIcon, 'CalendarLtr32Regular');

const CalendarLtr48FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6 12.25C6 8.8 8.8 6 12.25 6h23.5C39.2 6 42 8.8 42 12.25V14H6v-1.75zm0 4.25v19.25C6 39.2 8.8 42 12.25 42h23.5C39.2 42 42 39.2 42 35.75V16.5H6zm12 7a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0zm6 2.5a2.5 2.5 0 110-5 2.5 2.5 0 010 5zm11-2.5a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0zM15.5 34a2.5 2.5 0 110-5 2.5 2.5 0 010 5zm11-2.5a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0z",
    fill: primaryFill
  }));
};

export const CalendarLtr48Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarLtr48FilledIcon, 'CalendarLtr48Filled');

const CalendarLtr48RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M15.5 26a2.5 2.5 0 100-5 2.5 2.5 0 000 5zm11-2.5a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0zm6 2.5a2.5 2.5 0 100-5 2.5 2.5 0 000 5zM18 31.5a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0zm6 2.5a2.5 2.5 0 100-5 2.5 2.5 0 000 5zM6 12.25C6 8.8 8.8 6 12.25 6h23.5C39.2 6 42 8.8 42 12.25v23.5C42 39.2 39.2 42 35.75 42h-23.5A6.25 6.25 0 016 35.75v-23.5zm6.25-3.75a3.75 3.75 0 00-3.75 3.75V14h31v-1.75a3.75 3.75 0 00-3.75-3.75h-23.5zM8.5 35.75a3.75 3.75 0 003.75 3.75h23.5a3.75 3.75 0 003.75-3.75V16.5h-31v19.25z",
    fill: primaryFill
  }));
};

export const CalendarLtr48Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarLtr48RegularIcon, 'CalendarLtr48Regular');

const CalendarMail16FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M1.05 3h9.9A2.5 2.5 0 008.5 1h-5a2.5 2.5 0 00-2.45 2zM11 4H1v4.5A2.5 2.5 0 003.5 11H4V8.5A2.5 2.5 0 016.5 6H11V4zm-1.22 7.95L5 9.55v3.95c0 .83.67 1.5 1.5 1.5h7c.83 0 1.5-.67 1.5-1.5V9.56l-4.78 2.39a.5.5 0 01-.44 0zM6.5 7c-.8 0-1.47.64-1.5 1.44l5 2.5 5-2.5A1.5 1.5 0 0013.5 7h-7z",
    fill: primaryFill
  }));
};

export const CalendarMail16Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarMail16FilledIcon, 'CalendarMail16Filled');

const CalendarMail16RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M1 3.5A2.5 2.5 0 013.5 1h5A2.5 2.5 0 0111 3.5V6h-1V4H2v4.5c0 .83.67 1.5 1.5 1.5H4v1h-.5A2.5 2.5 0 011 8.5v-5zM3.5 2c-.65 0-1.2.42-1.41 1H9.9c-.2-.58-.76-1-1.41-1h-5zM5 8.5C5 7.67 5.67 7 6.5 7h7c.83 0 1.5.67 1.5 1.5v5c0 .83-.67 1.5-1.5 1.5h-7A1.5 1.5 0 015 13.5v-5zM6.5 8a.5.5 0 00-.5.5v.44l4 2 4-2V8.5a.5.5 0 00-.5-.5h-7zM6 13.5c0 .28.22.5.5.5h7a.5.5 0 00.5-.5v-3.44l-3.78 1.89a.5.5 0 01-.44 0L6 10.05v3.45z",
    fill: primaryFill
  }));
};

export const CalendarMail16Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarMail16RegularIcon, 'CalendarMail16Regular');

const CalendarMail20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4.5 2A2.5 2.5 0 002 4.5V5h12v-.5A2.5 2.5 0 0011.5 2h-7zM14 6H2v5.5A2.5 2.5 0 004.5 14H5v-3a3 3 0 013-3h6V6zm-7.93 4.48A2 2 0 018 9h8a2 2 0 011.93 1.48L12 13.96l-5.93-3.48zm6.31 4.42L18 11.6V16a2 2 0 01-2 2H8a2 2 0 01-2-2v-4.4l5.62 3.3c.23.14.53.14.76 0z",
    fill: primaryFill
  }));
};

export const CalendarMail20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarMail20FilledIcon, 'CalendarMail20Filled');

const CalendarMail20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2 4.5A2.5 2.5 0 014.5 2h7A2.5 2.5 0 0114 4.5V8h-1V6H3v5.5c0 .83.67 1.5 1.5 1.5H5v1h-.5A2.5 2.5 0 012 11.5v-7zm11 0c0-.83-.67-1.5-1.5-1.5h-7C3.67 3 3 3.67 3 4.5V5h10v-.5zM8 9a2 2 0 00-2 2v5c0 1.1.9 2 2 2h8a2 2 0 002-2v-5a2 2 0 00-2-2H8zm-1 2a1 1 0 011-1h8a1 1 0 011 1v.02l-5 2.94-5-2.94V11zm0 1.18l4.62 2.72c.23.14.53.14.76 0L17 12.18V16a1 1 0 01-1 1H8a1 1 0 01-1-1v-3.82z",
    fill: primaryFill
  }));
};

export const CalendarMail20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarMail20RegularIcon, 'CalendarMail20Regular');

const CalendarMention20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M17 7v3.42A4.98 4.98 0 0010 15c0 .71.15 1.39.42 2H5.5A2.5 2.5 0 013 14.5V7h14zm-2.5-4A2.5 2.5 0 0117 5.5V6H3v-.5A2.5 2.5 0 015.5 3h9zm.5 9a3 3 0 101.28 5.71.5.5 0 11.44.9A4 4 0 1119 15v.51a1.5 1.5 0 01-2.65.97A2 2 0 0113 15a2 2 0 013.17-1.62.5.5 0 01.83.37v1.75a.5.5 0 101 0V15a3 3 0 00-3-3zm-1 3a1 1 0 102 0 1 1 0 00-2 0z",
    fill: primaryFill
  }));
};

export const CalendarMention20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarMention20FilledIcon, 'CalendarMention20Filled');

const CalendarMention20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M14.5 3A2.5 2.5 0 0117 5.5v4.92a4.96 4.96 0 00-1-.32V7H4v7.5c0 .83.67 1.5 1.5 1.5h4.6c.07.35.18.68.32 1H5.5A2.5 2.5 0 013 14.5v-9A2.5 2.5 0 015.5 3h9zm0 1h-9C4.67 4 4 4.67 4 5.5V6h12v-.5c0-.83-.67-1.5-1.5-1.5zm.5 8a3 3 0 101.28 5.71.5.5 0 11.44.9A4 4 0 1119 15v.51a1.5 1.5 0 01-2.65.97A2 2 0 0113 15a2 2 0 013.17-1.62.5.5 0 01.83.37v1.75a.5.5 0 101 0V15a3 3 0 00-3-3zm-1 3a1 1 0 102 0 1 1 0 00-2 0z",
    fill: primaryFill
  }));
};

export const CalendarMention20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarMention20RegularIcon, 'CalendarMention20Regular');

const CalendarMonth20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M14.5 3A2.5 2.5 0 0117 5.5v9a2.5 2.5 0 01-2.5 2.5h-9A2.5 2.5 0 013 14.5v-9A2.5 2.5 0 015.5 3h9zM7 11a1 1 0 100 2 1 1 0 000-2zm3 0a1 1 0 100 2 1 1 0 000-2zM7 7a1 1 0 100 2 1 1 0 000-2zm3 0a1 1 0 100 2 1 1 0 000-2zm3 0a1 1 0 100 2 1 1 0 000-2z",
    fill: primaryFill
  }));
};

export const CalendarMonth20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarMonth20FilledIcon, 'CalendarMonth20Filled');

const CalendarMonth20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M14.5 3A2.5 2.5 0 0117 5.5v9a2.5 2.5 0 01-2.5 2.5h-9A2.5 2.5 0 013 14.5v-9A2.5 2.5 0 015.5 3h9zm0 1h-9C4.67 4 4 4.67 4 5.5v9c0 .83.67 1.5 1.5 1.5h9c.83 0 1.5-.67 1.5-1.5v-9c0-.83-.67-1.5-1.5-1.5zM7 11a1 1 0 110 2 1 1 0 010-2zm3 0a1 1 0 110 2 1 1 0 010-2zM7 7a1 1 0 110 2 1 1 0 010-2zm3 0a1 1 0 110 2 1 1 0 010-2zm3 0a1 1 0 110 2 1 1 0 010-2z",
    fill: primaryFill
  }));
};

export const CalendarMonth20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarMonth20RegularIcon, 'CalendarMonth20Regular');

const CalendarMonth24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M17.75 3C19.55 3 21 4.46 21 6.25v11.5c0 1.8-1.46 3.25-3.25 3.25H6.25A3.25 3.25 0 013 17.75V6.25C3 4.45 4.46 3 6.25 3h11.5zm-10 10.5a1.25 1.25 0 100 2.5 1.25 1.25 0 000-2.5zm4.25 0a1.25 1.25 0 100 2.5 1.25 1.25 0 000-2.5zm-4.25-5a1.25 1.25 0 100 2.5 1.25 1.25 0 000-2.5zm4.25 0a1.25 1.25 0 100 2.5 1.25 1.25 0 000-2.5zm4.25 0a1.25 1.25 0 100 2.5 1.25 1.25 0 000-2.5z",
    fill: primaryFill
  }));
};

export const CalendarMonth24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarMonth24FilledIcon, 'CalendarMonth24Filled');

const CalendarMonth24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M17.75 3C19.55 3 21 4.46 21 6.25v11.5c0 1.8-1.46 3.25-3.25 3.25H6.25A3.25 3.25 0 013 17.75V6.25C3 4.45 4.46 3 6.25 3h11.5zm0 1.5H6.25c-.97 0-1.75.78-1.75 1.75v11.5c0 .97.78 1.75 1.75 1.75h11.5c.97 0 1.75-.78 1.75-1.75V6.25c0-.97-.78-1.75-1.75-1.75zm-10 9a1.25 1.25 0 110 2.5 1.25 1.25 0 010-2.5zm4.25 0a1.25 1.25 0 110 2.5 1.25 1.25 0 010-2.5zm-4.25-5a1.25 1.25 0 110 2.5 1.25 1.25 0 010-2.5zm4.25 0a1.25 1.25 0 110 2.5 1.25 1.25 0 010-2.5zm4.25 0a1.25 1.25 0 110 2.5 1.25 1.25 0 010-2.5z",
    fill: primaryFill
  }));
};

export const CalendarMonth24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarMonth24RegularIcon, 'CalendarMonth24Regular');

const CalendarMonth28FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M21.75 3C23.55 3 25 4.46 25 6.25v15.5c0 1.8-1.46 3.25-3.25 3.25H6.25A3.25 3.25 0 013 21.75V6.25C3 4.45 4.46 3 6.25 3h15.5zM8.5 15.5a1.5 1.5 0 100 3 1.5 1.5 0 000-3zm5.5 0a1.5 1.5 0 100 3 1.5 1.5 0 000-3zm-5.5-6a1.5 1.5 0 100 3 1.5 1.5 0 000-3zm5.5 0a1.5 1.5 0 100 3 1.5 1.5 0 000-3zm5.5 0a1.5 1.5 0 100 3 1.5 1.5 0 000-3z",
    fill: primaryFill
  }));
};

export const CalendarMonth28Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarMonth28FilledIcon, 'CalendarMonth28Filled');

const CalendarMonth28RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M21.75 3C23.55 3 25 4.46 25 6.25v15.5c0 1.8-1.46 3.25-3.25 3.25H6.25A3.25 3.25 0 013 21.75V6.25C3 4.45 4.46 3 6.25 3h15.5zm0 1.5H6.25c-.97 0-1.75.78-1.75 1.75v15.5c0 .97.78 1.75 1.75 1.75h15.5c.97 0 1.75-.78 1.75-1.75V6.25c0-.97-.78-1.75-1.75-1.75zM8.5 15.5a1.5 1.5 0 110 3 1.5 1.5 0 010-3zm5.5 0a1.5 1.5 0 110 3 1.5 1.5 0 010-3zm-5.5-6a1.5 1.5 0 110 3 1.5 1.5 0 010-3zm5.5 0a1.5 1.5 0 110 3 1.5 1.5 0 010-3zm5.5 0a1.5 1.5 0 110 3 1.5 1.5 0 010-3z",
    fill: primaryFill
  }));
};

export const CalendarMonth28Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarMonth28RegularIcon, 'CalendarMonth28Regular');

const CalendarMonth32FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3 7.5A4.5 4.5 0 017.5 3h17A4.5 4.5 0 0129 7.5v17a4.5 4.5 0 01-4.5 4.5h-17A4.5 4.5 0 013 24.5v-17zm9 5a1.5 1.5 0 10-3 0 1.5 1.5 0 003 0zM10.5 20a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm5.5 0a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm0-6a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm5.5 0a1.5 1.5 0 100-3 1.5 1.5 0 000 3z",
    fill: primaryFill
  }));
};

export const CalendarMonth32Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarMonth32FilledIcon, 'CalendarMonth32Filled');

const CalendarMonth32RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M12 12.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zM10.5 20a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm5.5 0a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm0-6a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm5.5 0a1.5 1.5 0 100-3 1.5 1.5 0 000 3zM7.5 3A4.5 4.5 0 003 7.5v17A4.5 4.5 0 007.5 29h17a4.5 4.5 0 004.5-4.5v-17A4.5 4.5 0 0024.5 3h-17zM5 7.5A2.5 2.5 0 017.5 5h17A2.5 2.5 0 0127 7.5v17a2.5 2.5 0 01-2.5 2.5h-17A2.5 2.5 0 015 24.5v-17z",
    fill: primaryFill
  }));
};

export const CalendarMonth32Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarMonth32RegularIcon, 'CalendarMonth32Regular');

const CalendarMultiple16FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2.05 4A2.5 2.5 0 014.5 2h5a2.5 2.5 0 012.45 2h-9.9zM2 5v4.5A2.5 2.5 0 004.5 12h5A2.5 2.5 0 0012 9.5V5H2zm4.5 9a2.5 2.5 0 01-2-1h5.25c1.8 0 3.25-1.46 3.25-3.25V4.5c.6.46 1 1.18 1 2v3.25C14 12.1 12.1 14 9.75 14H6.5z",
    fill: primaryFill
  }));
};

export const CalendarMultiple16Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarMultiple16FilledIcon, 'CalendarMultiple16Filled');

const CalendarMultiple16RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4.5 2A2.5 2.5 0 002 4.5v5A2.5 2.5 0 004.5 12h5A2.5 2.5 0 0012 9.5v-5A2.5 2.5 0 009.5 2h-5zM3.09 4c.2-.58.76-1 1.41-1h5c.65 0 1.2.42 1.41 1H3.1zM3 5h8v4.5c0 .83-.67 1.5-1.5 1.5h-5A1.5 1.5 0 013 9.5V5zm3.5 9a2.5 2.5 0 01-2-1h5.25c1.8 0 3.25-1.46 3.25-3.25V4.5c.6.46 1 1.18 1 2v3.25C14 12.1 12.1 14 9.75 14H6.5z",
    fill: primaryFill
  }));
};

export const CalendarMultiple16Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarMultiple16RegularIcon, 'CalendarMultiple16Regular');

const CalendarMultiple20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M16 13.5V6H2v7.5A2.5 2.5 0 004.5 16h9a2.5 2.5 0 002.5-2.5zm0-9A2.5 2.5 0 0013.5 2h-9A2.5 2.5 0 002 4.5V5h14v-.5zM5 17c.46.6 1.18 1 2 1h6.5a4.5 4.5 0 004.5-4.5v-7c0-.82-.4-1.54-1-2v9a3.5 3.5 0 01-3.5 3.5H5z",
    fill: primaryFill
  }));
};

export const CalendarMultiple20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarMultiple20FilledIcon, 'CalendarMultiple20Filled');

const CalendarMultiple20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M16 4.5A2.5 2.5 0 0013.5 2h-9A2.5 2.5 0 002 4.5v9A2.5 2.5 0 004.5 16h9a2.5 2.5 0 002.5-2.5v-9zM3 6h12v7.5c0 .83-.67 1.5-1.5 1.5h-9A1.5 1.5 0 013 13.5V6zm1.5-3h9c.83 0 1.5.67 1.5 1.5V5H3v-.5C3 3.67 3.67 3 4.5 3zM5 17c.46.6 1.18 1 2 1h6.5a4.5 4.5 0 004.5-4.5v-7c0-.82-.4-1.54-1-2v9a3.5 3.5 0 01-3.5 3.5H5z",
    fill: primaryFill
  }));
};

export const CalendarMultiple20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarMultiple20RegularIcon, 'CalendarMultiple20Regular');

const CalendarMultiple24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M20 5v11.35A3.65 3.65 0 0116.35 20H5.01c.57.9 1.59 1.5 2.74 1.5h8.6c2.84 0 5.15-2.3 5.15-5.15v-8.6c0-1.15-.6-2.17-1.5-2.74zM2 7.5v8.25C2 17.55 3.46 19 5.25 19h10.5c1.8 0 3.25-1.46 3.25-3.25V7.5H2zM5.25 2A3.25 3.25 0 002 5.25V6h17v-.75C19 3.45 17.54 2 15.75 2H5.25z",
    fill: primaryFill
  }));
};

export const CalendarMultiple24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarMultiple24FilledIcon, 'CalendarMultiple24Filled');

const CalendarMultiple24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M20 5v11.35A3.65 3.65 0 0116.35 20H5.01c.57.9 1.59 1.5 2.74 1.5h8.6c2.84 0 5.15-2.3 5.15-5.15v-8.6c0-1.15-.6-2.17-1.5-2.74zM5.24 2A3.25 3.25 0 002 5.25v10.5C2 17.55 3.46 19 5.25 19h10.5c1.8 0 3.25-1.46 3.25-3.25V5.25C19 3.45 17.54 2 15.75 2H5.25zM3.5 7.5h14v8.25c0 .97-.78 1.75-1.75 1.75H5.25c-.97 0-1.75-.78-1.75-1.75V7.5zm1.75-4h10.5c.97 0 1.75.78 1.75 1.75V6h-14v-.75c0-.97.78-1.75 1.75-1.75z",
    fill: primaryFill
  }));
};

export const CalendarMultiple24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarMultiple24RegularIcon, 'CalendarMultiple24Regular');

const CalendarMultiple28FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6 24c.59.9 1.6 1.5 2.75 1.5h11.5c2.9 0 5.25-2.35 5.25-5.25V8.75c0-1.15-.6-2.16-1.5-2.74v14.24A3.75 3.75 0 0120.25 24H19 6zM3 6.25C3 4.45 4.46 3 6.25 3h13.5C21.55 3 23 4.46 23 6.25V7H3v-.75zM3 8.5v11.25C3 21.55 4.46 23 6.25 23h13.5c1.8 0 3.25-1.46 3.25-3.25V8.5H3z",
    fill: primaryFill
  }));
};

export const CalendarMultiple28Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarMultiple28FilledIcon, 'CalendarMultiple28Filled');

const CalendarMultiple28RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6.25 3A3.25 3.25 0 003 6.25v13.5C3 21.55 4.46 23 6.25 23h13.5c1.8 0 3.25-1.46 3.25-3.25V6.25C23 4.45 21.54 3 19.75 3H6.25zM4.5 6.25c0-.97.78-1.75 1.75-1.75h13.5c.97 0 1.75.78 1.75 1.75V7h-17v-.75zm0 2.25h17v11.25c0 .97-.78 1.75-1.75 1.75H6.25c-.97 0-1.75-.78-1.75-1.75V8.5zm4.25 17C7.6 25.5 6.59 24.9 6 24h14.24A3.75 3.75 0 0024 20.25v-1.07V6c.9.58 1.5 1.6 1.5 2.74v11.5c0 2.9-2.35 5.25-5.25 5.25H8.75z",
    fill: primaryFill
  }));
};

export const CalendarMultiple28Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarMultiple28RegularIcon, 'CalendarMultiple28Regular');

const CalendarMultiple32FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6.5 2A4.5 4.5 0 002 6.5V7h24v-.5A4.5 4.5 0 0021.5 2h-15zM2 21.5V9h24v12.5a4.5 4.5 0 01-4.5 4.5h-15A4.5 4.5 0 012 21.5zm26-12V5.76c1.2.8 2 2.18 2 3.74V22a8 8 0 01-8 8H9.5a4.5 4.5 0 01-3.74-2H22a6 6 0 006-6V9.5z",
    fill: primaryFill
  }));
};

export const CalendarMultiple32Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarMultiple32FilledIcon, 'CalendarMultiple32Filled');

const CalendarMultiple32RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2 6.5A4.5 4.5 0 016.5 2h15A4.5 4.5 0 0126 6.5v15a4.5 4.5 0 01-4.5 4.5h-15A4.5 4.5 0 012 21.5v-15zM6.5 4A2.5 2.5 0 004 6.5V7h20v-.5A2.5 2.5 0 0021.5 4h-15zM4 21.5A2.5 2.5 0 006.5 24h15a2.5 2.5 0 002.5-2.5V9H4v12.5zm24-12V5.75c1.2.81 2 2.19 2 3.75V22a8 8 0 01-8 8H9.5a4.5 4.5 0 01-3.74-2H22a6 6 0 006-6V9.5z",
    fill: primaryFill
  }));
};

export const CalendarMultiple32Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarMultiple32RegularIcon, 'CalendarMultiple32Regular');

const CalendarPattern16FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4.75 2A2.75 2.75 0 002 4.75v6.5A2.75 2.75 0 004.75 14h6.5A2.75 2.75 0 0014 11.25v-6.5A2.75 2.75 0 0011.25 2h-6.5zM3.5 4.75c0-.69.56-1.25 1.25-1.25h6.5c.69 0 1.25.56 1.25 1.25V6h-9V4.75zM11.7 7h.8v.8L10.3 10H8.7l3-3zm-1.4 0l-3 3H5.7l3-3h1.6zm-6 3h-.8v-.8L5.7 7h1.6l-3 3zm-.8-2.2V7h.8l-.8.8zm8.2 2.2l.8-.8v.8h-.8z",
    fill: primaryFill
  }));
};

export const CalendarPattern16Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarPattern16FilledIcon, 'CalendarPattern16Filled');

const CalendarPattern16RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4.5 2A2.5 2.5 0 002 4.5v7A2.5 2.5 0 004.5 14h7a2.5 2.5 0 002.5-2.5v-7A2.5 2.5 0 0011.5 2h-7zM3 4.5C3 3.67 3.67 3 4.5 3h7c.83 0 1.5.67 1.5 1.5V6H3V4.5zM11.7 7H13v.3L10.3 10H8.7l3-3zm-1.4 0l-3 3H5.7l3-3h1.6zm-6 3H3v-.3L5.7 7h1.6l-3 3zM3 8.3V7h1.3L3 8.3zm8.7 1.7L13 8.7V10h-1.3z",
    fill: primaryFill
  }));
};

export const CalendarPattern16Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarPattern16RegularIcon, 'CalendarPattern16Regular');

const CalendarPattern20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5.75 3h8.5A2.75 2.75 0 0117 5.75v8.5A2.75 2.75 0 0114.25 17h-8.5A2.75 2.75 0 013 14.25v-8.5A2.75 2.75 0 015.75 3zM4.5 5.75V7h11V5.75c0-.69-.56-1.25-1.25-1.25h-8.5c-.69 0-1.25.56-1.25 1.25zM14.7 8l-4 4h2.6l2.2-2.2V8h-.8zm-1.4 0h-2.6l-4 4h2.6l4-4zm-8 4l4-4H6.7l-2.2 2.2V12h.8zm-.8-3.2l.8-.8h-.8v.8zM14.7 12h.8v-.8l-.8.8z",
    fill: primaryFill
  }));
};

export const CalendarPattern20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarPattern20FilledIcon, 'CalendarPattern20Filled');

const CalendarPattern20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5.5 3h9A2.5 2.5 0 0117 5.5v9a2.5 2.5 0 01-2.5 2.5h-9A2.5 2.5 0 013 14.5v-9A2.5 2.5 0 015.5 3zM4 5.5V7h12V5.5c0-.83-.67-1.5-1.5-1.5h-9C4.67 4 4 4.67 4 5.5zM14.7 8l-4 4h2.6L16 9.3V8h-1.3zm-1.4 0h-2.6l-4 4h2.6l4-4zm-8 4l4-4H6.7L4 10.7V12h1.3zM4 9.3L5.3 8H4v1.3zM14.7 12H16v-1.3L14.7 12z",
    fill: primaryFill
  }));
};

export const CalendarPattern20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarPattern20RegularIcon, 'CalendarPattern20Regular');

const CalendarPerson16FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M7.37 14H4.5A2.5 2.5 0 012 11.5V6h7.26a2.99 2.99 0 00.01 4.01A2.5 2.5 0 007 12.5c0 .51.12 1.03.37 1.5zM14 5v-.5A2.5 2.5 0 0011.5 2h-7A2.5 2.5 0 002 4.5V5h12zm-.5 3a2 2 0 11-4 0 2 2 0 014 0zm1.5 4.5c0 1.25-1 2.5-3.5 2.5S8 13.75 8 12.5c0-.83.67-1.5 1.5-1.5h4c.83 0 1.5.67 1.5 1.5z",
    fill: primaryFill
  }));
};

export const CalendarPerson16Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarPerson16FilledIcon, 'CalendarPerson16Filled');

const CalendarPerson16RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M11.5 2A2.5 2.5 0 0114 4.5v1.84c-.26-.38-.6-.7-1-.94v-.9c0-.83-.67-1.5-1.5-1.5h-7C3.67 3 3 3.67 3 4.5V5h8v.04A3 3 0 009.26 6H3v5.5c0 .83.67 1.5 1.5 1.5h2.54c.05.34.16.68.33 1H4.5A2.5 2.5 0 012 11.5v-7A2.5 2.5 0 014.5 2h7zm2 6a2 2 0 11-4 0 2 2 0 014 0zm1.5 4.5c0 1.25-1 2.5-3.5 2.5S8 13.75 8 12.5c0-.83.67-1.5 1.5-1.5h4c.83 0 1.5.67 1.5 1.5z",
    fill: primaryFill
  }));
};

export const CalendarPerson16Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarPerson16RegularIcon, 'CalendarPerson16Regular');

const CalendarPerson20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M17 7v2.4a3 3 0 00-3.73 4.6 2.5 2.5 0 00-2.23 3H5.5A2.5 2.5 0 013 14.5V7h14zm-2.5-4A2.5 2.5 0 0117 5.5V6H3v-.5A2.5 2.5 0 015.5 3h9zm3 9a2 2 0 11-4 0 2 2 0 014 0zm1.5 4.5c0 1.25-1 2.5-3.5 2.5S12 17.75 12 16.5c0-.83.67-1.5 1.5-1.5h4c.83 0 1.5.67 1.5 1.5z",
    fill: primaryFill
  }));
};

export const CalendarPerson20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarPerson20FilledIcon, 'CalendarPerson20Filled');

const CalendarPerson20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M14.5 3A2.5 2.5 0 0117 5.5v3.9c-.3-.17-.64-.3-1-.36V7H4v7.5c0 .83.67 1.5 1.5 1.5h5.55a2.51 2.51 0 00-.01 1H5.5A2.5 2.5 0 013 14.5v-9A2.5 2.5 0 015.5 3h9zm0 1h-9C4.67 4 4 4.67 4 5.5V6h12v-.5c0-.83-.67-1.5-1.5-1.5zm3 8a2 2 0 11-4 0 2 2 0 014 0zm1.5 4.5c0 1.25-1 2.5-3.5 2.5S12 17.75 12 16.5c0-.83.67-1.5 1.5-1.5h4c.83 0 1.5.67 1.5 1.5z",
    fill: primaryFill
  }));
};

export const CalendarPerson20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarPerson20RegularIcon, 'CalendarPerson20Regular');

const CalendarPerson24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M21 12.05V8.5H3v9.25C3 19.55 4.46 21 6.25 21h6.92a3.74 3.74 0 01-.17-1.13v-.1A2.77 2.77 0 0115.77 17h.28a3.49 3.49 0 012.45-6c.98 0 1.86.4 2.5 1.05zm0-5.8C21 4.45 19.54 3 17.75 3H6.25A3.25 3.25 0 003 6.25V7h18v-.75zm0 8.25a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0zm2 5.38c0 1.55-1.29 3.12-4.5 3.12S14 21.44 14 19.87v-.1c0-.98.8-1.77 1.77-1.77h5.46c.98 0 1.77.8 1.77 1.77v.1z",
    fill: primaryFill
  }));
};

export const CalendarPerson24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarPerson24FilledIcon, 'CalendarPerson24Filled');

const CalendarPerson24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M21 6.25C21 4.45 19.54 3 17.75 3H6.25A3.25 3.25 0 003 6.25v11.5C3 19.55 4.46 21 6.25 21h6.92a3.74 3.74 0 01-.17-1.13v-.1l.01-.27H6.25c-.97 0-1.75-.78-1.75-1.75V8.5h15v2.64a3.5 3.5 0 011.5.91v-5.8zM6.25 4.5h11.5c.97 0 1.75.78 1.75 1.75V7h-15v-.75c0-.97.78-1.75 1.75-1.75zM21 14.5a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0zm2 5.38c0 1.55-1.29 3.12-4.5 3.12S14 21.44 14 19.87v-.1c0-.98.8-1.77 1.77-1.77h5.46c.98 0 1.77.8 1.77 1.77v.1z",
    fill: primaryFill
  }));
};

export const CalendarPerson24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarPerson24RegularIcon, 'CalendarPerson24Regular');

const CalendarPhone16FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M8 7.5c0-.56.19-1.08.5-1.5H2v5.5A2.5 2.5 0 004.5 14h3.55a2.51 2.51 0 01-.05-.5v-6zM2 5v-.5A2.5 2.5 0 014.5 2h7A2.5 2.5 0 0114 4.5V5H2zm8.75 1C9.78 6 9 6.78 9 7.75v5.5c0 .97.78 1.75 1.75 1.75h2.5c.97 0 1.75-.78 1.75-1.75v-5.5C15 6.78 14.22 6 13.25 6h-2.5zm.25 6.5c0-.28.22-.5.5-.5h1a.5.5 0 010 1h-1a.5.5 0 01-.5-.5z",
    fill: primaryFill
  }));
};

export const CalendarPhone16Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarPhone16FilledIcon, 'CalendarPhone16Filled');

const CalendarPhone16RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M11.5 2A2.5 2.5 0 0114 4.5v.55a2.51 2.51 0 00-.5-.05H13v-.5c0-.83-.67-1.5-1.5-1.5h-7C3.67 3 3 3.67 3 4.5V5h7.5c-.82 0-1.54.4-2 1H3v5.5c0 .83.67 1.5 1.5 1.5H8v.5c0 .17.02.34.05.5H4.5A2.5 2.5 0 012 11.5v-7A2.5 2.5 0 014.5 2h7zm-.75 4C9.78 6 9 6.78 9 7.75v5.5c0 .97.78 1.75 1.75 1.75h2.5c.97 0 1.75-.78 1.75-1.75v-5.5C15 6.78 14.22 6 13.25 6h-2.5zm.25 6.5c0-.28.22-.5.5-.5h1a.5.5 0 010 1h-1a.5.5 0 01-.5-.5z",
    fill: primaryFill
  }));
};

export const CalendarPhone16Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarPhone16RegularIcon, 'CalendarPhone16Regular');

const CalendarPhone20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M17 7v1.05a2.51 2.51 0 00-.5-.05h-3a2.5 2.5 0 00-2.5 2.5v6c0 .17.02.34.05.5H5.5A2.5 2.5 0 013 14.5V7h14zm-2.5-4A2.5 2.5 0 0117 5.5V6H3v-.5A2.5 2.5 0 015.5 3h9zm-.75 6c-.97 0-1.75.78-1.75 1.75v5.5c0 .97.78 1.75 1.75 1.75h2.5c.97 0 1.75-.78 1.75-1.75v-5.5C18 9.78 17.22 9 16.25 9h-2.5zm.25 6.5c0-.28.22-.5.5-.5h1a.5.5 0 010 1h-1a.5.5 0 01-.5-.5z",
    fill: primaryFill
  }));
};

export const CalendarPhone20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarPhone20FilledIcon, 'CalendarPhone20Filled');

const CalendarPhone20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M14.5 3A2.5 2.5 0 0117 5.5v2.55a2.51 2.51 0 00-.5-.05H16V7H4v7.5c0 .83.67 1.5 1.5 1.5H11v.5c0 .17.02.34.05.5H5.5A2.5 2.5 0 013 14.5v-9A2.5 2.5 0 015.5 3h9zm0 1h-9C4.67 4 4 4.67 4 5.5V6h12v-.5c0-.83-.67-1.5-1.5-1.5zm-.75 5c-.97 0-1.75.78-1.75 1.75v5.5c0 .97.78 1.75 1.75 1.75h2.5c.97 0 1.75-.78 1.75-1.75v-5.5C18 9.78 17.22 9 16.25 9h-2.5zm.25 6.5c0-.28.22-.5.5-.5h1a.5.5 0 010 1h-1a.5.5 0 01-.5-.5z",
    fill: primaryFill
  }));
};

export const CalendarPhone20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarPhone20RegularIcon, 'CalendarPhone20Regular');

const CalendarQuestionMark16FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4.5 14h1.76a5.48 5.48 0 011.08-8H2v5.5A2.5 2.5 0 004.5 14zM14 5H2v-.5A2.5 2.5 0 014.5 2h7A2.5 2.5 0 0114 4.5V5zm1 5.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-4.5 1.88a.62.62 0 100 1.25.62.62 0 000-1.25zm0-4.88c-1.05 0-1.86.82-1.85 1.96a.5.5 0 001-.01c0-.58.36-.95.85-.95.47 0 .85.4.85.95 0 .2-.07.32-.36.55l-.27.21c-.51.4-.72.72-.72 1.29a.5.5 0 001 .09v-.16c.02-.14.1-.25.35-.44l.28-.22c.5-.4.72-.73.72-1.32 0-1.1-.82-1.95-1.85-1.95z",
    fill: primaryFill
  }));
};

export const CalendarQuestionMark16Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarQuestionMark16FilledIcon, 'CalendarQuestionMark16Filled');

const CalendarQuestionMark16RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M11.5 2A2.5 2.5 0 0114 4.5v1.76A5.48 5.48 0 0010.5 5H13v-.5c0-.83-.67-1.5-1.5-1.5h-7C3.67 3 3 3.67 3 4.5V5h7.5c-1.18 0-2.27.37-3.16 1H3v5.5c0 .83.67 1.5 1.5 1.5h1.1c.18.36.4.7.66 1H4.5A2.5 2.5 0 012 11.5v-7A2.5 2.5 0 014.5 2h7zm3.5 8.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-4.5 1.88a.62.62 0 100 1.25.62.62 0 000-1.25zm0-4.88c-1.05 0-1.86.82-1.85 1.96a.5.5 0 001-.01c0-.58.36-.95.85-.95.47 0 .85.4.85.95 0 .2-.07.32-.36.55l-.27.21c-.51.4-.72.72-.72 1.29a.5.5 0 001 .09v-.16c.02-.14.1-.25.35-.44l.28-.22c.5-.4.72-.73.72-1.32 0-1.1-.82-1.95-1.85-1.95z",
    fill: primaryFill
  }));
};

export const CalendarQuestionMark16Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarQuestionMark16RegularIcon, 'CalendarQuestionMark16Regular');

const CalendarQuestionMark20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M17 5.5A2.5 2.5 0 0014.5 3h-9A2.5 2.5 0 003 5.5V6h14v-.5zm0 4.1V7H3v7.5A2.5 2.5 0 005.5 17h4.1A5.5 5.5 0 0117 9.6zM14.5 19a4.5 4.5 0 100-9 4.5 4.5 0 000 9zm-.62-2a.62.62 0 111.24 0 .62.62 0 01-1.24 0zm-1.23-3.54c-.01-1.14.8-1.96 1.85-1.96 1.03 0 1.85.85 1.85 1.95 0 .59-.21.91-.72 1.32l-.28.22c-.25.19-.33.3-.35.44v.16a.5.5 0 01-1-.09c0-.57.21-.88.72-1.29l.27-.21c.3-.23.36-.35.36-.55 0-.55-.38-.95-.85-.95-.5 0-.86.37-.85.95a.5.5 0 11-1 0z",
    fill: primaryFill
  }));
};

export const CalendarQuestionMark20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarQuestionMark20FilledIcon, 'CalendarQuestionMark20Filled');

const CalendarQuestionMark20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M14.5 3A2.5 2.5 0 0117 5.5v4.1c-.32-.16-.65-.3-1-.4V7H4v7.5c0 .83.67 1.5 1.5 1.5h3.7c.1.35.24.68.4 1H5.5A2.5 2.5 0 013 14.5v-9A2.5 2.5 0 015.5 3h9zm0 1h-9C4.67 4 4 4.67 4 5.5V6h12v-.5c0-.83-.67-1.5-1.5-1.5zm0 15a4.5 4.5 0 100-9 4.5 4.5 0 000 9zm-.62-2a.62.62 0 111.24 0 .62.62 0 01-1.24 0zm-1.23-3.54c-.01-1.14.8-1.96 1.85-1.96 1.03 0 1.85.85 1.85 1.95 0 .59-.21.91-.72 1.32l-.28.22c-.25.19-.33.3-.35.44v.16a.5.5 0 01-1-.09c0-.57.21-.88.72-1.29l.27-.21c.3-.23.36-.35.36-.55 0-.55-.38-.95-.85-.95-.5 0-.86.37-.85.95a.5.5 0 11-1 0z",
    fill: primaryFill
  }));
};

export const CalendarQuestionMark20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarQuestionMark20RegularIcon, 'CalendarQuestionMark20Regular');

const CalendarQuestionMark24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M21 6.25C21 4.45 19.54 3 17.75 3H6.25A3.25 3.25 0 003 6.25V7h18v-.75zm0 5.77V8.5H3v9.25C3 19.55 4.46 21 6.25 21h5.77A6.5 6.5 0 0121 12.02zm2 5.48a5.5 5.5 0 10-11 0 5.5 5.5 0 0011 0zm-6.12 2.88a.62.62 0 111.24 0 .62.62 0 01-1.24 0zm-1.23-4.55c-.01-1.14.8-1.96 1.85-1.96 1.03 0 1.85.85 1.85 1.95 0 .51-.15.85-.52 1.3l-.14.15-.27.3-.1.1-.08.11c-.18.23-.24.39-.24.6a.5.5 0 11-1 0c0-.53.15-.86.53-1.32l.14-.16.27-.29.1-.1.09-.12c.17-.22.22-.37.22-.57 0-.55-.38-.95-.85-.95-.5 0-.86.37-.85.95a.5.5 0 11-1 0z",
    fill: primaryFill
  }));
};

export const CalendarQuestionMark24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarQuestionMark24FilledIcon, 'CalendarQuestionMark24Filled');

const CalendarQuestionMark24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M21 6.25C21 4.45 19.54 3 17.75 3H6.25A3.25 3.25 0 003 6.25v11.5C3 19.55 4.46 21 6.25 21h5.77c-.3-.46-.53-.97-.7-1.5H6.24c-.97 0-1.75-.78-1.75-1.75V8.5h15v2.81c.53.18 1.04.42 1.5.71V6.25zM6.25 4.5h11.5c.97 0 1.75.78 1.75 1.75V7h-15v-.75c0-.97.78-1.75 1.75-1.75zM23 17.5a5.5 5.5 0 10-11 0 5.5 5.5 0 0011 0zm-6.12 2.88a.62.62 0 111.24 0 .62.62 0 01-1.24 0zm-1.23-4.55c-.01-1.14.8-1.96 1.85-1.96 1.03 0 1.85.85 1.85 1.95 0 .51-.15.85-.52 1.3l-.14.15-.27.3-.1.1-.08.11c-.18.23-.24.39-.24.6a.5.5 0 11-1 0c0-.53.15-.86.53-1.32l.14-.16.27-.29.1-.1.09-.12c.17-.22.22-.37.22-.57 0-.55-.38-.95-.85-.95-.5 0-.86.37-.85.95a.5.5 0 11-1 0z",
    fill: primaryFill
  }));
};

export const CalendarQuestionMark24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarQuestionMark24RegularIcon, 'CalendarQuestionMark24Regular');

const CalendarReply16FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M14 6v.26c-.1-.1-.22-.18-.34-.26H14zm-9.5 8h1.76a5.48 5.48 0 011.08-8H2v5.5A2.5 2.5 0 004.5 14zM14 5H2v-.5A2.5 2.5 0 014.5 2h7A2.5 2.5 0 0114 4.5V5zm-3.5 10a4.5 4.5 0 100-9 4.5 4.5 0 000 9zm-.9-6.4l-.9.9h1.55A2.75 2.75 0 0113 12.25v.25a.5.5 0 01-1 0v-.25c0-.97-.78-1.75-1.75-1.75H8.71l.9.9a.5.5 0 01-.71.7l-1.76-1.75a.5.5 0 010-.7L8.9 7.9a.5.5 0 11.7.7z",
    fill: primaryFill
  }));
};

export const CalendarReply16Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarReply16FilledIcon, 'CalendarReply16Filled');

const CalendarReply16RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M11.5 2A2.5 2.5 0 0114 4.5v1.76A5.48 5.48 0 0010.5 5H13v-.5c0-.83-.67-1.5-1.5-1.5h-7C3.67 3 3 3.67 3 4.5V5h7.5c-1.18 0-2.27.37-3.16 1H3v5.5c0 .83.67 1.5 1.5 1.5h1.1c.18.36.4.7.66 1H4.5A2.5 2.5 0 012 11.5v-7A2.5 2.5 0 014.5 2h7zm-1 13a4.5 4.5 0 100-9 4.5 4.5 0 000 9zm-.9-6.4l-.9.9h1.55A2.75 2.75 0 0113 12.25v.25a.5.5 0 01-1 0v-.25c0-.97-.78-1.75-1.75-1.75H8.71l.9.9a.5.5 0 01-.71.7l-1.76-1.75a.5.5 0 010-.7L8.9 7.9a.5.5 0 11.7.7z",
    fill: primaryFill
  }));
};

export const CalendarReply16Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarReply16RegularIcon, 'CalendarReply16Regular');

const CalendarReply20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M17 7v2.6A5.5 5.5 0 009.6 17H5.5A2.5 2.5 0 013 14.5V7h14zm-2.5-4A2.5 2.5 0 0117 5.5V6H3v-.5A2.5 2.5 0 015.5 3h9zm0 16a4.5 4.5 0 100-9 4.5 4.5 0 000 9zm-.9-6.4l-.9.9h1.55A2.75 2.75 0 0117 16.25v.25a.5.5 0 01-1 0v-.25c0-.97-.78-1.75-1.75-1.75h-1.54l.9.9a.5.5 0 01-.71.7l-1.76-1.75a.5.5 0 010-.7l1.76-1.75a.5.5 0 01.7.7z",
    fill: primaryFill
  }));
};

export const CalendarReply20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarReply20FilledIcon, 'CalendarReply20Filled');

const CalendarReply20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M14.5 3A2.5 2.5 0 0117 5.5v4.1c-.32-.16-.65-.3-1-.4V7H4v7.5c0 .83.67 1.5 1.5 1.5h3.7c.1.35.24.68.4 1H5.5A2.5 2.5 0 013 14.5v-9A2.5 2.5 0 015.5 3h9zm0 1h-9C4.67 4 4 4.67 4 5.5V6h12v-.5c0-.83-.67-1.5-1.5-1.5zm0 15a4.5 4.5 0 100-9 4.5 4.5 0 000 9zm-.9-6.4l-.9.9h1.55A2.75 2.75 0 0117 16.25v.25a.5.5 0 01-1 0v-.25c0-.97-.78-1.75-1.75-1.75h-1.54l.9.9a.5.5 0 01-.71.7l-1.76-1.75a.5.5 0 010-.7l1.76-1.75a.5.5 0 01.7.7z",
    fill: primaryFill
  }));
};

export const CalendarReply20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarReply20RegularIcon, 'CalendarReply20Regular');

const CalendarReply24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M21 8.5v3.52A6.5 6.5 0 0012.02 21H6.25A3.25 3.25 0 013 17.75V8.5h18zM17.75 3C19.55 3 21 4.46 21 6.25V7H3v-.75C3 4.45 4.46 3 6.25 3h11.5zM23 17.5a5.5 5.5 0 11-11 0 5.5 5.5 0 0111 0zm-6.65-2.15a.5.5 0 00-.7-.7l-1.5 1.5a.5.5 0 000 .7l1.5 1.5a.5.5 0 00.7-.7l-.64-.65h2.04c1.24 0 2.25 1 2.25 2.25v.25a.5.5 0 001 0v-.25c0-1.8-1.46-3.25-3.25-3.25h-2.04l.64-.65z",
    fill: primaryFill
  }));
};

export const CalendarReply24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarReply24FilledIcon, 'CalendarReply24Filled');

const CalendarReply24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M17.75 3C19.55 3 21 4.46 21 6.25v5.77c-.46-.3-.97-.53-1.5-.7V8.5h-15v9.25c0 .97.78 1.75 1.75 1.75h5.06c.18.53.42 1.04.71 1.5H6.25A3.25 3.25 0 013 17.75V6.25C3 4.45 4.46 3 6.25 3h11.5zm0 1.5H6.25c-.97 0-1.75.78-1.75 1.75V7h15v-.75c0-.97-.78-1.75-1.75-1.75zm5.25 13a5.5 5.5 0 11-11 0 5.5 5.5 0 0111 0zm-6.65-2.15a.5.5 0 00-.7-.7l-1.5 1.5a.5.5 0 000 .7l1.5 1.5a.5.5 0 00.7-.7l-.64-.65h2.04c1.24 0 2.25 1 2.25 2.25v.25a.5.5 0 001 0v-.25c0-1.8-1.46-3.25-3.25-3.25h-2.04l.64-.65z",
    fill: primaryFill
  }));
};

export const CalendarReply24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarReply24RegularIcon, 'CalendarReply24Regular');

const CalendarReply28FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M25 9.5v5A7.5 7.5 0 0014.5 25H6.25A3.25 3.25 0 013 21.75V9.5h22zM21.75 3C23.55 3 25 4.46 25 6.25V8H3V6.25C3 4.45 4.46 3 6.25 3h15.5zM27 20.5a6.5 6.5 0 11-13 0 6.5 6.5 0 0113 0zm-8.15-2.65a.5.5 0 00-.7-.7l-2 2a.5.5 0 000 .7l2 2a.5.5 0 00.7-.7L17.71 20h2.54A2.75 2.75 0 0123 22.75V23a.5.5 0 001 0v-.25A3.75 3.75 0 0020.25 19h-2.54l1.14-1.15z",
    fill: primaryFill
  }));
};

export const CalendarReply28Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarReply28FilledIcon, 'CalendarReply28Filled');

const CalendarReply28RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M21.75 3C23.55 3 25 4.46 25 6.25v8.25a7.49 7.49 0 00-1.5-.88V9.5h-19v12.25c0 .97.78 1.75 1.75 1.75h7.37c.24.54.53 1.04.88 1.5H6.25A3.25 3.25 0 013 21.75V6.25C3 4.45 4.46 3 6.25 3h15.5zm0 1.5H6.25c-.97 0-1.75.78-1.75 1.75V8h19V6.25c0-.97-.78-1.75-1.75-1.75zm5.25 16a6.5 6.5 0 11-13 0 6.5 6.5 0 0113 0zm-8.15-2.65a.5.5 0 00-.7-.7l-2 2a.5.5 0 000 .7l2 2a.5.5 0 00.7-.7L17.71 20h2.54A2.75 2.75 0 0123 22.75V23a.5.5 0 001 0v-.25A3.75 3.75 0 0020.25 19h-2.54l1.14-1.15z",
    fill: primaryFill
  }));
};

export const CalendarReply28Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarReply28RegularIcon, 'CalendarReply28Regular');

const CalendarRtl12FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10.95 3A2.5 2.5 0 008.5 1h-5a2.5 2.5 0 00-2.45 2h9.9zM11 4v4.5A2.5 2.5 0 018.5 11h-5A2.5 2.5 0 011 8.5V4h10zM9 5.5a.5.5 0 10-1 0 .5.5 0 001 0zm0 2a.5.5 0 10-1 0 .5.5 0 001 0zM6.5 5a.5.5 0 100 1 .5.5 0 000-1zM7 7.5a.5.5 0 10-1 0 .5.5 0 001 0zM4.5 5a.5.5 0 100 1 .5.5 0 000-1z",
    fill: primaryFill
  }));
};

export const CalendarRtl12Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarRtl12FilledIcon, 'CalendarRtl12Filled');

const CalendarRtl12RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M9 5.5a.5.5 0 10-1 0 .5.5 0 001 0zM8.5 7a.5.5 0 110 1 .5.5 0 010-1zM7 5.5a.5.5 0 10-1 0 .5.5 0 001 0zM6.5 7a.5.5 0 110 1 .5.5 0 010-1zM5 5.5a.5.5 0 10-1 0 .5.5 0 001 0zm6-2A2.5 2.5 0 008.5 1h-5A2.5 2.5 0 001 3.5v5A2.5 2.5 0 003.5 11h5A2.5 2.5 0 0011 8.5v-5zM8.5 2c.65 0 1.2.42 1.41 1H2.1c.2-.58.76-1 1.41-1h5zM2 4h8v4.5c0 .83-.67 1.5-1.5 1.5h-5A1.5 1.5 0 012 8.5V4z",
    fill: primaryFill
  }));
};

export const CalendarRtl12Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarRtl12RegularIcon, 'CalendarRtl12Regular');

const CalendarRtl16FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2 11.5V6h12v5.5a2.5 2.5 0 01-2.5 2.5h-7A2.5 2.5 0 012 11.5zm8-3.25a.75.75 0 101.5 0 .75.75 0 00-1.5 0zm0 2.5a.75.75 0 101.5 0 .75.75 0 00-1.5 0zm-2.75-2.5a.75.75 0 101.5 0 .75.75 0 00-1.5 0zm0 2.5a.75.75 0 101.5 0 .75.75 0 00-1.5 0zM4.5 8.25a.75.75 0 101.5 0 .75.75 0 00-1.5 0zM2 4.5A2.5 2.5 0 014.5 2h7A2.5 2.5 0 0114 4.5V5H2v-.5z",
    fill: primaryFill
  }));
};

export const CalendarRtl16Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarRtl16FilledIcon, 'CalendarRtl16Filled');

const CalendarRtl16RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10.75 9a.75.75 0 110-1.5.75.75 0 010 1.5zM10 10.75a.75.75 0 101.5 0 .75.75 0 00-1.5 0zM8 9a.75.75 0 110-1.5A.75.75 0 018 9zm-.75 1.75a.75.75 0 101.5 0 .75.75 0 00-1.5 0zM5.25 9a.75.75 0 110-1.5.75.75 0 010 1.5zM2 4.5A2.5 2.5 0 014.5 2h7A2.5 2.5 0 0114 4.5v7a2.5 2.5 0 01-2.5 2.5h-7A2.5 2.5 0 012 11.5v-7zM13 6H3v5.5c0 .83.67 1.5 1.5 1.5h7c.83 0 1.5-.67 1.5-1.5V6zm-1.5-3h-7C3.67 3 3 3.67 3 4.5V5h10v-.5c0-.83-.67-1.5-1.5-1.5z",
    fill: primaryFill
  }));
};

export const CalendarRtl16Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarRtl16RegularIcon, 'CalendarRtl16Regular');

const CalendarRtl20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M14.5 3A2.5 2.5 0 0117 5.5V6H3v-.5A2.5 2.5 0 015.5 3h9zM3 7h14v7.5a2.5 2.5 0 01-2.5 2.5h-9A2.5 2.5 0 013 14.5V7zm9 3a1 1 0 102 0 1 1 0 00-2 0zm1 4a1 1 0 100-2 1 1 0 000 2zm-4-4a1 1 0 102 0 1 1 0 00-2 0zm1 4a1 1 0 100-2 1 1 0 000 2zm-4-4a1 1 0 102 0 1 1 0 00-2 0z",
    fill: primaryFill
  }));
};

export const CalendarRtl20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarRtl20FilledIcon, 'CalendarRtl20Filled');

const CalendarRtl20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M13 11a1 1 0 110-2 1 1 0 010 2zm-1 2a1 1 0 102 0 1 1 0 00-2 0zm-2-2a1 1 0 110-2 1 1 0 010 2zm-1 2a1 1 0 102 0 1 1 0 00-2 0zm-2-2a1 1 0 110-2 1 1 0 010 2zM3 5.5A2.5 2.5 0 015.5 3h9A2.5 2.5 0 0117 5.5v9a2.5 2.5 0 01-2.5 2.5h-9A2.5 2.5 0 013 14.5v-9zM16 7H4v7.5c0 .83.67 1.5 1.5 1.5h9c.83 0 1.5-.67 1.5-1.5V7zm-1.5-3h-9C4.67 4 4 4.67 4 5.5V6h12v-.5c0-.83-.67-1.5-1.5-1.5z",
    fill: primaryFill
  }));
};

export const CalendarRtl20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarRtl20RegularIcon, 'CalendarRtl20Regular');

const CalendarRtl24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3 8.5v9.25C3 19.55 4.46 21 6.25 21h11.5c1.8 0 3.25-1.46 3.25-3.25V8.5H3zM16.75 15a1.25 1.25 0 110 2.5 1.25 1.25 0 010-2.5zM12 15a1.25 1.25 0 110 2.5 1.25 1.25 0 010-2.5zm4.75-4.5a1.25 1.25 0 110 2.5 1.25 1.25 0 010-2.5zm-4.75 0a1.25 1.25 0 110 2.5 1.25 1.25 0 010-2.5zm-4.75 0a1.25 1.25 0 110 2.5 1.25 1.25 0 010-2.5zm-1-7.5A3.25 3.25 0 003 6.25V7h18v-.75C21 4.45 19.54 3 17.75 3H6.25z",
    fill: primaryFill
  }));
};

export const CalendarRtl24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarRtl24FilledIcon, 'CalendarRtl24Filled');

const CalendarRtl24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6.25 3A3.25 3.25 0 003 6.25v11.5C3 19.55 4.46 21 6.25 21h11.5c1.8 0 3.25-1.46 3.25-3.25V6.25C21 4.45 19.54 3 17.75 3H6.25zM4.5 8.5h15v9.25c0 .97-.78 1.75-1.75 1.75H6.25c-.97 0-1.75-.78-1.75-1.75V8.5zm11.75 6a1.25 1.25 0 100 2.5 1.25 1.25 0 000-2.5zm-4.25 0a1.25 1.25 0 100 2.5 1.25 1.25 0 000-2.5zm4.25-4a1.25 1.25 0 100 2.5 1.25 1.25 0 000-2.5zm-4.25 0a1.25 1.25 0 100 2.5 1.25 1.25 0 000-2.5zm-4.25 0a1.25 1.25 0 100 2.5 1.25 1.25 0 000-2.5zm-1.5-6h11.5c.97 0 1.75.78 1.75 1.75V7h-15v-.75c0-.97.78-1.75 1.75-1.75z",
    fill: primaryFill
  }));
};

export const CalendarRtl24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarRtl24RegularIcon, 'CalendarRtl24Regular');

const CalendarRtl28FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3 9.5v12.25C3 23.55 4.46 25 6.25 25h15.5c1.8 0 3.25-1.46 3.25-3.25V9.5H3zm16.26 8a1.25 1.25 0 110 2.5 1.25 1.25 0 010-2.5zm-5.26 0a1.25 1.25 0 110 2.5 1.25 1.25 0 010-2.5zm5.26-5a1.25 1.25 0 110 2.5 1.25 1.25 0 010-2.5zm-5.26 0a1.25 1.25 0 110 2.5 1.25 1.25 0 010-2.5zm-5.25 0a1.25 1.25 0 110 2.5 1.25 1.25 0 010-2.5zM6.25 3A3.25 3.25 0 003 6.25V8h22V6.25C25 4.45 23.54 3 21.75 3H6.25z",
    fill: primaryFill
  }));
};

export const CalendarRtl28Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarRtl28FilledIcon, 'CalendarRtl28Filled');

const CalendarRtl28RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6.25 3A3.25 3.25 0 003 6.25v15.5C3 23.55 4.46 25 6.25 25h15.5c1.8 0 3.25-1.46 3.25-3.25V6.25C25 4.45 23.54 3 21.75 3H6.25zM4.5 9.5h19v12.25c0 .97-.78 1.75-1.75 1.75H6.25c-.97 0-1.75-.78-1.75-1.75V9.5zm14.75 8a1.25 1.25 0 100 2.5 1.25 1.25 0 000-2.5zm-5.25 0a1.25 1.25 0 100 2.5 1.25 1.25 0 000-2.5zm5.25-5a1.25 1.25 0 100 2.5 1.25 1.25 0 000-2.5zm-5.25 0a1.25 1.25 0 100 2.5 1.25 1.25 0 000-2.5zm-5.26 0a1.25 1.25 0 100 2.5 1.25 1.25 0 000-2.5zm-2.49-8h15.5c.97 0 1.75.78 1.75 1.75V8h-19V6.25c0-.97.78-1.75 1.75-1.75z",
    fill: primaryFill
  }));
};

export const CalendarRtl28Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarRtl28RegularIcon, 'CalendarRtl28Regular');

const CalendarRtl32FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M23 4a5 5 0 015 5v1H4V9a5 5 0 015-5h14zm5 19V12H4v11a5 5 0 005 5h14a5 5 0 005-5zm-6.5-5a1.5 1.5 0 110-3 1.5 1.5 0 010 3zM20 21.5a1.5 1.5 0 113 0 1.5 1.5 0 01-3 0zM16 23a1.5 1.5 0 110-3 1.5 1.5 0 010 3zm-1.5-6.5a1.5 1.5 0 113 0 1.5 1.5 0 01-3 0zm-4 1.5a1.5 1.5 0 110-3 1.5 1.5 0 010 3z",
    fill: primaryFill
  }));
};

export const CalendarRtl32Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarRtl32FilledIcon, 'CalendarRtl32Filled');

const CalendarRtl32RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M21.5 18a1.5 1.5 0 110-3 1.5 1.5 0 010 3zM20 21.5a1.5 1.5 0 103 0 1.5 1.5 0 00-3 0zM16 23a1.5 1.5 0 110-3 1.5 1.5 0 010 3zm-1.5-6.5a1.5 1.5 0 103 0 1.5 1.5 0 00-3 0zm-4 1.5a1.5 1.5 0 110-3 1.5 1.5 0 010 3zM28 9a5 5 0 00-5-5H9a5 5 0 00-5 5v14a5 5 0 005 5h14a5 5 0 005-5V9zm-5-3a3 3 0 013 3v1H6V9a3 3 0 013-3h14zm3 17a3 3 0 01-3 3H9a3 3 0 01-3-3V12h20v11z",
    fill: primaryFill
  }));
};

export const CalendarRtl32Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarRtl32RegularIcon, 'CalendarRtl32Regular');

const CalendarRtl48FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M42 12.25C42 8.8 39.2 6 35.75 6h-23.5A6.25 6.25 0 006 12.25V14h36v-1.75zm0 4.25v19.25C42 39.2 39.2 42 35.75 42h-23.5A6.25 6.25 0 016 35.75V16.5h36zm-12 7a2.5 2.5 0 105 0 2.5 2.5 0 00-5 0zM24 26a2.5 2.5 0 100-5 2.5 2.5 0 000 5zm-11-2.5a2.5 2.5 0 105 0 2.5 2.5 0 00-5 0zM32.5 34a2.5 2.5 0 100-5 2.5 2.5 0 000 5zm-11-2.5a2.5 2.5 0 105 0 2.5 2.5 0 00-5 0z",
    fill: primaryFill
  }));
};

export const CalendarRtl48Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarRtl48FilledIcon, 'CalendarRtl48Filled');

const CalendarRtl48RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M32.5 26a2.5 2.5 0 110-5 2.5 2.5 0 010 5zm-11-2.5a2.5 2.5 0 105 0 2.5 2.5 0 00-5 0zm-6 2.5a2.5 2.5 0 110-5 2.5 2.5 0 010 5zM30 31.5a2.5 2.5 0 105 0 2.5 2.5 0 00-5 0zM24 34a2.5 2.5 0 110-5 2.5 2.5 0 010 5zm18-21.75C42 8.8 39.2 6 35.75 6h-23.5A6.25 6.25 0 006 12.25v23.5C6 39.2 8.8 42 12.25 42h23.5C39.2 42 42 39.2 42 35.75v-23.5zM35.75 8.5a3.75 3.75 0 013.75 3.75V14h-31v-1.75a3.75 3.75 0 013.75-3.75h23.5zm3.75 27.25a3.75 3.75 0 01-3.75 3.75h-23.5a3.75 3.75 0 01-3.75-3.75V16.5h31v19.25z",
    fill: primaryFill
  }));
};

export const CalendarRtl48Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarRtl48RegularIcon, 'CalendarRtl48Regular');

const CalendarSearch16FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M14 11.5V6H7.33a4.5 4.5 0 011.23 5.44l2 2c.16.16.28.36.35.56h.59a2.5 2.5 0 002.5-2.5zm0-7A2.5 2.5 0 0011.5 2h-7A2.5 2.5 0 002 4.5V5h12v-.5zm-7.4 7.8a3.5 3.5 0 11.7-.7l2.55 2.55a.5.5 0 01-.7.7L6.6 12.3zM7 9.5a2.5 2.5 0 10-5 0 2.5 2.5 0 005 0z",
    fill: primaryFill
  }));
};

export const CalendarSearch16Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarSearch16FilledIcon, 'CalendarSearch16Filled');

const CalendarSearch16RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M14 4.5A2.5 2.5 0 0011.5 2h-7A2.5 2.5 0 002 4.5v1.26A4.48 4.48 0 017.33 6H13v5.5c0 .83-.67 1.5-1.5 1.5h-1.38l.44.44c.16.16.28.36.35.56h.59a2.5 2.5 0 002.5-2.5v-7zM4.5 5H3v-.5C3 3.67 3.67 3 4.5 3h7c.83 0 1.5.67 1.5 1.5V5H4.5zm2.1 7.3a3.5 3.5 0 11.7-.7l2.55 2.55a.5.5 0 01-.7.7L6.6 12.3zM7 9.5a2.5 2.5 0 10-5 0 2.5 2.5 0 005 0z",
    fill: primaryFill
  }));
};

export const CalendarSearch16Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarSearch16RegularIcon, 'CalendarSearch16Regular');

const CalendarSearch20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M17 14.5V7H3v2.47a4.5 4.5 0 016.06 5.97L10.62 17h3.88a2.5 2.5 0 002.5-2.5zm0-9A2.5 2.5 0 0014.5 3h-9A2.5 2.5 0 003 5.5V6h14v-.5zM7.1 16.3a3.5 3.5 0 11.7-.7l2.55 2.55a.5.5 0 01-.7.7L7.1 16.3zm.4-2.8a2.5 2.5 0 10-5 0 2.5 2.5 0 005 0z",
    fill: primaryFill
  }));
};

export const CalendarSearch20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarSearch20FilledIcon, 'CalendarSearch20Filled');

const CalendarSearch20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M17 5.5A2.5 2.5 0 0014.5 3h-9A2.5 2.5 0 003 5.5v3.76c.32-.12.65-.2 1-.23V7h12v7.5c0 .83-.67 1.5-1.5 1.5H9.12l1 1h4.38a2.5 2.5 0 002.5-2.5v-9zM5.5 4h9c.83 0 1.5.67 1.5 1.5V6H4v-.5C4 4.67 4.67 4 5.5 4zm1.1 12.3a3.5 3.5 0 11.7-.7l2.55 2.55a.5.5 0 01-.7.7L6.6 16.3zm.4-2.8a2.5 2.5 0 10-5 0 2.5 2.5 0 005 0z",
    fill: primaryFill
  }));
};

export const CalendarSearch20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarSearch20RegularIcon, 'CalendarSearch20Regular');

const CalendarSettings16FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4.5 14h1.76a5.48 5.48 0 011.08-8H2v5.5A2.5 2.5 0 004.5 14zM2 5v-.5A2.5 2.5 0 014.5 2h7A2.5 2.5 0 0114 4.5V5H2zm4.64 4.92a2 2 0 001.43-2.48L7.9 6.9c.25-.2.53-.37.82-.5l.34.36a2 2 0 002.9 0l.33-.35c.3.14.58.32.84.52l-.13.42a2 2 0 001.46 2.52l.35.09a4.7 4.7 0 010 1.01l-.45.12a2 2 0 00-1.43 2.48l.15.55c-.25.2-.53.37-.82.5l-.34-.36a2 2 0 00-2.9 0l-.33.35c-.3-.14-.58-.32-.84-.52l.13-.42a2 2 0 00-1.46-2.52l-.35-.09a4.7 4.7 0 010-1.01l.46-.12zm4.86.58a1 1 0 10-2 0 1 1 0 002 0z",
    fill: primaryFill
  }));
};

export const CalendarSettings16Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarSettings16FilledIcon, 'CalendarSettings16Filled');

const CalendarSettings16RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M14 4.5A2.5 2.5 0 0011.5 2h-7A2.5 2.5 0 002 4.5v7A2.5 2.5 0 004.5 14h1.76a5.5 5.5 0 01-.66-1H4.5A1.5 1.5 0 013 11.5V6h4.34a5.47 5.47 0 016.66.26V4.5zm-3.5.5H3v-.5C3 3.67 3.67 3 4.5 3h7c.83 0 1.5.67 1.5 1.5V5h-2.5zM6.64 9.92a2 2 0 001.43-2.48L7.9 6.9c.25-.2.53-.37.82-.5l.34.36a2 2 0 002.9 0l.33-.35c.3.14.58.32.84.52l-.13.42a2 2 0 001.46 2.52l.35.09a4.7 4.7 0 010 1.01l-.45.12a2 2 0 00-1.43 2.48l.15.55c-.25.2-.53.37-.82.5l-.34-.36a2 2 0 00-2.9 0l-.33.35c-.3-.14-.58-.32-.84-.52l.13-.42a2 2 0 00-1.46-2.52l-.35-.09a4.7 4.7 0 010-1.01l.46-.12zm4.86.58a1 1 0 10-2 0 1 1 0 002 0z",
    fill: primaryFill
  }));
};

export const CalendarSettings16Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarSettings16RegularIcon, 'CalendarSettings16Regular');

const CalendarSettings20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M17 7v2.6A5.5 5.5 0 009.6 17H5.5A2.5 2.5 0 013 14.5V7h14zm-2.5-4A2.5 2.5 0 0117 5.5V6H3v-.5A2.5 2.5 0 015.5 3h9zm-2.43 8.44a2 2 0 01-1.43 2.48l-.47.12a4.7 4.7 0 00.01 1.01l.35.09A2 2 0 0112 17.66l-.13.42c.26.2.54.38.84.52l.32-.35a2 2 0 012.91 0l.34.36c.3-.13.57-.3.82-.5l-.15-.55a2 2 0 011.43-2.48l.46-.12a4.73 4.73 0 00-.01-1.01l-.35-.09A2 2 0 0117 11.34l.13-.42c-.26-.2-.54-.38-.84-.52l-.32.35a2 2 0 01-2.91 0l-.34-.36c-.3.13-.57.3-.82.5l.16.55zm2.43 4.06a1 1 0 110-2 1 1 0 010 2z",
    fill: primaryFill
  }));
};

export const CalendarSettings20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarSettings20FilledIcon, 'CalendarSettings20Filled');

const CalendarSettings20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M14.5 3A2.5 2.5 0 0117 5.5v4.1c-.32-.16-.65-.3-1-.4V7H4v7.5c0 .83.67 1.5 1.5 1.5h3.7c.1.35.24.68.4 1H5.5A2.5 2.5 0 013 14.5v-9A2.5 2.5 0 015.5 3h9zm0 1h-9C4.67 4 4 4.67 4 5.5V6h12v-.5c0-.83-.67-1.5-1.5-1.5zm-2.43 7.44a2 2 0 01-1.43 2.48l-.47.12a4.7 4.7 0 00.01 1.01l.35.09A2 2 0 0112 17.66l-.13.42c.26.2.54.38.84.52l.32-.35a2 2 0 012.91 0l.34.36c.3-.13.57-.3.82-.5l-.15-.55a2 2 0 011.43-2.48l.46-.12a4.73 4.73 0 00-.01-1.01l-.35-.09A2 2 0 0117 11.34l.13-.42c-.26-.2-.54-.38-.84-.52l-.32.35a2 2 0 01-2.91 0l-.34-.36c-.3.13-.57.3-.82.5l.16.55zm2.43 4.06a1 1 0 110-2 1 1 0 010 2z",
    fill: primaryFill
  }));
};

export const CalendarSettings20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarSettings20RegularIcon, 'CalendarSettings20Regular');

const CalendarStar16FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4.5 14h1.76a5.48 5.48 0 011.08-8H2v5.5A2.5 2.5 0 004.5 14zM14 5H2v-.5A2.5 2.5 0 014.5 2h7A2.5 2.5 0 0114 4.5V5zm-3.5 10a4.5 4.5 0 100-9 4.5 4.5 0 000 9zm.95-5.6H13c.48 0 .69.64.3.94l-1.26.94.48 1.53c.15.49-.38.89-.77.59l-1.25-.95-1.25.95c-.4.3-.92-.1-.77-.59l.48-1.53-1.25-.94c-.4-.3-.2-.95.3-.95h1.54l.47-1.53a.5.5 0 01.96 0l.47 1.53z",
    fill: primaryFill
  }));
};

export const CalendarStar16Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarStar16FilledIcon, 'CalendarStar16Filled');

const CalendarStar16RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M11.5 2A2.5 2.5 0 0114 4.5v1.76A5.48 5.48 0 0010.5 5H13v-.5c0-.83-.67-1.5-1.5-1.5h-7C3.67 3 3 3.67 3 4.5V5h7.5c-1.18 0-2.27.37-3.16 1H3v5.5c0 .83.67 1.5 1.5 1.5h1.1c.18.36.4.7.66 1H4.5A2.5 2.5 0 012 11.5v-7A2.5 2.5 0 014.5 2h7zm-1 13a4.5 4.5 0 100-9 4.5 4.5 0 000 9zm.95-5.6H13c.48 0 .69.64.3.94l-1.26.94.48 1.53c.15.49-.38.89-.77.59l-1.25-.95-1.25.95c-.4.3-.92-.1-.77-.59l.48-1.53-1.25-.94c-.4-.3-.2-.95.3-.95h1.54l.47-1.53a.5.5 0 01.96 0l.47 1.53z",
    fill: primaryFill
  }));
};

export const CalendarStar16Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarStar16RegularIcon, 'CalendarStar16Regular');

const CalendarStar20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M17 5.5A2.5 2.5 0 0014.5 3h-9A2.5 2.5 0 003 5.5V6h14v-.5zm0 4.1V7H3v7.5A2.5 2.5 0 005.5 17h4.1A5.5 5.5 0 0117 9.6zm2 4.9a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-4.02-2.64a.5.5 0 00-.96 0l-.47 1.53H12c-.48 0-.69.65-.3.95l1.26.94-.48 1.53c-.15.49.38.89.77.59l1.25-.95 1.25.95c.4.3.92-.1.77-.59l-.48-1.53 1.25-.94c.4-.3.2-.95-.3-.95h-1.54l-.47-1.53z",
    fill: primaryFill
  }));
};

export const CalendarStar20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarStar20FilledIcon, 'CalendarStar20Filled');

const CalendarStar20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M17 5.5A2.5 2.5 0 0014.5 3h-9A2.5 2.5 0 003 5.5v9A2.5 2.5 0 005.5 17h4.1c-.16-.32-.3-.65-.4-1H5.5A1.5 1.5 0 014 14.5V7h12v2.2c.35.1.68.24 1 .4V5.5zM5.5 4h9c.83 0 1.5.67 1.5 1.5V6H4v-.5C4 4.67 4.67 4 5.5 4zM19 14.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-4.02-2.64a.5.5 0 00-.96 0l-.47 1.53H12c-.48 0-.69.65-.3.95l1.26.94-.48 1.53c-.15.49.38.89.77.59l1.25-.95 1.25.95c.4.3.92-.1.77-.59l-.48-1.53 1.25-.94c.4-.3.2-.95-.3-.95h-1.54l-.47-1.53z",
    fill: primaryFill
  }));
};

export const CalendarStar20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarStar20RegularIcon, 'CalendarStar20Regular');

const CalendarStar24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M17.5 12a5.5 5.5 0 110 11 5.5 5.5 0 010-11zM21 8.5v3.52A6.5 6.5 0 0012.02 21H6.25A3.25 3.25 0 013 17.75V8.5h18zm-4.02 5.55l-.04.1-.55 1.78h-1.8c-.54 0-.78.67-.42 1.04l.07.06 1.46 1.1-.56 1.8c-.16.52.38.97.82.72l.08-.05 1.46-1.1 1.46 1.1c.43.33 1-.07.92-.58l-.02-.1-.56-1.78 1.46-1.1c.43-.33.25-1.02-.25-1.1H18.61l-.55-1.8a.58.58 0 00-1.08-.1zM17.75 3C19.55 3 21 4.46 21 6.25V7H3v-.75C3 4.45 4.46 3 6.25 3h11.5z",
    fill: primaryFill
  }));
};

export const CalendarStar24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarStar24FilledIcon, 'CalendarStar24Filled');

const CalendarStar24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M17.5 12a5.5 5.5 0 110 11 5.5 5.5 0 010-11zm.25-9C19.55 3 21 4.46 21 6.25v5.77c-.46-.3-.97-.53-1.5-.7V8.5h-15v9.25c0 .97.78 1.75 1.75 1.75h5.06c.18.53.42 1.04.71 1.5H6.25A3.25 3.25 0 013 17.75V6.25C3 4.45 4.46 3 6.25 3h11.5zm-.77 11.05l-.04.1-.55 1.78h-1.8c-.54 0-.78.67-.42 1.04l.07.06 1.46 1.1-.56 1.8c-.16.52.38.97.82.72l.08-.05 1.46-1.1 1.46 1.1c.43.33 1-.07.92-.58l-.02-.1-.56-1.78 1.46-1.1c.43-.33.25-1.02-.25-1.1H18.61l-.55-1.8a.58.58 0 00-1.08-.1zm.77-9.55H6.25c-.97 0-1.75.78-1.75 1.75V7h15v-.75c0-.97-.78-1.75-1.75-1.75z",
    fill: primaryFill
  }));
};

export const CalendarStar24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarStar24RegularIcon, 'CalendarStar24Regular');

const CalendarSync16FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6.26 14H4.5A2.5 2.5 0 012 11.5V6h5.34a5.5 5.5 0 00-1.08 8zM14 5v-.5A2.5 2.5 0 0011.5 2h-7A2.5 2.5 0 002 4.5V5h12zm-8 5.5a4.5 4.5 0 109 0 4.5 4.5 0 00-9 0zm6.5-3c.28 0 .5.22.5.5v1.5a.5.5 0 01-.5.5H11a.5.5 0 010-1h.47a1.98 1.98 0 00-1.72-.1 2 2 0 00-.66.44.5.5 0 01-.71-.71A3 3 0 0112 8.15V8c0-.28.22-.5.5-.5zm-.88 5.53A3 3 0 019 12.85V13a.5.5 0 01-1 0v-1.5c0-.28.22-.5.5-.5H10a.5.5 0 010 1h-.47a1.99 1.99 0 002.38-.34.5.5 0 01.71.71 3 3 0 01-1 .66z",
    fill: primaryFill
  }));
};

export const CalendarSync16Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarSync16FilledIcon, 'CalendarSync16Filled');

const CalendarSync16RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M11.5 2A2.5 2.5 0 0114 4.5v1.76A5.48 5.48 0 0010.5 5H13v-.5c0-.83-.67-1.5-1.5-1.5h-7C3.67 3 3 3.67 3 4.5V5h7.5c-1.18 0-2.27.37-3.16 1H3v5.5c0 .83.67 1.5 1.5 1.5h1.1c.18.36.4.7.66 1H4.5A2.5 2.5 0 012 11.5v-7A2.5 2.5 0 014.5 2h7zM6 10.5a4.5 4.5 0 109 0 4.5 4.5 0 00-9 0zm6.5-3c.28 0 .5.22.5.5v1.5a.5.5 0 01-.5.5H11a.5.5 0 010-1h.47a1.98 1.98 0 00-1.72-.1 2 2 0 00-.66.44.5.5 0 01-.71-.71A3 3 0 0112 8.15V8c0-.28.22-.5.5-.5zm-.88 5.53A3 3 0 019 12.85V13a.5.5 0 01-1 0v-1.5c0-.28.22-.5.5-.5H10a.5.5 0 010 1h-.47a1.99 1.99 0 002.38-.34.5.5 0 01.71.71 3 3 0 01-1 .66z",
    fill: primaryFill
  }));
};

export const CalendarSync16Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarSync16RegularIcon, 'CalendarSync16Regular');

const CalendarSync20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M17 7v2.6A5.5 5.5 0 009.6 17H5.5A2.5 2.5 0 013 14.5V7h14zm-2.5-4A2.5 2.5 0 0117 5.5V6H3v-.5A2.5 2.5 0 015.5 3h9zM10 14.5a4.5 4.5 0 109 0 4.5 4.5 0 00-9 0zm6.5-3c.28 0 .5.22.5.5v1.5a.5.5 0 01-.5.5H15a.5.5 0 010-1h.47a1.97 1.97 0 00-.94-.25 2 2 0 00-1.44.59.5.5 0 01-.71-.71 3 3 0 013.62-.48V12c0-.28.22-.5.5-.5zm-.88 5.53a3 3 0 01-2.62-.18V17a.5.5 0 01-1 0v-1.5c0-.28.22-.5.5-.5H14a.5.5 0 010 1h-.47a1.97 1.97 0 00.94.25 2 2 0 001.44-.59.5.5 0 01.71.71 3 3 0 01-1 .66z",
    fill: primaryFill
  }));
};

export const CalendarSync20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarSync20FilledIcon, 'CalendarSync20Filled');

const CalendarSync20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M14.5 3A2.5 2.5 0 0117 5.5v4.1c-.32-.16-.65-.3-1-.4V7H4v7.5c0 .83.67 1.5 1.5 1.5h3.7c.1.35.24.68.4 1H5.5A2.5 2.5 0 013 14.5v-9A2.5 2.5 0 015.5 3h9zm0 1h-9C4.67 4 4 4.67 4 5.5V6h12v-.5c0-.83-.67-1.5-1.5-1.5zM10 14.5a4.5 4.5 0 109 0 4.5 4.5 0 00-9 0zm6.5-3c.28 0 .5.22.5.5v1.5a.5.5 0 01-.5.5H15a.5.5 0 010-1h.47a1.97 1.97 0 00-.94-.25 2 2 0 00-1.44.59.5.5 0 01-.71-.71 3 3 0 013.62-.48V12c0-.28.22-.5.5-.5zm-.88 5.53a3 3 0 01-2.62-.18V17a.5.5 0 01-1 0v-1.5c0-.28.22-.5.5-.5H14a.5.5 0 010 1h-.47a1.97 1.97 0 00.94.25 2 2 0 001.44-.59.5.5 0 01.71.71 3 3 0 01-1 .66z",
    fill: primaryFill
  }));
};

export const CalendarSync20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarSync20RegularIcon, 'CalendarSync20Regular');

const CalendarSync24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M21 8.5v3.52A6.5 6.5 0 0012.02 21H6.25A3.25 3.25 0 013 17.75V8.5h18zM17.75 3C19.55 3 21 4.46 21 6.25V7H3v-.75C3 4.45 4.46 3 6.25 3h11.5zM12 17.5a5.5 5.5 0 1011 0 5.5 5.5 0 00-11 0zm8.5-3.5c.28 0 .5.22.5.5v2a.5.5 0 01-.5.5h-2a.5.5 0 010-1h1a2.5 2.5 0 00-4.03.04.5.5 0 01-.8-.59 3.5 3.5 0 015.33-.4v-.55c0-.28.22-.5.5-.5zM15 19.95v.55a.5.5 0 01-1 0v-2c0-.28.22-.5.5-.5h2a.5.5 0 010 1h-1a2.5 2.5 0 003.91.11.5.5 0 01.77.65 3.5 3.5 0 01-5.18.19z",
    fill: primaryFill
  }));
};

export const CalendarSync24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarSync24FilledIcon, 'CalendarSync24Filled');

const CalendarSync24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M17.75 3C19.55 3 21 4.46 21 6.25v5.77c-.46-.3-.97-.53-1.5-.7V8.5h-15v9.25c0 .97.78 1.75 1.75 1.75h5.06c.18.53.42 1.04.71 1.5H6.25A3.25 3.25 0 013 17.75V6.25C3 4.45 4.46 3 6.25 3h11.5zm0 1.5H6.25c-.97 0-1.75.78-1.75 1.75V7h15v-.75c0-.97-.78-1.75-1.75-1.75zM12 17.5a5.5 5.5 0 1011 0 5.5 5.5 0 00-11 0zm8.5-3.5c.28 0 .5.22.5.5v2a.5.5 0 01-.5.5h-2a.5.5 0 010-1h1a2.5 2.5 0 00-4.03.04.5.5 0 01-.8-.59 3.5 3.5 0 015.33-.4v-.55c0-.28.22-.5.5-.5zM15 19.95v.55a.5.5 0 01-1 0v-2c0-.28.22-.5.5-.5h2a.5.5 0 010 1h-1a2.5 2.5 0 003.91.11.5.5 0 01.77.65 3.5 3.5 0 01-5.18.19z",
    fill: primaryFill
  }));
};

export const CalendarSync24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarSync24RegularIcon, 'CalendarSync24Regular');

const CalendarToday16FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M14 11.5V6H2v5.5A2.5 2.5 0 004.5 14h2v-1.25a1.5 1.5 0 01-.96-2.65l1.27-1.06A1.75 1.75 0 018 6a1.75 1.75 0 011.19 3.04l1.27 1.06a1.5 1.5 0 01-.96 2.65V14h2a2.5 2.5 0 002.5-2.5zm0-7A2.5 2.5 0 0011.5 2h-7A2.5 2.5 0 002 4.5V5h12v-.5zm-6 4A.75.75 0 108 7a.75.75 0 000 1.5zm0 1a.5.5 0 00-.04 0l-.13.03a.5.5 0 00-.15.09l-1.5 1.25a.5.5 0 10.64.76l.68-.56v3.43a.5.5 0 00.5.5.5.5 0 00.5-.5v-3.43l.68.56a.5.5 0 00.41.11.5.5 0 00.23-.87l-1.5-1.25A.5.5 0 008 9.5z",
    fill: primaryFill
  }));
};

export const CalendarToday16Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarToday16FilledIcon, 'CalendarToday16Filled');

const CalendarToday16RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M14 4.5A2.5 2.5 0 0011.5 2h-7A2.5 2.5 0 002 4.5v7A2.5 2.5 0 004.5 14h2v-1h-2A1.5 1.5 0 013 11.5V6h10v5.5c0 .83-.67 1.5-1.5 1.5h-2v1h2a2.5 2.5 0 002.5-2.5v-7zM4.5 3h7c.83 0 1.5.67 1.5 1.5V5H3v-.5C3 3.67 3.67 3 4.5 3zm3.78 11.91a.5.5 0 00.22-.41v-3.43l.68.56a.5.5 0 00.64-.76l-1.5-1.25a.5.5 0 00-.64 0l-1.5 1.25a.5.5 0 10.64.76l.68-.56v3.43a.5.5 0 00.5.5c.1 0 .2-.03.28-.09zm.47-7.16a.75.75 0 11-1.5 0 .75.75 0 011.5 0z",
    fill: primaryFill
  }));
};

export const CalendarToday16Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarToday16RegularIcon, 'CalendarToday16Regular');

const CalendarToday20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10 10a1 1 0 100-2 1 1 0 000 2zm7 4.5V7H3v7.5A2.5 2.5 0 005.5 17h3v-1.75a1.5 1.5 0 01-.98-2.64h.01l1.5-1.25a1.5 1.5 0 011.94 0l1.5 1.25a1.5 1.5 0 01-.97 2.64V17h3a2.5 2.5 0 002.5-2.5zM12 9a2 2 0 11-4 0 2 2 0 014 0zm5-3.5A2.5 2.5 0 0014.5 3h-9A2.5 2.5 0 003 5.5V6h14v-.5zm-5.82 8.63a.5.5 0 00.64-.76l-1.5-1.25a.5.5 0 00-.64 0l-1.5 1.25a.5.5 0 10.64.76l.68-.56v3.93a.5.5 0 101 0v-3.93l.68.56z",
    fill: primaryFill
  }));
};

export const CalendarToday20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarToday20FilledIcon, 'CalendarToday20Filled');

const CalendarToday20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M14.5 3A2.5 2.5 0 0117 5.5v9a2.5 2.5 0 01-2.5 2.5h-3v-1h3c.83 0 1.5-.67 1.5-1.5V7H4v7.5c0 .83.67 1.5 1.5 1.5h3v1h-3A2.5 2.5 0 013 14.5v-9A2.5 2.5 0 015.5 3h9zm0 1h-9C4.67 4 4 4.67 4 5.5V6h12v-.5c0-.83-.67-1.5-1.5-1.5zM11 9a1 1 0 11-2 0 1 1 0 012 0zm.88 5.07a.5.5 0 01-.7.06l-.68-.56v3.93a.5.5 0 11-1 0v-3.93l-.68.56a.5.5 0 01-.64-.76l1.5-1.25a.5.5 0 01.64 0l1.5 1.25c.21.17.24.49.06.7z",
    fill: primaryFill
  }));
};

export const CalendarToday20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CalendarToday20RegularIcon, 'CalendarToday20Regular');